(function(factory) {
  typeof define === "function" && define.amd ? define(factory) : factory();
})(function() {
  "use strict";
  var n$1, l$2, u$2, t$2, r$3, o$2, f$3, e$2, c$2 = {}, s$1 = [], a$2 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
  function h$3(n2, l2) {
    for (var u2 in l2)
      n2[u2] = l2[u2];
    return n2;
  }
  function v$4(n2) {
    var l2 = n2.parentNode;
    l2 && l2.removeChild(n2);
  }
  function y$3(l2, u2, i2) {
    var t2, r2, o2, f2 = {};
    for (o2 in u2)
      "key" == o2 ? t2 = u2[o2] : "ref" == o2 ? r2 = u2[o2] : f2[o2] = u2[o2];
    if (arguments.length > 2 && (f2.children = arguments.length > 3 ? n$1.call(arguments, 2) : i2), "function" == typeof l2 && null != l2.defaultProps)
      for (o2 in l2.defaultProps)
        void 0 === f2[o2] && (f2[o2] = l2.defaultProps[o2]);
    return p$3(l2, f2, t2, r2, null);
  }
  function p$3(n2, i2, t2, r2, o2) {
    var f2 = { type: n2, props: i2, key: t2, ref: r2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: null == o2 ? ++u$2 : o2 };
    return null == o2 && null != l$2.vnode && l$2.vnode(f2), f2;
  }
  function d$3() {
    return { current: null };
  }
  function _$4(n2) {
    return n2.children;
  }
  function k$5(n2, l2) {
    this.props = n2, this.context = l2;
  }
  function b$4(n2, l2) {
    if (null == l2)
      return n2.__ ? b$4(n2.__, n2.__.__k.indexOf(n2) + 1) : null;
    for (var u2; l2 < n2.__k.length; l2++)
      if (null != (u2 = n2.__k[l2]) && null != u2.__e)
        return u2.__e;
    return "function" == typeof n2.type ? b$4(n2) : null;
  }
  function g$5(n2) {
    var l2, u2;
    if (null != (n2 = n2.__) && null != n2.__c) {
      for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++)
        if (null != (u2 = n2.__k[l2]) && null != u2.__e) {
          n2.__e = n2.__c.base = u2.__e;
          break;
        }
      return g$5(n2);
    }
  }
  function m$3(n2) {
    (!n2.__d && (n2.__d = true) && t$2.push(n2) && !w$4.__r++ || r$3 !== l$2.debounceRendering) && ((r$3 = l$2.debounceRendering) || o$2)(w$4);
  }
  function w$4() {
    var n2, l2, u2, i2, r2, o2, e2, c2;
    for (t$2.sort(f$3); n2 = t$2.shift(); )
      n2.__d && (l2 = t$2.length, i2 = void 0, r2 = void 0, e2 = (o2 = (u2 = n2).__v).__e, (c2 = u2.__P) && (i2 = [], (r2 = h$3({}, o2)).__v = o2.__v + 1, L$3(c2, o2, r2, u2.__n, void 0 !== c2.ownerSVGElement, null != o2.__h ? [e2] : null, i2, null == e2 ? b$4(o2) : e2, o2.__h), M$3(i2, o2), o2.__e != e2 && g$5(o2)), t$2.length > l2 && t$2.sort(f$3));
    w$4.__r = 0;
  }
  function x$4(n2, l2, u2, i2, t2, r2, o2, f2, e2, a2) {
    var h2, v2, y2, d2, k2, g2, m2, w2 = i2 && i2.__k || s$1, x2 = w2.length;
    for (u2.__k = [], h2 = 0; h2 < l2.length; h2++)
      if (null != (d2 = u2.__k[h2] = null == (d2 = l2[h2]) || "boolean" == typeof d2 || "function" == typeof d2 ? null : "string" == typeof d2 || "number" == typeof d2 || "bigint" == typeof d2 ? p$3(null, d2, null, null, d2) : Array.isArray(d2) ? p$3(_$4, { children: d2 }, null, null, null) : d2.__b > 0 ? p$3(d2.type, d2.props, d2.key, d2.ref ? d2.ref : null, d2.__v) : d2)) {
        if (d2.__ = u2, d2.__b = u2.__b + 1, null === (y2 = w2[h2]) || y2 && d2.key == y2.key && d2.type === y2.type)
          w2[h2] = void 0;
        else
          for (v2 = 0; v2 < x2; v2++) {
            if ((y2 = w2[v2]) && d2.key == y2.key && d2.type === y2.type) {
              w2[v2] = void 0;
              break;
            }
            y2 = null;
          }
        L$3(n2, d2, y2 = y2 || c$2, t2, r2, o2, f2, e2, a2), k2 = d2.__e, (v2 = d2.ref) && y2.ref != v2 && (m2 || (m2 = []), y2.ref && m2.push(y2.ref, null, d2), m2.push(v2, d2.__c || k2, d2)), null != k2 ? (null == g2 && (g2 = k2), "function" == typeof d2.type && d2.__k === y2.__k ? d2.__d = e2 = A$5(d2, e2, n2) : e2 = C$2(n2, d2, y2, w2, k2, e2), "function" == typeof u2.type && (u2.__d = e2)) : e2 && y2.__e == e2 && e2.parentNode != n2 && (e2 = b$4(y2));
      }
    for (u2.__e = g2, h2 = x2; h2--; )
      null != w2[h2] && ("function" == typeof u2.type && null != w2[h2].__e && w2[h2].__e == u2.__d && (u2.__d = $$2(i2).nextSibling), S$2(w2[h2], w2[h2]));
    if (m2)
      for (h2 = 0; h2 < m2.length; h2++)
        O$2(m2[h2], m2[++h2], m2[++h2]);
  }
  function A$5(n2, l2, u2) {
    for (var i2, t2 = n2.__k, r2 = 0; t2 && r2 < t2.length; r2++)
      (i2 = t2[r2]) && (i2.__ = n2, l2 = "function" == typeof i2.type ? A$5(i2, l2, u2) : C$2(u2, i2, i2, t2, i2.__e, l2));
    return l2;
  }
  function P$4(n2, l2) {
    return l2 = l2 || [], null == n2 || "boolean" == typeof n2 || (Array.isArray(n2) ? n2.some(function(n3) {
      P$4(n3, l2);
    }) : l2.push(n2)), l2;
  }
  function C$2(n2, l2, u2, i2, t2, r2) {
    var o2, f2, e2;
    if (void 0 !== l2.__d)
      o2 = l2.__d, l2.__d = void 0;
    else if (null == u2 || t2 != r2 || null == t2.parentNode)
      n:
        if (null == r2 || r2.parentNode !== n2)
          n2.appendChild(t2), o2 = null;
        else {
          for (f2 = r2, e2 = 0; (f2 = f2.nextSibling) && e2 < i2.length; e2 += 1)
            if (f2 == t2)
              break n;
          n2.insertBefore(t2, r2), o2 = r2;
        }
    return void 0 !== o2 ? o2 : t2.nextSibling;
  }
  function $$2(n2) {
    var l2, u2, i2;
    if (null == n2.type || "string" == typeof n2.type)
      return n2.__e;
    if (n2.__k) {
      for (l2 = n2.__k.length - 1; l2 >= 0; l2--)
        if ((u2 = n2.__k[l2]) && (i2 = $$2(u2)))
          return i2;
    }
    return null;
  }
  function H$3(n2, l2, u2, i2, t2) {
    var r2;
    for (r2 in u2)
      "children" === r2 || "key" === r2 || r2 in l2 || T$4(n2, r2, null, u2[r2], i2);
    for (r2 in l2)
      t2 && "function" != typeof l2[r2] || "children" === r2 || "key" === r2 || "value" === r2 || "checked" === r2 || u2[r2] === l2[r2] || T$4(n2, r2, l2[r2], u2[r2], i2);
  }
  function I$3(n2, l2, u2) {
    "-" === l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || a$2.test(l2) ? u2 : u2 + "px";
  }
  function T$4(n2, l2, u2, i2, t2) {
    var r2;
    n:
      if ("style" === l2)
        if ("string" == typeof u2)
          n2.style.cssText = u2;
        else {
          if ("string" == typeof i2 && (n2.style.cssText = i2 = ""), i2)
            for (l2 in i2)
              u2 && l2 in u2 || I$3(n2.style, l2, "");
          if (u2)
            for (l2 in u2)
              i2 && u2[l2] === i2[l2] || I$3(n2.style, l2, u2[l2]);
        }
      else if ("o" === l2[0] && "n" === l2[1])
        r2 = l2 !== (l2 = l2.replace(/Capture$/, "")), l2 = l2.toLowerCase() in n2 ? l2.toLowerCase().slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + r2] = u2, u2 ? i2 || n2.addEventListener(l2, r2 ? z$5 : j$4, r2) : n2.removeEventListener(l2, r2 ? z$5 : j$4, r2);
      else if ("dangerouslySetInnerHTML" !== l2) {
        if (t2)
          l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l2 && "height" !== l2 && "href" !== l2 && "list" !== l2 && "form" !== l2 && "tabIndex" !== l2 && "download" !== l2 && l2 in n2)
          try {
            n2[l2] = null == u2 ? "" : u2;
            break n;
          } catch (n3) {
          }
        "function" == typeof u2 || (null == u2 || false === u2 && -1 == l2.indexOf("-") ? n2.removeAttribute(l2) : n2.setAttribute(l2, u2));
      }
  }
  function j$4(n2) {
    return this.l[n2.type + false](l$2.event ? l$2.event(n2) : n2);
  }
  function z$5(n2) {
    return this.l[n2.type + true](l$2.event ? l$2.event(n2) : n2);
  }
  function L$3(n2, u2, i2, t2, r2, o2, f2, e2, c2) {
    var s2, a2, v2, y2, p2, d2, b2, g2, m2, w2, A2, P2, C2, $2, H2, I2 = u2.type;
    if (void 0 !== u2.constructor)
      return null;
    null != i2.__h && (c2 = i2.__h, e2 = u2.__e = i2.__e, u2.__h = null, o2 = [e2]), (s2 = l$2.__b) && s2(u2);
    try {
      n:
        if ("function" == typeof I2) {
          if (g2 = u2.props, m2 = (s2 = I2.contextType) && t2[s2.__c], w2 = s2 ? m2 ? m2.props.value : s2.__ : t2, i2.__c ? b2 = (a2 = u2.__c = i2.__c).__ = a2.__E : ("prototype" in I2 && I2.prototype.render ? u2.__c = a2 = new I2(g2, w2) : (u2.__c = a2 = new k$5(g2, w2), a2.constructor = I2, a2.render = q$5), m2 && m2.sub(a2), a2.props = g2, a2.state || (a2.state = {}), a2.context = w2, a2.__n = t2, v2 = a2.__d = true, a2.__h = [], a2._sb = []), null == a2.__s && (a2.__s = a2.state), null != I2.getDerivedStateFromProps && (a2.__s == a2.state && (a2.__s = h$3({}, a2.__s)), h$3(a2.__s, I2.getDerivedStateFromProps(g2, a2.__s))), y2 = a2.props, p2 = a2.state, a2.__v = u2, v2)
            null == I2.getDerivedStateFromProps && null != a2.componentWillMount && a2.componentWillMount(), null != a2.componentDidMount && a2.__h.push(a2.componentDidMount);
          else {
            if (null == I2.getDerivedStateFromProps && g2 !== y2 && null != a2.componentWillReceiveProps && a2.componentWillReceiveProps(g2, w2), !a2.__e && null != a2.shouldComponentUpdate && false === a2.shouldComponentUpdate(g2, a2.__s, w2) || u2.__v === i2.__v) {
              for (u2.__v !== i2.__v && (a2.props = g2, a2.state = a2.__s, a2.__d = false), a2.__e = false, u2.__e = i2.__e, u2.__k = i2.__k, u2.__k.forEach(function(n3) {
                n3 && (n3.__ = u2);
              }), A2 = 0; A2 < a2._sb.length; A2++)
                a2.__h.push(a2._sb[A2]);
              a2._sb = [], a2.__h.length && f2.push(a2);
              break n;
            }
            null != a2.componentWillUpdate && a2.componentWillUpdate(g2, a2.__s, w2), null != a2.componentDidUpdate && a2.__h.push(function() {
              a2.componentDidUpdate(y2, p2, d2);
            });
          }
          if (a2.context = w2, a2.props = g2, a2.__P = n2, P2 = l$2.__r, C2 = 0, "prototype" in I2 && I2.prototype.render) {
            for (a2.state = a2.__s, a2.__d = false, P2 && P2(u2), s2 = a2.render(a2.props, a2.state, a2.context), $2 = 0; $2 < a2._sb.length; $2++)
              a2.__h.push(a2._sb[$2]);
            a2._sb = [];
          } else
            do {
              a2.__d = false, P2 && P2(u2), s2 = a2.render(a2.props, a2.state, a2.context), a2.state = a2.__s;
            } while (a2.__d && ++C2 < 25);
          a2.state = a2.__s, null != a2.getChildContext && (t2 = h$3(h$3({}, t2), a2.getChildContext())), v2 || null == a2.getSnapshotBeforeUpdate || (d2 = a2.getSnapshotBeforeUpdate(y2, p2)), H2 = null != s2 && s2.type === _$4 && null == s2.key ? s2.props.children : s2, x$4(n2, Array.isArray(H2) ? H2 : [H2], u2, i2, t2, r2, o2, f2, e2, c2), a2.base = u2.__e, u2.__h = null, a2.__h.length && f2.push(a2), b2 && (a2.__E = a2.__ = null), a2.__e = false;
        } else
          null == o2 && u2.__v === i2.__v ? (u2.__k = i2.__k, u2.__e = i2.__e) : u2.__e = N$3(i2.__e, u2, i2, t2, r2, o2, f2, c2);
      (s2 = l$2.diffed) && s2(u2);
    } catch (n3) {
      u2.__v = null, (c2 || null != o2) && (u2.__e = e2, u2.__h = !!c2, o2[o2.indexOf(e2)] = null), l$2.__e(n3, u2, i2);
    }
  }
  function M$3(n2, u2) {
    l$2.__c && l$2.__c(u2, n2), n2.some(function(u3) {
      try {
        n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
          n3.call(u3);
        });
      } catch (n3) {
        l$2.__e(n3, u3.__v);
      }
    });
  }
  function N$3(l2, u2, i2, t2, r2, o2, f2, e2) {
    var s2, a2, h2, y2 = i2.props, p2 = u2.props, d2 = u2.type, _2 = 0;
    if ("svg" === d2 && (r2 = true), null != o2) {
      for (; _2 < o2.length; _2++)
        if ((s2 = o2[_2]) && "setAttribute" in s2 == !!d2 && (d2 ? s2.localName === d2 : 3 === s2.nodeType)) {
          l2 = s2, o2[_2] = null;
          break;
        }
    }
    if (null == l2) {
      if (null === d2)
        return document.createTextNode(p2);
      l2 = r2 ? document.createElementNS("http://www.w3.org/2000/svg", d2) : document.createElement(d2, p2.is && p2), o2 = null, e2 = false;
    }
    if (null === d2)
      y2 === p2 || e2 && l2.data === p2 || (l2.data = p2);
    else {
      if (o2 = o2 && n$1.call(l2.childNodes), a2 = (y2 = i2.props || c$2).dangerouslySetInnerHTML, h2 = p2.dangerouslySetInnerHTML, !e2) {
        if (null != o2)
          for (y2 = {}, _2 = 0; _2 < l2.attributes.length; _2++)
            y2[l2.attributes[_2].name] = l2.attributes[_2].value;
        (h2 || a2) && (h2 && (a2 && h2.__html == a2.__html || h2.__html === l2.innerHTML) || (l2.innerHTML = h2 && h2.__html || ""));
      }
      if (H$3(l2, p2, y2, r2, e2), h2)
        u2.__k = [];
      else if (_2 = u2.props.children, x$4(l2, Array.isArray(_2) ? _2 : [_2], u2, i2, t2, r2 && "foreignObject" !== d2, o2, f2, o2 ? o2[0] : i2.__k && b$4(i2, 0), e2), null != o2)
        for (_2 = o2.length; _2--; )
          null != o2[_2] && v$4(o2[_2]);
      e2 || ("value" in p2 && void 0 !== (_2 = p2.value) && (_2 !== l2.value || "progress" === d2 && !_2 || "option" === d2 && _2 !== y2.value) && T$4(l2, "value", _2, y2.value, false), "checked" in p2 && void 0 !== (_2 = p2.checked) && _2 !== l2.checked && T$4(l2, "checked", _2, y2.checked, false));
    }
    return l2;
  }
  function O$2(n2, u2, i2) {
    try {
      "function" == typeof n2 ? n2(u2) : n2.current = u2;
    } catch (n3) {
      l$2.__e(n3, i2);
    }
  }
  function S$2(n2, u2, i2) {
    var t2, r2;
    if (l$2.unmount && l$2.unmount(n2), (t2 = n2.ref) && (t2.current && t2.current !== n2.__e || O$2(t2, null, u2)), null != (t2 = n2.__c)) {
      if (t2.componentWillUnmount)
        try {
          t2.componentWillUnmount();
        } catch (n3) {
          l$2.__e(n3, u2);
        }
      t2.base = t2.__P = null, n2.__c = void 0;
    }
    if (t2 = n2.__k)
      for (r2 = 0; r2 < t2.length; r2++)
        t2[r2] && S$2(t2[r2], u2, i2 || "function" != typeof n2.type);
    i2 || null == n2.__e || v$4(n2.__e), n2.__ = n2.__e = n2.__d = void 0;
  }
  function q$5(n2, l2, u2) {
    return this.constructor(n2, u2);
  }
  function B$4(u2, i2, t2) {
    var r2, o2, f2;
    l$2.__ && l$2.__(u2, i2), o2 = (r2 = "function" == typeof t2) ? null : t2 && t2.__k || i2.__k, f2 = [], L$3(i2, u2 = (!r2 && t2 || i2).__k = y$3(_$4, null, [u2]), o2 || c$2, c$2, void 0 !== i2.ownerSVGElement, !r2 && t2 ? [t2] : o2 ? null : i2.firstChild ? n$1.call(i2.childNodes) : null, f2, !r2 && t2 ? t2 : o2 ? o2.__e : i2.firstChild, r2), M$3(f2, u2);
  }
  function D$2(n2, l2) {
    B$4(n2, l2, D$2);
  }
  function E$3(l2, u2, i2) {
    var t2, r2, o2, f2 = h$3({}, l2.props);
    for (o2 in u2)
      "key" == o2 ? t2 = u2[o2] : "ref" == o2 ? r2 = u2[o2] : f2[o2] = u2[o2];
    return arguments.length > 2 && (f2.children = arguments.length > 3 ? n$1.call(arguments, 2) : i2), p$3(l2.type, f2, t2 || l2.key, r2 || l2.ref, null);
  }
  function F$4(n2, l2) {
    var u2 = { __c: l2 = "__cC" + e$2++, __: n2, Consumer: function(n3, l3) {
      return n3.children(l3);
    }, Provider: function(n3) {
      var u3, i2;
      return this.getChildContext || (u3 = [], (i2 = {})[l2] = this, this.getChildContext = function() {
        return i2;
      }, this.shouldComponentUpdate = function(n4) {
        this.props.value !== n4.value && u3.some(function(n5) {
          n5.__e = true, m$3(n5);
        });
      }, this.sub = function(n4) {
        u3.push(n4);
        var l3 = n4.componentWillUnmount;
        n4.componentWillUnmount = function() {
          u3.splice(u3.indexOf(n4), 1), l3 && l3.call(n4);
        };
      }), n3.children;
    } };
    return u2.Provider.__ = u2.Consumer.contextType = u2;
  }
  n$1 = s$1.slice, l$2 = { __e: function(n2, l2, u2, i2) {
    for (var t2, r2, o2; l2 = l2.__; )
      if ((t2 = l2.__c) && !t2.__)
        try {
          if ((r2 = t2.constructor) && null != r2.getDerivedStateFromError && (t2.setState(r2.getDerivedStateFromError(n2)), o2 = t2.__d), null != t2.componentDidCatch && (t2.componentDidCatch(n2, i2 || {}), o2 = t2.__d), o2)
            return t2.__E = t2;
        } catch (l3) {
          n2 = l3;
        }
    throw n2;
  } }, u$2 = 0, k$5.prototype.setState = function(n2, l2) {
    var u2;
    u2 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = h$3({}, this.state), "function" == typeof n2 && (n2 = n2(h$3({}, u2), this.props)), n2 && h$3(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), m$3(this));
  }, k$5.prototype.forceUpdate = function(n2) {
    this.__v && (this.__e = true, n2 && this.__h.push(n2), m$3(this));
  }, k$5.prototype.render = _$4, t$2 = [], o$2 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$3 = function(n2, l2) {
    return n2.__v.__b - l2.__v.__b;
  }, w$4.__r = 0, e$2 = 0;
  "undefined" != typeof window && window.__PREACT_DEVTOOLS__ && window.__PREACT_DEVTOOLS__.attachPreact("10.13.1", l$2, { Fragment: _$4, Component: k$5 });
  var t$1, r$2, u$1, i$2, o$1 = 0, f$2 = [], c$1 = [], e$1 = l$2.__b, a$1 = l$2.__r, v$3 = l$2.diffed, l$1 = l$2.__c, m$2 = l$2.unmount;
  function d$2(t2, u2) {
    l$2.__h && l$2.__h(r$2, t2, o$1 || u2), o$1 = 0;
    var i2 = r$2.__H || (r$2.__H = { __: [], __h: [] });
    return t2 >= i2.__.length && i2.__.push({ __V: c$1 }), i2.__[t2];
  }
  function h$2(n2) {
    return o$1 = 1, s(B$3, n2);
  }
  function s(n2, u2, i2) {
    var o2 = d$2(t$1++, 2);
    if (o2.t = n2, !o2.__c && (o2.__ = [i2 ? i2(u2) : B$3(void 0, u2), function(n3) {
      var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
      t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
    }], o2.__c = r$2, !r$2.u)) {
      var f2 = function(n3, t2, r2) {
        if (!o2.__c.__H)
          return true;
        var u3 = o2.__c.__H.__.filter(function(n4) {
          return n4.__c;
        });
        if (u3.every(function(n4) {
          return !n4.__N;
        }))
          return !c2 || c2.call(this, n3, t2, r2);
        var i3 = false;
        return u3.forEach(function(n4) {
          if (n4.__N) {
            var t3 = n4.__[0];
            n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = true);
          }
        }), !(!i3 && o2.__c.props === n3) && (!c2 || c2.call(this, n3, t2, r2));
      };
      r$2.u = true;
      var c2 = r$2.shouldComponentUpdate, e2 = r$2.componentWillUpdate;
      r$2.componentWillUpdate = function(n3, t2, r2) {
        if (this.__e) {
          var u3 = c2;
          c2 = void 0, f2(n3, t2, r2), c2 = u3;
        }
        e2 && e2.call(this, n3, t2, r2);
      }, r$2.shouldComponentUpdate = f2;
    }
    return o2.__N || o2.__;
  }
  function p$2(u2, i2) {
    var o2 = d$2(t$1++, 3);
    !l$2.__s && z$4(o2.__H, i2) && (o2.__ = u2, o2.i = i2, r$2.__H.__h.push(o2));
  }
  function y$2(u2, i2) {
    var o2 = d$2(t$1++, 4);
    !l$2.__s && z$4(o2.__H, i2) && (o2.__ = u2, o2.i = i2, r$2.__h.push(o2));
  }
  function _$3(n2) {
    return o$1 = 5, F$3(function() {
      return { current: n2 };
    }, []);
  }
  function A$4(n2, t2, r2) {
    o$1 = 6, y$2(function() {
      return "function" == typeof n2 ? (n2(t2()), function() {
        return n2(null);
      }) : n2 ? (n2.current = t2(), function() {
        return n2.current = null;
      }) : void 0;
    }, null == r2 ? r2 : r2.concat(n2));
  }
  function F$3(n2, r2) {
    var u2 = d$2(t$1++, 7);
    return z$4(u2.__H, r2) ? (u2.__V = n2(), u2.i = r2, u2.__h = n2, u2.__V) : u2.__;
  }
  function T$3(n2, t2) {
    return o$1 = 8, F$3(function() {
      return n2;
    }, t2);
  }
  function q$4(n2) {
    var u2 = r$2.context[n2.__c], i2 = d$2(t$1++, 9);
    return i2.c = n2, u2 ? (null == i2.__ && (i2.__ = true, u2.sub(r$2)), u2.props.value) : n2.__;
  }
  function x$3(t2, r2) {
    l$2.useDebugValue && l$2.useDebugValue(r2 ? r2(t2) : t2);
  }
  function P$3(n2) {
    var u2 = d$2(t$1++, 10), i2 = h$2();
    return u2.__ = n2, r$2.componentDidCatch || (r$2.componentDidCatch = function(n3, t2) {
      u2.__ && u2.__(n3, t2), i2[1](n3);
    }), [i2[0], function() {
      i2[1](void 0);
    }];
  }
  function V$2() {
    var n2 = d$2(t$1++, 11);
    if (!n2.__) {
      for (var u2 = r$2.__v; null !== u2 && !u2.__m && null !== u2.__; )
        u2 = u2.__;
      var i2 = u2.__m || (u2.__m = [0, 0]);
      n2.__ = "P" + i2[0] + "-" + i2[1]++;
    }
    return n2.__;
  }
  function b$3() {
    for (var t2; t2 = f$2.shift(); )
      if (t2.__P && t2.__H)
        try {
          t2.__H.__h.forEach(k$4), t2.__H.__h.forEach(w$3), t2.__H.__h = [];
        } catch (r2) {
          t2.__H.__h = [], l$2.__e(r2, t2.__v);
        }
  }
  l$2.__b = function(n2) {
    r$2 = null, e$1 && e$1(n2);
  }, l$2.__r = function(n2) {
    a$1 && a$1(n2), t$1 = 0;
    var i2 = (r$2 = n2.__c).__H;
    i2 && (u$1 === r$2 ? (i2.__h = [], r$2.__h = [], i2.__.forEach(function(n3) {
      n3.__N && (n3.__ = n3.__N), n3.__V = c$1, n3.__N = n3.i = void 0;
    })) : (i2.__h.forEach(k$4), i2.__h.forEach(w$3), i2.__h = [])), u$1 = r$2;
  }, l$2.diffed = function(t2) {
    v$3 && v$3(t2);
    var o2 = t2.__c;
    o2 && o2.__H && (o2.__H.__h.length && (1 !== f$2.push(o2) && i$2 === l$2.requestAnimationFrame || ((i$2 = l$2.requestAnimationFrame) || j$3)(b$3)), o2.__H.__.forEach(function(n2) {
      n2.i && (n2.__H = n2.i), n2.__V !== c$1 && (n2.__ = n2.__V), n2.i = void 0, n2.__V = c$1;
    })), u$1 = r$2 = null;
  }, l$2.__c = function(t2, r2) {
    r2.some(function(t3) {
      try {
        t3.__h.forEach(k$4), t3.__h = t3.__h.filter(function(n2) {
          return !n2.__ || w$3(n2);
        });
      } catch (u2) {
        r2.some(function(n2) {
          n2.__h && (n2.__h = []);
        }), r2 = [], l$2.__e(u2, t3.__v);
      }
    }), l$1 && l$1(t2, r2);
  }, l$2.unmount = function(t2) {
    m$2 && m$2(t2);
    var r2, u2 = t2.__c;
    u2 && u2.__H && (u2.__H.__.forEach(function(n2) {
      try {
        k$4(n2);
      } catch (n3) {
        r2 = n3;
      }
    }), u2.__H = void 0, r2 && l$2.__e(r2, u2.__v));
  };
  var g$4 = "function" == typeof requestAnimationFrame;
  function j$3(n2) {
    var t2, r2 = function() {
      clearTimeout(u2), g$4 && cancelAnimationFrame(t2), setTimeout(n2);
    }, u2 = setTimeout(r2, 100);
    g$4 && (t2 = requestAnimationFrame(r2));
  }
  function k$4(n2) {
    var t2 = r$2, u2 = n2.__c;
    "function" == typeof u2 && (n2.__c = void 0, u2()), r$2 = t2;
  }
  function w$3(n2) {
    var t2 = r$2;
    n2.__c = n2.__(), r$2 = t2;
  }
  function z$4(n2, t2) {
    return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
      return t3 !== n2[r2];
    });
  }
  function B$3(n2, t2) {
    return "function" == typeof t2 ? t2(n2) : t2;
  }
  function g$3(n2, t2) {
    for (var e2 in t2)
      n2[e2] = t2[e2];
    return n2;
  }
  function C$1(n2, t2) {
    for (var e2 in n2)
      if ("__source" !== e2 && !(e2 in t2))
        return true;
    for (var r2 in t2)
      if ("__source" !== r2 && n2[r2] !== t2[r2])
        return true;
    return false;
  }
  function E$2(n2, t2) {
    return n2 === t2 && (0 !== n2 || 1 / n2 == 1 / t2) || n2 != n2 && t2 != t2;
  }
  function w$2(n2) {
    this.props = n2;
  }
  function x$2(n2, e2) {
    function r2(n3) {
      var t2 = this.props.ref, r3 = t2 == n3.ref;
      return !r3 && t2 && (t2.call ? t2(null) : t2.current = null), e2 ? !e2(this.props, n3) || !r3 : C$1(this.props, n3);
    }
    function u2(e3) {
      return this.shouldComponentUpdate = r2, y$3(n2, e3);
    }
    return u2.displayName = "Memo(" + (n2.displayName || n2.name) + ")", u2.prototype.isReactComponent = true, u2.__f = true, u2;
  }
  (w$2.prototype = new k$5()).isPureReactComponent = true, w$2.prototype.shouldComponentUpdate = function(n2, t2) {
    return C$1(this.props, n2) || C$1(this.state, t2);
  };
  var R$1 = l$2.__b;
  l$2.__b = function(n2) {
    n2.type && n2.type.__f && n2.ref && (n2.props.ref = n2.ref, n2.ref = null), R$1 && R$1(n2);
  };
  var N$2 = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
  function k$3(n2) {
    function t2(t3) {
      var e2 = g$3({}, t3);
      return delete e2.ref, n2(e2, t3.ref || null);
    }
    return t2.$$typeof = N$2, t2.render = t2, t2.prototype.isReactComponent = t2.__f = true, t2.displayName = "ForwardRef(" + (n2.displayName || n2.name) + ")", t2;
  }
  var A$3 = function(n2, t2) {
    return null == n2 ? null : P$4(P$4(n2).map(t2));
  }, O$1 = { map: A$3, forEach: A$3, count: function(n2) {
    return n2 ? P$4(n2).length : 0;
  }, only: function(n2) {
    var t2 = P$4(n2);
    if (1 !== t2.length)
      throw "Children.only";
    return t2[0];
  }, toArray: P$4 }, T$2 = l$2.__e;
  l$2.__e = function(n2, t2, e2, r2) {
    if (n2.then) {
      for (var u2, o2 = t2; o2 = o2.__; )
        if ((u2 = o2.__c) && u2.__c)
          return null == t2.__e && (t2.__e = e2.__e, t2.__k = e2.__k), u2.__c(n2, t2);
    }
    T$2(n2, t2, e2, r2);
  };
  var I$2 = l$2.unmount;
  function L$2(n2, t2, e2) {
    return n2 && (n2.__c && n2.__c.__H && (n2.__c.__H.__.forEach(function(n3) {
      "function" == typeof n3.__c && n3.__c();
    }), n2.__c.__H = null), null != (n2 = g$3({}, n2)).__c && (n2.__c.__P === e2 && (n2.__c.__P = t2), n2.__c = null), n2.__k = n2.__k && n2.__k.map(function(n3) {
      return L$2(n3, t2, e2);
    })), n2;
  }
  function U$1(n2, t2, e2) {
    return n2 && (n2.__v = null, n2.__k = n2.__k && n2.__k.map(function(n3) {
      return U$1(n3, t2, e2);
    }), n2.__c && n2.__c.__P === t2 && (n2.__e && e2.insertBefore(n2.__e, n2.__d), n2.__c.__e = true, n2.__c.__P = e2)), n2;
  }
  function D$1() {
    this.__u = 0, this.t = null, this.__b = null;
  }
  function F$2(n2) {
    var t2 = n2.__.__c;
    return t2 && t2.__a && t2.__a(n2);
  }
  function M$2(n2) {
    var e2, r2, u2;
    function o2(o3) {
      if (e2 || (e2 = n2()).then(function(n3) {
        r2 = n3.default || n3;
      }, function(n3) {
        u2 = n3;
      }), u2)
        throw u2;
      if (!r2)
        throw e2;
      return y$3(r2, o3);
    }
    return o2.displayName = "Lazy", o2.__f = true, o2;
  }
  function V$1() {
    this.u = null, this.o = null;
  }
  l$2.unmount = function(n2) {
    var t2 = n2.__c;
    t2 && t2.__R && t2.__R(), t2 && true === n2.__h && (n2.type = null), I$2 && I$2(n2);
  }, (D$1.prototype = new k$5()).__c = function(n2, t2) {
    var e2 = t2.__c, r2 = this;
    null == r2.t && (r2.t = []), r2.t.push(e2);
    var u2 = F$2(r2.__v), o2 = false, i2 = function() {
      o2 || (o2 = true, e2.__R = null, u2 ? u2(l2) : l2());
    };
    e2.__R = i2;
    var l2 = function() {
      if (!--r2.__u) {
        if (r2.state.__a) {
          var n3 = r2.state.__a;
          r2.__v.__k[0] = U$1(n3, n3.__c.__P, n3.__c.__O);
        }
        var t3;
        for (r2.setState({ __a: r2.__b = null }); t3 = r2.t.pop(); )
          t3.forceUpdate();
      }
    }, c2 = true === t2.__h;
    r2.__u++ || c2 || r2.setState({ __a: r2.__b = r2.__v.__k[0] }), n2.then(i2, i2);
  }, D$1.prototype.componentWillUnmount = function() {
    this.t = [];
  }, D$1.prototype.render = function(n2, e2) {
    if (this.__b) {
      if (this.__v.__k) {
        var r2 = document.createElement("div"), o2 = this.__v.__k[0].__c;
        this.__v.__k[0] = L$2(this.__b, r2, o2.__O = o2.__P);
      }
      this.__b = null;
    }
    var i2 = e2.__a && y$3(_$4, null, n2.fallback);
    return i2 && (i2.__h = null), [y$3(_$4, null, e2.__a ? null : n2.children), i2];
  };
  var W$1 = function(n2, t2, e2) {
    if (++e2[1] === e2[0] && n2.o.delete(t2), n2.props.revealOrder && ("t" !== n2.props.revealOrder[0] || !n2.o.size))
      for (e2 = n2.u; e2; ) {
        for (; e2.length > 3; )
          e2.pop()();
        if (e2[1] < e2[0])
          break;
        n2.u = e2 = e2[2];
      }
  };
  function P$2(n2) {
    return this.getChildContext = function() {
      return n2.context;
    }, n2.children;
  }
  function j$2(n2) {
    var e2 = this, r2 = n2.i;
    e2.componentWillUnmount = function() {
      B$4(null, e2.l), e2.l = null, e2.i = null;
    }, e2.i && e2.i !== r2 && e2.componentWillUnmount(), n2.__v ? (e2.l || (e2.i = r2, e2.l = { nodeType: 1, parentNode: r2, childNodes: [], appendChild: function(n3) {
      this.childNodes.push(n3), e2.i.appendChild(n3);
    }, insertBefore: function(n3, t2) {
      this.childNodes.push(n3), e2.i.appendChild(n3);
    }, removeChild: function(n3) {
      this.childNodes.splice(this.childNodes.indexOf(n3) >>> 1, 1), e2.i.removeChild(n3);
    } }), B$4(y$3(P$2, { context: e2.context }, n2.__v), e2.l)) : e2.l && e2.componentWillUnmount();
  }
  function z$3(n2, e2) {
    var r2 = y$3(j$2, { __v: n2, i: e2 });
    return r2.containerInfo = e2, r2;
  }
  (V$1.prototype = new k$5()).__a = function(n2) {
    var t2 = this, e2 = F$2(t2.__v), r2 = t2.o.get(n2);
    return r2[0]++, function(u2) {
      var o2 = function() {
        t2.props.revealOrder ? (r2.push(u2), W$1(t2, n2, r2)) : u2();
      };
      e2 ? e2(o2) : o2();
    };
  }, V$1.prototype.render = function(n2) {
    this.u = null, this.o = /* @__PURE__ */ new Map();
    var t2 = P$4(n2.children);
    n2.revealOrder && "b" === n2.revealOrder[0] && t2.reverse();
    for (var e2 = t2.length; e2--; )
      this.o.set(t2[e2], this.u = [1, 0, this.u]);
    return n2.children;
  }, V$1.prototype.componentDidUpdate = V$1.prototype.componentDidMount = function() {
    var n2 = this;
    this.o.forEach(function(t2, e2) {
      W$1(n2, e2, t2);
    });
  };
  var B$2 = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, H$2 = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, Z$1 = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, Y$1 = /[A-Z0-9]/g, $$1 = "undefined" != typeof document, q$3 = function(n2) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n2);
  };
  function G$1(n2, t2, e2) {
    return null == t2.__k && (t2.textContent = ""), B$4(n2, t2), "function" == typeof e2 && e2(), n2 ? n2.__c : null;
  }
  function J$1(n2, t2, e2) {
    return D$2(n2, t2), "function" == typeof e2 && e2(), n2 ? n2.__c : null;
  }
  k$5.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t2) {
    Object.defineProperty(k$5.prototype, t2, { configurable: true, get: function() {
      return this["UNSAFE_" + t2];
    }, set: function(n2) {
      Object.defineProperty(this, t2, { configurable: true, writable: true, value: n2 });
    } });
  });
  var K$1 = l$2.event;
  function Q$2() {
  }
  function X$1() {
    return this.cancelBubble;
  }
  function nn() {
    return this.defaultPrevented;
  }
  l$2.event = function(n2) {
    return K$1 && (n2 = K$1(n2)), n2.persist = Q$2, n2.isPropagationStopped = X$1, n2.isDefaultPrevented = nn, n2.nativeEvent = n2;
  };
  var tn, en = { configurable: true, get: function() {
    return this.class;
  } }, rn = l$2.vnode;
  l$2.vnode = function(n2) {
    var t2 = n2.type, e2 = n2.props, u2 = e2;
    if ("string" == typeof t2) {
      for (var o2 in u2 = {}, e2) {
        var i2 = e2[o2];
        if (!("value" === o2 && "defaultValue" in e2 && null == i2 || $$1 && "children" === o2 && "noscript" === t2)) {
          var l2 = o2.toLowerCase();
          "defaultValue" === o2 && "value" in e2 && null == e2.value ? o2 = "value" : "download" === o2 && true === i2 ? i2 = "" : "ondoubleclick" === l2 ? o2 = "ondblclick" : "onchange" !== l2 || "input" !== t2 && "textarea" !== t2 || q$3(e2.type) ? "onfocus" === l2 ? o2 = "onfocusin" : "onblur" === l2 ? o2 = "onfocusout" : Z$1.test(o2) ? o2 = l2 : -1 === t2.indexOf("-") && H$2.test(o2) ? o2 = o2.replace(Y$1, "-$&").toLowerCase() : null === i2 && (i2 = void 0) : l2 = o2 = "oninput", "oninput" === l2 && u2[o2 = l2] && (o2 = "oninputCapture"), u2[o2] = i2;
        }
      }
      "select" == t2 && u2.multiple && Array.isArray(u2.value) && (u2.value = P$4(e2.children).forEach(function(n3) {
        n3.props.selected = -1 != u2.value.indexOf(n3.props.value);
      })), "select" == t2 && null != u2.defaultValue && (u2.value = P$4(e2.children).forEach(function(n3) {
        n3.props.selected = u2.multiple ? -1 != u2.defaultValue.indexOf(n3.props.value) : u2.defaultValue == n3.props.value;
      })), n2.props = u2, e2.class != e2.className && (en.enumerable = "className" in e2, null != e2.className && (u2.class = e2.className), Object.defineProperty(u2, "className", en));
    }
    n2.$$typeof = B$2, rn && rn(n2);
  };
  var un = l$2.__r;
  l$2.__r = function(n2) {
    un && un(n2), tn = n2.__c;
  };
  var on = l$2.diffed;
  l$2.diffed = function(n2) {
    on && on(n2);
    var t2 = n2.props, e2 = n2.__e;
    null != e2 && "textarea" === n2.type && "value" in t2 && t2.value !== e2.value && (e2.value = null == t2.value ? "" : t2.value), tn = null;
  };
  var ln = { ReactCurrentDispatcher: { current: { readContext: function(n2) {
    return tn.__n[n2.__c].props.value;
  } } } }, cn = "17.0.2";
  function fn(n2) {
    return y$3.bind(null, n2);
  }
  function an(n2) {
    return !!n2 && n2.$$typeof === B$2;
  }
  function sn(n2) {
    return an(n2) ? E$3.apply(null, arguments) : n2;
  }
  function hn(n2) {
    return !!n2.__k && (B$4(null, n2), true);
  }
  function vn(n2) {
    return n2 && (n2.base || 1 === n2.nodeType && n2) || null;
  }
  var dn = function(n2, t2) {
    return n2(t2);
  }, pn = function(n2, t2) {
    return n2(t2);
  }, mn = _$4;
  function yn(n2) {
    n2();
  }
  function _n(n2) {
    return n2;
  }
  function bn() {
    return [false, yn];
  }
  var Sn = y$2;
  function gn(n2, t2) {
    var e2 = t2(), r2 = h$2({ h: { __: e2, v: t2 } }), u2 = r2[0].h, o2 = r2[1];
    return y$2(function() {
      u2.__ = e2, u2.v = t2, E$2(u2.__, t2()) || o2({ h: u2 });
    }, [n2, e2, t2]), p$2(function() {
      return E$2(u2.__, u2.v()) || o2({ h: u2 }), n2(function() {
        E$2(u2.__, u2.v()) || o2({ h: u2 });
      });
    }, [n2]), e2;
  }
  var Cn = { useState: h$2, useId: V$2, useReducer: s, useEffect: p$2, useLayoutEffect: y$2, useInsertionEffect: Sn, useTransition: bn, useDeferredValue: _n, useSyncExternalStore: gn, startTransition: yn, useRef: _$3, useImperativeHandle: A$4, useMemo: F$3, useCallback: T$3, useContext: q$4, useDebugValue: x$3, version: "17.0.2", Children: O$1, render: G$1, hydrate: J$1, unmountComponentAtNode: hn, createPortal: z$3, createElement: y$3, createContext: F$4, createFactory: fn, cloneElement: sn, createRef: d$3, Fragment: _$4, isValidElement: an, findDOMNode: vn, Component: k$5, PureComponent: w$2, memo: x$2, forwardRef: k$3, flushSync: pn, unstable_batchedUpdates: dn, StrictMode: mn, Suspense: D$1, SuspenseList: V$1, lazy: M$2, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: ln };
  const compat_module = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    Children: O$1,
    Component: k$5,
    Fragment: _$4,
    PureComponent: w$2,
    StrictMode: mn,
    Suspense: D$1,
    SuspenseList: V$1,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: ln,
    cloneElement: sn,
    createContext: F$4,
    createElement: y$3,
    createFactory: fn,
    createPortal: z$3,
    createRef: d$3,
    default: Cn,
    findDOMNode: vn,
    flushSync: pn,
    forwardRef: k$3,
    hydrate: J$1,
    isValidElement: an,
    lazy: M$2,
    memo: x$2,
    render: G$1,
    startTransition: yn,
    unmountComponentAtNode: hn,
    unstable_batchedUpdates: dn,
    useCallback: T$3,
    useContext: q$4,
    useDebugValue: x$3,
    useDeferredValue: _n,
    useEffect: p$2,
    useErrorBoundary: P$3,
    useId: V$2,
    useImperativeHandle: A$4,
    useInsertionEffect: Sn,
    useLayoutEffect: y$2,
    useMemo: F$3,
    useReducer: s,
    useRef: _$3,
    useState: h$2,
    useSyncExternalStore: gn,
    useTransition: bn,
    version: cn
  }, Symbol.toStringTag, { value: "Module" }));
  function r$1(e2) {
    var t2, f2, n2 = "";
    if ("string" == typeof e2 || "number" == typeof e2)
      n2 += e2;
    else if ("object" == typeof e2)
      if (Array.isArray(e2))
        for (t2 = 0; t2 < e2.length; t2++)
          e2[t2] && (f2 = r$1(e2[t2])) && (n2 && (n2 += " "), n2 += f2);
      else
        for (t2 in e2)
          e2[t2] && (n2 && (n2 += " "), n2 += t2);
    return n2;
  }
  function clsx() {
    for (var e2, t2, f2 = 0, n2 = ""; f2 < arguments.length; )
      (e2 = arguments[f2++]) && (t2 = r$1(e2)) && (n2 && (n2 += " "), n2 += t2);
    return n2;
  }
  const u = (t2) => "number" == typeof t2 && !isNaN(t2), d$1 = (t2) => "string" == typeof t2, p$1 = (t2) => "function" == typeof t2, m$1 = (t2) => d$1(t2) || p$1(t2) ? t2 : null, f$1 = (t2) => an(t2) || d$1(t2) || p$1(t2) || u(t2);
  function g$2(t2, e2, n2) {
    void 0 === n2 && (n2 = 300);
    const { scrollHeight: o2, style: s2 } = t2;
    requestAnimationFrame(() => {
      s2.minHeight = "initial", s2.height = o2 + "px", s2.transition = `all ${n2}ms`, requestAnimationFrame(() => {
        s2.height = "0", s2.padding = "0", s2.margin = "0", setTimeout(e2, n2);
      });
    });
  }
  function h$1(e2) {
    let { enter: a2, exit: r2, appendPosition: i2 = false, collapse: l2 = true, collapseDuration: c2 = 300 } = e2;
    return function(e3) {
      let { children: u2, position: d2, preventExitTransition: p2, done: m2, nodeRef: f2, isIn: h2 } = e3;
      const y2 = i2 ? `${a2}--${d2}` : a2, v2 = i2 ? `${r2}--${d2}` : r2, T2 = _$3(0);
      return y$2(() => {
        const t2 = f2.current, e4 = y2.split(" "), n2 = (o2) => {
          o2.target === f2.current && (t2.dispatchEvent(new Event("d")), t2.removeEventListener("animationend", n2), t2.removeEventListener("animationcancel", n2), 0 === T2.current && "animationcancel" !== o2.type && t2.classList.remove(...e4));
        };
        t2.classList.add(...e4), t2.addEventListener("animationend", n2), t2.addEventListener("animationcancel", n2);
      }, []), p$2(() => {
        const t2 = f2.current, e4 = () => {
          t2.removeEventListener("animationend", e4), l2 ? g$2(t2, m2, c2) : m2();
        };
        h2 || (p2 ? e4() : (T2.current = 1, t2.className += ` ${v2}`, t2.addEventListener("animationend", e4)));
      }, [h2]), Cn.createElement(Cn.Fragment, null, u2);
    };
  }
  function y$1(t2, e2) {
    return { content: t2.content, containerId: t2.props.containerId, id: t2.props.toastId, theme: t2.props.theme, type: t2.props.type, data: t2.props.data || {}, isLoading: t2.props.isLoading, icon: t2.props.icon, status: e2 };
  }
  const v$2 = { list: /* @__PURE__ */ new Map(), emitQueue: /* @__PURE__ */ new Map(), on(t2, e2) {
    return this.list.has(t2) || this.list.set(t2, []), this.list.get(t2).push(e2), this;
  }, off(t2, e2) {
    if (e2) {
      const n2 = this.list.get(t2).filter((t3) => t3 !== e2);
      return this.list.set(t2, n2), this;
    }
    return this.list.delete(t2), this;
  }, cancelEmit(t2) {
    const e2 = this.emitQueue.get(t2);
    return e2 && (e2.forEach(clearTimeout), this.emitQueue.delete(t2)), this;
  }, emit(t2) {
    this.list.has(t2) && this.list.get(t2).forEach((e2) => {
      const n2 = setTimeout(() => {
        e2(...[].slice.call(arguments, 1));
      }, 0);
      this.emitQueue.has(t2) || this.emitQueue.set(t2, []), this.emitQueue.get(t2).push(n2);
    });
  } }, T$1 = (e2) => {
    let { theme: n2, type: o2, ...s2 } = e2;
    return Cn.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: "colored" === n2 ? "currentColor" : `var(--toastify-icon-color-${o2})`, ...s2 });
  }, E$1 = { info: function(e2) {
    return Cn.createElement(T$1, { ...e2 }, Cn.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
  }, warning: function(e2) {
    return Cn.createElement(T$1, { ...e2 }, Cn.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
  }, success: function(e2) {
    return Cn.createElement(T$1, { ...e2 }, Cn.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
  }, error: function(e2) {
    return Cn.createElement(T$1, { ...e2 }, Cn.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
  }, spinner: function() {
    return Cn.createElement("div", { className: "Toastify__spinner" });
  } };
  function C(t2) {
    const [, o2] = s((t3) => t3 + 1, 0), [l2, c2] = h$2([]), g2 = _$3(null), h2 = _$3(/* @__PURE__ */ new Map()).current, T2 = (t3) => -1 !== l2.indexOf(t3), C2 = _$3({ toastKey: 1, displayedToast: 0, count: 0, queue: [], props: t2, containerId: null, isToastActive: T2, getToast: (t3) => h2.get(t3) }).current;
    function I2(t3) {
      let { containerId: e2 } = t3;
      const { limit: n2 } = C2.props;
      !n2 || e2 && C2.containerId !== e2 || (C2.count -= C2.queue.length, C2.queue = []);
    }
    function b2(t3) {
      c2((e2) => null == t3 ? [] : e2.filter((e3) => e3 !== t3));
    }
    function _2() {
      const { toastContent: t3, toastProps: e2, staleId: n2 } = C2.queue.shift();
      O2(t3, e2, n2);
    }
    function L2(t3, n2) {
      let { delay: s2, staleId: r2, ...i2 } = n2;
      if (!f$1(t3) || function(t4) {
        return !g2.current || C2.props.enableMultiContainer && t4.containerId !== C2.props.containerId || h2.has(t4.toastId) && null == t4.updateId;
      }(i2))
        return;
      const { toastId: l3, updateId: c3, data: T3 } = i2, { props: I3 } = C2, L3 = () => b2(l3), N2 = null == c3;
      N2 && C2.count++;
      const M2 = { ...I3, style: I3.toastStyle, key: C2.toastKey++, ...i2, toastId: l3, updateId: c3, data: T3, closeToast: L3, isIn: false, className: m$1(i2.className || I3.toastClassName), bodyClassName: m$1(i2.bodyClassName || I3.bodyClassName), progressClassName: m$1(i2.progressClassName || I3.progressClassName), autoClose: !i2.isLoading && (R2 = i2.autoClose, w2 = I3.autoClose, false === R2 || u(R2) && R2 > 0 ? R2 : w2), deleteToast() {
        const t4 = y$1(h2.get(l3), "removed");
        h2.delete(l3), v$2.emit(4, t4);
        const e2 = C2.queue.length;
        if (C2.count = null == l3 ? C2.count - C2.displayedToast : C2.count - 1, C2.count < 0 && (C2.count = 0), e2 > 0) {
          const t5 = null == l3 ? C2.props.limit : 1;
          if (1 === e2 || 1 === t5)
            C2.displayedToast++, _2();
          else {
            const n3 = t5 > e2 ? e2 : t5;
            C2.displayedToast = n3;
            for (let t6 = 0; t6 < n3; t6++)
              _2();
          }
        } else
          o2();
      } };
      var R2, w2;
      M2.iconOut = function(t4) {
        let { theme: n3, type: o3, isLoading: s3, icon: r3 } = t4, i3 = null;
        const l4 = { theme: n3, type: o3 };
        return false === r3 || (p$1(r3) ? i3 = r3(l4) : an(r3) ? i3 = sn(r3, l4) : d$1(r3) || u(r3) ? i3 = r3 : s3 ? i3 = E$1.spinner() : ((t5) => t5 in E$1)(o3) && (i3 = E$1[o3](l4))), i3;
      }(M2), p$1(i2.onOpen) && (M2.onOpen = i2.onOpen), p$1(i2.onClose) && (M2.onClose = i2.onClose), M2.closeButton = I3.closeButton, false === i2.closeButton || f$1(i2.closeButton) ? M2.closeButton = i2.closeButton : true === i2.closeButton && (M2.closeButton = !f$1(I3.closeButton) || I3.closeButton);
      let x2 = t3;
      an(t3) && !d$1(t3.type) ? x2 = sn(t3, { closeToast: L3, toastProps: M2, data: T3 }) : p$1(t3) && (x2 = t3({ closeToast: L3, toastProps: M2, data: T3 })), I3.limit && I3.limit > 0 && C2.count > I3.limit && N2 ? C2.queue.push({ toastContent: x2, toastProps: M2, staleId: r2 }) : u(s2) ? setTimeout(() => {
        O2(x2, M2, r2);
      }, s2) : O2(x2, M2, r2);
    }
    function O2(t3, e2, n2) {
      const { toastId: o3 } = e2;
      n2 && h2.delete(n2);
      const s2 = { content: t3, props: e2 };
      h2.set(o3, s2), c2((t4) => [...t4, o3].filter((t5) => t5 !== n2)), v$2.emit(4, y$1(s2, null == s2.props.updateId ? "added" : "updated"));
    }
    return p$2(() => (C2.containerId = t2.containerId, v$2.cancelEmit(3).on(0, L2).on(1, (t3) => g2.current && b2(t3)).on(5, I2).emit(2, C2), () => {
      h2.clear(), v$2.emit(3, C2);
    }), []), p$2(() => {
      C2.props = t2, C2.isToastActive = T2, C2.displayedToast = l2.length;
    }), { getToastToRender: function(e2) {
      const n2 = /* @__PURE__ */ new Map(), o3 = Array.from(h2.values());
      return t2.newestOnTop && o3.reverse(), o3.forEach((t3) => {
        const { position: e3 } = t3.props;
        n2.has(e3) || n2.set(e3, []), n2.get(e3).push(t3);
      }), Array.from(n2, (t3) => e2(t3[0], t3[1]));
    }, containerRef: g2, isToastActive: T2 };
  }
  function I$1(t2) {
    return t2.targetTouches && t2.targetTouches.length >= 1 ? t2.targetTouches[0].clientX : t2.clientX;
  }
  function b$2(t2) {
    return t2.targetTouches && t2.targetTouches.length >= 1 ? t2.targetTouches[0].clientY : t2.clientY;
  }
  function _$2(t2) {
    const [o2, a2] = h$2(false), [r2, l2] = h$2(false), c2 = _$3(null), u2 = _$3({ start: 0, x: 0, y: 0, delta: 0, removalDistance: 0, canCloseOnClick: true, canDrag: false, boundingRect: null, didMove: false }).current, d2 = _$3(t2), { autoClose: m2, pauseOnHover: f2, closeToast: g2, onClick: h2, closeOnClick: y2 } = t2;
    function v2(e2) {
      if (t2.draggable) {
        "touchstart" === e2.nativeEvent.type && e2.nativeEvent.preventDefault(), u2.didMove = false, document.addEventListener("mousemove", _2), document.addEventListener("mouseup", L2), document.addEventListener("touchmove", _2), document.addEventListener("touchend", L2);
        const n2 = c2.current;
        u2.canCloseOnClick = true, u2.canDrag = true, u2.boundingRect = n2.getBoundingClientRect(), n2.style.transition = "", u2.x = I$1(e2.nativeEvent), u2.y = b$2(e2.nativeEvent), "x" === t2.draggableDirection ? (u2.start = u2.x, u2.removalDistance = n2.offsetWidth * (t2.draggablePercent / 100)) : (u2.start = u2.y, u2.removalDistance = n2.offsetHeight * (80 === t2.draggablePercent ? 1.5 * t2.draggablePercent : t2.draggablePercent / 100));
      }
    }
    function T2(e2) {
      if (u2.boundingRect) {
        const { top: n2, bottom: o3, left: s2, right: a3 } = u2.boundingRect;
        "touchend" !== e2.nativeEvent.type && t2.pauseOnHover && u2.x >= s2 && u2.x <= a3 && u2.y >= n2 && u2.y <= o3 ? C2() : E2();
      }
    }
    function E2() {
      a2(true);
    }
    function C2() {
      a2(false);
    }
    function _2(e2) {
      const n2 = c2.current;
      u2.canDrag && n2 && (u2.didMove = true, o2 && C2(), u2.x = I$1(e2), u2.y = b$2(e2), u2.delta = "x" === t2.draggableDirection ? u2.x - u2.start : u2.y - u2.start, u2.start !== u2.x && (u2.canCloseOnClick = false), n2.style.transform = `translate${t2.draggableDirection}(${u2.delta}px)`, n2.style.opacity = "" + (1 - Math.abs(u2.delta / u2.removalDistance)));
    }
    function L2() {
      document.removeEventListener("mousemove", _2), document.removeEventListener("mouseup", L2), document.removeEventListener("touchmove", _2), document.removeEventListener("touchend", L2);
      const e2 = c2.current;
      if (u2.canDrag && u2.didMove && e2) {
        if (u2.canDrag = false, Math.abs(u2.delta) > u2.removalDistance)
          return l2(true), void t2.closeToast();
        e2.style.transition = "transform 0.2s, opacity 0.2s", e2.style.transform = `translate${t2.draggableDirection}(0)`, e2.style.opacity = "1";
      }
    }
    p$2(() => {
      d2.current = t2;
    }), p$2(() => (c2.current && c2.current.addEventListener("d", E2, { once: true }), p$1(t2.onOpen) && t2.onOpen(an(t2.children) && t2.children.props), () => {
      const t3 = d2.current;
      p$1(t3.onClose) && t3.onClose(an(t3.children) && t3.children.props);
    }), []), p$2(() => (t2.pauseOnFocusLoss && (document.hasFocus() || C2(), window.addEventListener("focus", E2), window.addEventListener("blur", C2)), () => {
      t2.pauseOnFocusLoss && (window.removeEventListener("focus", E2), window.removeEventListener("blur", C2));
    }), [t2.pauseOnFocusLoss]);
    const O2 = { onMouseDown: v2, onTouchStart: v2, onMouseUp: T2, onTouchEnd: T2 };
    return m2 && f2 && (O2.onMouseEnter = C2, O2.onMouseLeave = E2), y2 && (O2.onClick = (t3) => {
      h2 && h2(t3), u2.canCloseOnClick && g2();
    }), { playToast: E2, pauseToast: C2, isRunning: o2, preventExitTransition: r2, toastRef: c2, eventHandlers: O2 };
  }
  function L$1(e2) {
    let { closeToast: n2, theme: o2, ariaLabel: s2 = "close" } = e2;
    return Cn.createElement("button", { className: `Toastify__close-button Toastify__close-button--${o2}`, type: "button", onClick: (t2) => {
      t2.stopPropagation(), n2(t2);
    }, "aria-label": s2 }, Cn.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, Cn.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
  }
  function O(e2) {
    let { delay: n2, isRunning: o2, closeToast: s2, type: a2 = "default", hide: r2, className: i2, style: l2, controlledProgress: u2, progress: d2, rtl: m2, isIn: f2, theme: g2 } = e2;
    const h2 = r2 || u2 && 0 === d2, y2 = { ...l2, animationDuration: `${n2}ms`, animationPlayState: o2 ? "running" : "paused", opacity: h2 ? 0 : 1 };
    u2 && (y2.transform = `scaleX(${d2})`);
    const v2 = clsx("Toastify__progress-bar", u2 ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g2}`, `Toastify__progress-bar--${a2}`, { "Toastify__progress-bar--rtl": m2 }), T2 = p$1(i2) ? i2({ rtl: m2, type: a2, defaultClassName: v2 }) : clsx(v2, i2);
    return Cn.createElement("div", { role: "progressbar", "aria-hidden": h2 ? "true" : "false", "aria-label": "notification timer", className: T2, style: y2, [u2 && d2 >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u2 && d2 < 1 ? null : () => {
      f2 && s2();
    } });
  }
  const N$1 = (n2) => {
    const { isRunning: o2, preventExitTransition: s2, toastRef: r2, eventHandlers: i2 } = _$2(n2), { closeButton: l2, children: u2, autoClose: d2, onClick: m2, type: f2, hideProgressBar: g2, closeToast: h2, transition: y2, position: v2, className: T2, style: E2, bodyClassName: C2, bodyStyle: I2, progressClassName: b2, progressStyle: N2, updateId: M2, role: R2, progress: w2, rtl: x2, toastId: $2, deleteToast: k2, isIn: P2, isLoading: B2, iconOut: D2, closeOnClick: A2, theme: z2 } = n2, F2 = clsx("Toastify__toast", `Toastify__toast-theme--${z2}`, `Toastify__toast--${f2}`, { "Toastify__toast--rtl": x2 }, { "Toastify__toast--close-on-click": A2 }), H2 = p$1(T2) ? T2({ rtl: x2, position: v2, type: f2, defaultClassName: F2 }) : clsx(F2, T2), S2 = !!w2 || !d2, q2 = { closeToast: h2, type: f2, theme: z2 };
    let Q2 = null;
    return false === l2 || (Q2 = p$1(l2) ? l2(q2) : an(l2) ? sn(l2, q2) : L$1(q2)), Cn.createElement(y2, { isIn: P2, done: k2, position: v2, preventExitTransition: s2, nodeRef: r2 }, Cn.createElement("div", { id: $2, onClick: m2, className: H2, ...i2, style: E2, ref: r2 }, Cn.createElement("div", { ...P2 && { role: R2 }, className: p$1(C2) ? C2({ type: f2 }) : clsx("Toastify__toast-body", C2), style: I2 }, null != D2 && Cn.createElement("div", { className: clsx("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !B2 }) }, D2), Cn.createElement("div", null, u2)), Q2, Cn.createElement(O, { ...M2 && !S2 ? { key: `pb-${M2}` } : {}, rtl: x2, theme: z2, delay: d2, isRunning: o2, isIn: P2, closeToast: h2, hide: g2, type: f2, style: N2, className: b2, controlledProgress: S2, progress: w2 || 0 })));
  }, M$1 = function(t2, e2) {
    return void 0 === e2 && (e2 = false), { enter: `Toastify--animate Toastify__${t2}-enter`, exit: `Toastify--animate Toastify__${t2}-exit`, appendPosition: e2 };
  }, R = h$1(M$1("bounce", true));
  h$1(M$1("slide", true));
  h$1(M$1("zoom"));
  h$1(M$1("flip"));
  const k$2 = k$3((e2, n2) => {
    const { getToastToRender: o2, containerRef: a2, isToastActive: r2 } = C(e2), { className: i2, style: l2, rtl: u2, containerId: d2 } = e2;
    function f2(t2) {
      const e3 = clsx("Toastify__toast-container", `Toastify__toast-container--${t2}`, { "Toastify__toast-container--rtl": u2 });
      return p$1(i2) ? i2({ position: t2, rtl: u2, defaultClassName: e3 }) : clsx(e3, m$1(i2));
    }
    return p$2(() => {
      n2 && (n2.current = a2.current);
    }, []), Cn.createElement("div", { ref: a2, className: "Toastify", id: d2 }, o2((e3, n3) => {
      const o3 = n3.length ? { ...l2 } : { ...l2, pointerEvents: "none" };
      return Cn.createElement("div", { className: f2(e3), style: o3, key: `container-${e3}` }, n3.map((e4, o4) => {
        let { content: s2, props: a3 } = e4;
        return Cn.createElement(N$1, { ...a3, isIn: r2(a3.toastId), style: { ...a3.style, "--nth": o4 + 1, "--len": n3.length }, key: `toast-${a3.key}` }, s2);
      }));
    }));
  });
  k$2.displayName = "ToastContainer", k$2.defaultProps = { position: "top-right", transition: R, autoClose: 5e3, closeButton: L$1, pauseOnHover: true, pauseOnFocusLoss: true, closeOnClick: true, draggable: true, draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
  let P$1, B$1 = /* @__PURE__ */ new Map(), D = [], A$2 = 1;
  function z$2() {
    return "" + A$2++;
  }
  function F$1(t2) {
    return t2 && (d$1(t2.toastId) || u(t2.toastId)) ? t2.toastId : z$2();
  }
  function H$1(t2, e2) {
    return B$1.size > 0 ? v$2.emit(0, t2, e2) : D.push({ content: t2, options: e2 }), e2.toastId;
  }
  function S$1(t2, e2) {
    return { ...e2, type: e2 && e2.type || t2, toastId: F$1(e2) };
  }
  function q$2(t2) {
    return (e2, n2) => H$1(e2, S$1(t2, n2));
  }
  function Q$1(t2, e2) {
    return H$1(t2, S$1("default", e2));
  }
  Q$1.loading = (t2, e2) => H$1(t2, S$1("default", { isLoading: true, autoClose: false, closeOnClick: false, closeButton: false, draggable: false, ...e2 })), Q$1.promise = function(t2, e2, n2) {
    let o2, { pending: s2, error: a2, success: r2 } = e2;
    s2 && (o2 = d$1(s2) ? Q$1.loading(s2, n2) : Q$1.loading(s2.render, { ...n2, ...s2 }));
    const i2 = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null, delay: 100 }, l2 = (t3, e3, s3) => {
      if (null == e3)
        return void Q$1.dismiss(o2);
      const a3 = { type: t3, ...i2, ...n2, data: s3 }, r3 = d$1(e3) ? { render: e3 } : e3;
      return o2 ? Q$1.update(o2, { ...a3, ...r3 }) : Q$1(r3.render, { ...a3, ...r3 }), s3;
    }, c2 = p$1(t2) ? t2() : t2;
    return c2.then((t3) => l2("success", r2, t3)).catch((t3) => l2("error", a2, t3)), c2;
  }, Q$1.success = q$2("success"), Q$1.info = q$2("info"), Q$1.error = q$2("error"), Q$1.warning = q$2("warning"), Q$1.warn = Q$1.warning, Q$1.dark = (t2, e2) => H$1(t2, S$1("default", { theme: "dark", ...e2 })), Q$1.dismiss = (t2) => {
    B$1.size > 0 ? v$2.emit(1, t2) : D = D.filter((e2) => null != t2 && e2.options.toastId !== t2);
  }, Q$1.clearWaitingQueue = function(t2) {
    return void 0 === t2 && (t2 = {}), v$2.emit(5, t2);
  }, Q$1.isActive = (t2) => {
    let e2 = false;
    return B$1.forEach((n2) => {
      n2.isToastActive && n2.isToastActive(t2) && (e2 = true);
    }), e2;
  }, Q$1.update = function(t2, e2) {
    void 0 === e2 && (e2 = {}), setTimeout(() => {
      const n2 = function(t3, e3) {
        let { containerId: n3 } = e3;
        const o2 = B$1.get(n3 || P$1);
        return o2 && o2.getToast(t3);
      }(t2, e2);
      if (n2) {
        const { props: o2, content: s2 } = n2, a2 = { ...o2, ...e2, toastId: e2.toastId || t2, updateId: z$2() };
        a2.toastId !== t2 && (a2.staleId = t2);
        const r2 = a2.render || s2;
        delete a2.render, H$1(r2, a2);
      }
    }, 0);
  }, Q$1.done = (t2) => {
    Q$1.update(t2, { progress: 1 });
  }, Q$1.onChange = (t2) => (v$2.on(4, t2), () => {
    v$2.off(4, t2);
  }), Q$1.POSITION = { TOP_LEFT: "top-left", TOP_RIGHT: "top-right", TOP_CENTER: "top-center", BOTTOM_LEFT: "bottom-left", BOTTOM_RIGHT: "bottom-right", BOTTOM_CENTER: "bottom-center" }, Q$1.TYPE = { INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error", DEFAULT: "default" }, v$2.on(2, (t2) => {
    P$1 = t2.containerId || t2, B$1.set(P$1, t2), D.forEach((t3) => {
      v$2.emit(0, t3.content, t3.options);
    }), D = [];
  }).on(3, (t2) => {
    B$1.delete(t2.containerId || t2), 0 === B$1.size && v$2.off(0).off(1).off(5);
  });
  const ConfigContext = F$4("config");
  /*
    @license
    The MIT License (MIT)
  
    Copyright (c) 2016 Shopify Inc.
  
    Permission is hereby granted, free of charge, to any person obtaining a
    copy of this software and associated documentation files (the
    "Software"), to deal in the Software without restriction, including
    without limitation the rights to use, copy, modify, merge, publish,
    distribute, sublicense, and/or sell copies of the Software, and to
    permit persons to whom the Software is furnished to do so, subject to
    the following conditions:
  
    The above copyright notice and this permission notice shall be included
    in all copies or substantial portions of the Software.
  
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
    IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
    CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
    TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
    SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  
    */
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var classCallCheck$1 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  var createClass$1 = function() {
    function defineProperties(target2, props) {
      for (var i2 = 0; i2 < props.length; i2++) {
        var descriptor = props[i2];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target2, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var inherits$1 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };
  var possibleConstructorReturn$1 = function(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  };
  function join() {
    for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
      fields[_key] = arguments[_key];
    }
    return fields.join(" ");
  }
  function isObject$1(value) {
    return Boolean(value) && Object.prototype.toString.call(value.valueOf()) === "[object Object]";
  }
  function deepFreezeCopyExcept(predicate, structure) {
    if (predicate(structure)) {
      return structure;
    } else if (isObject$1(structure)) {
      return Object.freeze(Object.keys(structure).reduce(function(copy2, key) {
        copy2[key] = deepFreezeCopyExcept(predicate, structure[key]);
        return copy2;
      }, {}));
    } else if (Array.isArray(structure)) {
      return Object.freeze(structure.map(function(item) {
        return deepFreezeCopyExcept(predicate, item);
      }));
    } else {
      return structure;
    }
  }
  function schemaForType(typeBundle, typeName) {
    var typeSchema = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var type = typeBundle.types[typeName];
    if (type) {
      return type;
    } else if (typeSchema && typeSchema.kind === "INTERFACE") {
      return typeSchema;
    }
    throw new Error("No type of " + typeName + " found in schema");
  }
  var classCallCheck = function classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  var createClass = function() {
    function defineProperties(target2, props) {
      for (var i2 = 0; i2 < props.length; i2++) {
        var descriptor = props[i2];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target2, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _extends$3 = Object.assign || function(target2) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target2[key] = source[key];
        }
      }
    }
    return target2;
  };
  var inherits$2 = function inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };
  var possibleConstructorReturn = function possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self2;
  };
  var slicedToArray = function() {
    function sliceIterator(arr, i2) {
      var _arr = [];
      var _n2 = true;
      var _d = false;
      var _e2 = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
          _arr.push(_s.value);
          if (i2 && _arr.length === i2)
            break;
        }
      } catch (err) {
        _d = true;
        _e2 = err;
      } finally {
        try {
          if (!_n2 && _i["return"])
            _i["return"]();
        } finally {
          if (_d)
            throw _e2;
        }
      }
      return _arr;
    }
    return function(arr, i2) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i2);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
  var toConsumableArray = function toConsumableArray2(arr) {
    if (Array.isArray(arr)) {
      for (var i2 = 0, arr2 = Array(arr.length); i2 < arr.length; i2++) {
        arr2[i2] = arr[i2];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  };
  var VariableDefinition = function() {
    function VariableDefinition2(name, type, defaultValue) {
      classCallCheck(this, VariableDefinition2);
      this.name = name;
      this.type = type;
      this.defaultValue = defaultValue;
      Object.freeze(this);
    }
    createClass(VariableDefinition2, [{
      key: "toInputValueString",
      value: function toInputValueString() {
        return "$" + this.name;
      }
      /**
       * Returns the GraphQL query string for the variable (e.g. `$variableName:VariableType = defaultValue`).
       *
       * @return {String} The GraphQL query string for the variable.
       */
    }, {
      key: "toString",
      value: function toString2() {
        var defaultValueString = this.defaultValue ? " = " + formatInputValue(this.defaultValue) : "";
        return "$" + this.name + ":" + this.type + defaultValueString;
      }
    }]);
    return VariableDefinition2;
  }();
  function isVariable(value) {
    return VariableDefinition.prototype.isPrototypeOf(value);
  }
  function variable(name, type, defaultValue) {
    return new VariableDefinition(name, type, defaultValue);
  }
  var Enum = function() {
    function Enum2(key) {
      classCallCheck(this, Enum2);
      this.key = key;
    }
    createClass(Enum2, [{
      key: "toString",
      value: function toString2() {
        return this.key;
      }
    }, {
      key: "valueOf",
      value: function valueOf() {
        return this.key.valueOf();
      }
    }]);
    return Enum2;
  }();
  var enumFunction = function enumFunction2(key) {
    return new Enum(key);
  };
  var Scalar = function() {
    function Scalar2(value) {
      classCallCheck(this, Scalar2);
      this.value = value;
    }
    createClass(Scalar2, [{
      key: "toString",
      value: function toString2() {
        return this.value.toString();
      }
    }, {
      key: "valueOf",
      value: function valueOf() {
        return this.value.valueOf();
      }
    }, {
      key: "unwrapped",
      get: function get$$1() {
        return this.value;
      }
    }]);
    return Scalar2;
  }();
  function formatInputValue(value) {
    if (VariableDefinition.prototype.isPrototypeOf(value)) {
      return value.toInputValueString();
    } else if (Enum.prototype.isPrototypeOf(value)) {
      return String(value);
    } else if (Scalar.prototype.isPrototypeOf(value)) {
      return JSON.stringify(value.valueOf());
    } else if (Array.isArray(value)) {
      return "[" + join.apply(void 0, toConsumableArray(value.map(formatInputValue))) + "]";
    } else if (isObject$1(value)) {
      return formatObject(value, "{", "}");
    } else {
      return JSON.stringify(value);
    }
  }
  function formatObject(value) {
    var openChar = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var closeChar = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var argPairs = Object.keys(value).map(function(key) {
      return key + ": " + formatInputValue(value[key]);
    });
    return "" + openChar + join.apply(void 0, toConsumableArray(argPairs)) + closeChar;
  }
  function formatArgs(args) {
    if (!Object.keys(args).length) {
      return "";
    }
    return " (" + formatObject(args) + ")";
  }
  function formatDirectives(directives) {
    if (!Object.keys(directives).length) {
      return "";
    }
    var directiveStrings = Object.keys(directives).map(function(key) {
      var directiveArgs = directives[key];
      var arg = directiveArgs && Object.keys(directiveArgs).length ? "(" + formatObject(directiveArgs) + ")" : "";
      return "@" + key + arg;
    });
    return " " + join.apply(void 0, toConsumableArray(directiveStrings));
  }
  var noop$2 = function noop2() {
  };
  var Profiler = {
    trackTypeDependency: noop$2,
    trackFieldDependency: noop$2
  };
  var trackTypeDependency = Profiler.trackTypeDependency;
  var trackFieldDependency = Profiler.trackFieldDependency;
  function parseFieldCreationArgs(creationArgs) {
    var callback2 = noop$2;
    var options = {};
    var selectionSet = null;
    if (creationArgs.length === 2) {
      if (typeof creationArgs[1] === "function") {
        var _creationArgs = slicedToArray(creationArgs, 2);
        options = _creationArgs[0];
        callback2 = _creationArgs[1];
      } else {
        var _creationArgs2 = slicedToArray(creationArgs, 2);
        options = _creationArgs2[0];
        selectionSet = _creationArgs2[1];
      }
    } else if (creationArgs.length === 1) {
      if (SelectionSet.prototype.isPrototypeOf(creationArgs[0])) {
        selectionSet = creationArgs[0];
      } else if (typeof creationArgs[0] === "function") {
        callback2 = creationArgs[0];
      } else {
        options = creationArgs[0];
      }
    }
    return { options, selectionSet, callback: callback2 };
  }
  var emptyArgs = Object.freeze({});
  var emptyDirectives = Object.freeze({});
  var Field = function() {
    function Field2(name, options, selectionSet) {
      classCallCheck(this, Field2);
      this.name = name;
      this.alias = options.alias || null;
      this.responseKey = this.alias || this.name;
      this.args = options.args ? deepFreezeCopyExcept(isVariable, options.args) : emptyArgs;
      this.directives = options.directives ? deepFreezeCopyExcept(isVariable, options.directives) : emptyDirectives;
      this.selectionSet = selectionSet;
      Object.freeze(this);
    }
    createClass(Field2, [{
      key: "toString",
      value: function toString2() {
        var aliasPrefix = this.alias ? this.alias + ": " : "";
        return "" + aliasPrefix + this.name + formatArgs(this.args) + formatDirectives(this.directives) + this.selectionSet;
      }
    }]);
    return Field2;
  }();
  var Spread = function Spread2() {
    classCallCheck(this, Spread2);
  };
  var InlineFragment = function(_Spread) {
    inherits$2(InlineFragment2, _Spread);
    function InlineFragment2(typeName, selectionSet) {
      classCallCheck(this, InlineFragment2);
      var _this = possibleConstructorReturn(this, (InlineFragment2.__proto__ || Object.getPrototypeOf(InlineFragment2)).call(this));
      _this.typeName = typeName;
      _this.selectionSet = selectionSet;
      Object.freeze(_this);
      return _this;
    }
    createClass(InlineFragment2, [{
      key: "toString",
      value: function toString2() {
        return "... on " + this.typeName + this.selectionSet;
      }
    }]);
    return InlineFragment2;
  }(Spread);
  var FragmentSpread = function(_Spread2) {
    inherits$2(FragmentSpread2, _Spread2);
    function FragmentSpread2(fragmentDefinition) {
      classCallCheck(this, FragmentSpread2);
      var _this2 = possibleConstructorReturn(this, (FragmentSpread2.__proto__ || Object.getPrototypeOf(FragmentSpread2)).call(this));
      _this2.name = fragmentDefinition.name;
      _this2.selectionSet = fragmentDefinition.selectionSet;
      Object.freeze(_this2);
      return _this2;
    }
    createClass(FragmentSpread2, [{
      key: "toString",
      value: function toString2() {
        return "..." + this.name;
      }
    }, {
      key: "toDefinition",
      value: function toDefinition() {
        return new FragmentDefinition(this.name, this.selectionSet.typeSchema.name, this.selectionSet);
      }
    }]);
    return FragmentSpread2;
  }(Spread);
  var FragmentDefinition = function() {
    function FragmentDefinition2(name, typeName, selectionSet) {
      classCallCheck(this, FragmentDefinition2);
      this.name = name;
      this.typeName = typeName;
      this.selectionSet = selectionSet;
      this.spread = new FragmentSpread(this);
      Object.freeze(this);
    }
    createClass(FragmentDefinition2, [{
      key: "toString",
      value: function toString2() {
        return "fragment " + this.name + " on " + this.typeName + " " + this.selectionSet;
      }
    }]);
    return FragmentDefinition2;
  }();
  function selectionsHaveIdField(selections) {
    return selections.some(function(fieldOrFragment) {
      if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
        return fieldOrFragment.name === "id";
      } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
        return selectionsHaveIdField(fieldOrFragment.selectionSet.selections);
      }
      return false;
    });
  }
  function selectionsHaveTypenameField(selections) {
    return selections.some(function(fieldOrFragment) {
      if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
        return fieldOrFragment.name === "__typename";
      } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
        return selectionsHaveTypenameField(fieldOrFragment.selectionSet.selections);
      }
      return false;
    });
  }
  function indexSelectionsByResponseKey(selections) {
    function assignOrPush(obj, key, value) {
      if (Array.isArray(obj[key])) {
        obj[key].push(value);
      } else {
        obj[key] = [value];
      }
    }
    var unfrozenObject = selections.reduce(function(acc, selection) {
      if (selection.responseKey) {
        assignOrPush(acc, selection.responseKey, selection);
      } else {
        var responseKeys = Object.keys(selection.selectionSet.selectionsByResponseKey);
        responseKeys.forEach(function(responseKey) {
          assignOrPush(acc, responseKey, selection);
        });
      }
      return acc;
    }, {});
    Object.keys(unfrozenObject).forEach(function(key) {
      Object.freeze(unfrozenObject[key]);
    });
    return Object.freeze(unfrozenObject);
  }
  var SelectionSet = function() {
    function SelectionSet2(typeBundle, type, builderFunction) {
      classCallCheck(this, SelectionSet2);
      if (typeof type === "string") {
        this.typeSchema = schemaForType(typeBundle, type);
      } else {
        this.typeSchema = type;
      }
      trackTypeDependency(this.typeSchema.name);
      this.typeBundle = typeBundle;
      this.selections = [];
      if (builderFunction) {
        builderFunction(new SelectionSetBuilder(this.typeBundle, this.typeSchema, this.selections));
      }
      if (this.typeSchema.implementsNode || this.typeSchema.name === "Node") {
        if (!selectionsHaveIdField(this.selections)) {
          this.selections.unshift(new Field("id", {}, new SelectionSet2(typeBundle, "ID")));
        }
      }
      if (this.typeSchema.kind === "INTERFACE") {
        if (!selectionsHaveTypenameField(this.selections)) {
          this.selections.unshift(new Field("__typename", {}, new SelectionSet2(typeBundle, "String")));
        }
      }
      this.selectionsByResponseKey = indexSelectionsByResponseKey(this.selections);
      Object.freeze(this.selections);
      Object.freeze(this);
    }
    createClass(SelectionSet2, [{
      key: "toString",
      value: function toString2() {
        if (this.typeSchema.kind === "SCALAR" || this.typeSchema.kind === "ENUM") {
          return "";
        } else {
          return " { " + join(this.selections) + " }";
        }
      }
    }]);
    return SelectionSet2;
  }();
  var SelectionSetBuilder = function() {
    function SelectionSetBuilder2(typeBundle, typeSchema, selections) {
      classCallCheck(this, SelectionSetBuilder2);
      this.typeBundle = typeBundle;
      this.typeSchema = typeSchema;
      this.selections = selections;
    }
    createClass(SelectionSetBuilder2, [{
      key: "hasSelectionWithResponseKey",
      value: function hasSelectionWithResponseKey(responseKey) {
        return this.selections.some(function(field) {
          return field.responseKey === responseKey;
        });
      }
      /**
       * Adds a field to be queried on the current selection.
       *
       * @example
       * client.query((root) => {
       *   root.add('cat', {args: {id: '123456'}, alias: 'meow'}, (cat) => {
       *     cat.add('name');
       *   });
       * });
       *
       * @param {SelectionSet|String} selectionOrFieldName The selection or name of the field to add.
       * @param {Object} [options] Options on the query including:
       *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
       *   @param {String} [options.alias] Alias for the field being added.
       * @param {Function|SelectionSet} [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
       */
    }, {
      key: "add",
      value: function add(selectionOrFieldName) {
        var selection = void 0;
        if (Object.prototype.toString.call(selectionOrFieldName) === "[object String]") {
          trackFieldDependency(this.typeSchema.name, selectionOrFieldName);
          for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }
          selection = this.field.apply(this, [selectionOrFieldName].concat(rest));
        } else {
          if (Field.prototype.isPrototypeOf(selectionOrFieldName)) {
            trackFieldDependency(this.typeSchema.name, selectionOrFieldName.name);
          }
          selection = selectionOrFieldName;
        }
        if (selection.responseKey && this.hasSelectionWithResponseKey(selection.responseKey)) {
          throw new Error("The field name or alias '" + selection.responseKey + "' has already been added.");
        }
        this.selections.push(selection);
      }
    }, {
      key: "field",
      value: function field(name) {
        for (var _len2 = arguments.length, creationArgs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          creationArgs[_key2 - 1] = arguments[_key2];
        }
        var parsedArgs = parseFieldCreationArgs(creationArgs);
        var options = parsedArgs.options, callback2 = parsedArgs.callback;
        var selectionSet = parsedArgs.selectionSet;
        if (!selectionSet) {
          if (!this.typeSchema.fieldBaseTypes[name]) {
            throw new Error('No field of name "' + name + '" found on type "' + this.typeSchema.name + '" in schema');
          }
          var fieldBaseType = schemaForType(this.typeBundle, this.typeSchema.fieldBaseTypes[name]);
          selectionSet = new SelectionSet(this.typeBundle, fieldBaseType, callback2);
        }
        return new Field(name, options, selectionSet);
      }
      /**
       * Creates an inline fragment.
       *
       * @access private
       * @param {String} typeName The type  the inline fragment.
       * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
       * @return {InlineFragment} An inline fragment.
       */
    }, {
      key: "inlineFragmentOn",
      value: function inlineFragmentOn(typeName) {
        var builderFunctionOrSelectionSet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$2;
        var selectionSet = void 0;
        if (SelectionSet.prototype.isPrototypeOf(builderFunctionOrSelectionSet)) {
          selectionSet = builderFunctionOrSelectionSet;
        } else {
          selectionSet = new SelectionSet(this.typeBundle, schemaForType(this.typeBundle, typeName), builderFunctionOrSelectionSet);
        }
        return new InlineFragment(typeName, selectionSet);
      }
      /**
       * Adds a field to be queried on the current selection.
       *
       * @access private
       * @param {String}    name The name of the field to add to the query.
       * @param {Object} [options] Options on the query including:
       *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
       *   @param {String} [options.alias] Alias for the field being added.
       * @param {Function}  [callback] Callback which will be used to create a new {@link SelectionSet} for the field added.
       */
    }, {
      key: "addField",
      value: function addField(name) {
        for (var _len3 = arguments.length, creationArgs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          creationArgs[_key3 - 1] = arguments[_key3];
        }
        this.add.apply(this, [name].concat(creationArgs));
      }
      /**
       * Adds a connection to be queried on the current selection.
       * This adds all the fields necessary for pagination.
       *
       * @example
       * client.query((root) => {
       *   root.add('cat', (cat) => {
       *     cat.addConnection('friends', {args: {first: 10}, alias: 'coolCats'}, (friends) => {
       *       friends.add('name');
       *     });
       *   });
       * });
       *
       * @param {String}    name The name of the connection to add to the query.
       * @param {Object} [options] Options on the query including:
       *   @param {Object} [options.args] Arguments on the query (e.g. `{first: 10}`).
       *   @param {String} [options.alias] Alias for the field being added.
       * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
       */
    }, {
      key: "addConnection",
      value: function addConnection(name) {
        for (var _len4 = arguments.length, creationArgs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          creationArgs[_key4 - 1] = arguments[_key4];
        }
        var _parseFieldCreationAr = parseFieldCreationArgs(creationArgs), options = _parseFieldCreationAr.options, callback2 = _parseFieldCreationAr.callback, selectionSet = _parseFieldCreationAr.selectionSet;
        this.add(name, options, function(connection) {
          connection.add("pageInfo", {}, function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          connection.add("edges", {}, function(edges) {
            edges.add("cursor");
            edges.addField("node", {}, selectionSet || callback2);
          });
        });
      }
      /**
       * Adds an inline fragment on the current selection.
       *
       * @example
       * client.query((root) => {
       *   root.add('animal', (animal) => {
       *     animal.addInlineFragmentOn('cat', (cat) => {
       *       cat.add('name');
       *     });
       *   });
       * });
       *
       * @param {String} typeName The name of the type of the inline fragment.
       * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
       */
    }, {
      key: "addInlineFragmentOn",
      value: function addInlineFragmentOn(typeName) {
        var fieldTypeCb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$2;
        this.add(this.inlineFragmentOn(typeName, fieldTypeCb));
      }
      /**
       * Adds a fragment spread on the current selection.
       *
       * @example
       * client.query((root) => {
       *   root.addFragment(catFragmentSpread);
       * });
       *
       * @param {FragmentSpread} fragmentSpread The fragment spread to add.
       */
    }, {
      key: "addFragment",
      value: function addFragment(fragmentSpread) {
        this.add(fragmentSpread);
      }
    }]);
    return SelectionSetBuilder2;
  }();
  function parseArgs(args) {
    var name = void 0;
    var variables = void 0;
    var selectionSetCallback = void 0;
    if (args.length === 3) {
      var _args = slicedToArray(args, 3);
      name = _args[0];
      variables = _args[1];
      selectionSetCallback = _args[2];
    } else if (args.length === 2) {
      if (Object.prototype.toString.call(args[0]) === "[object String]") {
        name = args[0];
        variables = null;
      } else if (Array.isArray(args[0])) {
        variables = args[0];
        name = null;
      }
      selectionSetCallback = args[1];
    } else {
      selectionSetCallback = args[0];
      name = null;
    }
    return { name, variables, selectionSetCallback };
  }
  var VariableDefinitions = function() {
    function VariableDefinitions2(variableDefinitions) {
      classCallCheck(this, VariableDefinitions2);
      this.variableDefinitions = variableDefinitions ? [].concat(toConsumableArray(variableDefinitions)) : [];
      Object.freeze(this.variableDefinitions);
      Object.freeze(this);
    }
    createClass(VariableDefinitions2, [{
      key: "toString",
      value: function toString2() {
        if (this.variableDefinitions.length === 0) {
          return "";
        }
        return " (" + join(this.variableDefinitions) + ") ";
      }
    }]);
    return VariableDefinitions2;
  }();
  var Operation = function() {
    function Operation2(typeBundle, operationType) {
      classCallCheck(this, Operation2);
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      var _parseArgs = parseArgs(args), name = _parseArgs.name, variables = _parseArgs.variables, selectionSetCallback = _parseArgs.selectionSetCallback;
      this.typeBundle = typeBundle;
      this.name = name;
      this.variableDefinitions = new VariableDefinitions(variables);
      this.operationType = operationType;
      if (operationType === "query") {
        this.selectionSet = new SelectionSet(typeBundle, typeBundle.queryType, selectionSetCallback);
        this.typeSchema = schemaForType(typeBundle, typeBundle.queryType);
      } else {
        this.selectionSet = new SelectionSet(typeBundle, typeBundle.mutationType, selectionSetCallback);
        this.typeSchema = schemaForType(typeBundle, typeBundle.mutationType);
      }
      Object.freeze(this);
    }
    createClass(Operation2, [{
      key: "toString",
      /**
       * Returns the GraphQL query or mutation string (e.g. `query myQuery { cat { name } }`).
       *
       * @return {String} The GraphQL query or mutation string.
       */
      value: function toString2() {
        var nameString = this.name ? " " + this.name : "";
        return "" + this.operationType + nameString + this.variableDefinitions + this.selectionSet;
      }
    }, {
      key: "isAnonymous",
      get: function get$$1() {
        return !this.name;
      }
    }]);
    return Operation2;
  }();
  var Query = function(_Operation) {
    inherits$2(Query2, _Operation);
    function Query2(typeBundle) {
      var _ref;
      classCallCheck(this, Query2);
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return possibleConstructorReturn(this, (_ref = Query2.__proto__ || Object.getPrototypeOf(Query2)).call.apply(_ref, [this, typeBundle, "query"].concat(args)));
    }
    return Query2;
  }(Operation);
  var Mutation = function(_Operation) {
    inherits$2(Mutation2, _Operation);
    function Mutation2(typeBundle) {
      var _ref;
      classCallCheck(this, Mutation2);
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return possibleConstructorReturn(this, (_ref = Mutation2.__proto__ || Object.getPrototypeOf(Mutation2)).call.apply(_ref, [this, typeBundle, "mutation"].concat(args)));
    }
    return Mutation2;
  }(Operation);
  function isAnonymous(operation) {
    return operation.isAnonymous;
  }
  function hasAnonymousOperations(operations) {
    return operations.some(isAnonymous);
  }
  function hasDuplicateOperationNames(operations) {
    var names = operations.map(function(operation) {
      return operation.name;
    });
    return names.reduce(function(hasDuplicates, name, index2) {
      return hasDuplicates || names.indexOf(name) !== index2;
    }, false);
  }
  function extractOperation(typeBundle, operationType) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    if (Operation.prototype.isPrototypeOf(args[0])) {
      return args[0];
    }
    if (operationType === "query") {
      return new (Function.prototype.bind.apply(Query, [null].concat([typeBundle], args)))();
    } else {
      return new (Function.prototype.bind.apply(Mutation, [null].concat([typeBundle], args)))();
    }
  }
  function isInvalidOperationCombination(operations) {
    if (operations.length === 1) {
      return false;
    }
    return hasAnonymousOperations(operations) || hasDuplicateOperationNames(operations);
  }
  function fragmentNameIsNotUnique(existingDefinitions, name) {
    return existingDefinitions.some(function(definition) {
      return definition.name === name;
    });
  }
  var Document = function() {
    function Document2(typeBundle) {
      classCallCheck(this, Document2);
      this.typeBundle = typeBundle;
      this.definitions = [];
    }
    createClass(Document2, [{
      key: "toString",
      value: function toString2() {
        return join(this.definitions);
      }
      /**
       * Adds an operation to the Document.
       *
       * @private
       * @param {String} operationType The type of the operation. Either 'query' or 'mutation'.
       * @param {(Operation|String)} [query|queryName] Either an instance of an operation
       *   object, or the name of an operation. Both are optional.
       * @param {Object[]} [variables] A list of variables in the operation. See {@link Client#variable}.
       * @param {Function} [callback] The query builder callback. If an operation
       *   instance is passed, this callback will be ignored.
       *   A {@link SelectionSet} is created using this callback.
        */
    }, {
      key: "addOperation",
      value: function addOperation(operationType) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        var operation = extractOperation.apply(void 0, [this.typeBundle, operationType].concat(args));
        if (isInvalidOperationCombination(this.operations.concat(operation))) {
          throw new Error("All operations must be uniquely named on a multi-operation document");
        }
        this.definitions.push(operation);
      }
      /**
       * Adds a query to the Document.
       *
       * @example
       * document.addQuery('myQuery', (root) => {
       *   root.add('cat', (cat) => {
       *    cat.add('name');
       *   });
       * });
       *
       * @param {(Query|String)} [query|queryName] Either an instance of a query
       *   object, or the name of a query. Both are optional.
       * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
       * @param {Function} [callback] The query builder callback. If a query
       *   instance is passed, this callback will be ignored.
       *   A {@link SelectionSet} is created using this callback.
       */
    }, {
      key: "addQuery",
      value: function addQuery() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        this.addOperation.apply(this, ["query"].concat(args));
      }
      /**
       * Adds a mutation to the Document.
       *
       * @example
       * const input = client.variable('input', 'CatCreateInput!');
       *
       * document.addMutation('myMutation', [input], (root) => {
       *   root.add('catCreate', {args: {input}}, (catCreate) => {
       *     catCreate.add('cat', (cat) => {
       *       cat.add('name');
       *     });
       *   });
       * });
       *
       * @param {(Mutation|String)} [mutation|mutationName] Either an instance of a mutation
       *   object, or the name of a mutation. Both are optional.
       * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
       * @param {Function} [callback] The mutation builder callback. If a mutation
       *   instance is passed, this callback will be ignored.
       *   A {@link SelectionSet} is created using this callback.
       */
    }, {
      key: "addMutation",
      value: function addMutation() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        this.addOperation.apply(this, ["mutation"].concat(args));
      }
      /**
       * Defines a fragment on the Document.
       *
       * @param {String} name The name of the fragment.
       * @param {String} onType The type the fragment is on.
       * @param {Function} [builderFunction] The query builder callback.
       *   A {@link SelectionSet} is created using this callback.
       * @return {FragmentSpread} A {@link FragmentSpread} to be used with {@link SelectionSetBuilder#addFragment}.
       */
    }, {
      key: "defineFragment",
      value: function defineFragment(name, onType, builderFunction) {
        if (fragmentNameIsNotUnique(this.fragmentDefinitions, name)) {
          throw new Error("All fragments must be uniquely named on a multi-fragment document");
        }
        var selectionSet = new SelectionSet(this.typeBundle, onType, builderFunction);
        var fragment = new FragmentDefinition(name, onType, selectionSet);
        this.definitions.push(fragment);
        return fragment.spread;
      }
      /**
       * All operations ({@link Query} and {@link Mutation}) on the Document.
       */
    }, {
      key: "operations",
      get: function get$$1() {
        return this.definitions.filter(function(definition) {
          return Operation.prototype.isPrototypeOf(definition);
        });
      }
      /**
       * All {@link FragmentDefinition}s on the Document.
       */
    }, {
      key: "fragmentDefinitions",
      get: function get$$1() {
        return this.definitions.filter(function(definition) {
          return FragmentDefinition.prototype.isPrototypeOf(definition);
        });
      }
    }]);
    return Document2;
  }();
  var GraphModel = (
    /**
     * @param {Object} attrs Attributes on the GraphModel.
     */
    function GraphModel2(attrs) {
      var _this = this;
      classCallCheck(this, GraphModel2);
      Object.defineProperty(this, "attrs", { value: attrs, enumerable: false });
      Object.keys(this.attrs).filter(function(key) {
        return !(key in _this);
      }).forEach(function(key) {
        var descriptor = void 0;
        if (attrs[key] === null) {
          descriptor = {
            enumerable: true,
            get: function get$$1() {
              return null;
            }
          };
        } else {
          descriptor = {
            enumerable: true,
            get: function get$$1() {
              return this.attrs[key].valueOf();
            }
          };
        }
        Object.defineProperty(_this, key, descriptor);
      });
    }
  );
  var ClassRegistry = function() {
    function ClassRegistry2() {
      classCallCheck(this, ClassRegistry2);
      this.classStore = {};
    }
    createClass(ClassRegistry2, [{
      key: "registerClassForType",
      value: function registerClassForType(constructor, type) {
        this.classStore[type] = constructor;
      }
      /**
       * Unregisters a class for a GraphQL type in the registry.
       *
       * @param {String} type The GraphQL type to unregister.
       */
    }, {
      key: "unregisterClassForType",
      value: function unregisterClassForType(type) {
        delete this.classStore[type];
      }
      /**
       * Returns the class for the given GraphQL type.
       *
       * @param {String} type The GraphQL type to look up.
       * @return {Class|GraphModel} The class for the given GraphQL type. Defaults to {@link GraphModel} if no class is registered for the GraphQL type.
       */
    }, {
      key: "classForType",
      value: function classForType(type) {
        return this.classStore[type] || GraphModel;
      }
    }]);
    return ClassRegistry2;
  }();
  function isValue(arg) {
    return Object.prototype.toString.call(arg) !== "[object Null]" && Object.prototype.toString.call(arg) !== "[object Undefined]";
  }
  function isNodeContext(context) {
    return context.selection.selectionSet.typeSchema.implementsNode;
  }
  function isConnection(context) {
    return context.selection.selectionSet.typeSchema.name.endsWith("Connection");
  }
  function nearestNode(context) {
    if (context == null) {
      return null;
    } else if (isNodeContext(context)) {
      return context;
    } else {
      return nearestNode(context.parent);
    }
  }
  function contextsFromRoot(context) {
    if (context.parent) {
      return contextsFromRoot(context.parent).concat(context);
    } else {
      return [context];
    }
  }
  function contextsFromNearestNode(context) {
    if (context.selection.selectionSet.typeSchema.implementsNode) {
      return [context];
    } else {
      return contextsFromNearestNode(context.parent).concat(context);
    }
  }
  function initializeDocumentAndVars(currentContext, contextChain) {
    var lastInChain = contextChain[contextChain.length - 1];
    var first = lastInChain.selection.args.first;
    var variableDefinitions = Object.keys(lastInChain.selection.args).filter(function(key) {
      return isVariable(lastInChain.selection.args[key]);
    }).map(function(key) {
      return lastInChain.selection.args[key];
    });
    var firstVar = variableDefinitions.find(function(definition) {
      return definition.name === "first";
    });
    if (!firstVar) {
      if (isVariable(first)) {
        firstVar = first;
      } else {
        firstVar = variable("first", "Int", first);
        variableDefinitions.push(firstVar);
      }
    }
    var document2 = new Document(currentContext.selection.selectionSet.typeBundle);
    return [document2, variableDefinitions, firstVar];
  }
  function addNextFieldTo(currentSelection, contextChain, path, cursor) {
    var nextContext = contextChain.shift();
    path.push(nextContext.selection.responseKey);
    if (contextChain.length) {
      currentSelection.add(nextContext.selection.name, { alias: nextContext.selection.alias, args: nextContext.selection.args }, function(newSelection) {
        addNextFieldTo(newSelection, contextChain, path, cursor);
      });
    } else {
      var edgesField = nextContext.selection.selectionSet.selections.find(function(field) {
        return field.name === "edges";
      });
      var nodeField = edgesField.selectionSet.selections.find(function(field) {
        return field.name === "node";
      });
      var first = void 0;
      if (isVariable(nextContext.selection.args.first)) {
        first = nextContext.selection.args.first;
      } else {
        first = variable("first", "Int", nextContext.selection.args.first);
      }
      var options = {
        alias: nextContext.selection.alias,
        args: Object.assign({}, nextContext.selection.args, { after: cursor, first })
      };
      currentSelection.addConnection(nextContext.selection.name, options, nodeField.selectionSet);
    }
  }
  function collectFragments(selections) {
    return selections.reduce(function(fragmentDefinitions, field) {
      if (FragmentSpread.prototype.isPrototypeOf(field)) {
        fragmentDefinitions.push(field.toDefinition());
      }
      fragmentDefinitions.push.apply(fragmentDefinitions, toConsumableArray(collectFragments(field.selectionSet.selections)));
      return fragmentDefinitions;
    }, []);
  }
  function nextPageQueryAndPath(context, cursor) {
    var nearestNodeContext = nearestNode(context);
    if (nearestNodeContext) {
      return function() {
        var _document$definitions;
        var path = [];
        var nodeType = nearestNodeContext.selection.selectionSet.typeSchema;
        var nodeId = nearestNodeContext.responseData.id;
        var contextChain = contextsFromNearestNode(context);
        var _initializeDocumentAn = initializeDocumentAndVars(context, contextChain), _initializeDocumentAn2 = slicedToArray(_initializeDocumentAn, 2), document2 = _initializeDocumentAn2[0], variableDefinitions = _initializeDocumentAn2[1];
        document2.addQuery(variableDefinitions, function(root) {
          path.push("node");
          root.add("node", { args: { id: nodeId } }, function(node2) {
            node2.addInlineFragmentOn(nodeType.name, function(fragment) {
              addNextFieldTo(fragment, contextChain.slice(1), path, cursor);
            });
          });
        });
        var fragments = collectFragments(document2.operations[0].selectionSet.selections);
        (_document$definitions = document2.definitions).unshift.apply(_document$definitions, toConsumableArray(fragments));
        return [document2, path];
      };
    } else {
      return function() {
        var _document$definitions2;
        var path = [];
        var contextChain = contextsFromRoot(context);
        var _initializeDocumentAn3 = initializeDocumentAndVars(context, contextChain), _initializeDocumentAn4 = slicedToArray(_initializeDocumentAn3, 2), document2 = _initializeDocumentAn4[0], variableDefinitions = _initializeDocumentAn4[1];
        document2.addQuery(variableDefinitions, function(root) {
          addNextFieldTo(root, contextChain.slice(1), path, cursor);
        });
        var fragments = collectFragments(document2.operations[0].selectionSet.selections);
        (_document$definitions2 = document2.definitions).unshift.apply(_document$definitions2, toConsumableArray(fragments));
        return [document2, path];
      };
    }
  }
  function hasNextPage$1(connection, edge) {
    if (edge !== connection.edges[connection.edges.length - 1]) {
      return new Scalar(true);
    }
    return connection.pageInfo.hasNextPage;
  }
  function hasPreviousPage(connection, edge) {
    if (edge !== connection.edges[0]) {
      return new Scalar(true);
    }
    return connection.pageInfo.hasPreviousPage;
  }
  function transformConnections(variableValues) {
    return function(context, value) {
      if (isConnection(context)) {
        if (!(value.pageInfo && value.pageInfo.hasOwnProperty("hasNextPage") && value.pageInfo.hasOwnProperty("hasPreviousPage"))) {
          throw new Error('Connections must include the selections "pageInfo { hasNextPage, hasPreviousPage }".');
        }
        return value.edges.map(function(edge) {
          return Object.assign(edge.node, {
            nextPageQueryAndPath: nextPageQueryAndPath(context, edge.cursor),
            hasNextPage: hasNextPage$1(value, edge),
            hasPreviousPage: hasPreviousPage(value, edge),
            variableValues
          });
        });
      } else {
        return value;
      }
    };
  }
  var DecodingContext = function() {
    function DecodingContext2(selection, responseData) {
      var parent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      classCallCheck(this, DecodingContext2);
      this.selection = selection;
      this.responseData = responseData;
      this.parent = parent;
      Object.freeze(this);
    }
    createClass(DecodingContext2, [{
      key: "contextForObjectProperty",
      value: function contextForObjectProperty(responseKey) {
        var nestedSelections = this.selection.selectionSet.selectionsByResponseKey[responseKey];
        var nextSelection = nestedSelections && nestedSelections[0];
        var nextContext = void 0;
        if (Spread.prototype.isPrototypeOf(nextSelection)) {
          nextContext = new DecodingContext2(nextSelection, this.responseData, this.parent);
        } else {
          nextContext = new DecodingContext2(nextSelection, this.responseData[responseKey], this);
        }
        if (!nextSelection) {
          throw new Error('Unexpected response key "' + responseKey + '", not found in selection set: ' + this.selection.selectionSet);
        }
        if (Field.prototype.isPrototypeOf(nextSelection)) {
          return nextContext;
        } else {
          return nextContext.contextForObjectProperty(responseKey);
        }
      }
    }, {
      key: "contextForArrayItem",
      value: function contextForArrayItem(item) {
        return new DecodingContext2(this.selection, item, this.parent);
      }
    }]);
    return DecodingContext2;
  }();
  function decodeArrayItems(context, transformers) {
    return context.responseData.map(function(item) {
      return decodeContext(context.contextForArrayItem(item), transformers);
    });
  }
  function decodeObjectValues(context, transformers) {
    return Object.keys(context.responseData).reduce(function(acc, responseKey) {
      acc[responseKey] = decodeContext(context.contextForObjectProperty(responseKey), transformers);
      return acc;
    }, {});
  }
  function runTransformers(transformers, context, value) {
    return transformers.reduce(function(acc, transformer) {
      return transformer(context, acc);
    }, value);
  }
  function decodeContext(context, transformers) {
    var value = context.responseData;
    if (Array.isArray(value)) {
      value = decodeArrayItems(context, transformers);
    } else if (isObject$1(value)) {
      value = decodeObjectValues(context, transformers);
    }
    return runTransformers(transformers, context, value);
  }
  function generateRefetchQueries(context, value) {
    if (isValue(value) && isNodeContext(context)) {
      value.refetchQuery = function() {
        return new Query(context.selection.selectionSet.typeBundle, function(root) {
          root.add("node", { args: { id: context.responseData.id } }, function(node2) {
            node2.addInlineFragmentOn(context.selection.selectionSet.typeSchema.name, context.selection.selectionSet);
          });
        });
      };
    }
    return value;
  }
  function transformPojosToClassesWithRegistry(classRegistry) {
    return function transformPojosToClasses(context, value) {
      if (isObject$1(value)) {
        var Klass = classRegistry.classForType(context.selection.selectionSet.typeSchema.name);
        return new Klass(value);
      } else {
        return value;
      }
    };
  }
  function transformScalars(context, value) {
    if (isValue(value)) {
      if (context.selection.selectionSet.typeSchema.kind === "SCALAR") {
        return new Scalar(value);
      } else if (context.selection.selectionSet.typeSchema.kind === "ENUM") {
        return new Enum(value);
      }
    }
    return value;
  }
  function recordTypeInformation(context, value) {
    var _context$selection$se = context.selection.selectionSet, typeBundle = _context$selection$se.typeBundle, typeSchema = _context$selection$se.typeSchema;
    if (isValue(value)) {
      if (value.__typename) {
        value.type = schemaForType(typeBundle, value.__typename, typeSchema);
      } else {
        value.type = typeSchema;
      }
    }
    return value;
  }
  function defaultTransformers(_ref) {
    var _ref$classRegistry = _ref.classRegistry, classRegistry = _ref$classRegistry === void 0 ? new ClassRegistry() : _ref$classRegistry, variableValues = _ref.variableValues;
    return [transformScalars, generateRefetchQueries, transformConnections(variableValues), recordTypeInformation, transformPojosToClassesWithRegistry(classRegistry)];
  }
  function decode$1(selection, responseData) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var transformers = options.transformers || defaultTransformers(options);
    var context = new DecodingContext(selection, responseData);
    return decodeContext(context, transformers);
  }
  function httpFetcher(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function fetcher(graphQLParams, headers) {
      return fetch(url, _extends$3({
        body: JSON.stringify(graphQLParams),
        method: "POST",
        mode: "cors"
      }, options, {
        headers: _extends$3({
          "Content-Type": "application/json",
          Accept: "application/json"
        }, options.headers, headers)
      })).then(function(response) {
        var contentType = response.headers.get("content-type");
        if (contentType.indexOf("application/json") > -1) {
          return response.json();
        }
        return response.text().then(function(text) {
          return { text };
        });
      });
    };
  }
  function hasNextPage(paginatedModels) {
    return paginatedModels && paginatedModels.length && paginatedModels[paginatedModels.length - 1].hasNextPage;
  }
  var Client$2 = function() {
    function Client2(typeBundle, _ref) {
      var url = _ref.url, fetcherOptions = _ref.fetcherOptions, fetcher = _ref.fetcher, _ref$registry = _ref.registry, registry = _ref$registry === void 0 ? new ClassRegistry() : _ref$registry;
      classCallCheck(this, Client2);
      this.typeBundle = typeBundle;
      this.classRegistry = registry;
      if (url && fetcher) {
        throw new Error("Arguments not supported: supply either `url` and optional `fetcherOptions` OR use a `fetcher` function for further customization.");
      }
      if (url) {
        this.fetcher = httpFetcher(url, fetcherOptions);
      } else if (fetcher) {
        if (fetcherOptions) {
          throw new Error("Arguments not supported: when specifying your own `fetcher`, set options through it and not with `fetcherOptions`");
        }
        this.fetcher = fetcher;
      } else {
        throw new Error("Invalid arguments: one of `url` or `fetcher` is needed.");
      }
    }
    createClass(Client2, [{
      key: "document",
      value: function document2() {
        return new Document(this.typeBundle);
      }
      /**
       * Creates a GraphQL query.
       *
       * @example
       * const query = client.query('myQuery', (root) => {
       *   root.add('cat', (cat) => {
       *    cat.add('name');
       *   });
       * });
       *
       * @param {String} [name] A name for the query.
       * @param {VariableDefinition[]} [variables] A list of variables in the query. See {@link Client#variable}.
       * @param {Function} selectionSetCallback The query builder callback.
       *   A {@link SelectionSet} is created using this callback.
       * @return {Query} A GraphQL query.
       */
    }, {
      key: "query",
      value: function query2() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return new (Function.prototype.bind.apply(Query, [null].concat([this.typeBundle], args)))();
      }
      /**
       * Creates a GraphQL mutation.
       *
       * @example
       * const input = client.variable('input', 'CatCreateInput!');
       *
       * const mutation = client.mutation('myMutation', [input], (root) => {
       *   root.add('catCreate', {args: {input}}, (catCreate) => {
       *     catCreate.add('cat', (cat) => {
       *       cat.add('name');
       *     });
       *   });
       * });
       *
       * @param {String} [name] A name for the mutation.
       * @param {VariableDefinition[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
       * @param {Function} selectionSetCallback The mutation builder callback.
       *   A {@link SelectionSet} is created using this callback.
       * @return {Mutation} A GraphQL mutation.
       */
    }, {
      key: "mutation",
      value: function mutation() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return new (Function.prototype.bind.apply(Mutation, [null].concat([this.typeBundle], args)))();
      }
      /**
       * Sends a GraphQL operation (query or mutation) or a document.
       *
       * @example
       * client.send(query, {id: '12345'}).then((result) => {
       *   // Do something with the returned result
       *   console.log(result);
       * });
       *
       * @param {(Query|Mutation|Document|Function)} request The operation or document to send. If represented
       * as a function, it must return `Query`, `Mutation`, or `Document` and recieve the client as the only param.
       * @param {Object} [variableValues] The values for variables in the operation or document.
       * @param {Object} [otherProperties] Other properties to send with the query. For example, a custom operation name.
       * @param {Object} [headers] Additional headers to be applied on a request by request basis.
       * @return {Promise.<Object>} A promise resolving to an object containing the response data.
       */
    }, {
      key: "send",
      value: function send(request) {
        var variableValues = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var _this = this;
        var otherProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var headers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        var operationOrDocument = void 0;
        if (Function.prototype.isPrototypeOf(request)) {
          operationOrDocument = request(this);
        } else {
          operationOrDocument = request;
        }
        var graphQLParams = { query: operationOrDocument.toString() };
        if (variableValues) {
          graphQLParams.variables = variableValues;
        }
        Object.assign(graphQLParams, otherProperties);
        var operation = void 0;
        if (Operation.prototype.isPrototypeOf(operationOrDocument)) {
          operation = operationOrDocument;
        } else {
          var document2 = operationOrDocument;
          if (document2.operations.length === 1) {
            operation = document2.operations[0];
          } else if (otherProperties.operationName) {
            operation = document2.operations.find(function(documentOperation) {
              return documentOperation.name === otherProperties.operationName;
            });
          } else {
            throw new Error("\n          A document must contain exactly one operation, or an operationName\n          must be specified. Example:\n\n            client.send(document, null, {operationName: 'myFancyQuery'});\n        ");
          }
        }
        return this.fetcher(graphQLParams, headers).then(function(response) {
          if (response.data) {
            response.model = decode$1(operation, response.data, {
              classRegistry: _this.classRegistry,
              variableValues
            });
          }
          return response;
        });
      }
      /**
       * Fetches the next page of a paginated node or array of nodes.
       *
       * @example
       * client.fetchNextPage(node, {first: 10}).then((result) => {
       *   // Do something with the next page
       *   console.log(result);
       * });
       *
       * @param {(GraphModel|GraphModel[])} nodeOrNodes The node or list of nodes on which to fetch the next page.
       * @param {Object} [options] Options object containing:
       *   @param {Integer} [options.first] The number of nodes to query on the next page. Defaults to the page size of the previous query.
       * @return {Promise.<GraphModel[]>} A promise resolving with the next page of {@link GraphModel}s.
       */
    }, {
      key: "fetchNextPage",
      value: function fetchNextPage(nodeOrNodes, options) {
        var node2 = void 0;
        if (Array.isArray(nodeOrNodes)) {
          node2 = nodeOrNodes[nodeOrNodes.length - 1];
        } else {
          node2 = nodeOrNodes;
        }
        var _node$nextPageQueryAn = node2.nextPageQueryAndPath(), _node$nextPageQueryAn2 = slicedToArray(_node$nextPageQueryAn, 2), query2 = _node$nextPageQueryAn2[0], path = _node$nextPageQueryAn2[1];
        var variableValues = void 0;
        if (node2.variableValues || options) {
          variableValues = Object.assign({}, node2.variableValues, options);
        }
        return this.send(query2, variableValues).then(function(response) {
          response.model = path.reduce(function(object, key) {
            return object[key];
          }, response.model);
          return response;
        });
      }
      /**
       * Fetches all subsequent pages of a paginated array of nodes.
       *
       * @example
       * client.fetchAllPages(nodes, {pageSize: 20}).then((result) => {
       *   // Do something with all the models
       *   console.log(result);
       * });
       *
       * @param {GraphModel[]} paginatedModels The list of nodes on which to fetch all pages.
       * @param {Object} options Options object containing:
       *   @param {Integer} options.pageSize The number of nodes to query on each page.
       * @return {Promise.<GraphModel[]>} A promise resolving with all pages of {@link GraphModel}s, including the original list.
       */
    }, {
      key: "fetchAllPages",
      value: function fetchAllPages(paginatedModels, _ref2) {
        var _this2 = this;
        var pageSize = _ref2.pageSize;
        if (hasNextPage(paginatedModels)) {
          return this.fetchNextPage(paginatedModels, { first: pageSize }).then(function(_ref3) {
            var model = _ref3.model;
            var pages = paginatedModels.concat(model);
            return _this2.fetchAllPages(pages, { pageSize });
          });
        }
        return Promise.resolve(paginatedModels);
      }
      /**
       * Refetches a {@link GraphModel} whose type implements `Node`.
       *
       * @example
       * client.refetch(node).then((result) => {
       *   // Do something with the refetched node
       *   console.log(result);
       * });
       *
       * @param {GraphModel} nodeType A {@link GraphModel} whose type implements `Node`.
       * @return {Promise.<GraphModel>} The refetched {@link GraphModel}.
       */
    }, {
      key: "refetch",
      value: function refetch(nodeType) {
        if (!nodeType) {
          throw new Error("'client#refetch' must be called with a non-null instance of a Node.");
        } else if (!nodeType.type.implementsNode) {
          throw new Error("'client#refetch' must be called with a type that implements Node. Received " + nodeType.type.name + ".");
        }
        return this.send(nodeType.refetchQuery()).then(function(_ref4) {
          var model = _ref4.model;
          return model.node;
        });
      }
      /**
       * Creates a variable to be used in a {@link Query} or {@link Mutation}.
       *
       * @example
       * const idVariable = client.variable('id', 'ID!', '12345');
       *
       * @param {String} name The name of the variable.
       * @param {String} type The GraphQL type of the variable.
       * @param {*} [defaultValue] The default value of the variable.
       * @return {VariableDefinition} A variable object that can be used in a {@link Query} or {@link Mutation}.
       */
    }, {
      key: "variable",
      value: function variable$$1(name, type, defaultValue) {
        return variable(name, type, defaultValue);
      }
      /**
       * Creates an enum to be used in a {@link Query} or {@link Mutation}.
       *
       * @example
       * const titleEnum = client.enum('TITLE');
       *
       * @param {String} key The key of the enum.
       * @return {Enum} An enum object that can be used in a {@link Query} or {@link Mutation}.
       */
    }, {
      key: "enum",
      value: function _enum(key) {
        return enumFunction(key);
      }
    }]);
    return Client2;
  }();
  var Config = function() {
    createClass$1(Config2, [{
      key: "requiredProperties",
      /**
       * Properties that must be set on initializations
       * @attribute requiredProperties
       * @default ['storefrontAccessToken', 'domain']
       * @type Array
       * @private
       */
      get: function get$$1() {
        return ["storefrontAccessToken", "domain"];
      }
      /**
       * Deprecated properties that map directly to required properties
       * @attribute deprecatedProperties
       * @default {'accessToken': 'storefrontAccessToken', 'apiKey': 'storefrontAccessToken'}
       * @type Object
       * @private
       */
    }, {
      key: "deprecatedProperties",
      get: function get$$1() {
        return {
          accessToken: "storefrontAccessToken",
          apiKey: "storefrontAccessToken"
        };
      }
      /**
       * @constructs Config
       * @param {Object} attrs An object specifying the configuration. Requires the following properties:
       *   @param {String} attrs.storefrontAccessToken The {@link https://help.shopify.com/api/reference/storefront_access_token|Storefront access token} for the shop.
       *   @param {String} attrs.domain The `myshopify` domain for the shop (e.g. `graphql.myshopify.com`).
       */
    }]);
    function Config2(attrs) {
      var _this = this;
      classCallCheck$1(this, Config2);
      Object.keys(this.deprecatedProperties).forEach(function(key) {
        if (!attrs.hasOwnProperty(key)) {
          return;
        }
        console.warn("[ShopifyBuy] Config property " + key + " is deprecated as of v1.0, please use " + _this.deprecatedProperties[key] + " instead.");
        attrs[_this.deprecatedProperties[key]] = attrs[key];
      });
      this.requiredProperties.forEach(function(key) {
        if (attrs.hasOwnProperty(key)) {
          _this[key] = attrs[key];
        } else {
          throw new Error("new Config() requires the option '" + key + "'");
        }
      });
      if (attrs.hasOwnProperty("apiVersion")) {
        this.apiVersion = attrs.apiVersion;
      } else {
        this.apiVersion = "2023-01";
      }
      if (attrs.hasOwnProperty("source")) {
        this.source = attrs.source;
      }
      if (attrs.hasOwnProperty("language")) {
        this.language = attrs.language;
      }
    }
    return Config2;
  }();
  var Resource = function Resource2(client) {
    classCallCheck$1(this, Resource2);
    this.graphQLClient = client;
  };
  var defaultErrors = [{ message: "an unknown error has occurred." }];
  function defaultResolver(path) {
    var keys = path.split(".");
    return function(_ref) {
      var model = _ref.model, errors = _ref.errors;
      return new Promise(function(resolve, reject) {
        try {
          var result = keys.reduce(function(ref, key) {
            return ref[key];
          }, model);
          resolve(result);
        } catch (_2) {
          if (errors) {
            reject(errors);
          } else {
            reject(defaultErrors);
          }
        }
      });
    };
  }
  function fetchResourcesForProducts(productOrProduct, client) {
    var products = [].concat(productOrProduct);
    return Promise.all(products.reduce(function(promiseAcc, product) {
      if (product === null) {
        return promiseAcc;
      }
      promiseAcc.push(client.fetchAllPages(product.images, { pageSize: 250 }).then(function(images) {
        product.attrs.images = images;
      }));
      promiseAcc.push(client.fetchAllPages(product.variants, { pageSize: 250 }).then(function(variants) {
        product.attrs.variants = variants;
      }));
      return promiseAcc;
    }, []));
  }
  function paginateProductConnectionsAndResolve(client) {
    return function(products) {
      return fetchResourcesForProducts(products, client).then(function() {
        return products;
      });
    };
  }
  function paginateCollectionsProductConnectionsAndResolve(client) {
    return function(collectionOrCollections) {
      var collections = [].concat(collectionOrCollections);
      return Promise.all(collections.reduce(function(promiseAcc, collection) {
        return promiseAcc.concat(fetchResourcesForProducts(collection.products, client));
      }, [])).then(function() {
        return collectionOrCollections;
      });
    };
  }
  var productHelpers = {
    /**
     * Returns the variant of a product corresponding to the options given.
     *
     * @example
     * const selectedVariant = client.product.helpers.variantForOptions(product, {
     *   size: "Small",
     *   color: "Red"
     * });
     *
     * @memberof ProductHelpers
     * @method variantForOptions
     * @param {GraphModel} product The product to find the variant on. Must include `variants`.
     * @param {Object} options An object containing the options for the variant.
     * @return {GraphModel} The variant corresponding to the options given.
     */
    variantForOptions: function variantForOptions(product, options) {
      return product.variants.find(function(variant) {
        return variant.selectedOptions.every(function(selectedOption) {
          return options[selectedOption.name] === selectedOption.value.valueOf();
        });
      });
    }
  };
  function query(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.id = client.variable("id", "ID!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document2.defineFragment("ProductFragment", "Product", function(root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function(options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function(images) {
        images.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("url", {
              alias: "src"
            });
            node2.add("altText");
            node2.add("width");
            node2.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function(variants) {
        variants.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.id], function(root) {
      root.add("node", {
        args: {
          id: variables.__defaultOperation__.id
        }
      }, function(node2) {
        node2.addFragment(spreads.ProductFragment);
      });
    });
    return document2;
  }
  function query$1(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.ids = client.variable("ids", "[ID!]!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document2.defineFragment("ProductFragment", "Product", function(root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function(options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function(images) {
        images.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("url", {
              alias: "src"
            });
            node2.add("altText");
            node2.add("width");
            node2.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function(variants) {
        variants.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.ids], function(root) {
      root.add("nodes", {
        args: {
          ids: variables.__defaultOperation__.ids
        }
      }, function(nodes) {
        nodes.addFragment(spreads.ProductFragment);
      });
    });
    return document2;
  }
  function query$2(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.first = client.variable("first", "Int!");
    variables.__defaultOperation__.query = client.variable("query", "String");
    variables.__defaultOperation__.sortKey = client.variable("sortKey", "ProductSortKeys");
    variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document2.defineFragment("ProductFragment", "Product", function(root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function(options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function(images) {
        images.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("url", {
              alias: "src"
            });
            node2.add("altText");
            node2.add("width");
            node2.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function(variants) {
        variants.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function(root) {
      root.add("products", {
        args: {
          first: variables.__defaultOperation__.first,
          query: variables.__defaultOperation__.query,
          sortKey: variables.__defaultOperation__.sortKey,
          reverse: variables.__defaultOperation__.reverse
        }
      }, function(products) {
        products.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        products.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.ProductFragment);
          });
        });
      });
    });
    return document2;
  }
  function query$3(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.handle = client.variable("handle", "String!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document2.defineFragment("ProductFragment", "Product", function(root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function(options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function(images) {
        images.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("url", {
              alias: "src"
            });
            node2.add("altText");
            node2.add("width");
            node2.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function(variants) {
        variants.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.handle], function(root) {
      root.add("productByHandle", {
        args: {
          handle: variables.__defaultOperation__.handle
        }
      }, function(productByHandle) {
        productByHandle.addFragment(spreads.ProductFragment);
      });
    });
    return document2;
  }
  function query$4(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.productId = client.variable("productId", "ID!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document2.defineFragment("ProductFragment", "Product", function(root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function(options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function(images) {
        images.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("url", {
              alias: "src"
            });
            node2.add("altText");
            node2.add("width");
            node2.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function(variants) {
        variants.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.productId], function(root) {
      root.add("productRecommendations", {
        args: {
          productId: variables.__defaultOperation__.productId
        }
      }, function(productRecommendations) {
        productRecommendations.addFragment(spreads.ProductFragment);
      });
    });
    return document2;
  }
  var ProductResource = function(_Resource) {
    inherits$1(ProductResource2, _Resource);
    function ProductResource2() {
      classCallCheck$1(this, ProductResource2);
      return possibleConstructorReturn$1(this, (ProductResource2.__proto__ || Object.getPrototypeOf(ProductResource2)).apply(this, arguments));
    }
    createClass$1(ProductResource2, [{
      key: "fetchAll",
      /**
       * Fetches all products on the shop.
       *
       * @example
       * client.product.fetchAll().then((products) => {
       *   // Do something with the products
       * });
       *
       * @param {Int} [pageSize] The number of products to fetch per page
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
       */
      value: function fetchAll() {
        var first = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 20;
        return this.graphQLClient.send(query$2, { first }).then(defaultResolver("products")).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }
      /**
       * Fetches a single product by ID on the shop.
       *
       * @example
       * client.product.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==').then((product) => {
       *   // Do something with the product
       * });
       *
       * @param {String} id The id of the product to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
       */
    }, {
      key: "fetch",
      value: function fetch2(id2) {
        return this.graphQLClient.send(query, { id: id2 }).then(defaultResolver("node")).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }
      /**
       * Fetches multiple products by ID on the shop.
       *
       * @example
       * const ids = ['Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==', 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc4NTc5ODkzODQ='];
       * client.product.fetchMultiple(ids).then((products) => {
       *   // Do something with the products
       * });
       *
       * @param {String[]} ids The ids of the products to fetch
       * @return {Promise|GraphModel[]} A promise resolving with a `GraphModel` of the product.
       */
    }, {
      key: "fetchMultiple",
      value: function fetchMultiple(ids) {
        return this.graphQLClient.send(query$1, { ids }).then(defaultResolver("nodes")).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }
      /**
       * Fetches a single product by handle on the shop.
       *
       * @example
       * client.product.fetchByHandle('my-product').then((product) => {
       *   // Do something with the product
       * });
       *
       * @param {String} handle The handle of the product to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
       */
    }, {
      key: "fetchByHandle",
      value: function fetchByHandle(handle) {
        return this.graphQLClient.send(query$3, { handle }).then(defaultResolver("productByHandle")).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }
      /**
       * Fetches all products on the shop that match the query.
       *
       * @example
       * client.product.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((products) => {
       *   // Do something with the first 10 products sorted by title in ascending order
       * });
       *
       * @param {Object} [args] An object specifying the query data containing zero or more of:
       *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
       *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
       *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/productsortkeys|Product Sort Keys}.
       *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#products|here}
       *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
       */
    }, {
      key: "fetchQuery",
      value: function fetchQuery() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref$first = _ref.first, first = _ref$first === void 0 ? 20 : _ref$first, _ref$sortKey = _ref.sortKey, sortKey = _ref$sortKey === void 0 ? "ID" : _ref$sortKey, query$$1 = _ref.query, reverse = _ref.reverse;
        return this.graphQLClient.send(query$2, {
          first,
          sortKey,
          query: query$$1,
          reverse
        }).then(defaultResolver("products")).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }
      /**
       * Find recommended products related to a given productId.
       * To learn more about how recommendations are generated, see https://shopify.dev/themes/product-merchandising/recommendations.
       *
       * @example
       * const productId 'Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==';
       * client.product.fetchProductRecommendations(productId).then((products) => {
       *   // Do something with the products
       * });
       *
       * @param {String} productId The id of the product to fetch.
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
       */
    }, {
      key: "fetchRecommendations",
      value: function fetchRecommendations(productId) {
        return this.graphQLClient.send(query$4, { productId }).then(defaultResolver("productRecommendations")).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }
    }, {
      key: "helpers",
      get: function get$$1() {
        return productHelpers;
      }
    }]);
    return ProductResource2;
  }(Resource);
  function query$5(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.id = client.variable("id", "ID!");
    spreads.CollectionFragment = document2.defineFragment("CollectionFragment", "Collection", function(root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
      });
    });
    document2.addQuery([variables.__defaultOperation__.id], function(root) {
      root.add("node", {
        args: {
          id: variables.__defaultOperation__.id
        }
      }, function(node2) {
        node2.addFragment(spreads.CollectionFragment);
      });
    });
    return document2;
  }
  function query$6(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.id = client.variable("id", "ID!");
    variables.__defaultOperation__.productsFirst = client.variable("productsFirst", "Int!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.CollectionFragment = document2.defineFragment("CollectionFragment", "Collection", function(root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
      });
    });
    spreads.ProductFragment = document2.defineFragment("ProductFragment", "Product", function(root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function(options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function(images) {
        images.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("url", {
              alias: "src"
            });
            node2.add("altText");
            node2.add("width");
            node2.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function(variants) {
        variants.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.id, variables.__defaultOperation__.productsFirst], function(root) {
      root.add("node", {
        args: {
          id: variables.__defaultOperation__.id
        }
      }, function(node2) {
        node2.addFragment(spreads.CollectionFragment);
        node2.addInlineFragmentOn("Collection", function(Collection2) {
          Collection2.add("products", {
            args: {
              first: variables.__defaultOperation__.productsFirst
            }
          }, function(products) {
            products.add("pageInfo", function(pageInfo) {
              pageInfo.add("hasNextPage");
              pageInfo.add("hasPreviousPage");
            });
            products.add("edges", function(edges) {
              edges.add("cursor");
              edges.add("node", function(node3) {
                node3.addFragment(spreads.ProductFragment);
              });
            });
          });
        });
      });
    });
    return document2;
  }
  function query$7(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.first = client.variable("first", "Int!");
    variables.__defaultOperation__.query = client.variable("query", "String");
    variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
    variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
    spreads.CollectionFragment = document2.defineFragment("CollectionFragment", "Collection", function(root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
      });
    });
    document2.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function(root) {
      root.add("collections", {
        args: {
          first: variables.__defaultOperation__.first,
          query: variables.__defaultOperation__.query,
          sortKey: variables.__defaultOperation__.sortKey,
          reverse: variables.__defaultOperation__.reverse
        }
      }, function(collections) {
        collections.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        collections.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.CollectionFragment);
          });
        });
      });
    });
    return document2;
  }
  function query$8(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.first = client.variable("first", "Int!");
    variables.__defaultOperation__.query = client.variable("query", "String");
    variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
    variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
    variables.__defaultOperation__.productsFirst = client.variable("productsFirst", "Int!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.CollectionFragment = document2.defineFragment("CollectionFragment", "Collection", function(root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
      });
    });
    spreads.ProductFragment = document2.defineFragment("ProductFragment", "Product", function(root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function(options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function(images) {
        images.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("url", {
              alias: "src"
            });
            node2.add("altText");
            node2.add("width");
            node2.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function(variants) {
        variants.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse, variables.__defaultOperation__.productsFirst], function(root) {
      root.add("collections", {
        args: {
          first: variables.__defaultOperation__.first,
          query: variables.__defaultOperation__.query,
          sortKey: variables.__defaultOperation__.sortKey,
          reverse: variables.__defaultOperation__.reverse
        }
      }, function(collections) {
        collections.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        collections.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.CollectionFragment);
            node2.add("products", {
              args: {
                first: variables.__defaultOperation__.productsFirst
              }
            }, function(products) {
              products.add("pageInfo", function(pageInfo) {
                pageInfo.add("hasNextPage");
                pageInfo.add("hasPreviousPage");
              });
              products.add("edges", function(edges2) {
                edges2.add("cursor");
                edges2.add("node", function(node3) {
                  node3.addFragment(spreads.ProductFragment);
                });
              });
            });
          });
        });
      });
    });
    return document2;
  }
  function query$9(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.handle = client.variable("handle", "String!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document2.defineFragment("ProductFragment", "Product", function(root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function(options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function(images) {
        images.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("url", {
              alias: "src"
            });
            node2.add("altText");
            node2.add("width");
            node2.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function(variants) {
        variants.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    spreads.CollectionFragment = document2.defineFragment("CollectionFragment", "Collection", function(root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
      });
    });
    spreads.CollectionsProductsFragment = document2.defineFragment("CollectionsProductsFragment", "Collection", function(root) {
      root.add("products", {
        args: {
          first: 20
        }
      }, function(products) {
        products.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        products.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.addFragment(spreads.ProductFragment);
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.handle], function(root) {
      root.add("collectionByHandle", {
        args: {
          handle: variables.__defaultOperation__.handle
        }
      }, function(collectionByHandle) {
        collectionByHandle.addFragment(spreads.CollectionFragment);
        collectionByHandle.addFragment(spreads.CollectionsProductsFragment);
      });
    });
    return document2;
  }
  var CollectionResource = function(_Resource) {
    inherits$1(CollectionResource2, _Resource);
    function CollectionResource2() {
      classCallCheck$1(this, CollectionResource2);
      return possibleConstructorReturn$1(this, (CollectionResource2.__proto__ || Object.getPrototypeOf(CollectionResource2)).apply(this, arguments));
    }
    createClass$1(CollectionResource2, [{
      key: "fetchAll",
      /**
       * Fetches all collections on the shop, not including products.
       * To fetch collections with products use [fetchAllsWithProducts]{@link Client#fetchAllsWithProducts}.
       *
       * @example
       * client.collection.fetchAll().then((collections) => {
       *   // Do something with the collections
       * });
       *
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
       */
      value: function fetchAll() {
        var first = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 20;
        return this.graphQLClient.send(query$7, { first }).then(defaultResolver("collections"));
      }
      /**
       * Fetches all collections on the shop, including products.
       *
       * @example
       * client.collection.fetchAllWithProducts().then((collections) => {
       *   // Do something with the collections
       * });
       *
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
       */
    }, {
      key: "fetchAllWithProducts",
      value: function fetchAllWithProducts() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref$first = _ref.first, first = _ref$first === void 0 ? 20 : _ref$first, _ref$productsFirst = _ref.productsFirst, productsFirst = _ref$productsFirst === void 0 ? 20 : _ref$productsFirst;
        return this.graphQLClient.send(query$8, { first, productsFirst }).then(defaultResolver("collections")).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
      }
      /**
       * Fetches a single collection by ID on the shop, not including products.
       * To fetch the collection with products use [fetchWithProducts]{@link Client#fetchWithProducts}.
       *
       * @example
       * client.collection.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
       *   // Do something with the collection
       * });
       *
       * @param {String} id The id of the collection to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
       */
    }, {
      key: "fetch",
      value: function fetch2(id2) {
        return this.graphQLClient.send(query$5, { id: id2 }).then(defaultResolver("node"));
      }
      /**
       * Fetches a single collection by ID on the shop, including products.
       *
       * @example
       * client.collection.fetchWithProducts('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
       *   // Do something with the collection
       * });
       *
       * @param {String} id The id of the collection to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
       */
    }, {
      key: "fetchWithProducts",
      value: function fetchWithProducts(id2) {
        var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref2$productsFirst = _ref2.productsFirst, productsFirst = _ref2$productsFirst === void 0 ? 20 : _ref2$productsFirst;
        return this.graphQLClient.send(query$6, { id: id2, productsFirst }).then(defaultResolver("node")).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
      }
      /**
       * Fetches a collection by handle on the shop.
       *
       * @example
       * client.collection.fetchByHandle('my-collection').then((collection) => {
       *   // Do something with the collection
       * });
       *
       * @param {String} handle The handle of the collection to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
       */
    }, {
      key: "fetchByHandle",
      value: function fetchByHandle(handle) {
        return this.graphQLClient.send(query$9, { handle }).then(defaultResolver("collectionByHandle"));
      }
      /**
       * Fetches all collections on the shop that match the query.
       *
       * @example
       * client.collection.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((collections) => {
       *   // Do something with the first 10 collections sorted by title in ascending order
       * });
       *
       * @param {Object} [args] An object specifying the query data containing zero or more of:
       *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
       *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
       *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/collectionsortkeys|Collection Sort Keys}.
       *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#collections|here}
       *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
       */
    }, {
      key: "fetchQuery",
      value: function fetchQuery() {
        var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$first = _ref3.first, first = _ref3$first === void 0 ? 20 : _ref3$first, _ref3$sortKey = _ref3.sortKey, sortKey = _ref3$sortKey === void 0 ? "ID" : _ref3$sortKey, query2 = _ref3.query, reverse = _ref3.reverse;
        return this.graphQLClient.send(query$7, {
          first,
          sortKey,
          query: query2,
          reverse
        }).then(defaultResolver("collections"));
      }
    }]);
    return CollectionResource2;
  }(Resource);
  function query$10(client) {
    var document2 = client.document();
    document2.addQuery(function(root) {
      root.add("shop", function(shop) {
        shop.add("paymentSettings", function(paymentSettings) {
          paymentSettings.add("enabledPresentmentCurrencies");
        });
        shop.add("description");
        shop.add("moneyFormat");
        shop.add("name");
        shop.add("primaryDomain", function(primaryDomain) {
          primaryDomain.add("host");
          primaryDomain.add("sslEnabled");
          primaryDomain.add("url");
        });
      });
    });
    return document2;
  }
  function query$11(client) {
    var document2 = client.document();
    var spreads = {};
    spreads.PolicyFragment = document2.defineFragment("PolicyFragment", "ShopPolicy", function(root) {
      root.add("id");
      root.add("title");
      root.add("url");
      root.add("body");
    });
    document2.addQuery(function(root) {
      root.add("shop", function(shop) {
        shop.add("privacyPolicy", function(privacyPolicy) {
          privacyPolicy.addFragment(spreads.PolicyFragment);
        });
        shop.add("termsOfService", function(termsOfService) {
          termsOfService.addFragment(spreads.PolicyFragment);
        });
        shop.add("refundPolicy", function(refundPolicy) {
          refundPolicy.addFragment(spreads.PolicyFragment);
        });
      });
    });
    return document2;
  }
  var ShopResource = function(_Resource) {
    inherits$1(ShopResource2, _Resource);
    function ShopResource2() {
      classCallCheck$1(this, ShopResource2);
      return possibleConstructorReturn$1(this, (ShopResource2.__proto__ || Object.getPrototypeOf(ShopResource2)).apply(this, arguments));
    }
    createClass$1(ShopResource2, [{
      key: "fetchInfo",
      /**
       * Fetches shop information (`currencyCode`, `description`, `moneyFormat`, `name`, and `primaryDomain`).
       * See the {@link https://help.shopify.com/api/storefront-api/reference/object/shop|Storefront API reference} for more information.
       *
       * @example
       * client.shop.fetchInfo().then((shop) => {
       *   // Do something with the shop
       * });
       *
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
       */
      value: function fetchInfo() {
        return this.graphQLClient.send(query$10).then(defaultResolver("shop"));
      }
      /**
       * Fetches shop policies (privacy policy, terms of service and refund policy).
       *
       * @example
       * client.shop.fetchPolicies().then((shop) => {
       *   // Do something with the shop
       * });
       *
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
       */
    }, {
      key: "fetchPolicies",
      value: function fetchPolicies() {
        return this.graphQLClient.send(query$11).then(defaultResolver("shop"));
      }
    }]);
    return ShopResource2;
  }(Resource);
  function handleCheckoutMutation(mutationRootKey, client) {
    return function(_ref) {
      var _ref$data = _ref.data, data = _ref$data === void 0 ? {} : _ref$data, errors = _ref.errors, _ref$model = _ref.model, model = _ref$model === void 0 ? {} : _ref$model;
      var rootData = data[mutationRootKey];
      var rootModel = model[mutationRootKey];
      if (rootData && rootData.checkout) {
        return client.fetchAllPages(rootModel.checkout.lineItems, { pageSize: 250 }).then(function(lineItems) {
          rootModel.checkout.attrs.lineItems = lineItems;
          rootModel.checkout.errors = errors;
          rootModel.checkout.userErrors = rootModel.userErrors;
          return rootModel.checkout;
        });
      }
      if (errors && errors.length) {
        return Promise.reject(new Error(JSON.stringify(errors)));
      }
      if (rootData && rootData.checkoutUserErrors && rootData.checkoutUserErrors.length) {
        return Promise.reject(new Error(JSON.stringify(rootData.checkoutUserErrors)));
      }
      if (rootData && rootData.userErrors && rootData.userErrors.length) {
        return Promise.reject(new Error(JSON.stringify(rootData.userErrors)));
      }
      return Promise.reject(new Error("The " + mutationRootKey + " mutation failed due to an unknown error."));
    };
  }
  function query$12(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.id = client.variable("id", "ID!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addQuery([variables.__defaultOperation__.id], function(root) {
      root.add("node", {
        args: {
          id: variables.__defaultOperation__.id
        }
      }, function(node2) {
        node2.addFragment(spreads.CheckoutFragment);
      });
    });
    return document2;
  }
  function query$13(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.input = client.variable("input", "CheckoutCreateInput!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation([variables.__defaultOperation__.input], function(root) {
      root.add("checkoutCreate", {
        args: {
          input: variables.__defaultOperation__.input
        }
      }, function(checkoutCreate) {
        checkoutCreate.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutCreate.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutCreate.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$14(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
    variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function(root) {
      root.add("checkoutLineItemsAdd", {
        args: {
          checkoutId: variables.__defaultOperation__.checkoutId,
          lineItems: variables.__defaultOperation__.lineItems
        }
      }, function(checkoutLineItemsAdd) {
        checkoutLineItemsAdd.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutLineItemsAdd.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutLineItemsAdd.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$15(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
    variables.__defaultOperation__.lineItemIds = client.variable("lineItemIds", "[ID!]!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItemIds], function(root) {
      root.add("checkoutLineItemsRemove", {
        args: {
          checkoutId: variables.__defaultOperation__.checkoutId,
          lineItemIds: variables.__defaultOperation__.lineItemIds
        }
      }, function(checkoutLineItemsRemove) {
        checkoutLineItemsRemove.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutLineItemsRemove.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutLineItemsRemove.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$16(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
    variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function(root) {
      root.add("checkoutLineItemsReplace", {
        args: {
          checkoutId: variables.__defaultOperation__.checkoutId,
          lineItems: variables.__defaultOperation__.lineItems
        }
      }, function(checkoutLineItemsReplace) {
        checkoutLineItemsReplace.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutLineItemsReplace.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$17(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
    variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemUpdateInput!]!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function(root) {
      root.add("checkoutLineItemsUpdate", {
        args: {
          checkoutId: variables.__defaultOperation__.checkoutId,
          lineItems: variables.__defaultOperation__.lineItems
        }
      }, function(checkoutLineItemsUpdate) {
        checkoutLineItemsUpdate.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutLineItemsUpdate.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutLineItemsUpdate.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$18(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutAttributesUpdateV2 = {};
    variables.checkoutAttributesUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
    variables.checkoutAttributesUpdateV2.input = client.variable("input", "CheckoutAttributesUpdateV2Input!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation("checkoutAttributesUpdateV2", [variables.checkoutAttributesUpdateV2.checkoutId, variables.checkoutAttributesUpdateV2.input], function(root) {
      root.add("checkoutAttributesUpdateV2", {
        args: {
          checkoutId: variables.checkoutAttributesUpdateV2.checkoutId,
          input: variables.checkoutAttributesUpdateV2.input
        }
      }, function(checkoutAttributesUpdateV2) {
        checkoutAttributesUpdateV2.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutAttributesUpdateV2.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutAttributesUpdateV2.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$19(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutDiscountCodeApplyV2 = {};
    variables.checkoutDiscountCodeApplyV2.discountCode = client.variable("discountCode", "String!");
    variables.checkoutDiscountCodeApplyV2.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation("checkoutDiscountCodeApplyV2", [variables.checkoutDiscountCodeApplyV2.discountCode, variables.checkoutDiscountCodeApplyV2.checkoutId], function(root) {
      root.add("checkoutDiscountCodeApplyV2", {
        args: {
          discountCode: variables.checkoutDiscountCodeApplyV2.discountCode,
          checkoutId: variables.checkoutDiscountCodeApplyV2.checkoutId
        }
      }, function(checkoutDiscountCodeApplyV2) {
        checkoutDiscountCodeApplyV2.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutDiscountCodeApplyV2.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutDiscountCodeApplyV2.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$20(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutDiscountCodeRemove = {};
    variables.checkoutDiscountCodeRemove.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation("checkoutDiscountCodeRemove", [variables.checkoutDiscountCodeRemove.checkoutId], function(root) {
      root.add("checkoutDiscountCodeRemove", {
        args: {
          checkoutId: variables.checkoutDiscountCodeRemove.checkoutId
        }
      }, function(checkoutDiscountCodeRemove) {
        checkoutDiscountCodeRemove.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutDiscountCodeRemove.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutDiscountCodeRemove.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$21(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutGiftCardsAppend = {};
    variables.checkoutGiftCardsAppend.giftCardCodes = client.variable("giftCardCodes", "[String!]!");
    variables.checkoutGiftCardsAppend.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation("checkoutGiftCardsAppend", [variables.checkoutGiftCardsAppend.giftCardCodes, variables.checkoutGiftCardsAppend.checkoutId], function(root) {
      root.add("checkoutGiftCardsAppend", {
        args: {
          giftCardCodes: variables.checkoutGiftCardsAppend.giftCardCodes,
          checkoutId: variables.checkoutGiftCardsAppend.checkoutId
        }
      }, function(checkoutGiftCardsAppend) {
        checkoutGiftCardsAppend.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutGiftCardsAppend.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutGiftCardsAppend.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$22(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutGiftCardRemoveV2 = {};
    variables.checkoutGiftCardRemoveV2.appliedGiftCardId = client.variable("appliedGiftCardId", "ID!");
    variables.checkoutGiftCardRemoveV2.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation("checkoutGiftCardRemoveV2", [variables.checkoutGiftCardRemoveV2.appliedGiftCardId, variables.checkoutGiftCardRemoveV2.checkoutId], function(root) {
      root.add("checkoutGiftCardRemoveV2", {
        args: {
          appliedGiftCardId: variables.checkoutGiftCardRemoveV2.appliedGiftCardId,
          checkoutId: variables.checkoutGiftCardRemoveV2.checkoutId
        }
      }, function(checkoutGiftCardRemoveV2) {
        checkoutGiftCardRemoveV2.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutGiftCardRemoveV2.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutGiftCardRemoveV2.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$23(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutEmailUpdateV2 = {};
    variables.checkoutEmailUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
    variables.checkoutEmailUpdateV2.email = client.variable("email", "String!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation("checkoutEmailUpdateV2", [variables.checkoutEmailUpdateV2.checkoutId, variables.checkoutEmailUpdateV2.email], function(root) {
      root.add("checkoutEmailUpdateV2", {
        args: {
          checkoutId: variables.checkoutEmailUpdateV2.checkoutId,
          email: variables.checkoutEmailUpdateV2.email
        }
      }, function(checkoutEmailUpdateV2) {
        checkoutEmailUpdateV2.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutEmailUpdateV2.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutEmailUpdateV2.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  function query$24(client) {
    var document2 = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutShippingAddressUpdateV2 = {};
    variables.checkoutShippingAddressUpdateV2.shippingAddress = client.variable("shippingAddress", "MailingAddressInput!");
    variables.checkoutShippingAddressUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document2.defineFragment("VariantFragment", "ProductVariant", function(root) {
      root.add("id");
      root.add("title");
      root.add("price", function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function(price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function(compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function(image2) {
        image2.add("id");
        image2.add("url", {
          alias: "src"
        });
        image2.add("altText");
        image2.add("width");
        image2.add("height");
      });
      root.add("selectedOptions", function(selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function(unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function(unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document2.defineFragment("DiscountApplicationFragment", "DiscountApplication", function(root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function(value) {
        value.addInlineFragmentOn("MoneyV2", function(MoneyV22) {
          MoneyV22.add("amount");
          MoneyV22.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function(PricingPercentageValue2) {
          PricingPercentageValue2.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function(ManualDiscountApplication2) {
        ManualDiscountApplication2.add("title");
        ManualDiscountApplication2.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function(DiscountCodeApplication2) {
        DiscountCodeApplication2.add("code");
        DiscountCodeApplication2.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function(ScriptDiscountApplication2) {
        ScriptDiscountApplication2.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function(AutomaticDiscountApplication2) {
        AutomaticDiscountApplication2.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document2.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function(root) {
      root.add("amountUsed", function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function(amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function(balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function(presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document2.defineFragment("VariantWithProductFragment", "ProductVariant", function(root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function(product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document2.defineFragment("UserErrorFragment", "UserError", function(root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document2.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function(root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document2.defineFragment("MailingAddressFragment", "MailingAddress", function(root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document2.defineFragment("CheckoutFragment", "Checkout", function(root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function(paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function(totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function(lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function(subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function(totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function(discountApplications) {
        discountApplications.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function(edges) {
          edges.add("node", function(node2) {
            node2.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function(appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function(shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function(shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function(price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function(customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function(order2) {
        order2.add("id");
        order2.add("processedAt");
        order2.add("orderNumber");
        order2.add("subtotalPrice", function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function(subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function(totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order2.add("totalTax", function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalTax", {
          alias: "totalTaxV2"
        }, function(totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order2.add("totalPrice", function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("totalPrice", {
          alias: "totalPriceV2"
        }, function(totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order2.add("currencyCode");
        order2.add("totalRefunded", function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function(totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order2.add("customerUrl");
        order2.add("shippingAddress", function(shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order2.add("lineItems", {
          args: {
            first: 250
          }
        }, function(lineItems) {
          lineItems.add("pageInfo", function(pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function(edges) {
            edges.add("cursor");
            edges.add("node", function(node2) {
              node2.add("title");
              node2.add("variant", function(variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node2.add("quantity");
              node2.add("customAttributes", function(customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function(lineItems) {
        lineItems.add("pageInfo", function(pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function(edges) {
          edges.add("cursor");
          edges.add("node", function(node2) {
            node2.add("id");
            node2.add("title");
            node2.add("variant", function(variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node2.add("quantity");
            node2.add("customAttributes", function(customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node2.add("discountAllocations", function(discountAllocations) {
              discountAllocations.add("allocatedAmount", function(allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function(discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document2.addMutation("checkoutShippingAddressUpdateV2", [variables.checkoutShippingAddressUpdateV2.shippingAddress, variables.checkoutShippingAddressUpdateV2.checkoutId], function(root) {
      root.add("checkoutShippingAddressUpdateV2", {
        args: {
          shippingAddress: variables.checkoutShippingAddressUpdateV2.shippingAddress,
          checkoutId: variables.checkoutShippingAddressUpdateV2.checkoutId
        }
      }, function(checkoutShippingAddressUpdateV2) {
        checkoutShippingAddressUpdateV2.add("userErrors", function(userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutShippingAddressUpdateV2.add("checkoutUserErrors", function(checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutShippingAddressUpdateV2.add("checkout", function(checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document2;
  }
  var CheckoutResource = function(_Resource) {
    inherits$1(CheckoutResource2, _Resource);
    function CheckoutResource2() {
      classCallCheck$1(this, CheckoutResource2);
      return possibleConstructorReturn$1(this, (CheckoutResource2.__proto__ || Object.getPrototypeOf(CheckoutResource2)).apply(this, arguments));
    }
    createClass$1(CheckoutResource2, [{
      key: "fetch",
      /**
       * Fetches a checkout by ID.
       *
       * @example
       * client.checkout.fetch('FlZj9rZXlN5MDY4ZDFiZTUyZTUwNTE2MDNhZjg=').then((checkout) => {
       *   // Do something with the checkout
       * });
       *
       * @param {String} id The id of the checkout to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the checkout.
       */
      value: function fetch2(id2) {
        var _this2 = this;
        return this.graphQLClient.send(query$12, { id: id2 }).then(defaultResolver("node")).then(function(checkout) {
          if (!checkout) {
            return null;
          }
          return _this2.graphQLClient.fetchAllPages(checkout.lineItems, { pageSize: 250 }).then(function(lineItems) {
            checkout.attrs.lineItems = lineItems;
            return checkout;
          });
        });
      }
      /**
       * Creates a checkout.
       *
       * @example
       * const input = {
       *   lineItems: [
       *     {variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}
       *   ]
       * };
       *
       * client.checkout.create(input).then((checkout) => {
       *   // Do something with the newly created checkout
       * });
       *
       * @param {Object} [input] An input object containing zero or more of:
       *   @param {String} [input.email] An email connected to the checkout.
       *   @param {Object[]} [input.lineItems] A list of line items in the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
       *   @param {Object} [input.shippingAddress] A shipping address. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/mailingaddressinput|Storefront API reference} for valid input fields.
       *   @param {String} [input.note] A note for the checkout.
       *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/attributeinput|Storefront API reference} for valid input fields.
       *   @param {String} [input.presentmentCurrencyCode ] A presentment currency code. See the {@link https://help.shopify.com/en/api/storefront-api/reference/enum/currencycode|Storefront API reference} for valid currency code values.
       * @return {Promise|GraphModel} A promise resolving with the created checkout.
       */
    }, {
      key: "create",
      value: function create() {
        var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return this.graphQLClient.send(query$13, { input }).then(handleCheckoutMutation("checkoutCreate", this.graphQLClient));
      }
      /**
       * Replaces the value of checkout's custom attributes and/or note with values defined in the input
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const input = {customAttributes: [{key: "MyKey", value: "MyValue"}]};
       *
       * client.checkout.updateAttributes(checkoutId, input).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to update.
       * @param {Object} [input] An input object containing zero or more of:
       *   @param {Boolean} [input.allowPartialAddresses] An email connected to the checkout.
       *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/attributeinput|Storefront API reference} for valid input fields.
       *   @param {String} [input.note] A note for the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "updateAttributes",
      value: function updateAttributes(checkoutId) {
        var input = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.graphQLClient.send(query$18, { checkoutId, input }).then(handleCheckoutMutation("checkoutAttributesUpdateV2", this.graphQLClient));
      }
      /**
       * Replaces the value of checkout's email address
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const email = 'user@example.com';
       *
       * client.checkout.updateEmail(checkoutId, email).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to update.
       * @param {String} email The email address to apply to the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "updateEmail",
      value: function updateEmail(checkoutId, email) {
        return this.graphQLClient.send(query$23, { checkoutId, email }).then(handleCheckoutMutation("checkoutEmailUpdateV2", this.graphQLClient));
      }
      /**
       * Adds line items to an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
       *
       * client.checkout.addLineItems(checkoutId, lineItems).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add line items to.
       * @param {Object[]} lineItems A list of line items to add to the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "addLineItems",
      value: function addLineItems(checkoutId, lineItems) {
        return this.graphQLClient.send(query$14, { checkoutId, lineItems }).then(handleCheckoutMutation("checkoutLineItemsAdd", this.graphQLClient));
      }
      /**
       * Applies a discount to an existing checkout using a discount code.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const discountCode = 'best-discount-ever';
       *
       * client.checkout.addDiscount(checkoutId, discountCode).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add discount to.
       * @param {String} discountCode The discount code to apply to the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "addDiscount",
      value: function addDiscount(checkoutId, discountCode) {
        return this.graphQLClient.send(query$19, { checkoutId, discountCode }).then(handleCheckoutMutation("checkoutDiscountCodeApplyV2", this.graphQLClient));
      }
      /**
       * Removes the applied discount from an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       *
       * client.checkout.removeDiscount(checkoutId).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to remove the discount from.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "removeDiscount",
      value: function removeDiscount(checkoutId) {
        return this.graphQLClient.send(query$20, { checkoutId }).then(handleCheckoutMutation("checkoutDiscountCodeRemove", this.graphQLClient));
      }
      /**
       * Applies gift cards to an existing checkout using a list of gift card codes
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const giftCardCodes = ['6FD8853DAGAA949F'];
       *
       * client.checkout.addGiftCards(checkoutId, giftCardCodes).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add gift cards to.
       * @param {String[]} giftCardCodes The gift card codes to apply to the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "addGiftCards",
      value: function addGiftCards(checkoutId, giftCardCodes) {
        return this.graphQLClient.send(query$21, { checkoutId, giftCardCodes }).then(handleCheckoutMutation("checkoutGiftCardsAppend", this.graphQLClient));
      }
      /**
       * Remove a gift card from an existing checkout
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const appliedGiftCardId = 'Z2lkOi8vc2hvcGlmeS9BcHBsaWVkR2lmdENhcmQvNDI4NTQ1ODAzMTI=';
       *
       * client.checkout.removeGiftCard(checkoutId, appliedGiftCardId).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add gift cards to.
       * @param {String} appliedGiftCardId The gift card id to remove from the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "removeGiftCard",
      value: function removeGiftCard(checkoutId, appliedGiftCardId) {
        return this.graphQLClient.send(query$22, { checkoutId, appliedGiftCardId }).then(handleCheckoutMutation("checkoutGiftCardRemoveV2", this.graphQLClient));
      }
      /**
       * Removes line items from an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const lineItemIds = ['TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU='];
       *
       * client.checkout.removeLineItems(checkoutId, lineItemIds).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to remove line items from.
       * @param {String[]} lineItemIds A list of the ids of line items to remove from the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "removeLineItems",
      value: function removeLineItems(checkoutId, lineItemIds) {
        return this.graphQLClient.send(query$15, { checkoutId, lineItemIds }).then(handleCheckoutMutation("checkoutLineItemsRemove", this.graphQLClient));
      }
      /**
       * Replace line items on an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
       *
       * client.checkout.replaceLineItems(checkoutId, lineItems).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add line items to.
       * @param {Object[]} lineItems A list of line items to set on the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "replaceLineItems",
      value: function replaceLineItems(checkoutId, lineItems) {
        return this.graphQLClient.send(query$16, { checkoutId, lineItems }).then(handleCheckoutMutation("checkoutLineItemsReplace", this.graphQLClient));
      }
      /**
       * Updates line items on an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const lineItems = [
       *   {
       *     id: 'TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU=',
       *     quantity: 5,
       *     variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg=='
       *   }
       * ];
       *
       * client.checkout.updateLineItems(checkoutId, lineItems).then(checkout => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to update a line item on.
       * @param {Object[]} lineItems A list of line item information to update. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineitemupdateinput|Storefront API reference} for valid input fields for each line item.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "updateLineItems",
      value: function updateLineItems(checkoutId, lineItems) {
        return this.graphQLClient.send(query$17, { checkoutId, lineItems }).then(handleCheckoutMutation("checkoutLineItemsUpdate", this.graphQLClient));
      }
      /**
       * Updates shipping address on an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const shippingAddress = {
       *    address1: 'Chestnut Street 92',
       *    address2: 'Apartment 2',
       *    city: 'Louisville',
       *    company: null,
       *    country: 'United States',
       *    firstName: 'Bob',
       *    lastName: 'Norman',
       *    phone: '555-625-1199',
       *    province: 'Kentucky',
       *    zip: '40202'
       *  };
       *
       * client.checkout.updateShippingAddress(checkoutId, shippingAddress).then(checkout => {
       *   // Do something with the updated checkout
       * });
       *
       * @param  {String} checkoutId The ID of the checkout to update shipping address.
       * @param  {Object} shippingAddress A shipping address.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */
    }, {
      key: "updateShippingAddress",
      value: function updateShippingAddress(checkoutId, shippingAddress) {
        return this.graphQLClient.send(query$24, { checkoutId, shippingAddress }).then(handleCheckoutMutation("checkoutShippingAddressUpdateV2", this.graphQLClient));
      }
    }]);
    return CheckoutResource2;
  }(Resource);
  var imageHelpers = {
    /**
     * Generates the image src for a resized image with maximum dimensions `maxWidth` and `maxHeight`.
     * Images do not scale up.
     *
     * @example
     * const url = client.image.helpers.imageForSize(product.variants[0].image, {maxWidth: 50, maxHeight: 50});
     *
     * @memberof ImageHelpers
     * @method imageForSize
     * @param {Object} image The original image model to generate the image src for.
     * @param {Object} options An options object containing:
     *  @param {Integer} options.maxWidth The maximum width for the image.
     *  @param {Integer} options.maxHeight The maximum height for the image.
     * @return {String} The image src for the resized image.
     */
    imageForSize: function imageForSize(image2, _ref) {
      var maxWidth = _ref.maxWidth, maxHeight = _ref.maxHeight;
      var splitUrl = image2.src.split("?");
      var notQuery = splitUrl[0];
      var query2 = splitUrl[1] ? "?" + splitUrl[1] : "";
      var imageTokens = notQuery.split(".");
      var imagePathIndex = imageTokens.length - 2;
      imageTokens[imagePathIndex] = imageTokens[imagePathIndex] + "_" + maxWidth + "x" + maxHeight;
      return "" + imageTokens.join(".") + query2;
    }
  };
  var ImageResource = function(_Resource) {
    inherits$1(ImageResource2, _Resource);
    function ImageResource2() {
      classCallCheck$1(this, ImageResource2);
      return possibleConstructorReturn$1(this, (ImageResource2.__proto__ || Object.getPrototypeOf(ImageResource2)).apply(this, arguments));
    }
    createClass$1(ImageResource2, [{
      key: "helpers",
      get: function get$$1() {
        return imageHelpers;
      }
    }]);
    return ImageResource2;
  }(Resource);
  var version = "2.18.0";
  var AppliedGiftCard = {
    "name": "AppliedGiftCard",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "amountUsed": "MoneyV2",
      "balance": "MoneyV2",
      "id": "ID",
      "lastCharacters": "String",
      "presentmentAmountUsed": "MoneyV2"
    },
    "implementsNode": true
  };
  var Attribute = {
    "name": "Attribute",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "key": "String",
      "value": "String"
    },
    "implementsNode": false
  };
  var AutomaticDiscountApplication = {
    "name": "AutomaticDiscountApplication",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "title": "String"
    },
    "implementsNode": false
  };
  var Boolean$1 = {
    "name": "Boolean",
    "kind": "SCALAR"
  };
  var Checkout = {
    "name": "Checkout",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "appliedGiftCards": "AppliedGiftCard",
      "completedAt": "DateTime",
      "createdAt": "DateTime",
      "currencyCode": "CurrencyCode",
      "customAttributes": "Attribute",
      "discountApplications": "DiscountApplicationConnection",
      "email": "String",
      "id": "ID",
      "lineItems": "CheckoutLineItemConnection",
      "lineItemsSubtotalPrice": "MoneyV2",
      "note": "String",
      "order": "Order",
      "orderStatusUrl": "URL",
      "paymentDue": "MoneyV2",
      "ready": "Boolean",
      "requiresShipping": "Boolean",
      "shippingAddress": "MailingAddress",
      "shippingLine": "ShippingRate",
      "subtotalPrice": "MoneyV2",
      "taxExempt": "Boolean",
      "taxesIncluded": "Boolean",
      "totalPrice": "MoneyV2",
      "totalTax": "MoneyV2",
      "updatedAt": "DateTime",
      "webUrl": "URL"
    },
    "implementsNode": true
  };
  var CheckoutAttributesUpdateV2Payload = {
    "name": "CheckoutAttributesUpdateV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutCreatePayload = {
    "name": "CheckoutCreatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutDiscountCodeApplyV2Payload = {
    "name": "CheckoutDiscountCodeApplyV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutDiscountCodeRemovePayload = {
    "name": "CheckoutDiscountCodeRemovePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutEmailUpdateV2Payload = {
    "name": "CheckoutEmailUpdateV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutErrorCode = {
    "name": "CheckoutErrorCode",
    "kind": "ENUM"
  };
  var CheckoutGiftCardRemoveV2Payload = {
    "name": "CheckoutGiftCardRemoveV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutGiftCardsAppendPayload = {
    "name": "CheckoutGiftCardsAppendPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutLineItem = {
    "name": "CheckoutLineItem",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customAttributes": "Attribute",
      "discountAllocations": "DiscountAllocation",
      "id": "ID",
      "quantity": "Int",
      "title": "String",
      "variant": "ProductVariant"
    },
    "implementsNode": true
  };
  var CheckoutLineItemConnection = {
    "name": "CheckoutLineItemConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "CheckoutLineItemEdge",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };
  var CheckoutLineItemEdge = {
    "name": "CheckoutLineItemEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "CheckoutLineItem"
    },
    "implementsNode": false
  };
  var CheckoutLineItemsAddPayload = {
    "name": "CheckoutLineItemsAddPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutLineItemsRemovePayload = {
    "name": "CheckoutLineItemsRemovePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutLineItemsReplacePayload = {
    "name": "CheckoutLineItemsReplacePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "userErrors": "CheckoutUserError"
    },
    "implementsNode": false
  };
  var CheckoutLineItemsUpdatePayload = {
    "name": "CheckoutLineItemsUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutShippingAddressUpdateV2Payload = {
    "name": "CheckoutShippingAddressUpdateV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };
  var CheckoutUserError = {
    "name": "CheckoutUserError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "CheckoutErrorCode",
      "field": "String",
      "message": "String"
    },
    "implementsNode": false
  };
  var Collection = {
    "name": "Collection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "description": "String",
      "descriptionHtml": "HTML",
      "handle": "String",
      "id": "ID",
      "image": "Image",
      "products": "ProductConnection",
      "title": "String",
      "updatedAt": "DateTime"
    },
    "implementsNode": true
  };
  var CollectionConnection = {
    "name": "CollectionConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "CollectionEdge",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };
  var CollectionEdge = {
    "name": "CollectionEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Collection"
    },
    "implementsNode": false
  };
  var CountryCode = {
    "name": "CountryCode",
    "kind": "ENUM"
  };
  var CurrencyCode = {
    "name": "CurrencyCode",
    "kind": "ENUM"
  };
  var DateTime = {
    "name": "DateTime",
    "kind": "SCALAR"
  };
  var Decimal = {
    "name": "Decimal",
    "kind": "SCALAR"
  };
  var DiscountAllocation = {
    "name": "DiscountAllocation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "allocatedAmount": "MoneyV2",
      "discountApplication": "DiscountApplication"
    },
    "implementsNode": false
  };
  var DiscountApplication = {
    "name": "DiscountApplication",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "allocationMethod": "DiscountApplicationAllocationMethod",
      "targetSelection": "DiscountApplicationTargetSelection",
      "targetType": "DiscountApplicationTargetType",
      "value": "PricingValue"
    },
    "possibleTypes": ["AutomaticDiscountApplication", "DiscountCodeApplication", "ManualDiscountApplication", "ScriptDiscountApplication"]
  };
  var DiscountApplicationAllocationMethod = {
    "name": "DiscountApplicationAllocationMethod",
    "kind": "ENUM"
  };
  var DiscountApplicationConnection = {
    "name": "DiscountApplicationConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "DiscountApplicationEdge",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };
  var DiscountApplicationEdge = {
    "name": "DiscountApplicationEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "node": "DiscountApplication"
    },
    "implementsNode": false
  };
  var DiscountApplicationTargetSelection = {
    "name": "DiscountApplicationTargetSelection",
    "kind": "ENUM"
  };
  var DiscountApplicationTargetType = {
    "name": "DiscountApplicationTargetType",
    "kind": "ENUM"
  };
  var DiscountCodeApplication = {
    "name": "DiscountCodeApplication",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "applicable": "Boolean",
      "code": "String"
    },
    "implementsNode": false
  };
  var Domain = {
    "name": "Domain",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "host": "String",
      "sslEnabled": "Boolean",
      "url": "URL"
    },
    "implementsNode": false
  };
  var Float = {
    "name": "Float",
    "kind": "SCALAR"
  };
  var HTML = {
    "name": "HTML",
    "kind": "SCALAR"
  };
  var ID = {
    "name": "ID",
    "kind": "SCALAR"
  };
  var Image$1 = {
    "name": "Image",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "altText": "String",
      "height": "Int",
      "id": "ID",
      "url": "URL",
      "width": "Int"
    },
    "implementsNode": false
  };
  var ImageConnection = {
    "name": "ImageConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "ImageEdge",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };
  var ImageEdge = {
    "name": "ImageEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Image"
    },
    "implementsNode": false
  };
  var Int$2 = {
    "name": "Int",
    "kind": "SCALAR"
  };
  var MailingAddress = {
    "name": "MailingAddress",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "address1": "String",
      "address2": "String",
      "city": "String",
      "company": "String",
      "country": "String",
      "countryCodeV2": "CountryCode",
      "firstName": "String",
      "formatted": "String",
      "id": "ID",
      "lastName": "String",
      "latitude": "Float",
      "longitude": "Float",
      "name": "String",
      "phone": "String",
      "province": "String",
      "provinceCode": "String",
      "zip": "String"
    },
    "implementsNode": true
  };
  var ManualDiscountApplication = {
    "name": "ManualDiscountApplication",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "description": "String",
      "title": "String"
    },
    "implementsNode": false
  };
  var MoneyV2 = {
    "name": "MoneyV2",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "amount": "Decimal",
      "currencyCode": "CurrencyCode"
    },
    "implementsNode": false
  };
  var Mutation$1 = {
    "name": "Mutation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Payload",
      "checkoutCreate": "CheckoutCreatePayload",
      "checkoutDiscountCodeApplyV2": "CheckoutDiscountCodeApplyV2Payload",
      "checkoutDiscountCodeRemove": "CheckoutDiscountCodeRemovePayload",
      "checkoutEmailUpdateV2": "CheckoutEmailUpdateV2Payload",
      "checkoutGiftCardRemoveV2": "CheckoutGiftCardRemoveV2Payload",
      "checkoutGiftCardsAppend": "CheckoutGiftCardsAppendPayload",
      "checkoutLineItemsAdd": "CheckoutLineItemsAddPayload",
      "checkoutLineItemsRemove": "CheckoutLineItemsRemovePayload",
      "checkoutLineItemsReplace": "CheckoutLineItemsReplacePayload",
      "checkoutLineItemsUpdate": "CheckoutLineItemsUpdatePayload",
      "checkoutShippingAddressUpdateV2": "CheckoutShippingAddressUpdateV2Payload"
    },
    "implementsNode": false,
    "relayInputObjectBaseTypes": {
      "cartCreate": "CartInput",
      "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Input",
      "checkoutCreate": "CheckoutCreateInput",
      "customerAccessTokenCreate": "CustomerAccessTokenCreateInput",
      "customerActivate": "CustomerActivateInput",
      "customerCreate": "CustomerCreateInput",
      "customerReset": "CustomerResetInput"
    }
  };
  var Node = {
    "name": "Node",
    "kind": "INTERFACE",
    "fieldBaseTypes": {},
    "possibleTypes": ["AppliedGiftCard", "Article", "Blog", "Cart", "CartLine", "Checkout", "CheckoutLineItem", "Collection", "Comment", "ExternalVideo", "GenericFile", "Location", "MailingAddress", "MediaImage", "Menu", "MenuItem", "Metafield", "Metaobject", "Model3d", "Order", "Page", "Payment", "Product", "ProductOption", "ProductVariant", "Shop", "ShopPolicy", "UrlRedirect", "Video"]
  };
  var Order = {
    "name": "Order",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "currencyCode": "CurrencyCode",
      "customerUrl": "URL",
      "id": "ID",
      "lineItems": "OrderLineItemConnection",
      "orderNumber": "Int",
      "processedAt": "DateTime",
      "shippingAddress": "MailingAddress",
      "subtotalPrice": "MoneyV2",
      "totalPrice": "MoneyV2",
      "totalRefunded": "MoneyV2",
      "totalShippingPrice": "MoneyV2",
      "totalTax": "MoneyV2"
    },
    "implementsNode": true
  };
  var OrderLineItem = {
    "name": "OrderLineItem",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customAttributes": "Attribute",
      "quantity": "Int",
      "title": "String",
      "variant": "ProductVariant"
    },
    "implementsNode": false
  };
  var OrderLineItemConnection = {
    "name": "OrderLineItemConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "OrderLineItemEdge",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };
  var OrderLineItemEdge = {
    "name": "OrderLineItemEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "OrderLineItem"
    },
    "implementsNode": false
  };
  var PageInfo = {
    "name": "PageInfo",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "hasNextPage": "Boolean",
      "hasPreviousPage": "Boolean"
    },
    "implementsNode": false
  };
  var PaymentSettings = {
    "name": "PaymentSettings",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "enabledPresentmentCurrencies": "CurrencyCode"
    },
    "implementsNode": false
  };
  var PricingPercentageValue = {
    "name": "PricingPercentageValue",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "percentage": "Float"
    },
    "implementsNode": false
  };
  var PricingValue = {
    "name": "PricingValue",
    "kind": "UNION"
  };
  var Product$3 = {
    "name": "Product",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "availableForSale": "Boolean",
      "createdAt": "DateTime",
      "description": "String",
      "descriptionHtml": "HTML",
      "handle": "String",
      "id": "ID",
      "images": "ImageConnection",
      "onlineStoreUrl": "URL",
      "options": "ProductOption",
      "productType": "String",
      "publishedAt": "DateTime",
      "title": "String",
      "updatedAt": "DateTime",
      "variants": "ProductVariantConnection",
      "vendor": "String"
    },
    "implementsNode": true
  };
  var ProductConnection = {
    "name": "ProductConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "ProductEdge",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };
  var ProductEdge = {
    "name": "ProductEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Product"
    },
    "implementsNode": false
  };
  var ProductOption = {
    "name": "ProductOption",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "name": "String",
      "values": "String"
    },
    "implementsNode": true
  };
  var ProductVariant = {
    "name": "ProductVariant",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "availableForSale": "Boolean",
      "compareAtPrice": "MoneyV2",
      "id": "ID",
      "image": "Image",
      "price": "MoneyV2",
      "product": "Product",
      "selectedOptions": "SelectedOption",
      "sku": "String",
      "title": "String",
      "unitPrice": "MoneyV2",
      "unitPriceMeasurement": "UnitPriceMeasurement",
      "weight": "Float"
    },
    "implementsNode": true
  };
  var ProductVariantConnection = {
    "name": "ProductVariantConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "ProductVariantEdge",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };
  var ProductVariantEdge = {
    "name": "ProductVariantEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "ProductVariant"
    },
    "implementsNode": false
  };
  var QueryRoot = {
    "name": "QueryRoot",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "collectionByHandle": "Collection",
      "collections": "CollectionConnection",
      "node": "Node",
      "nodes": "Node",
      "productByHandle": "Product",
      "productRecommendations": "Product",
      "products": "ProductConnection",
      "shop": "Shop"
    },
    "implementsNode": false
  };
  var ScriptDiscountApplication = {
    "name": "ScriptDiscountApplication",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "title": "String"
    },
    "implementsNode": false
  };
  var SelectedOption = {
    "name": "SelectedOption",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "name": "String",
      "value": "String"
    },
    "implementsNode": false
  };
  var ShippingRate = {
    "name": "ShippingRate",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "handle": "String",
      "price": "MoneyV2",
      "title": "String"
    },
    "implementsNode": false
  };
  var Shop = {
    "name": "Shop",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "description": "String",
      "moneyFormat": "String",
      "name": "String",
      "paymentSettings": "PaymentSettings",
      "primaryDomain": "Domain",
      "privacyPolicy": "ShopPolicy",
      "refundPolicy": "ShopPolicy",
      "termsOfService": "ShopPolicy"
    },
    "implementsNode": true
  };
  var ShopPolicy = {
    "name": "ShopPolicy",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "body": "String",
      "id": "ID",
      "title": "String",
      "url": "URL"
    },
    "implementsNode": true
  };
  var String$1 = {
    "name": "String",
    "kind": "SCALAR"
  };
  var URL = {
    "name": "URL",
    "kind": "SCALAR"
  };
  var UnitPriceMeasurement = {
    "name": "UnitPriceMeasurement",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "measuredType": "UnitPriceMeasurementMeasuredType",
      "quantityUnit": "UnitPriceMeasurementMeasuredUnit",
      "quantityValue": "Float",
      "referenceUnit": "UnitPriceMeasurementMeasuredUnit",
      "referenceValue": "Int"
    },
    "implementsNode": false
  };
  var UnitPriceMeasurementMeasuredType = {
    "name": "UnitPriceMeasurementMeasuredType",
    "kind": "ENUM"
  };
  var UnitPriceMeasurementMeasuredUnit = {
    "name": "UnitPriceMeasurementMeasuredUnit",
    "kind": "ENUM"
  };
  var UserError = {
    "name": "UserError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "field": "String",
      "message": "String"
    },
    "implementsNode": false
  };
  var Types = {
    types: {}
  };
  Types.types["AppliedGiftCard"] = AppliedGiftCard;
  Types.types["Attribute"] = Attribute;
  Types.types["AutomaticDiscountApplication"] = AutomaticDiscountApplication;
  Types.types["Boolean"] = Boolean$1;
  Types.types["Checkout"] = Checkout;
  Types.types["CheckoutAttributesUpdateV2Payload"] = CheckoutAttributesUpdateV2Payload;
  Types.types["CheckoutCreatePayload"] = CheckoutCreatePayload;
  Types.types["CheckoutDiscountCodeApplyV2Payload"] = CheckoutDiscountCodeApplyV2Payload;
  Types.types["CheckoutDiscountCodeRemovePayload"] = CheckoutDiscountCodeRemovePayload;
  Types.types["CheckoutEmailUpdateV2Payload"] = CheckoutEmailUpdateV2Payload;
  Types.types["CheckoutErrorCode"] = CheckoutErrorCode;
  Types.types["CheckoutGiftCardRemoveV2Payload"] = CheckoutGiftCardRemoveV2Payload;
  Types.types["CheckoutGiftCardsAppendPayload"] = CheckoutGiftCardsAppendPayload;
  Types.types["CheckoutLineItem"] = CheckoutLineItem;
  Types.types["CheckoutLineItemConnection"] = CheckoutLineItemConnection;
  Types.types["CheckoutLineItemEdge"] = CheckoutLineItemEdge;
  Types.types["CheckoutLineItemsAddPayload"] = CheckoutLineItemsAddPayload;
  Types.types["CheckoutLineItemsRemovePayload"] = CheckoutLineItemsRemovePayload;
  Types.types["CheckoutLineItemsReplacePayload"] = CheckoutLineItemsReplacePayload;
  Types.types["CheckoutLineItemsUpdatePayload"] = CheckoutLineItemsUpdatePayload;
  Types.types["CheckoutShippingAddressUpdateV2Payload"] = CheckoutShippingAddressUpdateV2Payload;
  Types.types["CheckoutUserError"] = CheckoutUserError;
  Types.types["Collection"] = Collection;
  Types.types["CollectionConnection"] = CollectionConnection;
  Types.types["CollectionEdge"] = CollectionEdge;
  Types.types["CountryCode"] = CountryCode;
  Types.types["CurrencyCode"] = CurrencyCode;
  Types.types["DateTime"] = DateTime;
  Types.types["Decimal"] = Decimal;
  Types.types["DiscountAllocation"] = DiscountAllocation;
  Types.types["DiscountApplication"] = DiscountApplication;
  Types.types["DiscountApplicationAllocationMethod"] = DiscountApplicationAllocationMethod;
  Types.types["DiscountApplicationConnection"] = DiscountApplicationConnection;
  Types.types["DiscountApplicationEdge"] = DiscountApplicationEdge;
  Types.types["DiscountApplicationTargetSelection"] = DiscountApplicationTargetSelection;
  Types.types["DiscountApplicationTargetType"] = DiscountApplicationTargetType;
  Types.types["DiscountCodeApplication"] = DiscountCodeApplication;
  Types.types["Domain"] = Domain;
  Types.types["Float"] = Float;
  Types.types["HTML"] = HTML;
  Types.types["ID"] = ID;
  Types.types["Image"] = Image$1;
  Types.types["ImageConnection"] = ImageConnection;
  Types.types["ImageEdge"] = ImageEdge;
  Types.types["Int"] = Int$2;
  Types.types["MailingAddress"] = MailingAddress;
  Types.types["ManualDiscountApplication"] = ManualDiscountApplication;
  Types.types["MoneyV2"] = MoneyV2;
  Types.types["Mutation"] = Mutation$1;
  Types.types["Node"] = Node;
  Types.types["Order"] = Order;
  Types.types["OrderLineItem"] = OrderLineItem;
  Types.types["OrderLineItemConnection"] = OrderLineItemConnection;
  Types.types["OrderLineItemEdge"] = OrderLineItemEdge;
  Types.types["PageInfo"] = PageInfo;
  Types.types["PaymentSettings"] = PaymentSettings;
  Types.types["PricingPercentageValue"] = PricingPercentageValue;
  Types.types["PricingValue"] = PricingValue;
  Types.types["Product"] = Product$3;
  Types.types["ProductConnection"] = ProductConnection;
  Types.types["ProductEdge"] = ProductEdge;
  Types.types["ProductOption"] = ProductOption;
  Types.types["ProductVariant"] = ProductVariant;
  Types.types["ProductVariantConnection"] = ProductVariantConnection;
  Types.types["ProductVariantEdge"] = ProductVariantEdge;
  Types.types["QueryRoot"] = QueryRoot;
  Types.types["ScriptDiscountApplication"] = ScriptDiscountApplication;
  Types.types["SelectedOption"] = SelectedOption;
  Types.types["ShippingRate"] = ShippingRate;
  Types.types["Shop"] = Shop;
  Types.types["ShopPolicy"] = ShopPolicy;
  Types.types["String"] = String$1;
  Types.types["URL"] = URL;
  Types.types["UnitPriceMeasurement"] = UnitPriceMeasurement;
  Types.types["UnitPriceMeasurementMeasuredType"] = UnitPriceMeasurementMeasuredType;
  Types.types["UnitPriceMeasurementMeasuredUnit"] = UnitPriceMeasurementMeasuredUnit;
  Types.types["UserError"] = UserError;
  Types.queryType = "QueryRoot";
  Types.mutationType = "Mutation";
  Types.subscriptionType = null;
  function recursivelyFreezeObject(structure) {
    Object.getOwnPropertyNames(structure).forEach(function(key) {
      var value = structure[key];
      if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
        recursivelyFreezeObject(value);
      }
    });
    Object.freeze(structure);
    return structure;
  }
  var types = recursivelyFreezeObject(Types);
  var Client = function() {
    createClass$1(Client2, null, [{
      key: "buildClient",
      /**
       * Primary entry point for building a new Client.
       */
      value: function buildClient(config, fetchFunction) {
        var newConfig = new Config(config);
        var client = new Client2(newConfig, Client$2, fetchFunction);
        client.config = newConfig;
        return client;
      }
      /**
       * @constructs Client
       * @param {Config} config An instance of {@link Config} used to configure the Client.
       */
    }]);
    function Client2(config) {
      var GraphQLClientClass = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Client$2;
      var fetchFunction = arguments[2];
      classCallCheck$1(this, Client2);
      var url = "https://" + config.domain + "/api/" + config.apiVersion + "/graphql";
      var headers = {
        "X-SDK-Variant": "javascript",
        "X-SDK-Version": version,
        "X-Shopify-Storefront-Access-Token": config.storefrontAccessToken
      };
      if (config.source) {
        headers["X-SDK-Variant-Source"] = config.source;
      }
      var languageHeader = config.language ? config.language : "*";
      headers["Accept-Language"] = languageHeader;
      if (fetchFunction) {
        headers["Content-Type"] = "application/json";
        headers.Accept = "application/json";
        this.graphQLClient = new GraphQLClientClass(types, {
          fetcher: function fetcher(graphQLParams) {
            return fetchFunction(url, {
              body: JSON.stringify(graphQLParams),
              method: "POST",
              mode: "cors",
              headers
            }).then(function(response) {
              return response.json();
            });
          }
        });
      } else {
        this.graphQLClient = new GraphQLClientClass(types, {
          url,
          fetcherOptions: { headers }
        });
      }
      this.product = new ProductResource(this.graphQLClient);
      this.collection = new CollectionResource(this.graphQLClient);
      this.shop = new ShopResource(this.graphQLClient);
      this.checkout = new CheckoutResource(this.graphQLClient);
      this.image = new ImageResource(this.graphQLClient);
    }
    createClass$1(Client2, [{
      key: "fetchNextPage",
      value: function fetchNextPage(models2) {
        return this.graphQLClient.fetchNextPage(models2);
      }
    }]);
    return Client2;
  }();
  const useClient = (config) => {
    const [client, setClient] = h$2(false);
    const [checkout, setCheckout] = h$2(false);
    const fetchClient = async function() {
      let client2 = Client.buildClient({
        domain: "giftboxloveco.myshopify.com",
        storefrontAccessToken: "0eae98fe5ae8c99241a5dbcf696f0a95"
      });
      setCheckout(null);
      setClient(client2);
    };
    p$2(() => {
      fetchClient();
    }, []);
    return [client, checkout];
  };
  var getDefaultStyle = function(visible) {
    return {
      display: visible ? "flex" : "none"
    };
  };
  var DEFAULT_COLOR = "#4fa94d";
  var DEFAULT_WAI_ARIA_ATTRIBUTE = {
    "aria-busy": true,
    role: "status"
  };
  var __assign$v = globalThis && globalThis.__assign || function() {
    __assign$v = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$v.apply(this, arguments);
  };
  var __assign$u = globalThis && globalThis.__assign || function() {
    __assign$u = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$u.apply(this, arguments);
  };
  var __assign$t = globalThis && globalThis.__assign || function() {
    __assign$t = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$t.apply(this, arguments);
  };
  var __assign$s = globalThis && globalThis.__assign || function() {
    __assign$s = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$s.apply(this, arguments);
  };
  var __assign$r = globalThis && globalThis.__assign || function() {
    __assign$r = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$r.apply(this, arguments);
  };
  var __assign$q = globalThis && globalThis.__assign || function() {
    __assign$q = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$q.apply(this, arguments);
  };
  var __assign$p = globalThis && globalThis.__assign || function() {
    __assign$p = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$p.apply(this, arguments);
  };
  var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
  function getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
  }
  function getAugmentedNamespace(n2) {
    if (n2.__esModule)
      return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
      var a2 = function a3() {
        if (this instanceof a3) {
          var args = [null];
          args.push.apply(args, arguments);
          var Ctor = Function.bind.apply(f2, args);
          return new Ctor();
        }
        return f2.apply(this, arguments);
      };
      a2.prototype = f2.prototype;
    } else
      a2 = {};
    Object.defineProperty(a2, "__esModule", { value: true });
    Object.keys(n2).forEach(function(k2) {
      var d2 = Object.getOwnPropertyDescriptor(n2, k2);
      Object.defineProperty(a2, k2, d2.get ? d2 : {
        enumerable: true,
        get: function() {
          return n2[k2];
        }
      });
    });
    return a2;
  }
  var reactIsExports = {};
  var reactIs$1 = {
    get exports() {
      return reactIsExports;
    },
    set exports(v2) {
      reactIsExports = v2;
    }
  };
  var reactIs_production_min = {};
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var b$1 = "function" === typeof Symbol && Symbol.for, c = b$1 ? Symbol.for("react.element") : 60103, d = b$1 ? Symbol.for("react.portal") : 60106, e = b$1 ? Symbol.for("react.fragment") : 60107, f = b$1 ? Symbol.for("react.strict_mode") : 60108, g$1 = b$1 ? Symbol.for("react.profiler") : 60114, h = b$1 ? Symbol.for("react.provider") : 60109, k$1 = b$1 ? Symbol.for("react.context") : 60110, l = b$1 ? Symbol.for("react.async_mode") : 60111, m = b$1 ? Symbol.for("react.concurrent_mode") : 60111, n = b$1 ? Symbol.for("react.forward_ref") : 60112, p = b$1 ? Symbol.for("react.suspense") : 60113, q$1 = b$1 ? Symbol.for("react.suspense_list") : 60120, r = b$1 ? Symbol.for("react.memo") : 60115, t = b$1 ? Symbol.for("react.lazy") : 60116, v$1 = b$1 ? Symbol.for("react.block") : 60121, w$1 = b$1 ? Symbol.for("react.fundamental") : 60117, x$1 = b$1 ? Symbol.for("react.responder") : 60118, y = b$1 ? Symbol.for("react.scope") : 60119;
  function z$1(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c:
          switch (a2 = a2.type, a2) {
            case l:
            case m:
            case e:
            case g$1:
            case f:
            case p:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k$1:
                case n:
                case t:
                case r:
                case h:
                  return a2;
                default:
                  return u2;
              }
          }
        case d:
          return u2;
      }
    }
  }
  function A$1(a2) {
    return z$1(a2) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k$1;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g$1;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a2) {
    return A$1(a2) || z$1(a2) === l;
  };
  reactIs_production_min.isConcurrentMode = A$1;
  reactIs_production_min.isContextConsumer = function(a2) {
    return z$1(a2) === k$1;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return z$1(a2) === h;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return z$1(a2) === n;
  };
  reactIs_production_min.isFragment = function(a2) {
    return z$1(a2) === e;
  };
  reactIs_production_min.isLazy = function(a2) {
    return z$1(a2) === t;
  };
  reactIs_production_min.isMemo = function(a2) {
    return z$1(a2) === r;
  };
  reactIs_production_min.isPortal = function(a2) {
    return z$1(a2) === d;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return z$1(a2) === g$1;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return z$1(a2) === f;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return z$1(a2) === p;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e || a2 === m || a2 === g$1 || a2 === f || a2 === p || a2 === q$1 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t || a2.$$typeof === r || a2.$$typeof === h || a2.$$typeof === k$1 || a2.$$typeof === n || a2.$$typeof === w$1 || a2.$$typeof === x$1 || a2.$$typeof === y || a2.$$typeof === v$1);
  };
  reactIs_production_min.typeOf = z$1;
  (function(module) {
    {
      module.exports = reactIs_production_min;
    }
  })(reactIs$1);
  function stylis_min(W2) {
    function M2(d2, c2, e2, h2, a2) {
      for (var m2 = 0, b2 = 0, v2 = 0, n2 = 0, q2, g2, x2 = 0, K2 = 0, k2, u2 = k2 = q2 = 0, l2 = 0, r2 = 0, I2 = 0, t2 = 0, B3 = e2.length, J2 = B3 - 1, y2, f2 = "", p2 = "", F3 = "", G3 = "", C2; l2 < B3; ) {
        g2 = e2.charCodeAt(l2);
        l2 === J2 && 0 !== b2 + n2 + v2 + m2 && (0 !== b2 && (g2 = 47 === b2 ? 10 : 47), n2 = v2 = m2 = 0, B3++, J2++);
        if (0 === b2 + n2 + v2 + m2) {
          if (l2 === J2 && (0 < r2 && (f2 = f2.replace(N2, "")), 0 < f2.trim().length)) {
            switch (g2) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;
              default:
                f2 += e2.charAt(l2);
            }
            g2 = 59;
          }
          switch (g2) {
            case 123:
              f2 = f2.trim();
              q2 = f2.charCodeAt(0);
              k2 = 1;
              for (t2 = ++l2; l2 < B3; ) {
                switch (g2 = e2.charCodeAt(l2)) {
                  case 123:
                    k2++;
                    break;
                  case 125:
                    k2--;
                    break;
                  case 47:
                    switch (g2 = e2.charCodeAt(l2 + 1)) {
                      case 42:
                      case 47:
                        a: {
                          for (u2 = l2 + 1; u2 < J2; ++u2) {
                            switch (e2.charCodeAt(u2)) {
                              case 47:
                                if (42 === g2 && 42 === e2.charCodeAt(u2 - 1) && l2 + 2 !== u2) {
                                  l2 = u2 + 1;
                                  break a;
                                }
                                break;
                              case 10:
                                if (47 === g2) {
                                  l2 = u2 + 1;
                                  break a;
                                }
                            }
                          }
                          l2 = u2;
                        }
                    }
                    break;
                  case 91:
                    g2++;
                  case 40:
                    g2++;
                  case 34:
                  case 39:
                    for (; l2++ < J2 && e2.charCodeAt(l2) !== g2; ) {
                    }
                }
                if (0 === k2)
                  break;
                l2++;
              }
              k2 = e2.substring(t2, l2);
              0 === q2 && (q2 = (f2 = f2.replace(ca, "").trim()).charCodeAt(0));
              switch (q2) {
                case 64:
                  0 < r2 && (f2 = f2.replace(N2, ""));
                  g2 = f2.charCodeAt(1);
                  switch (g2) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      r2 = c2;
                      break;
                    default:
                      r2 = O2;
                  }
                  k2 = M2(c2, r2, k2, g2, a2 + 1);
                  t2 = k2.length;
                  0 < A2 && (r2 = X2(O2, f2, I2), C2 = H2(3, k2, r2, c2, D2, z2, t2, g2, a2, h2), f2 = r2.join(""), void 0 !== C2 && 0 === (t2 = (k2 = C2.trim()).length) && (g2 = 0, k2 = ""));
                  if (0 < t2)
                    switch (g2) {
                      case 115:
                        f2 = f2.replace(da, ea);
                      case 100:
                      case 109:
                      case 45:
                        k2 = f2 + "{" + k2 + "}";
                        break;
                      case 107:
                        f2 = f2.replace(fa, "$1 $2");
                        k2 = f2 + "{" + k2 + "}";
                        k2 = 1 === w2 || 2 === w2 && L2("@" + k2, 3) ? "@-webkit-" + k2 + "@" + k2 : "@" + k2;
                        break;
                      default:
                        k2 = f2 + k2, 112 === h2 && (k2 = (p2 += k2, ""));
                    }
                  else
                    k2 = "";
                  break;
                default:
                  k2 = M2(c2, X2(c2, f2, I2), k2, h2, a2 + 1);
              }
              F3 += k2;
              k2 = I2 = r2 = u2 = q2 = 0;
              f2 = "";
              g2 = e2.charCodeAt(++l2);
              break;
            case 125:
            case 59:
              f2 = (0 < r2 ? f2.replace(N2, "") : f2).trim();
              if (1 < (t2 = f2.length))
                switch (0 === u2 && (q2 = f2.charCodeAt(0), 45 === q2 || 96 < q2 && 123 > q2) && (t2 = (f2 = f2.replace(" ", ":")).length), 0 < A2 && void 0 !== (C2 = H2(1, f2, c2, d2, D2, z2, p2.length, h2, a2, h2)) && 0 === (t2 = (f2 = C2.trim()).length) && (f2 = "\0\0"), q2 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q2) {
                  case 0:
                    break;
                  case 64:
                    if (105 === g2 || 99 === g2) {
                      G3 += f2 + e2.charAt(l2);
                      break;
                    }
                  default:
                    58 !== f2.charCodeAt(t2 - 1) && (p2 += P2(f2, q2, g2, f2.charCodeAt(2)));
                }
              I2 = r2 = u2 = q2 = 0;
              f2 = "";
              g2 = e2.charCodeAt(++l2);
          }
        }
        switch (g2) {
          case 13:
          case 10:
            47 === b2 ? b2 = 0 : 0 === 1 + q2 && 107 !== h2 && 0 < f2.length && (r2 = 1, f2 += "\0");
            0 < A2 * Y2 && H2(0, f2, c2, d2, D2, z2, p2.length, h2, a2, h2);
            z2 = 1;
            D2++;
            break;
          case 59:
          case 125:
            if (0 === b2 + n2 + v2 + m2) {
              z2++;
              break;
            }
          default:
            z2++;
            y2 = e2.charAt(l2);
            switch (g2) {
              case 9:
              case 32:
                if (0 === n2 + m2 + b2)
                  switch (x2) {
                    case 44:
                    case 58:
                    case 9:
                    case 32:
                      y2 = "";
                      break;
                    default:
                      32 !== g2 && (y2 = " ");
                  }
                break;
              case 0:
                y2 = "\\0";
                break;
              case 12:
                y2 = "\\f";
                break;
              case 11:
                y2 = "\\v";
                break;
              case 38:
                0 === n2 + b2 + m2 && (r2 = I2 = 1, y2 = "\f" + y2);
                break;
              case 108:
                if (0 === n2 + b2 + m2 + E2 && 0 < u2)
                  switch (l2 - u2) {
                    case 2:
                      112 === x2 && 58 === e2.charCodeAt(l2 - 3) && (E2 = x2);
                    case 8:
                      111 === K2 && (E2 = K2);
                  }
                break;
              case 58:
                0 === n2 + b2 + m2 && (u2 = l2);
                break;
              case 44:
                0 === b2 + v2 + n2 + m2 && (r2 = 1, y2 += "\r");
                break;
              case 34:
              case 39:
                0 === b2 && (n2 = n2 === g2 ? 0 : 0 === n2 ? g2 : n2);
                break;
              case 91:
                0 === n2 + b2 + v2 && m2++;
                break;
              case 93:
                0 === n2 + b2 + v2 && m2--;
                break;
              case 41:
                0 === n2 + b2 + m2 && v2--;
                break;
              case 40:
                if (0 === n2 + b2 + m2) {
                  if (0 === q2)
                    switch (2 * x2 + 3 * K2) {
                      case 533:
                        break;
                      default:
                        q2 = 1;
                    }
                  v2++;
                }
                break;
              case 64:
                0 === b2 + v2 + n2 + m2 + u2 + k2 && (k2 = 1);
                break;
              case 42:
              case 47:
                if (!(0 < n2 + m2 + v2))
                  switch (b2) {
                    case 0:
                      switch (2 * g2 + 3 * e2.charCodeAt(l2 + 1)) {
                        case 235:
                          b2 = 47;
                          break;
                        case 220:
                          t2 = l2, b2 = 42;
                      }
                      break;
                    case 42:
                      47 === g2 && 42 === x2 && t2 + 2 !== l2 && (33 === e2.charCodeAt(t2 + 2) && (p2 += e2.substring(t2, l2 + 1)), y2 = "", b2 = 0);
                  }
            }
            0 === b2 && (f2 += y2);
        }
        K2 = x2;
        x2 = g2;
        l2++;
      }
      t2 = p2.length;
      if (0 < t2) {
        r2 = c2;
        if (0 < A2 && (C2 = H2(2, p2, r2, d2, D2, z2, t2, h2, a2, h2), void 0 !== C2 && 0 === (p2 = C2).length))
          return G3 + p2 + F3;
        p2 = r2.join(",") + "{" + p2 + "}";
        if (0 !== w2 * E2) {
          2 !== w2 || L2(p2, 2) || (E2 = 0);
          switch (E2) {
            case 111:
              p2 = p2.replace(ha, ":-moz-$1") + p2;
              break;
            case 112:
              p2 = p2.replace(Q2, "::-webkit-input-$1") + p2.replace(Q2, "::-moz-$1") + p2.replace(Q2, ":-ms-input-$1") + p2;
          }
          E2 = 0;
        }
      }
      return G3 + p2 + F3;
    }
    function X2(d2, c2, e2) {
      var h2 = c2.trim().split(ia);
      c2 = h2;
      var a2 = h2.length, m2 = d2.length;
      switch (m2) {
        case 0:
        case 1:
          var b2 = 0;
          for (d2 = 0 === m2 ? "" : d2[0] + " "; b2 < a2; ++b2) {
            c2[b2] = Z2(d2, c2[b2], e2).trim();
          }
          break;
        default:
          var v2 = b2 = 0;
          for (c2 = []; b2 < a2; ++b2) {
            for (var n2 = 0; n2 < m2; ++n2) {
              c2[v2++] = Z2(d2[n2] + " ", h2[b2], e2).trim();
            }
          }
      }
      return c2;
    }
    function Z2(d2, c2, e2) {
      var h2 = c2.charCodeAt(0);
      33 > h2 && (h2 = (c2 = c2.trim()).charCodeAt(0));
      switch (h2) {
        case 38:
          return c2.replace(F2, "$1" + d2.trim());
        case 58:
          return d2.trim() + c2.replace(F2, "$1" + d2.trim());
        default:
          if (0 < 1 * e2 && 0 < c2.indexOf("\f"))
            return c2.replace(F2, (58 === d2.charCodeAt(0) ? "" : "$1") + d2.trim());
      }
      return d2 + c2;
    }
    function P2(d2, c2, e2, h2) {
      var a2 = d2 + ";", m2 = 2 * c2 + 3 * e2 + 4 * h2;
      if (944 === m2) {
        d2 = a2.indexOf(":", 9) + 1;
        var b2 = a2.substring(d2, a2.length - 1).trim();
        b2 = a2.substring(0, d2).trim() + b2 + ";";
        return 1 === w2 || 2 === w2 && L2(b2, 1) ? "-webkit-" + b2 + b2 : b2;
      }
      if (0 === w2 || 2 === w2 && !L2(a2, 1))
        return a2;
      switch (m2) {
        case 1015:
          return 97 === a2.charCodeAt(10) ? "-webkit-" + a2 + a2 : a2;
        case 951:
          return 116 === a2.charCodeAt(3) ? "-webkit-" + a2 + a2 : a2;
        case 963:
          return 110 === a2.charCodeAt(5) ? "-webkit-" + a2 + a2 : a2;
        case 1009:
          if (100 !== a2.charCodeAt(4))
            break;
        case 969:
        case 942:
          return "-webkit-" + a2 + a2;
        case 978:
          return "-webkit-" + a2 + "-moz-" + a2 + a2;
        case 1019:
        case 983:
          return "-webkit-" + a2 + "-moz-" + a2 + "-ms-" + a2 + a2;
        case 883:
          if (45 === a2.charCodeAt(8))
            return "-webkit-" + a2 + a2;
          if (0 < a2.indexOf("image-set(", 11))
            return a2.replace(ja, "$1-webkit-$2") + a2;
          break;
        case 932:
          if (45 === a2.charCodeAt(4))
            switch (a2.charCodeAt(5)) {
              case 103:
                return "-webkit-box-" + a2.replace("-grow", "") + "-webkit-" + a2 + "-ms-" + a2.replace("grow", "positive") + a2;
              case 115:
                return "-webkit-" + a2 + "-ms-" + a2.replace("shrink", "negative") + a2;
              case 98:
                return "-webkit-" + a2 + "-ms-" + a2.replace("basis", "preferred-size") + a2;
            }
          return "-webkit-" + a2 + "-ms-" + a2 + a2;
        case 964:
          return "-webkit-" + a2 + "-ms-flex-" + a2 + a2;
        case 1023:
          if (99 !== a2.charCodeAt(8))
            break;
          b2 = a2.substring(a2.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
          return "-webkit-box-pack" + b2 + "-webkit-" + a2 + "-ms-flex-pack" + b2 + a2;
        case 1005:
          return ka.test(a2) ? a2.replace(aa, ":-webkit-") + a2.replace(aa, ":-moz-") + a2 : a2;
        case 1e3:
          b2 = a2.substring(13).trim();
          c2 = b2.indexOf("-") + 1;
          switch (b2.charCodeAt(0) + b2.charCodeAt(c2)) {
            case 226:
              b2 = a2.replace(G2, "tb");
              break;
            case 232:
              b2 = a2.replace(G2, "tb-rl");
              break;
            case 220:
              b2 = a2.replace(G2, "lr");
              break;
            default:
              return a2;
          }
          return "-webkit-" + a2 + "-ms-" + b2 + a2;
        case 1017:
          if (-1 === a2.indexOf("sticky", 9))
            break;
        case 975:
          c2 = (a2 = d2).length - 10;
          b2 = (33 === a2.charCodeAt(c2) ? a2.substring(0, c2) : a2).substring(d2.indexOf(":", 7) + 1).trim();
          switch (m2 = b2.charCodeAt(0) + (b2.charCodeAt(7) | 0)) {
            case 203:
              if (111 > b2.charCodeAt(8))
                break;
            case 115:
              a2 = a2.replace(b2, "-webkit-" + b2) + ";" + a2;
              break;
            case 207:
            case 102:
              a2 = a2.replace(b2, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a2.replace(b2, "-webkit-" + b2) + ";" + a2.replace(b2, "-ms-" + b2 + "box") + ";" + a2;
          }
          return a2 + ";";
        case 938:
          if (45 === a2.charCodeAt(5))
            switch (a2.charCodeAt(6)) {
              case 105:
                return b2 = a2.replace("-items", ""), "-webkit-" + a2 + "-webkit-box-" + b2 + "-ms-flex-" + b2 + a2;
              case 115:
                return "-webkit-" + a2 + "-ms-flex-item-" + a2.replace(ba, "") + a2;
              default:
                return "-webkit-" + a2 + "-ms-flex-line-pack" + a2.replace("align-content", "").replace(ba, "") + a2;
            }
          break;
        case 973:
        case 989:
          if (45 !== a2.charCodeAt(3) || 122 === a2.charCodeAt(4))
            break;
        case 931:
        case 953:
          if (true === la.test(d2))
            return 115 === (b2 = d2.substring(d2.indexOf(":") + 1)).charCodeAt(0) ? P2(d2.replace("stretch", "fill-available"), c2, e2, h2).replace(":fill-available", ":stretch") : a2.replace(b2, "-webkit-" + b2) + a2.replace(b2, "-moz-" + b2.replace("fill-", "")) + a2;
          break;
        case 962:
          if (a2 = "-webkit-" + a2 + (102 === a2.charCodeAt(5) ? "-ms-" + a2 : "") + a2, 211 === e2 + h2 && 105 === a2.charCodeAt(13) && 0 < a2.indexOf("transform", 10))
            return a2.substring(0, a2.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a2;
      }
      return a2;
    }
    function L2(d2, c2) {
      var e2 = d2.indexOf(1 === c2 ? ":" : "{"), h2 = d2.substring(0, 3 !== c2 ? e2 : 10);
      e2 = d2.substring(e2 + 1, d2.length - 1);
      return R2(2 !== c2 ? h2 : h2.replace(na, "$1"), e2, c2);
    }
    function ea(d2, c2) {
      var e2 = P2(c2, c2.charCodeAt(0), c2.charCodeAt(1), c2.charCodeAt(2));
      return e2 !== c2 + ";" ? e2.replace(oa, " or ($1)").substring(4) : "(" + c2 + ")";
    }
    function H2(d2, c2, e2, h2, a2, m2, b2, v2, n2, q2) {
      for (var g2 = 0, x2 = c2, w3; g2 < A2; ++g2) {
        switch (w3 = S2[g2].call(B2, d2, x2, e2, h2, a2, m2, b2, v2, n2, q2)) {
          case void 0:
          case false:
          case true:
          case null:
            break;
          default:
            x2 = w3;
        }
      }
      if (x2 !== c2)
        return x2;
    }
    function T2(d2) {
      switch (d2) {
        case void 0:
        case null:
          A2 = S2.length = 0;
          break;
        default:
          if ("function" === typeof d2)
            S2[A2++] = d2;
          else if ("object" === typeof d2)
            for (var c2 = 0, e2 = d2.length; c2 < e2; ++c2) {
              T2(d2[c2]);
            }
          else
            Y2 = !!d2 | 0;
      }
      return T2;
    }
    function U2(d2) {
      d2 = d2.prefix;
      void 0 !== d2 && (R2 = null, d2 ? "function" !== typeof d2 ? w2 = 1 : (w2 = 2, R2 = d2) : w2 = 0);
      return U2;
    }
    function B2(d2, c2) {
      var e2 = d2;
      33 > e2.charCodeAt(0) && (e2 = e2.trim());
      V2 = e2;
      e2 = [V2];
      if (0 < A2) {
        var h2 = H2(-1, c2, e2, e2, D2, z2, 0, 0, 0, 0);
        void 0 !== h2 && "string" === typeof h2 && (c2 = h2);
      }
      var a2 = M2(O2, e2, c2, 0, 0);
      0 < A2 && (h2 = H2(-2, a2, e2, e2, D2, z2, a2.length, 0, 0, 0), void 0 !== h2 && (a2 = h2));
      V2 = "";
      E2 = 0;
      z2 = D2 = 1;
      return a2;
    }
    var ca = /^\0+/g, N2 = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F2 = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q2 = /::(place)/g, ha = /:(read-only)/g, G2 = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z2 = 1, D2 = 1, E2 = 0, w2 = 1, O2 = [], S2 = [], A2 = 0, R2 = null, Y2 = 0, V2 = "";
    B2.use = T2;
    B2.set = U2;
    void 0 !== W2 && U2(W2);
    return B2;
  }
  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };
  function memoize(fn2) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(arg) {
      if (cache[arg] === void 0)
        cache[arg] = fn2(arg);
      return cache[arg];
    };
  }
  var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
  var isPropValid = /* @__PURE__ */ memoize(
    function(prop2) {
      return reactPropsRegex.test(prop2) || prop2.charCodeAt(0) === 111 && prop2.charCodeAt(1) === 110 && prop2.charCodeAt(2) < 91;
    }
    /* Z+1 */
  );
  var reactIs = reactIsExports;
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
  function getStatics(component) {
    if (reactIs.isMemo(component)) {
      return MEMO_STATICS;
    }
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
  }
  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf$1 = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf$1(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys = keys.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i2 = 0; i2 < keys.length; ++i2) {
        var key = keys[i2];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
          try {
            defineProperty(targetComponent, key, descriptor);
          } catch (e2) {
          }
        }
      }
    }
    return targetComponent;
  }
  var hoistNonReactStatics_cjs = hoistNonReactStatics;
  function v() {
    return (v = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2)
          Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var g = function(e2, t2) {
    for (var n2 = [e2[0]], r2 = 0, o2 = t2.length; r2 < o2; r2 += 1)
      n2.push(t2[r2], e2[r2 + 1]);
    return n2;
  }, S = function(t2) {
    return null !== t2 && "object" == typeof t2 && "[object Object]" === (t2.toString ? t2.toString() : Object.prototype.toString.call(t2)) && !reactIsExports.typeOf(t2);
  }, w = Object.freeze([]), E = Object.freeze({});
  function b(e2) {
    return "function" == typeof e2;
  }
  function _$1(e2) {
    return e2.displayName || e2.name || "Component";
  }
  function N(e2) {
    return e2 && "string" == typeof e2.styledComponentId;
  }
  var A = "undefined" != typeof process && void 0 !== process.env && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", I = "undefined" != typeof window && "HTMLElement" in window, P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && (void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : false));
  function j$1(e2) {
    for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
      n2[r2 - 1] = arguments[r2];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e2 + " for more information." + (n2.length > 0 ? " Args: " + n2.join(", ") : ""));
  }
  var T = function() {
    function e2(e3) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e3;
    }
    var t2 = e2.prototype;
    return t2.indexOfGroup = function(e3) {
      for (var t3 = 0, n2 = 0; n2 < e3; n2++)
        t3 += this.groupSizes[n2];
      return t3;
    }, t2.insertRules = function(e3, t3) {
      if (e3 >= this.groupSizes.length) {
        for (var n2 = this.groupSizes, r2 = n2.length, o2 = r2; e3 >= o2; )
          (o2 <<= 1) < 0 && j$1(16, "" + e3);
        this.groupSizes = new Uint32Array(o2), this.groupSizes.set(n2), this.length = o2;
        for (var s2 = r2; s2 < o2; s2++)
          this.groupSizes[s2] = 0;
      }
      for (var i2 = this.indexOfGroup(e3 + 1), a2 = 0, c2 = t3.length; a2 < c2; a2++)
        this.tag.insertRule(i2, t3[a2]) && (this.groupSizes[e3]++, i2++);
    }, t2.clearGroup = function(e3) {
      if (e3 < this.length) {
        var t3 = this.groupSizes[e3], n2 = this.indexOfGroup(e3), r2 = n2 + t3;
        this.groupSizes[e3] = 0;
        for (var o2 = n2; o2 < r2; o2++)
          this.tag.deleteRule(n2);
      }
    }, t2.getGroup = function(e3) {
      var t3 = "";
      if (e3 >= this.length || 0 === this.groupSizes[e3])
        return t3;
      for (var n2 = this.groupSizes[e3], r2 = this.indexOfGroup(e3), o2 = r2 + n2, s2 = r2; s2 < o2; s2++)
        t3 += this.tag.getRule(s2) + "/*!sc*/\n";
      return t3;
    }, e2;
  }(), x = /* @__PURE__ */ new Map(), k = /* @__PURE__ */ new Map(), V = 1, B = function(e2) {
    if (x.has(e2))
      return x.get(e2);
    for (; k.has(V); )
      V++;
    var t2 = V++;
    return x.set(e2, t2), k.set(t2, e2), t2;
  }, z = function(e2) {
    return k.get(e2);
  }, M = function(e2, t2) {
    t2 >= V && (V = t2 + 1), x.set(e2, t2), k.set(t2, e2);
  }, G = "style[" + A + '][data-styled-version="5.3.9"]', L = new RegExp("^" + A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), F = function(e2, t2, n2) {
    for (var r2, o2 = n2.split(","), s2 = 0, i2 = o2.length; s2 < i2; s2++)
      (r2 = o2[s2]) && e2.registerName(t2, r2);
  }, Y = function(e2, t2) {
    for (var n2 = (t2.textContent || "").split("/*!sc*/\n"), r2 = [], o2 = 0, s2 = n2.length; o2 < s2; o2++) {
      var i2 = n2[o2].trim();
      if (i2) {
        var a2 = i2.match(L);
        if (a2) {
          var c2 = 0 | parseInt(a2[1], 10), u2 = a2[2];
          0 !== c2 && (M(u2, c2), F(e2, u2, a2[3]), e2.getTag().insertRules(c2, r2)), r2.length = 0;
        } else
          r2.push(i2);
      }
    }
  }, q = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
  }, H = function(e2) {
    var t2 = document.head, n2 = e2 || t2, r2 = document.createElement("style"), o2 = function(e3) {
      for (var t3 = e3.childNodes, n3 = t3.length; n3 >= 0; n3--) {
        var r3 = t3[n3];
        if (r3 && 1 === r3.nodeType && r3.hasAttribute(A))
          return r3;
      }
    }(n2), s2 = void 0 !== o2 ? o2.nextSibling : null;
    r2.setAttribute(A, "active"), r2.setAttribute("data-styled-version", "5.3.9");
    var i2 = q();
    return i2 && r2.setAttribute("nonce", i2), n2.insertBefore(r2, s2), r2;
  }, $ = function() {
    function e2(e3) {
      var t3 = this.element = H(e3);
      t3.appendChild(document.createTextNode("")), this.sheet = function(e4) {
        if (e4.sheet)
          return e4.sheet;
        for (var t4 = document.styleSheets, n2 = 0, r2 = t4.length; n2 < r2; n2++) {
          var o2 = t4[n2];
          if (o2.ownerNode === e4)
            return o2;
        }
        j$1(17);
      }(t3), this.length = 0;
    }
    var t2 = e2.prototype;
    return t2.insertRule = function(e3, t3) {
      try {
        return this.sheet.insertRule(t3, e3), this.length++, true;
      } catch (e4) {
        return false;
      }
    }, t2.deleteRule = function(e3) {
      this.sheet.deleteRule(e3), this.length--;
    }, t2.getRule = function(e3) {
      var t3 = this.sheet.cssRules[e3];
      return void 0 !== t3 && "string" == typeof t3.cssText ? t3.cssText : "";
    }, e2;
  }(), W = function() {
    function e2(e3) {
      var t3 = this.element = H(e3);
      this.nodes = t3.childNodes, this.length = 0;
    }
    var t2 = e2.prototype;
    return t2.insertRule = function(e3, t3) {
      if (e3 <= this.length && e3 >= 0) {
        var n2 = document.createTextNode(t3), r2 = this.nodes[e3];
        return this.element.insertBefore(n2, r2 || null), this.length++, true;
      }
      return false;
    }, t2.deleteRule = function(e3) {
      this.element.removeChild(this.nodes[e3]), this.length--;
    }, t2.getRule = function(e3) {
      return e3 < this.length ? this.nodes[e3].textContent : "";
    }, e2;
  }(), U = function() {
    function e2(e3) {
      this.rules = [], this.length = 0;
    }
    var t2 = e2.prototype;
    return t2.insertRule = function(e3, t3) {
      return e3 <= this.length && (this.rules.splice(e3, 0, t3), this.length++, true);
    }, t2.deleteRule = function(e3) {
      this.rules.splice(e3, 1), this.length--;
    }, t2.getRule = function(e3) {
      return e3 < this.length ? this.rules[e3] : "";
    }, e2;
  }(), J = I, X = { isServer: !I, useCSSOMInjection: !P }, Z = function() {
    function e2(e3, t3, n2) {
      void 0 === e3 && (e3 = E), void 0 === t3 && (t3 = {}), this.options = v({}, X, {}, e3), this.gs = t3, this.names = new Map(n2), this.server = !!e3.isServer, !this.server && I && J && (J = false, function(e4) {
        for (var t4 = document.querySelectorAll(G), n3 = 0, r2 = t4.length; n3 < r2; n3++) {
          var o2 = t4[n3];
          o2 && "active" !== o2.getAttribute(A) && (Y(e4, o2), o2.parentNode && o2.parentNode.removeChild(o2));
        }
      }(this));
    }
    e2.registerId = function(e3) {
      return B(e3);
    };
    var t2 = e2.prototype;
    return t2.reconstructWithOptions = function(t3, n2) {
      return void 0 === n2 && (n2 = true), new e2(v({}, this.options, {}, t3), this.gs, n2 && this.names || void 0);
    }, t2.allocateGSInstance = function(e3) {
      return this.gs[e3] = (this.gs[e3] || 0) + 1;
    }, t2.getTag = function() {
      return this.tag || (this.tag = (n2 = (t3 = this.options).isServer, r2 = t3.useCSSOMInjection, o2 = t3.target, e3 = n2 ? new U(o2) : r2 ? new $(o2) : new W(o2), new T(e3)));
      var e3, t3, n2, r2, o2;
    }, t2.hasNameForId = function(e3, t3) {
      return this.names.has(e3) && this.names.get(e3).has(t3);
    }, t2.registerName = function(e3, t3) {
      if (B(e3), this.names.has(e3))
        this.names.get(e3).add(t3);
      else {
        var n2 = /* @__PURE__ */ new Set();
        n2.add(t3), this.names.set(e3, n2);
      }
    }, t2.insertRules = function(e3, t3, n2) {
      this.registerName(e3, t3), this.getTag().insertRules(B(e3), n2);
    }, t2.clearNames = function(e3) {
      this.names.has(e3) && this.names.get(e3).clear();
    }, t2.clearRules = function(e3) {
      this.getTag().clearGroup(B(e3)), this.clearNames(e3);
    }, t2.clearTag = function() {
      this.tag = void 0;
    }, t2.toString = function() {
      return function(e3) {
        for (var t3 = e3.getTag(), n2 = t3.length, r2 = "", o2 = 0; o2 < n2; o2++) {
          var s2 = z(o2);
          if (void 0 !== s2) {
            var i2 = e3.names.get(s2), a2 = t3.getGroup(o2);
            if (i2 && a2 && i2.size) {
              var c2 = A + ".g" + o2 + '[id="' + s2 + '"]', u2 = "";
              void 0 !== i2 && i2.forEach(function(e4) {
                e4.length > 0 && (u2 += e4 + ",");
              }), r2 += "" + a2 + c2 + '{content:"' + u2 + '"}/*!sc*/\n';
            }
          }
        }
        return r2;
      }(this);
    }, e2;
  }(), K = /(a)(d)/gi, Q = function(e2) {
    return String.fromCharCode(e2 + (e2 > 25 ? 39 : 97));
  };
  function ee$2(e2) {
    var t2, n2 = "";
    for (t2 = Math.abs(e2); t2 > 52; t2 = t2 / 52 | 0)
      n2 = Q(t2 % 52) + n2;
    return (Q(t2 % 52) + n2).replace(K, "$1-$2");
  }
  var te = function(e2, t2) {
    for (var n2 = t2.length; n2; )
      e2 = 33 * e2 ^ t2.charCodeAt(--n2);
    return e2;
  }, ne$2 = function(e2) {
    return te(5381, e2);
  };
  function re(e2) {
    for (var t2 = 0; t2 < e2.length; t2 += 1) {
      var n2 = e2[t2];
      if (b(n2) && !N(n2))
        return false;
    }
    return true;
  }
  var oe = ne$2("5.3.9"), se = function() {
    function e2(e3, t2, n2) {
      this.rules = e3, this.staticRulesId = "", this.isStatic = (void 0 === n2 || n2.isStatic) && re(e3), this.componentId = t2, this.baseHash = te(oe, t2), this.baseStyle = n2, Z.registerId(t2);
    }
    return e2.prototype.generateAndInjectStyles = function(e3, t2, n2) {
      var r2 = this.componentId, o2 = [];
      if (this.baseStyle && o2.push(this.baseStyle.generateAndInjectStyles(e3, t2, n2)), this.isStatic && !n2.hash)
        if (this.staticRulesId && t2.hasNameForId(r2, this.staticRulesId))
          o2.push(this.staticRulesId);
        else {
          var s2 = Ne(this.rules, e3, t2, n2).join(""), i2 = ee$2(te(this.baseHash, s2) >>> 0);
          if (!t2.hasNameForId(r2, i2)) {
            var a2 = n2(s2, "." + i2, void 0, r2);
            t2.insertRules(r2, i2, a2);
          }
          o2.push(i2), this.staticRulesId = i2;
        }
      else {
        for (var c2 = this.rules.length, u2 = te(this.baseHash, n2.hash), l2 = "", d2 = 0; d2 < c2; d2++) {
          var h2 = this.rules[d2];
          if ("string" == typeof h2)
            l2 += h2;
          else if (h2) {
            var p2 = Ne(h2, e3, t2, n2), f2 = Array.isArray(p2) ? p2.join("") : p2;
            u2 = te(u2, f2 + d2), l2 += f2;
          }
        }
        if (l2) {
          var m2 = ee$2(u2 >>> 0);
          if (!t2.hasNameForId(r2, m2)) {
            var y2 = n2(l2, "." + m2, void 0, r2);
            t2.insertRules(r2, m2, y2);
          }
          o2.push(m2);
        }
      }
      return o2.join(" ");
    }, e2;
  }(), ie = /^\s*\/\/.*$/gm, ae = [":", "[", ".", "#"];
  function ce(e2) {
    var t2, n2, r2, o2, s2 = void 0 === e2 ? E : e2, i2 = s2.options, a2 = void 0 === i2 ? E : i2, c2 = s2.plugins, u2 = void 0 === c2 ? w : c2, l2 = new stylis_min(a2), d2 = [], h2 = function(e3) {
      function t3(t4) {
        if (t4)
          try {
            e3(t4 + "}");
          } catch (e4) {
          }
      }
      return function(n3, r3, o3, s3, i3, a3, c3, u3, l3, d3) {
        switch (n3) {
          case 1:
            if (0 === l3 && 64 === r3.charCodeAt(0))
              return e3(r3 + ";"), "";
            break;
          case 2:
            if (0 === u3)
              return r3 + "/*|*/";
            break;
          case 3:
            switch (u3) {
              case 102:
              case 112:
                return e3(o3[0] + r3), "";
              default:
                return r3 + (0 === d3 ? "/*|*/" : "");
            }
          case -2:
            r3.split("/*|*/}").forEach(t3);
        }
      };
    }(function(e3) {
      d2.push(e3);
    }), f2 = function(e3, r3, s3) {
      return 0 === r3 && -1 !== ae.indexOf(s3[n2.length]) || s3.match(o2) ? e3 : "." + t2;
    };
    function m2(e3, s3, i3, a3) {
      void 0 === a3 && (a3 = "&");
      var c3 = e3.replace(ie, ""), u3 = s3 && i3 ? i3 + " " + s3 + " { " + c3 + " }" : c3;
      return t2 = a3, n2 = s3, r2 = new RegExp("\\" + n2 + "\\b", "g"), o2 = new RegExp("(\\" + n2 + "\\b){2,}"), l2(i3 || !s3 ? "" : s3, u3);
    }
    return l2.use([].concat(u2, [function(e3, t3, o3) {
      2 === e3 && o3.length && o3[0].lastIndexOf(n2) > 0 && (o3[0] = o3[0].replace(r2, f2));
    }, h2, function(e3) {
      if (-2 === e3) {
        var t3 = d2;
        return d2 = [], t3;
      }
    }])), m2.hash = u2.length ? u2.reduce(function(e3, t3) {
      return t3.name || j$1(15), te(e3, t3.name);
    }, 5381).toString() : "", m2;
  }
  var ue = Cn.createContext();
  ue.Consumer;
  var de = Cn.createContext(), he = (de.Consumer, new Z()), pe = ce();
  function fe() {
    return q$4(ue) || he;
  }
  function me() {
    return q$4(de) || pe;
  }
  var ve = function() {
    function e2(e3, t2) {
      var n2 = this;
      this.inject = function(e4, t3) {
        void 0 === t3 && (t3 = pe);
        var r2 = n2.name + t3.hash;
        e4.hasNameForId(n2.id, r2) || e4.insertRules(n2.id, r2, t3(n2.rules, r2, "@keyframes"));
      }, this.toString = function() {
        return j$1(12, String(n2.name));
      }, this.name = e3, this.id = "sc-keyframes-" + e3, this.rules = t2;
    }
    return e2.prototype.getName = function(e3) {
      return void 0 === e3 && (e3 = pe), this.name + e3.hash;
    }, e2;
  }(), ge$2 = /([A-Z])/, Se = /([A-Z])/g, we = /^ms-/, Ee = function(e2) {
    return "-" + e2.toLowerCase();
  };
  function be(e2) {
    return ge$2.test(e2) ? e2.replace(Se, Ee).replace(we, "-ms-") : e2;
  }
  var _e = function(e2) {
    return null == e2 || false === e2 || "" === e2;
  };
  function Ne(e2, n2, r2, o2) {
    if (Array.isArray(e2)) {
      for (var s2, i2 = [], a2 = 0, c2 = e2.length; a2 < c2; a2 += 1)
        "" !== (s2 = Ne(e2[a2], n2, r2, o2)) && (Array.isArray(s2) ? i2.push.apply(i2, s2) : i2.push(s2));
      return i2;
    }
    if (_e(e2))
      return "";
    if (N(e2))
      return "." + e2.styledComponentId;
    if (b(e2)) {
      if ("function" != typeof (l2 = e2) || l2.prototype && l2.prototype.isReactComponent || !n2)
        return e2;
      var u2 = e2(n2);
      return Ne(u2, n2, r2, o2);
    }
    var l2;
    return e2 instanceof ve ? r2 ? (e2.inject(r2, o2), e2.getName(o2)) : e2 : S(e2) ? function e3(t2, n3) {
      var r3, o3, s3 = [];
      for (var i3 in t2)
        t2.hasOwnProperty(i3) && !_e(t2[i3]) && (Array.isArray(t2[i3]) && t2[i3].isCss || b(t2[i3]) ? s3.push(be(i3) + ":", t2[i3], ";") : S(t2[i3]) ? s3.push.apply(s3, e3(t2[i3], i3)) : s3.push(be(i3) + ": " + (r3 = i3, null == (o3 = t2[i3]) || "boolean" == typeof o3 || "" === o3 ? "" : "number" != typeof o3 || 0 === o3 || r3 in unitlessKeys ? String(o3).trim() : o3 + "px") + ";"));
      return n3 ? [n3 + " {"].concat(s3, ["}"]) : s3;
    }(e2) : e2.toString();
  }
  var Ae = function(e2) {
    return Array.isArray(e2) && (e2.isCss = true), e2;
  };
  function Ce(e2) {
    for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
      n2[r2 - 1] = arguments[r2];
    return b(e2) || S(e2) ? Ae(Ne(g(w, [e2].concat(n2)))) : 0 === n2.length && 1 === e2.length && "string" == typeof e2[0] ? e2 : Ae(Ne(g(e2, n2)));
  }
  var Re$2 = function(e2, t2, n2) {
    return void 0 === n2 && (n2 = E), e2.theme !== n2.theme && e2.theme || t2 || n2.theme;
  }, De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, je = /(^-|-$)/g;
  function Te(e2) {
    return e2.replace(De, "-").replace(je, "");
  }
  var xe = function(e2) {
    return ee$2(ne$2(e2) >>> 0);
  };
  function ke(e2) {
    return "string" == typeof e2 && true;
  }
  var Ve = function(e2) {
    return "function" == typeof e2 || "object" == typeof e2 && null !== e2 && !Array.isArray(e2);
  }, Be = function(e2) {
    return "__proto__" !== e2 && "constructor" !== e2 && "prototype" !== e2;
  };
  function ze(e2, t2, n2) {
    var r2 = e2[n2];
    Ve(t2) && Ve(r2) ? Me(r2, t2) : e2[n2] = t2;
  }
  function Me(e2) {
    for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
      n2[r2 - 1] = arguments[r2];
    for (var o2 = 0, s2 = n2; o2 < s2.length; o2++) {
      var i2 = s2[o2];
      if (Ve(i2))
        for (var a2 in i2)
          Be(a2) && ze(e2, i2[a2], a2);
    }
    return e2;
  }
  var Ge = Cn.createContext();
  Ge.Consumer;
  var Ye = {};
  function qe(e2, t2, n2) {
    var o2 = N(e2), i2 = !ke(e2), a2 = t2.attrs, c2 = void 0 === a2 ? w : a2, d2 = t2.componentId, h2 = void 0 === d2 ? function(e3, t3) {
      var n3 = "string" != typeof e3 ? "sc" : Te(e3);
      Ye[n3] = (Ye[n3] || 0) + 1;
      var r2 = n3 + "-" + xe("5.3.9" + n3 + Ye[n3]);
      return t3 ? t3 + "-" + r2 : r2;
    }(t2.displayName, t2.parentComponentId) : d2, p2 = t2.displayName, f2 = void 0 === p2 ? function(e3) {
      return ke(e3) ? "styled." + e3 : "Styled(" + _$1(e3) + ")";
    }(e2) : p2, g2 = t2.displayName && t2.componentId ? Te(t2.displayName) + "-" + t2.componentId : t2.componentId || h2, S2 = o2 && e2.attrs ? Array.prototype.concat(e2.attrs, c2).filter(Boolean) : c2, A2 = t2.shouldForwardProp;
    o2 && e2.shouldForwardProp && (A2 = t2.shouldForwardProp ? function(n3, r2, o3) {
      return e2.shouldForwardProp(n3, r2, o3) && t2.shouldForwardProp(n3, r2, o3);
    } : e2.shouldForwardProp);
    var C2, I2 = new se(n2, g2, o2 ? e2.componentStyle : void 0), P2 = I2.isStatic && 0 === c2.length, O2 = function(e3, t3) {
      return function(e4, t4, n3, r2) {
        var o3 = e4.attrs, i3 = e4.componentStyle, a3 = e4.defaultProps, c3 = e4.foldedComponentIds, d3 = e4.shouldForwardProp, h3 = e4.styledComponentId, p3 = e4.target;
        var f3 = function(e5, t5, n4) {
          void 0 === e5 && (e5 = E);
          var r3 = v({}, t5, { theme: e5 }), o4 = {};
          return n4.forEach(function(e6) {
            var t6, n5, s2, i4 = e6;
            for (t6 in b(i4) && (i4 = i4(r3)), i4)
              r3[t6] = o4[t6] = "className" === t6 ? (n5 = o4[t6], s2 = i4[t6], n5 && s2 ? n5 + " " + s2 : n5 || s2) : i4[t6];
          }), [r3, o4];
        }(Re$2(t4, q$4(Ge), a3) || E, t4, o3), y2 = f3[0], g3 = f3[1], S3 = function(e5, t5, n4, r3) {
          var o4 = fe(), s2 = me(), i4 = t5 ? e5.generateAndInjectStyles(E, o4, s2) : e5.generateAndInjectStyles(n4, o4, s2);
          return i4;
        }(i3, r2, y2), w2 = n3, _2 = g3.$as || t4.$as || g3.as || t4.as || p3, N2 = ke(_2), A3 = g3 !== t4 ? v({}, t4, {}, g3) : t4, C3 = {};
        for (var I3 in A3)
          "$" !== I3[0] && "as" !== I3 && ("forwardedAs" === I3 ? C3.as = A3[I3] : (d3 ? d3(I3, isPropValid, _2) : !N2 || isPropValid(I3)) && (C3[I3] = A3[I3]));
        return t4.style && g3.style !== t4.style && (C3.style = v({}, t4.style, {}, g3.style)), C3.className = Array.prototype.concat(c3, h3, S3 !== h3 ? S3 : null, t4.className, g3.className).filter(Boolean).join(" "), C3.ref = w2, y$3(_2, C3);
      }(C2, e3, t3, P2);
    };
    return O2.displayName = f2, (C2 = Cn.forwardRef(O2)).attrs = S2, C2.componentStyle = I2, C2.displayName = f2, C2.shouldForwardProp = A2, C2.foldedComponentIds = o2 ? Array.prototype.concat(e2.foldedComponentIds, e2.styledComponentId) : w, C2.styledComponentId = g2, C2.target = o2 ? e2.target : e2, C2.withComponent = function(e3) {
      var r2 = t2.componentId, o3 = function(e4, t3) {
        if (null == e4)
          return {};
        var n3, r3, o4 = {}, s3 = Object.keys(e4);
        for (r3 = 0; r3 < s3.length; r3++)
          n3 = s3[r3], t3.indexOf(n3) >= 0 || (o4[n3] = e4[n3]);
        return o4;
      }(t2, ["componentId"]), s2 = r2 && r2 + "-" + (ke(e3) ? e3 : Te(_$1(e3)));
      return qe(e3, v({}, o3, { attrs: S2, componentId: s2 }), n2);
    }, Object.defineProperty(C2, "defaultProps", { get: function() {
      return this._foldedDefaultProps;
    }, set: function(t3) {
      this._foldedDefaultProps = o2 ? Me({}, e2.defaultProps, t3) : t3;
    } }), Object.defineProperty(C2, "toString", { value: function() {
      return "." + C2.styledComponentId;
    } }), i2 && hoistNonReactStatics_cjs(C2, e2, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true, withComponent: true }), C2;
  }
  var He = function(e2) {
    return function e3(t2, r2, o2) {
      if (void 0 === o2 && (o2 = E), !reactIsExports.isValidElementType(r2))
        return j$1(1, String(r2));
      var s2 = function() {
        return t2(r2, o2, Ce.apply(void 0, arguments));
      };
      return s2.withConfig = function(n2) {
        return e3(t2, r2, v({}, o2, {}, n2));
      }, s2.attrs = function(n2) {
        return e3(t2, r2, v({}, o2, { attrs: Array.prototype.concat(o2.attrs, n2).filter(Boolean) }));
      }, s2;
    }(qe, e2);
  };
  ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e2) {
    He[e2] = He(e2);
  });
  function Ue(e2) {
    for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
      n2[r2 - 1] = arguments[r2];
    var o2 = Ce.apply(void 0, [e2].concat(n2)).join(""), s2 = xe(o2);
    return new ve(s2, o2);
  }
  const styled = He;
  var __makeTemplateObject$2 = globalThis && globalThis.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, "raw", { value: raw });
    } else {
      cooked.raw = raw;
    }
    return cooked;
  };
  var len = 242.776657104492;
  var time = 1.6;
  var anim = Ue(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$2(["\n  12.5% {\n    stroke-dasharray: ", "px, ", "px;\n    stroke-dashoffset: -", "px;\n  }\n  43.75% {\n    stroke-dasharray: ", "px, ", "px;\n    stroke-dashoffset: -", "px;\n  }\n  100% {\n    stroke-dasharray: ", "px, ", "px;\n    stroke-dashoffset: -", "px;\n  }\n"], ["\n  12.5% {\n    stroke-dasharray: ", "px, ", "px;\n    stroke-dashoffset: -", "px;\n  }\n  43.75% {\n    stroke-dasharray: ", "px, ", "px;\n    stroke-dashoffset: -", "px;\n  }\n  100% {\n    stroke-dasharray: ", "px, ", "px;\n    stroke-dashoffset: -", "px;\n  }\n"])), len * 0.14, len, len * 0.11, len * 0.35, len, len * 0.35, len * 0.01, len, len * 0.99);
  styled.path(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$2(["\n  stroke-dasharray: ", "px, ", ";\n  stroke-dashoffset: 0;\n  animation: ", " ", "s linear infinite;\n"], ["\n  stroke-dasharray: ", "px, ", ";\n  stroke-dashoffset: 0;\n  animation: ", " ", "s linear infinite;\n"])), len * 0.01, len, anim, time);
  var templateObject_1$2, templateObject_2$2;
  var __assign$o = globalThis && globalThis.__assign || function() {
    __assign$o = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$o.apply(this, arguments);
  };
  var __assign$n = globalThis && globalThis.__assign || function() {
    __assign$n = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$n.apply(this, arguments);
  };
  var __assign$m = globalThis && globalThis.__assign || function() {
    __assign$m = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$m.apply(this, arguments);
  };
  var __assign$l = globalThis && globalThis.__assign || function() {
    __assign$l = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$l.apply(this, arguments);
  };
  var __assign$k = globalThis && globalThis.__assign || function() {
    __assign$k = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$k.apply(this, arguments);
  };
  var __assign$j = globalThis && globalThis.__assign || function() {
    __assign$j = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$j.apply(this, arguments);
  };
  var __assign$i = globalThis && globalThis.__assign || function() {
    __assign$i = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$i.apply(this, arguments);
  };
  var prop$2 = function prop2(path, defaultValue) {
    return function() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (typeof props[path] !== "undefined") {
        return props[path];
      }
      if (path && path.indexOf(".") > 0) {
        var paths = path.split(".");
        var length = paths.length;
        var object = props[paths[0]];
        var index2 = 1;
        while (object != null && index2 < length) {
          object = object[paths[index2]];
          index2 += 1;
        }
        if (typeof object !== "undefined") {
          return object;
        }
      }
      return defaultValue;
    };
  };
  var __makeTemplateObject$1 = globalThis && globalThis.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, "raw", { value: raw });
    } else {
      cooked.raw = raw;
    }
    return cooked;
  };
  var __assign$h = globalThis && globalThis.__assign || function() {
    __assign$h = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$h.apply(this, arguments);
  };
  var spin = Ue(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1(["\n to {\n    transform: rotate(360deg);\n  }\n"], ["\n to {\n    transform: rotate(360deg);\n  }\n"])));
  styled.svg(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject$1(["\n  animation: ", " 0.75s steps(12, end) infinite;\n  animation-duration: ", "s;\n"], ["\n  animation: ", " 0.75s steps(12, end) infinite;\n  animation-duration: ", "s;\n"])), spin, prop$2("speed", "0.75"));
  styled.polyline(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject$1(["\n  stroke-width: ", "px;\n  stroke-linecap: round;\n\n  &:nth-child(12n + 0) {\n    stroke-opacity: 0.08;\n  }\n\n  &:nth-child(12n + 1) {\n    stroke-opacity: 0.17;\n  }\n\n  &:nth-child(12n + 2) {\n    stroke-opacity: 0.25;\n  }\n\n  &:nth-child(12n + 3) {\n    stroke-opacity: 0.33;\n  }\n\n  &:nth-child(12n + 4) {\n    stroke-opacity: 0.42;\n  }\n\n  &:nth-child(12n + 5) {\n    stroke-opacity: 0.5;\n  }\n\n  &:nth-child(12n + 6) {\n    stroke-opacity: 0.58;\n  }\n\n  &:nth-child(12n + 7) {\n    stroke-opacity: 0.66;\n  }\n\n  &:nth-child(12n + 8) {\n    stroke-opacity: 0.75;\n  }\n\n  &:nth-child(12n + 9) {\n    stroke-opacity: 0.83;\n  }\n\n  &:nth-child(12n + 11) {\n    stroke-opacity: 0.92;\n  }\n"], ["\n  stroke-width: ", "px;\n  stroke-linecap: round;\n\n  &:nth-child(12n + 0) {\n    stroke-opacity: 0.08;\n  }\n\n  &:nth-child(12n + 1) {\n    stroke-opacity: 0.17;\n  }\n\n  &:nth-child(12n + 2) {\n    stroke-opacity: 0.25;\n  }\n\n  &:nth-child(12n + 3) {\n    stroke-opacity: 0.33;\n  }\n\n  &:nth-child(12n + 4) {\n    stroke-opacity: 0.42;\n  }\n\n  &:nth-child(12n + 5) {\n    stroke-opacity: 0.5;\n  }\n\n  &:nth-child(12n + 6) {\n    stroke-opacity: 0.58;\n  }\n\n  &:nth-child(12n + 7) {\n    stroke-opacity: 0.66;\n  }\n\n  &:nth-child(12n + 8) {\n    stroke-opacity: 0.75;\n  }\n\n  &:nth-child(12n + 9) {\n    stroke-opacity: 0.83;\n  }\n\n  &:nth-child(12n + 11) {\n    stroke-opacity: 0.92;\n  }\n"])), function(props) {
    return props.width;
  });
  var templateObject_1$1, templateObject_2$1, templateObject_3$1;
  var __assign$g = globalThis && globalThis.__assign || function() {
    __assign$g = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$g.apply(this, arguments);
  };
  var __assign$f = globalThis && globalThis.__assign || function() {
    __assign$f = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$f.apply(this, arguments);
  };
  var __assign$e = globalThis && globalThis.__assign || function() {
    __assign$e = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$e.apply(this, arguments);
  };
  var ThreeDots = function(_a2) {
    var _b = _a2.height, height = _b === void 0 ? 80 : _b, _c = _a2.width, width = _c === void 0 ? 80 : _c, _d = _a2.radius, radius = _d === void 0 ? 9 : _d, _e2 = _a2.color, color = _e2 === void 0 ? DEFAULT_COLOR : _e2, _f = _a2.ariaLabel, ariaLabel = _f === void 0 ? "three-dots-loading" : _f, wrapperStyle = _a2.wrapperStyle, wrapperClass = _a2.wrapperClass, _g = _a2.visible, visible = _g === void 0 ? true : _g;
    return Cn.createElement(
      "div",
      __assign$e({ style: __assign$e(__assign$e({}, getDefaultStyle(visible)), wrapperStyle), className: wrapperClass, "data-testid": "three-dots-loading", "aria-label": ariaLabel }, DEFAULT_WAI_ARIA_ATTRIBUTE),
      Cn.createElement(
        "svg",
        { width, height, viewBox: "0 0 120 30", xmlns: "http://www.w3.org/2000/svg", fill: color, "data-testid": "three-dots-svg" },
        Cn.createElement(
          "circle",
          { cx: "15", cy: "15", r: Number(radius) + 6 },
          Cn.createElement("animate", { attributeName: "r", from: "15", to: "15", begin: "0s", dur: "0.8s", values: "15;9;15", calcMode: "linear", repeatCount: "indefinite" }),
          Cn.createElement("animate", { attributeName: "fill-opacity", from: "1", to: "1", begin: "0s", dur: "0.8s", values: "1;.5;1", calcMode: "linear", repeatCount: "indefinite" })
        ),
        Cn.createElement(
          "circle",
          { cx: "60", cy: "15", r: radius, attributeName: "fill-opacity", from: "1", to: "0.3" },
          Cn.createElement("animate", { attributeName: "r", from: "9", to: "9", begin: "0s", dur: "0.8s", values: "9;15;9", calcMode: "linear", repeatCount: "indefinite" }),
          Cn.createElement("animate", { attributeName: "fill-opacity", from: "0.5", to: "0.5", begin: "0s", dur: "0.8s", values: ".5;1;.5", calcMode: "linear", repeatCount: "indefinite" })
        ),
        Cn.createElement(
          "circle",
          { cx: "105", cy: "15", r: Number(radius) + 6 },
          Cn.createElement("animate", { attributeName: "r", from: "15", to: "15", begin: "0s", dur: "0.8s", values: "15;9;15", calcMode: "linear", repeatCount: "indefinite" }),
          Cn.createElement("animate", { attributeName: "fill-opacity", from: "1", to: "1", begin: "0s", dur: "0.8s", values: "1;.5;1", calcMode: "linear", repeatCount: "indefinite" })
        )
      )
    );
  };
  var __makeTemplateObject = globalThis && globalThis.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, "raw", { value: raw });
    } else {
      cooked.raw = raw;
    }
    return cooked;
  };
  var __assign$d = globalThis && globalThis.__assign || function() {
    __assign$d = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$d.apply(this, arguments);
  };
  var dash$2 = Ue(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n to {\n    stroke-dashoffset: 136;\n  }\n"], ["\n to {\n    stroke-dashoffset: 136;\n  }\n"])));
  styled.polygon(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  stroke-dasharray: 17;\n  animation: ", " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"], ["\n  stroke-dasharray: 17;\n  animation: ", " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"])), dash$2);
  styled.svg(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transform-origin: 50% 65%;\n"], ["\n  transform-origin: 50% 65%;\n"])));
  var templateObject_1, templateObject_2, templateObject_3;
  var __assign$c = globalThis && globalThis.__assign || function() {
    __assign$c = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$c.apply(this, arguments);
  };
  var __assign$b = globalThis && globalThis.__assign || function() {
    __assign$b = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$b.apply(this, arguments);
  };
  var __assign$a = globalThis && globalThis.__assign || function() {
    __assign$a = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$a.apply(this, arguments);
  };
  var __assign$9 = globalThis && globalThis.__assign || function() {
    __assign$9 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$9.apply(this, arguments);
  };
  var __assign$8 = globalThis && globalThis.__assign || function() {
    __assign$8 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$8.apply(this, arguments);
  };
  var __assign$7 = globalThis && globalThis.__assign || function() {
    __assign$7 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$7.apply(this, arguments);
  };
  var __assign$6 = globalThis && globalThis.__assign || function() {
    __assign$6 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$6.apply(this, arguments);
  };
  var __assign$5 = globalThis && globalThis.__assign || function() {
    __assign$5 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$5.apply(this, arguments);
  };
  var __assign$4 = globalThis && globalThis.__assign || function() {
    __assign$4 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$4.apply(this, arguments);
  };
  var __assign$3 = globalThis && globalThis.__assign || function() {
    __assign$3 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$3.apply(this, arguments);
  };
  var __assign$2 = globalThis && globalThis.__assign || function() {
    __assign$2 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$2.apply(this, arguments);
  };
  var __assign$1 = globalThis && globalThis.__assign || function() {
    __assign$1 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign$1.apply(this, arguments);
  };
  var __assign = globalThis && globalThis.__assign || function() {
    __assign = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return __assign.apply(this, arguments);
  };
  function _extends$2() {
    _extends$2 = Object.assign || function(target2) {
      for (var i2 = 1; i2 < arguments.length; i2++) {
        var source = arguments[i2];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target2[key] = source[key];
          }
        }
      }
      return target2;
    };
    return _extends$2.apply(this, arguments);
  }
  var useOnEscape = function useOnEscape2(handler, active) {
    if (active === void 0) {
      active = true;
    }
    p$2(function() {
      if (!active)
        return;
      var listener = function listener2(event) {
        if (event.key === "Escape")
          handler(event);
      };
      document.addEventListener("keyup", listener);
      return function() {
        if (!active)
          return;
        document.removeEventListener("keyup", listener);
      };
    }, [handler, active]);
  };
  var useRepositionOnResize = function useRepositionOnResize2(handler, active) {
    if (active === void 0) {
      active = true;
    }
    p$2(function() {
      if (!active)
        return;
      var listener = function listener2() {
        handler();
      };
      window.addEventListener("resize", listener);
      return function() {
        if (!active)
          return;
        window.removeEventListener("resize", listener);
      };
    }, [handler, active]);
  };
  var useOnClickOutside = function useOnClickOutside2(ref, handler, active) {
    if (active === void 0) {
      active = true;
    }
    p$2(function() {
      if (!active)
        return;
      var listener = function listener2(event) {
        var refs = Array.isArray(ref) ? ref : [ref];
        var contains = false;
        refs.forEach(function(r2) {
          if (!r2.current || r2.current.contains(event.target)) {
            contains = true;
            return;
          }
        });
        event.stopPropagation();
        if (!contains)
          handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return function() {
        if (!active)
          return;
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }, [ref, handler, active]);
  };
  var useTabbing = function useTabbing2(contentRef, active) {
    if (active === void 0) {
      active = true;
    }
    p$2(function() {
      if (!active)
        return;
      var listener = function listener2(event) {
        if (event.keyCode === 9) {
          var _contentRef$current;
          var els2 = contentRef === null || contentRef === void 0 ? void 0 : (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
          var focusableEls = Array.prototype.slice.call(els2);
          if (focusableEls.length === 1) {
            event.preventDefault();
            return;
          }
          var firstFocusableEl = focusableEls[0];
          var lastFocusableEl = focusableEls[focusableEls.length - 1];
          if (event.shiftKey && document.activeElement === firstFocusableEl) {
            event.preventDefault();
            lastFocusableEl.focus();
          } else if (document.activeElement === lastFocusableEl) {
            event.preventDefault();
            firstFocusableEl.focus();
          }
        }
      };
      document.addEventListener("keydown", listener);
      return function() {
        if (!active)
          return;
        document.removeEventListener("keydown", listener);
      };
    }, [contentRef, active]);
  };
  var useIsomorphicLayoutEffect = typeof window !== "undefined" ? y$2 : p$2;
  var Style = {
    popupContent: {
      tooltip: {
        position: "absolute",
        zIndex: 999
      },
      modal: {
        position: "relative",
        margin: "auto"
      }
    },
    popupArrow: {
      height: "8px",
      width: "16px",
      position: "absolute",
      background: "transparent",
      color: "#FFF",
      zIndex: -1
    },
    overlay: {
      tooltip: {
        position: "fixed",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        zIndex: 999
      },
      modal: {
        position: "fixed",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        display: "flex",
        zIndex: 999
      }
    }
  };
  var POSITION_TYPES = ["top left", "top center", "top right", "right top", "right center", "right bottom", "bottom left", "bottom center", "bottom right", "left top", "left center", "left bottom"];
  var getCoordinatesForPosition = function getCoordinatesForPosition2(triggerBounding, ContentBounding, position, arrow, _ref) {
    var offsetX = _ref.offsetX, offsetY = _ref.offsetY;
    var margin = arrow ? 8 : 0;
    var args = position.split(" ");
    var CenterTop = triggerBounding.top + triggerBounding.height / 2;
    var CenterLeft = triggerBounding.left + triggerBounding.width / 2;
    var height = ContentBounding.height, width = ContentBounding.width;
    var top2 = CenterTop - height / 2;
    var left = CenterLeft - width / 2;
    var transform = "";
    var arrowTop = "0%";
    var arrowLeft = "0%";
    switch (args[0]) {
      case "top":
        top2 -= height / 2 + triggerBounding.height / 2 + margin;
        transform = "rotate(180deg)  translateX(50%)";
        arrowTop = "100%";
        arrowLeft = "50%";
        break;
      case "bottom":
        top2 += height / 2 + triggerBounding.height / 2 + margin;
        transform = "rotate(0deg) translateY(-100%) translateX(-50%)";
        arrowLeft = "50%";
        break;
      case "left":
        left -= width / 2 + triggerBounding.width / 2 + margin;
        transform = " rotate(90deg)  translateY(50%) translateX(-25%)";
        arrowLeft = "100%";
        arrowTop = "50%";
        break;
      case "right":
        left += width / 2 + triggerBounding.width / 2 + margin;
        transform = "rotate(-90deg)  translateY(-150%) translateX(25%)";
        arrowTop = "50%";
        break;
    }
    switch (args[1]) {
      case "top":
        top2 = triggerBounding.top;
        arrowTop = triggerBounding.height / 2 + "px";
        break;
      case "bottom":
        top2 = triggerBounding.top - height + triggerBounding.height;
        arrowTop = height - triggerBounding.height / 2 + "px";
        break;
      case "left":
        left = triggerBounding.left;
        arrowLeft = triggerBounding.width / 2 + "px";
        break;
      case "right":
        left = triggerBounding.left - width + triggerBounding.width;
        arrowLeft = width - triggerBounding.width / 2 + "px";
        break;
    }
    top2 = args[0] === "top" ? top2 - offsetY : top2 + offsetY;
    left = args[0] === "left" ? left - offsetX : left + offsetX;
    return {
      top: top2,
      left,
      transform,
      arrowLeft,
      arrowTop
    };
  };
  var getTooltipBoundary = function getTooltipBoundary2(keepTooltipInside) {
    var boundingBox = {
      top: 0,
      left: 0,
      /* eslint-disable-next-line no-undef */
      width: window.innerWidth,
      /* eslint-disable-next-line no-undef */
      height: window.innerHeight
    };
    if (typeof keepTooltipInside === "string") {
      var selector = document.querySelector(keepTooltipInside);
      if (selector !== null)
        boundingBox = selector.getBoundingClientRect();
    }
    return boundingBox;
  };
  var calculatePosition = function calculatePosition2(triggerBounding, ContentBounding, position, arrow, _ref2, keepTooltipInside) {
    var offsetX = _ref2.offsetX, offsetY = _ref2.offsetY;
    var bestCoords = {
      arrowLeft: "0%",
      arrowTop: "0%",
      left: 0,
      top: 0,
      transform: "rotate(135deg)"
    };
    var i2 = 0;
    var wrapperBox = getTooltipBoundary(keepTooltipInside);
    var positions = Array.isArray(position) ? position : [position];
    if (keepTooltipInside || Array.isArray(position))
      positions = [].concat(positions, POSITION_TYPES);
    while (i2 < positions.length) {
      bestCoords = getCoordinatesForPosition(triggerBounding, ContentBounding, positions[i2], arrow, {
        offsetX,
        offsetY
      });
      var contentBox = {
        top: bestCoords.top,
        left: bestCoords.left,
        width: ContentBounding.width,
        height: ContentBounding.height
      };
      if (contentBox.top <= wrapperBox.top || contentBox.left <= wrapperBox.left || contentBox.top + contentBox.height >= wrapperBox.top + wrapperBox.height || contentBox.left + contentBox.width >= wrapperBox.left + wrapperBox.width) {
        i2++;
      } else {
        break;
      }
    }
    return bestCoords;
  };
  var popupIdCounter = 0;
  var getRootPopup = function getRootPopup2() {
    var PopupRoot = document.getElementById("popup-root");
    if (PopupRoot === null) {
      PopupRoot = document.createElement("div");
      PopupRoot.setAttribute("id", "popup-root");
      document.body.appendChild(PopupRoot);
    }
    return PopupRoot;
  };
  var Popup = /* @__PURE__ */ k$3(function(_ref, ref) {
    var _ref$trigger = _ref.trigger, trigger = _ref$trigger === void 0 ? null : _ref$trigger, _ref$onOpen = _ref.onOpen, onOpen = _ref$onOpen === void 0 ? function() {
    } : _ref$onOpen, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? function() {
    } : _ref$onClose, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$open = _ref.open, open = _ref$open === void 0 ? void 0 : _ref$open, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$nested = _ref.nested, nested = _ref$nested === void 0 ? false : _ref$nested, _ref$closeOnDocumentC = _ref.closeOnDocumentClick, closeOnDocumentClick = _ref$closeOnDocumentC === void 0 ? true : _ref$closeOnDocumentC, _ref$repositionOnResi = _ref.repositionOnResize, repositionOnResize = _ref$repositionOnResi === void 0 ? true : _ref$repositionOnResi, _ref$closeOnEscape = _ref.closeOnEscape, closeOnEscape = _ref$closeOnEscape === void 0 ? true : _ref$closeOnEscape, _ref$on = _ref.on, on2 = _ref$on === void 0 ? ["click"] : _ref$on, _ref$contentStyle = _ref.contentStyle, contentStyle = _ref$contentStyle === void 0 ? {} : _ref$contentStyle, _ref$arrowStyle = _ref.arrowStyle, arrowStyle = _ref$arrowStyle === void 0 ? {} : _ref$arrowStyle, _ref$overlayStyle = _ref.overlayStyle, overlayStyle = _ref$overlayStyle === void 0 ? {} : _ref$overlayStyle, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom center" : _ref$position, _ref$modal = _ref.modal, modal = _ref$modal === void 0 ? false : _ref$modal, _ref$lockScroll = _ref.lockScroll, lockScroll = _ref$lockScroll === void 0 ? false : _ref$lockScroll, _ref$arrow = _ref.arrow, arrow = _ref$arrow === void 0 ? true : _ref$arrow, _ref$offsetX = _ref.offsetX, offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX, _ref$offsetY = _ref.offsetY, offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY, _ref$mouseEnterDelay = _ref.mouseEnterDelay, mouseEnterDelay = _ref$mouseEnterDelay === void 0 ? 100 : _ref$mouseEnterDelay, _ref$mouseLeaveDelay = _ref.mouseLeaveDelay, mouseLeaveDelay = _ref$mouseLeaveDelay === void 0 ? 100 : _ref$mouseLeaveDelay, _ref$keepTooltipInsid = _ref.keepTooltipInside, keepTooltipInside = _ref$keepTooltipInsid === void 0 ? false : _ref$keepTooltipInsid, children = _ref.children;
    var _useState = h$2(open || defaultOpen), isOpen = _useState[0], setIsOpen = _useState[1];
    var triggerRef = _$3(null);
    var contentRef = _$3(null);
    var arrowRef = _$3(null);
    var focusedElBeforeOpen = _$3(null);
    var popupId = _$3("popup-" + ++popupIdCounter);
    var isModal = modal ? true : !trigger;
    var timeOut = _$3(0);
    useIsomorphicLayoutEffect(function() {
      if (isOpen) {
        focusedElBeforeOpen.current = document.activeElement;
        setPosition();
        focusContentOnOpen();
        lockScrolll();
      } else {
        resetScroll();
      }
      return function() {
        clearTimeout(timeOut.current);
      };
    }, [isOpen]);
    p$2(function() {
      if (typeof open === "boolean") {
        if (open)
          openPopup();
        else
          closePopup();
      }
    }, [open, disabled]);
    var openPopup = function openPopup2(event) {
      if (isOpen || disabled)
        return;
      setIsOpen(true);
      setTimeout(function() {
        return onOpen(event);
      }, 0);
    };
    var closePopup = function closePopup2(event) {
      var _focusedElBeforeOpen$;
      if (!isOpen || disabled)
        return;
      setIsOpen(false);
      if (isModal)
        (_focusedElBeforeOpen$ = focusedElBeforeOpen.current) === null || _focusedElBeforeOpen$ === void 0 ? void 0 : _focusedElBeforeOpen$.focus();
      setTimeout(function() {
        return onClose(event);
      }, 0);
    };
    var togglePopup = function togglePopup2(event) {
      event === null || event === void 0 ? void 0 : event.stopPropagation();
      if (!isOpen)
        openPopup(event);
      else
        closePopup(event);
    };
    var onMouseEnter = function onMouseEnter2(event) {
      clearTimeout(timeOut.current);
      timeOut.current = setTimeout(function() {
        return openPopup(event);
      }, mouseEnterDelay);
    };
    var onContextMenu = function onContextMenu2(event) {
      event === null || event === void 0 ? void 0 : event.preventDefault();
      togglePopup();
    };
    var onMouseLeave = function onMouseLeave2(event) {
      clearTimeout(timeOut.current);
      timeOut.current = setTimeout(function() {
        return closePopup(event);
      }, mouseLeaveDelay);
    };
    var lockScrolll = function lockScrolll2() {
      if (isModal && lockScroll)
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
    };
    var resetScroll = function resetScroll2() {
      if (isModal && lockScroll)
        document.getElementsByTagName("body")[0].style.overflow = "auto";
    };
    var focusContentOnOpen = function focusContentOnOpen2() {
      var _contentRef$current;
      var focusableEls = contentRef === null || contentRef === void 0 ? void 0 : (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
      var firstEl = Array.prototype.slice.call(focusableEls)[0];
      firstEl === null || firstEl === void 0 ? void 0 : firstEl.focus();
    };
    A$4(ref, function() {
      return {
        open: function open2() {
          openPopup();
        },
        close: function close() {
          closePopup();
        },
        toggle: function toggle() {
          togglePopup();
        }
      };
    });
    var setPosition = function setPosition2() {
      if (isModal || !isOpen)
        return;
      if (!(triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) || !(triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) || !(contentRef === null || contentRef === void 0 ? void 0 : contentRef.current))
        return;
      var trigger2 = triggerRef.current.getBoundingClientRect();
      var content2 = contentRef.current.getBoundingClientRect();
      var cords = calculatePosition(trigger2, content2, position, arrow, {
        offsetX,
        offsetY
      }, keepTooltipInside);
      contentRef.current.style.top = cords.top + window.scrollY + "px";
      contentRef.current.style.left = cords.left + window.scrollX + "px";
      if (arrow && !!arrowRef.current) {
        var _arrowStyle$top, _arrowStyle$left;
        arrowRef.current.style.transform = cords.transform;
        arrowRef.current.style.setProperty("-ms-transform", cords.transform);
        arrowRef.current.style.setProperty("-webkit-transform", cords.transform);
        arrowRef.current.style.top = ((_arrowStyle$top = arrowStyle.top) === null || _arrowStyle$top === void 0 ? void 0 : _arrowStyle$top.toString()) || cords.arrowTop;
        arrowRef.current.style.left = ((_arrowStyle$left = arrowStyle.left) === null || _arrowStyle$left === void 0 ? void 0 : _arrowStyle$left.toString()) || cords.arrowLeft;
      }
    };
    useOnEscape(closePopup, closeOnEscape);
    useTabbing(contentRef, isOpen && isModal);
    useRepositionOnResize(setPosition, repositionOnResize);
    useOnClickOutside(!!trigger ? [contentRef, triggerRef] : [contentRef], closePopup, closeOnDocumentClick && !nested);
    var renderTrigger = function renderTrigger2() {
      var triggerProps = {
        key: "T",
        ref: triggerRef,
        "aria-describedby": popupId.current
      };
      var onAsArray = Array.isArray(on2) ? on2 : [on2];
      for (var i2 = 0, len2 = onAsArray.length; i2 < len2; i2++) {
        switch (onAsArray[i2]) {
          case "click":
            triggerProps.onClick = togglePopup;
            break;
          case "right-click":
            triggerProps.onContextMenu = onContextMenu;
            break;
          case "hover":
            triggerProps.onMouseEnter = onMouseEnter;
            triggerProps.onMouseLeave = onMouseLeave;
            break;
          case "focus":
            triggerProps.onFocus = onMouseEnter;
            triggerProps.onBlur = onMouseLeave;
            break;
        }
      }
      if (typeof trigger === "function") {
        var comp2 = trigger(isOpen);
        return !!trigger && Cn.cloneElement(comp2, triggerProps);
      }
      return !!trigger && Cn.cloneElement(trigger, triggerProps);
    };
    var addWarperAction = function addWarperAction2() {
      var popupContentStyle = isModal ? Style.popupContent.modal : Style.popupContent.tooltip;
      var childrenElementProps = {
        className: "popup-content " + (className !== "" ? className.split(" ").map(function(c2) {
          return c2 + "-content";
        }).join(" ") : ""),
        style: _extends$2({}, popupContentStyle, contentStyle, {
          pointerEvents: "auto"
        }),
        ref: contentRef,
        onClick: function onClick(e2) {
          e2.stopPropagation();
        }
      };
      if (!modal && on2.indexOf("hover") >= 0) {
        childrenElementProps.onMouseEnter = onMouseEnter;
        childrenElementProps.onMouseLeave = onMouseLeave;
      }
      return childrenElementProps;
    };
    var renderContent = function renderContent2() {
      return Cn.createElement("div", Object.assign({}, addWarperAction(), {
        key: "C",
        role: isModal ? "dialog" : "tooltip",
        id: popupId.current
      }), arrow && !isModal && Cn.createElement("div", {
        ref: arrowRef,
        style: Style.popupArrow
      }, Cn.createElement("svg", {
        "data-testid": "arrow",
        className: "popup-arrow " + (className !== "" ? className.split(" ").map(function(c2) {
          return c2 + "-arrow";
        }).join(" ") : ""),
        viewBox: "0 0 32 16",
        style: _extends$2({
          position: "absolute"
        }, arrowStyle)
      }, Cn.createElement("path", {
        d: "M16 0l16 16H0z",
        fill: "currentcolor"
      }))), children && typeof children === "function" ? children(closePopup, isOpen) : children);
    };
    var overlay = !(on2.indexOf("hover") >= 0);
    var ovStyle = isModal ? Style.overlay.modal : Style.overlay.tooltip;
    var content = [overlay && Cn.createElement("div", {
      key: "O",
      "data-testid": "overlay",
      "data-popup": isModal ? "modal" : "tooltip",
      className: "popup-overlay " + (className !== "" ? className.split(" ").map(function(c2) {
        return c2 + "-overlay";
      }).join(" ") : ""),
      style: _extends$2({}, ovStyle, overlayStyle, {
        pointerEvents: closeOnDocumentClick && nested || isModal ? "auto" : "none"
      }),
      onClick: closeOnDocumentClick && nested ? closePopup : void 0,
      tabIndex: -1
    }, isModal && renderContent()), !isModal && renderContent()];
    return Cn.createElement(Cn.Fragment, null, renderTrigger(), isOpen && Cn.createPortal(content, getRootPopup()));
  });
  function _extends$1() {
    _extends$1 = Object.assign || function(target2) {
      for (var i2 = 1; i2 < arguments.length; i2++) {
        var source = arguments[i2];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target2[key] = source[key];
          }
        }
      }
      return target2;
    };
    return _extends$1.apply(this, arguments);
  }
  var getDirectionStyle = function getDirectionStyle2(dir, size) {
    switch (dir) {
      case "left":
        return {
          top: 0,
          left: 0,
          transform: "translate3d(-100%, 0, 0)",
          width: size,
          height: "100vh"
        };
      case "right":
        return {
          top: 0,
          right: 0,
          transform: "translate3d(100%, 0, 0)",
          width: size,
          height: "100vh"
        };
      case "bottom":
        return {
          left: 0,
          right: 0,
          bottom: 0,
          transform: "translate3d(0, 100%, 0)",
          width: "100%",
          height: size
        };
      case "top":
        return {
          left: 0,
          right: 0,
          top: 0,
          transform: "translate3d(0, -100%, 0)",
          width: "100%",
          height: size
        };
      default:
        return {};
    }
  };
  var EZDrawer = function EZDrawer2(props) {
    var open = props.open, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? function() {
    } : _props$onClose, children = props.children, style = props.style, _props$enableOverlay = props.enableOverlay, enableOverlay = _props$enableOverlay === void 0 ? true : _props$enableOverlay, _props$overlayColor = props.overlayColor, overlayColor = _props$overlayColor === void 0 ? "#000" : _props$overlayColor, _props$overlayOpacity = props.overlayOpacity, overlayOpacity = _props$overlayOpacity === void 0 ? 0.4 : _props$overlayOpacity, _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? 100 : _props$zIndex, _props$duration = props.duration, duration = _props$duration === void 0 ? 500 : _props$duration, direction = props.direction, _props$size = props.size, size = _props$size === void 0 ? 250 : _props$size, className = props.className, customIdSuffix = props.customIdSuffix, _props$lockBackground = props.lockBackgroundScroll, lockBackgroundScroll = _props$lockBackground === void 0 ? false : _props$lockBackground;
    var bodyRef = _$3(null);
    p$2(function() {
      var updatePageScroll = function updatePageScroll2() {
        bodyRef.current = window.document.querySelector("body");
        if (bodyRef.current && lockBackgroundScroll) {
          if (open) {
            bodyRef.current.style.overflow = "hidden";
          } else {
            bodyRef.current.style.overflow = "";
          }
        }
      };
      updatePageScroll();
    }, [open]);
    var idSuffix = F$3(function() {
      return customIdSuffix || (Math.random() + 1).toString(36).substring(7);
    }, [customIdSuffix]);
    var overlayStyles = {
      backgroundColor: "" + overlayColor,
      opacity: "" + overlayOpacity,
      zIndex
    };
    var drawerStyles = _extends$1({
      zIndex: zIndex + 1,
      transitionDuration: duration + "ms"
    }, getDirectionStyle(direction, size), style);
    return Cn.createElement("div", {
      id: "EZDrawer" + idSuffix,
      className: "EZDrawer"
    }, Cn.createElement("input", {
      type: "checkbox",
      id: "EZDrawer__checkbox" + idSuffix,
      className: "EZDrawer__checkbox",
      onChange: onClose,
      checked: open
    }), Cn.createElement("nav", {
      role: "navigation",
      id: "EZDrawer__container" + idSuffix,
      style: drawerStyles,
      className: "EZDrawer__container " + className
    }, children), enableOverlay && Cn.createElement("label", {
      htmlFor: "EZDrawer__checkbox" + idSuffix,
      id: "EZDrawer__overlay" + idSuffix,
      className: "EZDrawer__overlay",
      style: overlayStyles
    }));
  };
  const createMediaQueries = (breakpoints) => {
    const sortedBreakpoints = Object.keys(breakpoints).sort((a2, b2) => breakpoints[b2] - breakpoints[a2]);
    return sortedBreakpoints.map((breakpoint, index2) => {
      let query2 = "";
      const minWidth = breakpoints[breakpoint];
      const nextBreakpoint = sortedBreakpoints[index2 - 1];
      const maxWidth = nextBreakpoint ? breakpoints[nextBreakpoint] : null;
      if (minWidth >= 0) {
        query2 = `(min-width: ${minWidth}px)`;
      }
      if (maxWidth !== null) {
        if (query2) {
          query2 += " and ";
        }
        query2 += `(max-width: ${maxWidth - 1}px)`;
      }
      const mediaQuery = {
        breakpoint,
        maxWidth: maxWidth ? maxWidth - 1 : null,
        minWidth,
        query: query2
      };
      return mediaQuery;
    });
  };
  const createMediaQueries$1 = createMediaQueries;
  const useIsomorphicEffect = typeof window === "undefined" ? p$2 : y$2;
  const useIsomorphicEffect$1 = useIsomorphicEffect;
  const EMPTY_BREAKPOINT = {
    breakpoint: void 0,
    minWidth: void 0,
    maxWidth: void 0
  };
  const useBreakpoint = (config, defaultBreakpoint, hydrateInitial = true) => {
    const mediaQueries = F$3(() => createMediaQueries$1(config), [config]);
    const [currentBreakpoint, setCurrentBreakpoint] = h$2(() => {
      for (const { query: query2, ...breakpoint } of mediaQueries) {
        if (typeof window !== "undefined" && !(defaultBreakpoint && hydrateInitial)) {
          const mediaQuery = window.matchMedia(query2);
          if (mediaQuery.matches) {
            return breakpoint;
          }
        } else if (breakpoint.breakpoint === defaultBreakpoint) {
          return breakpoint;
        }
      }
      return EMPTY_BREAKPOINT;
    });
    const updateBreakpoint = T$3(({ matches }, breakpoint) => {
      if (matches) {
        setCurrentBreakpoint(breakpoint);
      }
    }, []);
    useIsomorphicEffect$1(() => {
      const unsubscribers = mediaQueries.map(({ query: query2, ...breakpoint }) => {
        const list = window.matchMedia(query2);
        updateBreakpoint(list, breakpoint);
        const handleChange = (event) => {
          updateBreakpoint(event, breakpoint);
        };
        const supportsNewEventListeners = "addEventListener" in list && "removeEventListener" in list;
        if (supportsNewEventListeners) {
          list.addEventListener("change", handleChange);
        } else {
          list.addListener(handleChange);
        }
        return () => {
          if (supportsNewEventListeners) {
            list.removeEventListener("change", handleChange);
          } else {
            list.removeListener(handleChange);
          }
        };
      });
      return () => unsubscribers.forEach((unsubscriber) => unsubscriber());
    }, [mediaQueries, updateBreakpoint]);
    x$3(currentBreakpoint, (c2) => typeof c2.breakpoint === "string" ? `${c2.breakpoint} (${c2.minWidth} ≤ x${c2.maxWidth ? ` < ${c2.maxWidth + 1}` : ""})` : "");
    return currentBreakpoint;
  };
  const useBreakpoint$1 = useBreakpoint;
  var dist = {};
  const require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(compat_module);
  var _a;
  var marginRE = /^-?\d*\.?\d+(px|%)$/;
  function parseRootMargin(rootMargin) {
    var marginString = rootMargin ? rootMargin.trim() : "0px";
    var result = marginString.split(/\s+/).map(function(margin) {
      if (!marginRE.test(margin)) {
        throw new Error("rootMargin must be a string literal containing pixels and/or percent values");
      }
      return margin;
    });
    var m0 = result.shift();
    var _a2 = result[0], m1 = _a2 === void 0 ? m0 : _a2, _b = result[1], m2 = _b === void 0 ? m0 : _b, _c = result[2], m3 = _c === void 0 ? m1 : _c;
    return m0 + " " + m1 + " " + m2 + " " + m3;
  }
  function shallowCompare(next, prev) {
    if (Array.isArray(next) && Array.isArray(prev)) {
      if (next.length === prev.length) {
        return next.some(function(_2, index2) {
          return shallowCompare(next[index2], prev[index2]);
        });
      }
    }
    return next !== prev;
  }
  var hasOwnProperty$2 = (_a = Object.prototype, _a.hasOwnProperty), toString$1 = _a.toString;
  function isChildrenWithRef(children) {
    return children && hasOwnProperty$2.call(children, "ref");
  }
  function thresholdCacheKey(threshold) {
    if (!threshold || typeof threshold === "number") {
      return threshold;
    }
    return threshold.join(",");
  }
  var observerElementsMap = /* @__PURE__ */ new Map();
  function getPooled(options) {
    if (options === void 0) {
      options = {};
    }
    var root = options.root || null;
    var rootMargin = parseRootMargin(options.rootMargin);
    var threshold = Array.isArray(options.threshold) ? options.threshold : [options.threshold != null ? options.threshold : 0];
    var observers = observerElementsMap.keys();
    var observer;
    while (observer = observers.next().value) {
      var unmatched = root !== observer.root || rootMargin !== observer.rootMargin || shallowCompare(threshold, observer.thresholds);
      if (!unmatched) {
        return observer;
      }
    }
    return null;
  }
  function findObserverElement(observer, entry) {
    var elements = observerElementsMap.get(observer);
    if (elements) {
      var values = elements.values();
      var element2 = void 0;
      while (element2 = values.next().value) {
        if (element2.target === entry.target) {
          return element2;
        }
      }
    }
    return null;
  }
  function callback(entries, observer) {
    for (var i2 = 0; i2 < entries.length; i2++) {
      var element2 = findObserverElement(observer, entries[i2]);
      if (element2) {
        element2.handleChange(entries[i2]);
      }
    }
  }
  function createObserver(options) {
    var pooled = getPooled(options);
    if (pooled) {
      return pooled;
    }
    var observer = new IntersectionObserver(callback, options);
    observerElementsMap.set(observer, /* @__PURE__ */ new Set());
    return observer;
  }
  function observeElement(element2) {
    var _a2;
    if (element2.observer && !observerElementsMap.has(element2.observer)) {
      observerElementsMap.set(element2.observer, /* @__PURE__ */ new Set());
    }
    (_a2 = observerElementsMap.get(element2.observer)) === null || _a2 === void 0 ? void 0 : _a2.add(element2);
    element2.observer.observe(element2.target);
  }
  function unobserveElement(element2, target2) {
    if (observerElementsMap.has(element2.observer)) {
      var targets = observerElementsMap.get(element2.observer);
      if (targets === null || targets === void 0 ? void 0 : targets.delete(element2)) {
        if (targets.size > 0) {
          element2.observer.unobserve(target2);
        } else {
          element2.observer.disconnect();
          observerElementsMap.delete(element2.observer);
        }
      }
    }
  }
  var __extends = globalThis && globalThis.__extends || function() {
    var extendStatics = function(d2, b2) {
      extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
        d3.__proto__ = b3;
      } || function(d3, b3) {
        for (var p2 in b3)
          if (Object.prototype.hasOwnProperty.call(b3, p2))
            d3[p2] = b3[p2];
      };
      return extendStatics(d2, b2);
    };
    return function(d2, b2) {
      extendStatics(d2, b2);
      function __() {
        this.constructor = d2;
      }
      d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
    };
  }();
  var observerOptions = ["root", "rootMargin", "threshold"];
  var observableProps = ["root", "rootMargin", "threshold", "disabled"];
  var getOptions = function(props) {
    return observerOptions.reduce(function(options, key) {
      var _a2;
      var isRootString = key === "root" && toString$1.call(props.root) === "[object String]";
      return Object.assign(options, (_a2 = {}, _a2[key] = isRootString ? document.querySelector(props[key]) : props[key], _a2));
    }, {});
  };
  var ReactIntersectionObserver = (
    /** @class */
    function(_super) {
      __extends(ReactIntersectionObserver2, _super);
      function ReactIntersectionObserver2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function(event) {
          _this.props.onChange(event, _this.externalUnobserve);
        };
        _this.handleNode = function(target2) {
          var children = _this.props.children;
          if (isChildrenWithRef(children)) {
            var childenRef = children.ref;
            if (typeof childenRef === "function") {
              childenRef(target2);
            } else if (childenRef && hasOwnProperty$2.call(childenRef, "current")) {
              childenRef.current = target2;
            }
          }
          _this.targetNode = void 0;
          if (target2) {
            var targetNode = vn(target2);
            if (targetNode && targetNode.nodeType === 1) {
              _this.targetNode = targetNode;
            }
          }
        };
        _this.observe = function() {
          if (_this.props.children == null || _this.props.disabled) {
            return false;
          }
          if (!_this.targetNode) {
            throw new Error("ReactIntersectionObserver: Can't find DOM node in the provided children. Make sure to render at least one DOM node in the tree.");
          }
          _this.observer = createObserver(getOptions(_this.props));
          _this.target = _this.targetNode;
          observeElement(_this);
          return true;
        };
        _this.unobserve = function(target2) {
          unobserveElement(_this, target2);
        };
        _this.externalUnobserve = function() {
          if (_this.targetNode) {
            _this.unobserve(_this.targetNode);
          }
        };
        return _this;
      }
      ReactIntersectionObserver2.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var _this = this;
        this.prevTargetNode = this.targetNode;
        var relatedPropsChanged = observableProps.some(function(prop2) {
          return shallowCompare(_this.props[prop2], prevProps[prop2]);
        });
        if (relatedPropsChanged) {
          if (this.prevTargetNode) {
            if (!prevProps.disabled) {
              this.unobserve(this.prevTargetNode);
            }
          }
        }
        return relatedPropsChanged;
      };
      ReactIntersectionObserver2.prototype.componentDidUpdate = function(_2, __, relatedPropsChanged) {
        var targetNodeChanged = false;
        if (!relatedPropsChanged) {
          targetNodeChanged = this.prevTargetNode !== this.targetNode;
          if (targetNodeChanged && this.prevTargetNode != null) {
            this.unobserve(this.prevTargetNode);
          }
        }
        if (relatedPropsChanged || targetNodeChanged) {
          this.observe();
        }
      };
      ReactIntersectionObserver2.prototype.componentDidMount = function() {
        this.observe();
      };
      ReactIntersectionObserver2.prototype.componentWillUnmount = function() {
        if (this.targetNode) {
          this.unobserve(this.targetNode);
        }
      };
      ReactIntersectionObserver2.prototype.render = function() {
        var children = this.props.children;
        return children != null ? Cn.cloneElement(Cn.Children.only(children), {
          ref: this.handleNode
        }) : null;
      };
      ReactIntersectionObserver2.displayName = "IntersectionObserver";
      return ReactIntersectionObserver2;
    }(Cn.Component)
  );
  var noop$1 = function() {
  };
  var useIntersectionObserver = function(onChange, _a2) {
    var _b = _a2 === void 0 ? {} : _a2, root = _b.root, rootMargin = _b.rootMargin, threshold = _b.threshold, disabled = _b.disabled;
    var observingRef = _$3(false);
    var instanceRef = _$3({
      // unobserve function needs an instance and instance.handleChange needs an unobserve to be caught by closure.
      // So it's essentially a circular reference that's resolved by assigning handleChange later
      handleChange: function(event) {
        onChange(event, noop$1);
      }
    });
    var unobserve = T$3(function() {
      if (instanceRef.current.target && observingRef.current) {
        unobserveElement(instanceRef.current, instanceRef.current.target);
        observingRef.current = false;
      }
    }, []);
    instanceRef.current.handleChange = function handleChange(event) {
      onChange(event, unobserve);
    };
    var observe = function() {
      if (instanceRef.current.observer && instanceRef.current.target && !observingRef.current) {
        observeElement(instanceRef.current);
        observingRef.current = true;
      }
    };
    var memoizedThreshold = F$3(function() {
      return threshold;
    }, [
      thresholdCacheKey(threshold)
    ]);
    var observer = F$3(function() {
      if (disabled) {
        unobserve();
        instanceRef.current.observer = void 0;
        return void 0;
      }
      var rootOption = typeof root === "string" ? document.querySelector(root) : root;
      var obs = createObserver({
        root: rootOption,
        rootMargin,
        threshold: memoizedThreshold
      });
      instanceRef.current.observer = obs;
      unobserve();
      observe();
      return obs;
    }, [root, rootMargin, memoizedThreshold, disabled]);
    var setRef = T$3(function(node2) {
      var isNewNode = node2 != null && instanceRef.current.target !== node2;
      if (!observer) {
        unobserve();
      }
      if (isNewNode) {
        unobserve();
        instanceRef.current.target = node2;
        observe();
      }
      if (!node2) {
        unobserve();
        instanceRef.current.target = void 0;
      }
    }, [observer]);
    return [setRef, unobserve];
  };
  const es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: ReactIntersectionObserver,
    parseRootMargin,
    useIntersectionObserver
  }, Symbol.toStringTag, { value: "Module" }));
  const require$$1$3 = /* @__PURE__ */ getAugmentedNamespace(es);
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = void 0;
    var React = _interopRequireWildcard(require$$0$3);
    var _reactIntersectionObserver = _interopRequireDefault(require$$1$3);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _getRequireWildcardCache() {
      if (typeof WeakMap !== "function")
        return null;
      var cache = /* @__PURE__ */ new WeakMap();
      _getRequireWildcardCache = function _getRequireWildcardCache2() {
        return cache;
      };
      return cache;
    }
    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      }
      if (obj === null || _typeof2(obj) !== "object" && typeof obj !== "function") {
        return { "default": obj };
      }
      var cache = _getRequireWildcardCache();
      if (cache && cache.has(obj)) {
        return cache.get(obj);
      }
      var newObj = {};
      var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
          if (desc && (desc.get || desc.set)) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
      newObj["default"] = obj;
      if (cache) {
        cache.set(obj, newObj);
      }
      return newObj;
    }
    function _typeof2(obj) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof2 = function _typeof3(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof2 = function _typeof3(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof2(obj);
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _defineProperties(target2, props) {
      for (var i2 = 0; i2 < props.length; i2++) {
        var descriptor = props[i2];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target2, descriptor.key, descriptor);
      }
    }
    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        _defineProperties(Constructor, staticProps);
      return Constructor;
    }
    function _possibleConstructorReturn(self2, call) {
      if (call && (_typeof2(call) === "object" || typeof call === "function")) {
        return call;
      }
      return _assertThisInitialized(self2);
    }
    function _getPrototypeOf(o2) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
        return o3.__proto__ || Object.getPrototypeOf(o3);
      };
      return _getPrototypeOf(o2);
    }
    function _assertThisInitialized(self2) {
      if (self2 === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return self2;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
      if (superClass)
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o2, p2) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
        o3.__proto__ = p3;
        return o3;
      };
      return _setPrototypeOf(o2, p2);
    }
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    var hasWindow = function hasWindow2() {
      return typeof window !== "undefined";
    };
    var ProgressiveImage2 = /* @__PURE__ */ function(_React$Component) {
      _inherits(ProgressiveImage3, _React$Component);
      function ProgressiveImage3(props) {
        var _this;
        _classCallCheck(this, ProgressiveImage3);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressiveImage3).call(this, props));
        _defineProperty(_assertThisInitialized(_this), "image", void 0);
        _defineProperty(_assertThisInitialized(_this), "handleOnlineStatus", function() {
          _this.setState({
            isOnline: window.navigator.onLine
          });
        });
        _defineProperty(_assertThisInitialized(_this), "loadImage", function(src, srcSetData) {
          if (_this.image) {
            _this.image.onload = null;
            _this.image.onerror = null;
          }
          var image2 = new Image();
          _this.image = image2;
          image2.onload = _this.onLoad;
          image2.onerror = function(errorEvent) {
            _this.onError(errorEvent);
            return;
          };
          image2.src = src;
          if (srcSetData) {
            image2.srcset = srcSetData.srcSet;
            image2.sizes = srcSetData.sizes;
          }
        });
        _defineProperty(_assertThisInitialized(_this), "onLoad", function() {
          if (_this.props.delay) {
            _this.setImageWithDelay();
          } else {
            _this.setImage();
          }
        });
        _defineProperty(_assertThisInitialized(_this), "setImageWithDelay", function() {
          setTimeout(function() {
            _this.setImage();
          }, _this.props.delay);
        });
        _defineProperty(_assertThisInitialized(_this), "setImage", function() {
          if (_this._isMounted) {
            _this.setState({
              image: _this.image.src,
              loading: false,
              srcSetData: {
                srcSet: _this.image.srcset || "",
                sizes: _this.image.sizes || ""
              }
            }, function() {
              window.removeEventListener("online", _this.handleOnlineStatus);
              window.removeEventListener("offline", _this.handleOnlineStatus);
            });
          }
        });
        _defineProperty(_assertThisInitialized(_this), "onError", function(errorEvent) {
          var onError = _this.props.onError;
          if (onError) {
            onError(errorEvent);
          }
        });
        _defineProperty(_assertThisInitialized(_this), "handleIntersection", function(event, unobserve, isOnline) {
          if (event.isIntersecting) {
            var _this$props = _this.props, src = _this$props.src, srcSetData = _this$props.srcSetData;
            if (isOnline) {
              _this.loadImage(src, srcSetData);
              unobserve();
            }
          }
        });
        _this._isMounted = false;
        _this.state = {
          isOnline: hasWindow() ? window.navigator.onLine : true,
          image: props.placeholder,
          loading: true,
          srcSetData: {
            srcSet: "",
            sizes: ""
          }
        };
        return _this;
      }
      _createClass(ProgressiveImage3, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this._isMounted = true;
          if (!hasWindow()) {
            return;
          }
          window.addEventListener("online", this.handleOnlineStatus);
          window.addEventListener("offline", this.handleOnlineStatus);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this2 = this;
          var _this$props2 = this.props, src = _this$props2.src, placeholder = _this$props2.placeholder, srcSetData = _this$props2.srcSetData;
          if (src !== prevProps.src) {
            this.setState({
              image: placeholder,
              loading: true
            }, function() {
              _this2.loadImage(src, srcSetData);
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this._isMounted = false;
          if (this.image) {
            this.image.onload = null;
            this.image.onerror = null;
          }
          if (this.timeout) {
            window.clearTimeout(this.timeout);
          }
          window.removeEventListener("online", this.handleOnlineStatus);
          window.removeEventListener("offline", this.handleOnlineStatus);
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;
          var options = {
            onChange: function onChange(event, unobserve) {
              return _this3.handleIntersection(event, unobserve, _this3.state.isOnline);
            },
            rootMargin: this.props.rootMargin || "0% 0% 25%",
            threshold: this.props.threshold || [0],
            disabled: this.props.noLazyLoad || false
          };
          var _this$state = this.state, image2 = _this$state.image, loading = _this$state.loading, srcSetData = _this$state.srcSetData;
          var _this$props3 = this.props, src = _this$props3.src, children = _this$props3.children;
          _this$props3.noRetry;
          var noLazyLoad = _this$props3.noLazyLoad;
          if (!children || typeof children !== "function") {
            throw new Error("ProgressiveImage requires a function as its only child");
          }
          if (noLazyLoad) {
            return children(src, false, this.props.srcSetData);
          }
          return React.createElement(_reactIntersectionObserver["default"], options, children(image2, loading, srcSetData));
        }
      }]);
      return ProgressiveImage3;
    }(React.Component);
    exports["default"] = ProgressiveImage2;
  })(dist);
  const ProgressiveImage = /* @__PURE__ */ getDefaultExportFromCjs(dist);
  var _ = 0;
  function o(o2, e2, n2, t2, f2, l2) {
    var s2, u2, a2 = {};
    for (u2 in e2)
      "ref" == u2 ? s2 = e2[u2] : a2[u2] = e2[u2];
    var i2 = { type: o2, props: a2, key: n2, ref: s2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: --_, __source: f2, __self: l2 };
    if ("function" == typeof o2 && (s2 = o2.defaultProps))
      for (u2 in s2)
        void 0 === a2[u2] && (a2[u2] = s2[u2]);
    return l$2.vnode && l$2.vnode(i2), i2;
  }
  const Cards = ({
    selected,
    step
  }) => {
    const {
      config,
      setConfig
    } = q$4(ConfigContext);

    const removeSelected = (product, index) => {
      if (step.type == "box") return;

      setConfig((current) => {
        let temp = {
          ...current
        };

        if (step.type == "products") {
          temp.selected.products = temp.selected.products.filter((p2, i2) => {
            return i2 !== index;
          });
        }

        if (step.type == "card") {
          temp.selected.card = [];
        }

        return temp;
      });
    };

    return o("div", {
      class: "summary__card is-flex is-flex-wrap summary__card--" + step.type,
      children: selected.map((product, index) => {
        return o("div", {
          class: "summary__card__item one-third medium-down--one-half column",
          children: [
            step.type != "box" ? o("button", {
              type: "button",
              class: "quantity-modifier modifier-left remove__card__item",
              onClick: () => removeSelected(product, index),
              children: "✕"
            }) : null,
            o("div", {
              class: "image-wrapper is-relative",
              children: o(ProgressiveImage, {
                src: product.featured_image,
                children: (src) => o("img", {
                  src,
                  alt: product.title
                })
              })
            })
          ]
        });
      })
    });
  };
  const PrevNextBtns = ({
    context,
    toggleCartDrawer
  }) => {
    const {
      config,
      setConfig
    } = q$4(ConfigContext);
    let currentIndex = config.steps.findIndex((s2) => s2.active);
    const translations = Shopify.theme.BundleTranslations;
    let showSummaryBtn = false;
    let nextBtn = false;
    let hasProducts = config.selected.products.length;
    let hasBox = config.selected.box.length;
    let hasCard = config.selected.card.length;
    let hasMessage = false;
    let message = config.message;
    if (hasCard > 0) {
      if (message.skip == false) {
        if (!message.from.trim().length || !message.message.trim().length) {
          hasMessage = false;
        } else {
          hasMessage = true;
        }
      } else {
        hasMessage = true;
      }
    }
    if (currentIndex == 3 && hasProducts > 0 && hasBox > 0 && hasCard > 0 && hasMessage == true) {
      showSummaryBtn = true;
    } else {
      showSummaryBtn = false;
    }
    let bodyElem = document.querySelector("body");
    bodyElem.classList.add(`enableIndex${currentIndex + 1}`);
    if (currentIndex == 0 && hasBox > 0 || currentIndex == 1 && hasProducts > 0 || currentIndex == 2 && hasCard > 0) {
      nextBtn = true;
    } else {
      bodyElem.classList.remove(`enableIndex${currentIndex + 1}`);
      nextBtn = false;
    }
    let totalSteps = 3;
    const changeStep = (index2) => {
      setConfig(() => {
        let temp = {
          ...config
        };
        temp.steps.map((step, i2) => {
          if (i2 == index2)
            step.active = true;
          else
            step.active = false;
          return step;
        });
        return temp;
      });
      const stepsAndNavContainer = document.querySelector(".navigationAndSetps");
      const body = document.querySelector("body");
      const html = document.documentElement;
      if (stepsAndNavContainer) {
        stepsAndNavContainer.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        body.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        html.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    return o("div", {
      class: `${context}__buttons prev-next--buttons is-justify-space-between one-whole column is-flex`,
      children: [o("div", {
        class: "buttons__left",
        children: currentIndex > 0 ? o("button", {
          class: "button button--secondary",
          onClick: () => changeStep(currentIndex - 1),
          children: translations.summary.prev_button
        }) : null
      }), o("div", {
        class: "buttons__right",
        children: [currentIndex < totalSteps && nextBtn ? o("button", {
          class: "button button--secondary",
          onClick: () => changeStep(currentIndex + 1),
          children: translations.summary.next_button
        }) : null, showSummaryBtn ? o("button", {
          class: "button button--primary summaryOpeniningBtn",
          onClick: toggleCartDrawer,
          children: "Finish Box"
        }) : null]
      })]
    });
  };
  const Summary = ({
    toggleCartDrawer
  }) => {
    const {
      config
    } = q$4(ConfigContext);
    const {
      breakpoint
    } = useBreakpoint$1(Shopify.theme.BREAKPOINTS);
    const translations = Shopify.theme.BundleTranslations;
    const selected = [config.selected.box, config.selected.products, config.selected.card];
    const isNotBlank = selected.some((s2) => s2.length != 0);
    return o("div", {
      class: `summary one-half medium-down--one-whole column summary--${isNotBlank ? "not-empty" : "empty"}`,
      children: o(_$4, {
        children: isNotBlank ? o(_$4, {
          children: [breakpoint != "small" ? o(PrevNextBtns, {
            context: "summary",
            toggleCartDrawer
          }) : null, config.steps.map((step) => o(_$4, {
            children: config.selected[step.type].length ? o(Cards, {
              selected: config.selected[step.type],
              step
            }) : null
          }))]
        }) : o("h2", {
          class: "is-h4 summary__empty",
          children: translations.summary.empty
        })
      })
    });
  };
  var libExports$1 = {};
  var lib$2 = {
    get exports() {
      return libExports$1;
    },
    set exports(v2) {
      libExports$1 = v2;
    }
  };
  const require$$0$2 = {
    "0": 65533,
    "128": 8364,
    "130": 8218,
    "131": 402,
    "132": 8222,
    "133": 8230,
    "134": 8224,
    "135": 8225,
    "136": 710,
    "137": 8240,
    "138": 352,
    "139": 8249,
    "140": 338,
    "142": 381,
    "145": 8216,
    "146": 8217,
    "147": 8220,
    "148": 8221,
    "149": 8226,
    "150": 8211,
    "151": 8212,
    "152": 732,
    "153": 8482,
    "154": 353,
    "155": 8250,
    "156": 339,
    "158": 382,
    "159": 376
  };
  var decodeMap = require$$0$2;
  var decode_codepoint$1 = decodeCodePoint$1;
  function decodeCodePoint$1(codePoint) {
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
      return "�";
    }
    if (codePoint in decodeMap) {
      codePoint = decodeMap[codePoint];
    }
    var output = "";
    if (codePoint > 65535) {
      codePoint -= 65536;
      output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
  }
  const Aacute$3 = "Á";
  const aacute$3 = "á";
  const Abreve$1 = "Ă";
  const abreve$1 = "ă";
  const ac$1 = "∾";
  const acd$1 = "∿";
  const acE$1 = "∾̳";
  const Acirc$3 = "Â";
  const acirc$3 = "â";
  const acute$3 = "´";
  const Acy$1 = "А";
  const acy$1 = "а";
  const AElig$3 = "Æ";
  const aelig$3 = "æ";
  const af$1 = "⁡";
  const Afr$1 = "𝔄";
  const afr$1 = "𝔞";
  const Agrave$3 = "À";
  const agrave$3 = "à";
  const alefsym$1 = "ℵ";
  const aleph$1 = "ℵ";
  const Alpha$1 = "Α";
  const alpha$1 = "α";
  const Amacr$1 = "Ā";
  const amacr$1 = "ā";
  const amalg$1 = "⨿";
  const amp$5 = "&";
  const AMP$3 = "&";
  const andand$1 = "⩕";
  const And$1 = "⩓";
  const and$1 = "∧";
  const andd$1 = "⩜";
  const andslope$1 = "⩘";
  const andv$1 = "⩚";
  const ang$1 = "∠";
  const ange$1 = "⦤";
  const angle$1 = "∠";
  const angmsdaa$1 = "⦨";
  const angmsdab$1 = "⦩";
  const angmsdac$1 = "⦪";
  const angmsdad$1 = "⦫";
  const angmsdae$1 = "⦬";
  const angmsdaf$1 = "⦭";
  const angmsdag$1 = "⦮";
  const angmsdah$1 = "⦯";
  const angmsd$1 = "∡";
  const angrt$1 = "∟";
  const angrtvb$1 = "⊾";
  const angrtvbd$1 = "⦝";
  const angsph$1 = "∢";
  const angst$1 = "Å";
  const angzarr$1 = "⍼";
  const Aogon$1 = "Ą";
  const aogon$1 = "ą";
  const Aopf$1 = "𝔸";
  const aopf$1 = "𝕒";
  const apacir$1 = "⩯";
  const ap$1 = "≈";
  const apE$1 = "⩰";
  const ape$1 = "≊";
  const apid$1 = "≋";
  const apos$3 = "'";
  const ApplyFunction$1 = "⁡";
  const approx$1 = "≈";
  const approxeq$1 = "≊";
  const Aring$3 = "Å";
  const aring$3 = "å";
  const Ascr$1 = "𝒜";
  const ascr$1 = "𝒶";
  const Assign$1 = "≔";
  const ast$1 = "*";
  const asymp$1 = "≈";
  const asympeq$1 = "≍";
  const Atilde$3 = "Ã";
  const atilde$3 = "ã";
  const Auml$3 = "Ä";
  const auml$3 = "ä";
  const awconint$1 = "∳";
  const awint$1 = "⨑";
  const backcong$1 = "≌";
  const backepsilon$1 = "϶";
  const backprime$1 = "‵";
  const backsim$1 = "∽";
  const backsimeq$1 = "⋍";
  const Backslash$1 = "∖";
  const Barv$1 = "⫧";
  const barvee$1 = "⊽";
  const barwed$1 = "⌅";
  const Barwed$1 = "⌆";
  const barwedge$1 = "⌅";
  const bbrk$1 = "⎵";
  const bbrktbrk$1 = "⎶";
  const bcong$1 = "≌";
  const Bcy$1 = "Б";
  const bcy$1 = "б";
  const bdquo$1 = "„";
  const becaus$1 = "∵";
  const because$1 = "∵";
  const Because$1 = "∵";
  const bemptyv$1 = "⦰";
  const bepsi$1 = "϶";
  const bernou$1 = "ℬ";
  const Bernoullis$1 = "ℬ";
  const Beta$1 = "Β";
  const beta$1 = "β";
  const beth$1 = "ℶ";
  const between$1 = "≬";
  const Bfr$1 = "𝔅";
  const bfr$1 = "𝔟";
  const bigcap$1 = "⋂";
  const bigcirc$1 = "◯";
  const bigcup$1 = "⋃";
  const bigodot$1 = "⨀";
  const bigoplus$1 = "⨁";
  const bigotimes$1 = "⨂";
  const bigsqcup$1 = "⨆";
  const bigstar$1 = "★";
  const bigtriangledown$1 = "▽";
  const bigtriangleup$1 = "△";
  const biguplus$1 = "⨄";
  const bigvee$1 = "⋁";
  const bigwedge$1 = "⋀";
  const bkarow$1 = "⤍";
  const blacklozenge$1 = "⧫";
  const blacksquare$1 = "▪";
  const blacktriangle$1 = "▴";
  const blacktriangledown$1 = "▾";
  const blacktriangleleft$1 = "◂";
  const blacktriangleright$1 = "▸";
  const blank$1 = "␣";
  const blk12$1 = "▒";
  const blk14$1 = "░";
  const blk34$1 = "▓";
  const block$1 = "█";
  const bne$1 = "=⃥";
  const bnequiv$1 = "≡⃥";
  const bNot$1 = "⫭";
  const bnot$1 = "⌐";
  const Bopf$1 = "𝔹";
  const bopf$1 = "𝕓";
  const bot$1 = "⊥";
  const bottom$1 = "⊥";
  const bowtie$1 = "⋈";
  const boxbox$1 = "⧉";
  const boxdl$1 = "┐";
  const boxdL$1 = "╕";
  const boxDl$1 = "╖";
  const boxDL$1 = "╗";
  const boxdr$1 = "┌";
  const boxdR$1 = "╒";
  const boxDr$1 = "╓";
  const boxDR$1 = "╔";
  const boxh$1 = "─";
  const boxH$1 = "═";
  const boxhd$1 = "┬";
  const boxHd$1 = "╤";
  const boxhD$1 = "╥";
  const boxHD$1 = "╦";
  const boxhu$1 = "┴";
  const boxHu$1 = "╧";
  const boxhU$1 = "╨";
  const boxHU$1 = "╩";
  const boxminus$1 = "⊟";
  const boxplus$1 = "⊞";
  const boxtimes$1 = "⊠";
  const boxul$1 = "┘";
  const boxuL$1 = "╛";
  const boxUl$1 = "╜";
  const boxUL$1 = "╝";
  const boxur$1 = "└";
  const boxuR$1 = "╘";
  const boxUr$1 = "╙";
  const boxUR$1 = "╚";
  const boxv$1 = "│";
  const boxV$1 = "║";
  const boxvh$1 = "┼";
  const boxvH$1 = "╪";
  const boxVh$1 = "╫";
  const boxVH$1 = "╬";
  const boxvl$1 = "┤";
  const boxvL$1 = "╡";
  const boxVl$1 = "╢";
  const boxVL$1 = "╣";
  const boxvr$1 = "├";
  const boxvR$1 = "╞";
  const boxVr$1 = "╟";
  const boxVR$1 = "╠";
  const bprime$1 = "‵";
  const breve$1 = "˘";
  const Breve$1 = "˘";
  const brvbar$3 = "¦";
  const bscr$1 = "𝒷";
  const Bscr$1 = "ℬ";
  const bsemi$1 = "⁏";
  const bsim$1 = "∽";
  const bsime$1 = "⋍";
  const bsolb$1 = "⧅";
  const bsol$1 = "\\";
  const bsolhsub$1 = "⟈";
  const bull$1 = "•";
  const bullet$1 = "•";
  const bump$1 = "≎";
  const bumpE$1 = "⪮";
  const bumpe$1 = "≏";
  const Bumpeq$1 = "≎";
  const bumpeq$1 = "≏";
  const Cacute$1 = "Ć";
  const cacute$1 = "ć";
  const capand$1 = "⩄";
  const capbrcup$1 = "⩉";
  const capcap$1 = "⩋";
  const cap$1 = "∩";
  const Cap$1 = "⋒";
  const capcup$1 = "⩇";
  const capdot$1 = "⩀";
  const CapitalDifferentialD$1 = "ⅅ";
  const caps$1 = "∩︀";
  const caret$1 = "⁁";
  const caron$1 = "ˇ";
  const Cayleys$1 = "ℭ";
  const ccaps$1 = "⩍";
  const Ccaron$1 = "Č";
  const ccaron$1 = "č";
  const Ccedil$3 = "Ç";
  const ccedil$3 = "ç";
  const Ccirc$1 = "Ĉ";
  const ccirc$1 = "ĉ";
  const Cconint$1 = "∰";
  const ccups$1 = "⩌";
  const ccupssm$1 = "⩐";
  const Cdot$1 = "Ċ";
  const cdot$1 = "ċ";
  const cedil$3 = "¸";
  const Cedilla$1 = "¸";
  const cemptyv$1 = "⦲";
  const cent$3 = "¢";
  const centerdot$1 = "·";
  const CenterDot$1 = "·";
  const cfr$1 = "𝔠";
  const Cfr$1 = "ℭ";
  const CHcy$1 = "Ч";
  const chcy$1 = "ч";
  const check$1 = "✓";
  const checkmark$1 = "✓";
  const Chi$1 = "Χ";
  const chi$1 = "χ";
  const circ$1 = "ˆ";
  const circeq$1 = "≗";
  const circlearrowleft$1 = "↺";
  const circlearrowright$1 = "↻";
  const circledast$1 = "⊛";
  const circledcirc$1 = "⊚";
  const circleddash$1 = "⊝";
  const CircleDot$1 = "⊙";
  const circledR$1 = "®";
  const circledS$1 = "Ⓢ";
  const CircleMinus$1 = "⊖";
  const CirclePlus$1 = "⊕";
  const CircleTimes$1 = "⊗";
  const cir$1 = "○";
  const cirE$1 = "⧃";
  const cire$1 = "≗";
  const cirfnint$1 = "⨐";
  const cirmid$1 = "⫯";
  const cirscir$1 = "⧂";
  const ClockwiseContourIntegral$1 = "∲";
  const CloseCurlyDoubleQuote$1 = "”";
  const CloseCurlyQuote$1 = "’";
  const clubs$1 = "♣";
  const clubsuit$1 = "♣";
  const colon$1 = ":";
  const Colon$1 = "∷";
  const Colone$1 = "⩴";
  const colone$1 = "≔";
  const coloneq$1 = "≔";
  const comma$1 = ",";
  const commat$1 = "@";
  const comp$1 = "∁";
  const compfn$1 = "∘";
  const complement$1 = "∁";
  const complexes$1 = "ℂ";
  const cong$1 = "≅";
  const congdot$1 = "⩭";
  const Congruent$1 = "≡";
  const conint$1 = "∮";
  const Conint$1 = "∯";
  const ContourIntegral$1 = "∮";
  const copf$1 = "𝕔";
  const Copf$1 = "ℂ";
  const coprod$1 = "∐";
  const Coproduct$1 = "∐";
  const copy$3 = "©";
  const COPY$3 = "©";
  const copysr$1 = "℗";
  const CounterClockwiseContourIntegral$1 = "∳";
  const crarr$1 = "↵";
  const cross$1 = "✗";
  const Cross$1 = "⨯";
  const Cscr$1 = "𝒞";
  const cscr$1 = "𝒸";
  const csub$1 = "⫏";
  const csube$1 = "⫑";
  const csup$1 = "⫐";
  const csupe$1 = "⫒";
  const ctdot$1 = "⋯";
  const cudarrl$1 = "⤸";
  const cudarrr$1 = "⤵";
  const cuepr$1 = "⋞";
  const cuesc$1 = "⋟";
  const cularr$1 = "↶";
  const cularrp$1 = "⤽";
  const cupbrcap$1 = "⩈";
  const cupcap$1 = "⩆";
  const CupCap$1 = "≍";
  const cup$1 = "∪";
  const Cup$1 = "⋓";
  const cupcup$1 = "⩊";
  const cupdot$1 = "⊍";
  const cupor$1 = "⩅";
  const cups$1 = "∪︀";
  const curarr$1 = "↷";
  const curarrm$1 = "⤼";
  const curlyeqprec$1 = "⋞";
  const curlyeqsucc$1 = "⋟";
  const curlyvee$1 = "⋎";
  const curlywedge$1 = "⋏";
  const curren$3 = "¤";
  const curvearrowleft$1 = "↶";
  const curvearrowright$1 = "↷";
  const cuvee$1 = "⋎";
  const cuwed$1 = "⋏";
  const cwconint$1 = "∲";
  const cwint$1 = "∱";
  const cylcty$1 = "⌭";
  const dagger$1 = "†";
  const Dagger$1 = "‡";
  const daleth$1 = "ℸ";
  const darr$1 = "↓";
  const Darr$1 = "↡";
  const dArr$1 = "⇓";
  const dash$1 = "‐";
  const Dashv$1 = "⫤";
  const dashv$1 = "⊣";
  const dbkarow$1 = "⤏";
  const dblac$1 = "˝";
  const Dcaron$1 = "Ď";
  const dcaron$1 = "ď";
  const Dcy$1 = "Д";
  const dcy$1 = "д";
  const ddagger$1 = "‡";
  const ddarr$1 = "⇊";
  const DD$1 = "ⅅ";
  const dd$1 = "ⅆ";
  const DDotrahd$1 = "⤑";
  const ddotseq$1 = "⩷";
  const deg$3 = "°";
  const Del$1 = "∇";
  const Delta$1 = "Δ";
  const delta$1 = "δ";
  const demptyv$1 = "⦱";
  const dfisht$1 = "⥿";
  const Dfr$1 = "𝔇";
  const dfr$1 = "𝔡";
  const dHar$1 = "⥥";
  const dharl$1 = "⇃";
  const dharr$1 = "⇂";
  const DiacriticalAcute$1 = "´";
  const DiacriticalDot$1 = "˙";
  const DiacriticalDoubleAcute$1 = "˝";
  const DiacriticalGrave$1 = "`";
  const DiacriticalTilde$1 = "˜";
  const diam$1 = "⋄";
  const diamond$1 = "⋄";
  const Diamond$1 = "⋄";
  const diamondsuit$1 = "♦";
  const diams$1 = "♦";
  const die$1 = "¨";
  const DifferentialD$1 = "ⅆ";
  const digamma$1 = "ϝ";
  const disin$1 = "⋲";
  const div$1 = "÷";
  const divide$3 = "÷";
  const divideontimes$1 = "⋇";
  const divonx$1 = "⋇";
  const DJcy$1 = "Ђ";
  const djcy$1 = "ђ";
  const dlcorn$1 = "⌞";
  const dlcrop$1 = "⌍";
  const dollar$1 = "$";
  const Dopf$1 = "𝔻";
  const dopf$1 = "𝕕";
  const Dot$1 = "¨";
  const dot$1 = "˙";
  const DotDot$1 = "⃜";
  const doteq$1 = "≐";
  const doteqdot$1 = "≑";
  const DotEqual$1 = "≐";
  const dotminus$1 = "∸";
  const dotplus$1 = "∔";
  const dotsquare$1 = "⊡";
  const doublebarwedge$1 = "⌆";
  const DoubleContourIntegral$1 = "∯";
  const DoubleDot$1 = "¨";
  const DoubleDownArrow$1 = "⇓";
  const DoubleLeftArrow$1 = "⇐";
  const DoubleLeftRightArrow$1 = "⇔";
  const DoubleLeftTee$1 = "⫤";
  const DoubleLongLeftArrow$1 = "⟸";
  const DoubleLongLeftRightArrow$1 = "⟺";
  const DoubleLongRightArrow$1 = "⟹";
  const DoubleRightArrow$1 = "⇒";
  const DoubleRightTee$1 = "⊨";
  const DoubleUpArrow$1 = "⇑";
  const DoubleUpDownArrow$1 = "⇕";
  const DoubleVerticalBar$1 = "∥";
  const DownArrowBar$1 = "⤓";
  const downarrow$1 = "↓";
  const DownArrow$1 = "↓";
  const Downarrow$1 = "⇓";
  const DownArrowUpArrow$1 = "⇵";
  const DownBreve$1 = "̑";
  const downdownarrows$1 = "⇊";
  const downharpoonleft$1 = "⇃";
  const downharpoonright$1 = "⇂";
  const DownLeftRightVector$1 = "⥐";
  const DownLeftTeeVector$1 = "⥞";
  const DownLeftVectorBar$1 = "⥖";
  const DownLeftVector$1 = "↽";
  const DownRightTeeVector$1 = "⥟";
  const DownRightVectorBar$1 = "⥗";
  const DownRightVector$1 = "⇁";
  const DownTeeArrow$1 = "↧";
  const DownTee$1 = "⊤";
  const drbkarow$1 = "⤐";
  const drcorn$1 = "⌟";
  const drcrop$1 = "⌌";
  const Dscr$1 = "𝒟";
  const dscr$1 = "𝒹";
  const DScy$1 = "Ѕ";
  const dscy$1 = "ѕ";
  const dsol$1 = "⧶";
  const Dstrok$1 = "Đ";
  const dstrok$1 = "đ";
  const dtdot$1 = "⋱";
  const dtri$1 = "▿";
  const dtrif$1 = "▾";
  const duarr$1 = "⇵";
  const duhar$1 = "⥯";
  const dwangle$1 = "⦦";
  const DZcy$1 = "Џ";
  const dzcy$1 = "џ";
  const dzigrarr$1 = "⟿";
  const Eacute$3 = "É";
  const eacute$3 = "é";
  const easter$1 = "⩮";
  const Ecaron$1 = "Ě";
  const ecaron$1 = "ě";
  const Ecirc$3 = "Ê";
  const ecirc$3 = "ê";
  const ecir$1 = "≖";
  const ecolon$1 = "≕";
  const Ecy$1 = "Э";
  const ecy$1 = "э";
  const eDDot$1 = "⩷";
  const Edot$1 = "Ė";
  const edot$1 = "ė";
  const eDot$1 = "≑";
  const ee$1 = "ⅇ";
  const efDot$1 = "≒";
  const Efr$1 = "𝔈";
  const efr$1 = "𝔢";
  const eg$1 = "⪚";
  const Egrave$3 = "È";
  const egrave$3 = "è";
  const egs$1 = "⪖";
  const egsdot$1 = "⪘";
  const el$1 = "⪙";
  const Element$1 = "∈";
  const elinters$1 = "⏧";
  const ell$1 = "ℓ";
  const els$1 = "⪕";
  const elsdot$1 = "⪗";
  const Emacr$1 = "Ē";
  const emacr$1 = "ē";
  const empty$1 = "∅";
  const emptyset$1 = "∅";
  const EmptySmallSquare$1 = "◻";
  const emptyv$1 = "∅";
  const EmptyVerySmallSquare$1 = "▫";
  const emsp13$1 = " ";
  const emsp14$1 = " ";
  const emsp$1 = " ";
  const ENG$1 = "Ŋ";
  const eng$1 = "ŋ";
  const ensp$1 = " ";
  const Eogon$1 = "Ę";
  const eogon$1 = "ę";
  const Eopf$1 = "𝔼";
  const eopf$1 = "𝕖";
  const epar$1 = "⋕";
  const eparsl$1 = "⧣";
  const eplus$1 = "⩱";
  const epsi$1 = "ε";
  const Epsilon$1 = "Ε";
  const epsilon$1 = "ε";
  const epsiv$1 = "ϵ";
  const eqcirc$1 = "≖";
  const eqcolon$1 = "≕";
  const eqsim$1 = "≂";
  const eqslantgtr$1 = "⪖";
  const eqslantless$1 = "⪕";
  const Equal$1 = "⩵";
  const equals$1 = "=";
  const EqualTilde$1 = "≂";
  const equest$1 = "≟";
  const Equilibrium$1 = "⇌";
  const equiv$1 = "≡";
  const equivDD$1 = "⩸";
  const eqvparsl$1 = "⧥";
  const erarr$1 = "⥱";
  const erDot$1 = "≓";
  const escr$1 = "ℯ";
  const Escr$1 = "ℰ";
  const esdot$1 = "≐";
  const Esim$1 = "⩳";
  const esim$1 = "≂";
  const Eta$1 = "Η";
  const eta$1 = "η";
  const ETH$3 = "Ð";
  const eth$3 = "ð";
  const Euml$3 = "Ë";
  const euml$3 = "ë";
  const euro$1 = "€";
  const excl$1 = "!";
  const exist$1 = "∃";
  const Exists$1 = "∃";
  const expectation$1 = "ℰ";
  const exponentiale$1 = "ⅇ";
  const ExponentialE$1 = "ⅇ";
  const fallingdotseq$1 = "≒";
  const Fcy$1 = "Ф";
  const fcy$1 = "ф";
  const female$1 = "♀";
  const ffilig$1 = "ﬃ";
  const fflig$1 = "ﬀ";
  const ffllig$1 = "ﬄ";
  const Ffr$1 = "𝔉";
  const ffr$1 = "𝔣";
  const filig$1 = "ﬁ";
  const FilledSmallSquare$1 = "◼";
  const FilledVerySmallSquare$1 = "▪";
  const fjlig$1 = "fj";
  const flat$1 = "♭";
  const fllig$1 = "ﬂ";
  const fltns$1 = "▱";
  const fnof$1 = "ƒ";
  const Fopf$1 = "𝔽";
  const fopf$1 = "𝕗";
  const forall$1 = "∀";
  const ForAll$1 = "∀";
  const fork$1 = "⋔";
  const forkv$1 = "⫙";
  const Fouriertrf$1 = "ℱ";
  const fpartint$1 = "⨍";
  const frac12$3 = "½";
  const frac13$1 = "⅓";
  const frac14$3 = "¼";
  const frac15$1 = "⅕";
  const frac16$1 = "⅙";
  const frac18$1 = "⅛";
  const frac23$1 = "⅔";
  const frac25$1 = "⅖";
  const frac34$3 = "¾";
  const frac35$1 = "⅗";
  const frac38$1 = "⅜";
  const frac45$1 = "⅘";
  const frac56$1 = "⅚";
  const frac58$1 = "⅝";
  const frac78$1 = "⅞";
  const frasl$1 = "⁄";
  const frown$1 = "⌢";
  const fscr$1 = "𝒻";
  const Fscr$1 = "ℱ";
  const gacute$1 = "ǵ";
  const Gamma$1 = "Γ";
  const gamma$1 = "γ";
  const Gammad$1 = "Ϝ";
  const gammad$1 = "ϝ";
  const gap$1 = "⪆";
  const Gbreve$1 = "Ğ";
  const gbreve$1 = "ğ";
  const Gcedil$1 = "Ģ";
  const Gcirc$1 = "Ĝ";
  const gcirc$1 = "ĝ";
  const Gcy$1 = "Г";
  const gcy$1 = "г";
  const Gdot$1 = "Ġ";
  const gdot$1 = "ġ";
  const ge$1 = "≥";
  const gE$1 = "≧";
  const gEl$1 = "⪌";
  const gel$1 = "⋛";
  const geq$1 = "≥";
  const geqq$1 = "≧";
  const geqslant$1 = "⩾";
  const gescc$1 = "⪩";
  const ges$1 = "⩾";
  const gesdot$1 = "⪀";
  const gesdoto$1 = "⪂";
  const gesdotol$1 = "⪄";
  const gesl$1 = "⋛︀";
  const gesles$1 = "⪔";
  const Gfr$1 = "𝔊";
  const gfr$1 = "𝔤";
  const gg$1 = "≫";
  const Gg$1 = "⋙";
  const ggg$1 = "⋙";
  const gimel$1 = "ℷ";
  const GJcy$1 = "Ѓ";
  const gjcy$1 = "ѓ";
  const gla$1 = "⪥";
  const gl$1 = "≷";
  const glE$1 = "⪒";
  const glj$1 = "⪤";
  const gnap$1 = "⪊";
  const gnapprox$1 = "⪊";
  const gne$1 = "⪈";
  const gnE$1 = "≩";
  const gneq$1 = "⪈";
  const gneqq$1 = "≩";
  const gnsim$1 = "⋧";
  const Gopf$1 = "𝔾";
  const gopf$1 = "𝕘";
  const grave$1 = "`";
  const GreaterEqual$1 = "≥";
  const GreaterEqualLess$1 = "⋛";
  const GreaterFullEqual$1 = "≧";
  const GreaterGreater$1 = "⪢";
  const GreaterLess$1 = "≷";
  const GreaterSlantEqual$1 = "⩾";
  const GreaterTilde$1 = "≳";
  const Gscr$1 = "𝒢";
  const gscr$1 = "ℊ";
  const gsim$1 = "≳";
  const gsime$1 = "⪎";
  const gsiml$1 = "⪐";
  const gtcc$1 = "⪧";
  const gtcir$1 = "⩺";
  const gt$5 = ">";
  const GT$3 = ">";
  const Gt$1 = "≫";
  const gtdot$1 = "⋗";
  const gtlPar$1 = "⦕";
  const gtquest$1 = "⩼";
  const gtrapprox$1 = "⪆";
  const gtrarr$1 = "⥸";
  const gtrdot$1 = "⋗";
  const gtreqless$1 = "⋛";
  const gtreqqless$1 = "⪌";
  const gtrless$1 = "≷";
  const gtrsim$1 = "≳";
  const gvertneqq$1 = "≩︀";
  const gvnE$1 = "≩︀";
  const Hacek$1 = "ˇ";
  const hairsp$1 = " ";
  const half$1 = "½";
  const hamilt$1 = "ℋ";
  const HARDcy$1 = "Ъ";
  const hardcy$1 = "ъ";
  const harrcir$1 = "⥈";
  const harr$1 = "↔";
  const hArr$1 = "⇔";
  const harrw$1 = "↭";
  const Hat$1 = "^";
  const hbar$1 = "ℏ";
  const Hcirc$1 = "Ĥ";
  const hcirc$1 = "ĥ";
  const hearts$1 = "♥";
  const heartsuit$1 = "♥";
  const hellip$1 = "…";
  const hercon$1 = "⊹";
  const hfr$1 = "𝔥";
  const Hfr$1 = "ℌ";
  const HilbertSpace$1 = "ℋ";
  const hksearow$1 = "⤥";
  const hkswarow$1 = "⤦";
  const hoarr$1 = "⇿";
  const homtht$1 = "∻";
  const hookleftarrow$1 = "↩";
  const hookrightarrow$1 = "↪";
  const hopf$1 = "𝕙";
  const Hopf$1 = "ℍ";
  const horbar$1 = "―";
  const HorizontalLine$1 = "─";
  const hscr$1 = "𝒽";
  const Hscr$1 = "ℋ";
  const hslash$1 = "ℏ";
  const Hstrok$1 = "Ħ";
  const hstrok$1 = "ħ";
  const HumpDownHump$1 = "≎";
  const HumpEqual$1 = "≏";
  const hybull$1 = "⁃";
  const hyphen$1 = "‐";
  const Iacute$3 = "Í";
  const iacute$3 = "í";
  const ic$1 = "⁣";
  const Icirc$3 = "Î";
  const icirc$3 = "î";
  const Icy$1 = "И";
  const icy$1 = "и";
  const Idot$1 = "İ";
  const IEcy$1 = "Е";
  const iecy$1 = "е";
  const iexcl$3 = "¡";
  const iff$1 = "⇔";
  const ifr$1 = "𝔦";
  const Ifr$1 = "ℑ";
  const Igrave$3 = "Ì";
  const igrave$3 = "ì";
  const ii$1 = "ⅈ";
  const iiiint$1 = "⨌";
  const iiint$1 = "∭";
  const iinfin$1 = "⧜";
  const iiota$1 = "℩";
  const IJlig$1 = "Ĳ";
  const ijlig$1 = "ĳ";
  const Imacr$1 = "Ī";
  const imacr$1 = "ī";
  const image$1 = "ℑ";
  const ImaginaryI$1 = "ⅈ";
  const imagline$1 = "ℐ";
  const imagpart$1 = "ℑ";
  const imath$1 = "ı";
  const Im$1 = "ℑ";
  const imof$1 = "⊷";
  const imped$1 = "Ƶ";
  const Implies$1 = "⇒";
  const incare$1 = "℅";
  const infin$1 = "∞";
  const infintie$1 = "⧝";
  const inodot$1 = "ı";
  const intcal$1 = "⊺";
  const int$1 = "∫";
  const Int$1 = "∬";
  const integers$1 = "ℤ";
  const Integral$1 = "∫";
  const intercal$1 = "⊺";
  const Intersection$1 = "⋂";
  const intlarhk$1 = "⨗";
  const intprod$1 = "⨼";
  const InvisibleComma$1 = "⁣";
  const InvisibleTimes$1 = "⁢";
  const IOcy$1 = "Ё";
  const iocy$1 = "ё";
  const Iogon$1 = "Į";
  const iogon$1 = "į";
  const Iopf$1 = "𝕀";
  const iopf$1 = "𝕚";
  const Iota$1 = "Ι";
  const iota$1 = "ι";
  const iprod$1 = "⨼";
  const iquest$3 = "¿";
  const iscr$1 = "𝒾";
  const Iscr$1 = "ℐ";
  const isin$1 = "∈";
  const isindot$1 = "⋵";
  const isinE$1 = "⋹";
  const isins$1 = "⋴";
  const isinsv$1 = "⋳";
  const isinv$1 = "∈";
  const it$1 = "⁢";
  const Itilde$1 = "Ĩ";
  const itilde$1 = "ĩ";
  const Iukcy$1 = "І";
  const iukcy$1 = "і";
  const Iuml$3 = "Ï";
  const iuml$3 = "ï";
  const Jcirc$1 = "Ĵ";
  const jcirc$1 = "ĵ";
  const Jcy$1 = "Й";
  const jcy$1 = "й";
  const Jfr$1 = "𝔍";
  const jfr$1 = "𝔧";
  const jmath$1 = "ȷ";
  const Jopf$1 = "𝕁";
  const jopf$1 = "𝕛";
  const Jscr$1 = "𝒥";
  const jscr$1 = "𝒿";
  const Jsercy$1 = "Ј";
  const jsercy$1 = "ј";
  const Jukcy$1 = "Є";
  const jukcy$1 = "є";
  const Kappa$1 = "Κ";
  const kappa$1 = "κ";
  const kappav$1 = "ϰ";
  const Kcedil$1 = "Ķ";
  const kcedil$1 = "ķ";
  const Kcy$1 = "К";
  const kcy$1 = "к";
  const Kfr$1 = "𝔎";
  const kfr$1 = "𝔨";
  const kgreen$1 = "ĸ";
  const KHcy$1 = "Х";
  const khcy$1 = "х";
  const KJcy$1 = "Ќ";
  const kjcy$1 = "ќ";
  const Kopf$1 = "𝕂";
  const kopf$1 = "𝕜";
  const Kscr$1 = "𝒦";
  const kscr$1 = "𝓀";
  const lAarr$1 = "⇚";
  const Lacute$1 = "Ĺ";
  const lacute$1 = "ĺ";
  const laemptyv$1 = "⦴";
  const lagran$1 = "ℒ";
  const Lambda$1 = "Λ";
  const lambda$1 = "λ";
  const lang$1 = "⟨";
  const Lang$1 = "⟪";
  const langd$1 = "⦑";
  const langle$1 = "⟨";
  const lap$1 = "⪅";
  const Laplacetrf$1 = "ℒ";
  const laquo$3 = "«";
  const larrb$1 = "⇤";
  const larrbfs$1 = "⤟";
  const larr$1 = "←";
  const Larr$1 = "↞";
  const lArr$1 = "⇐";
  const larrfs$1 = "⤝";
  const larrhk$1 = "↩";
  const larrlp$1 = "↫";
  const larrpl$1 = "⤹";
  const larrsim$1 = "⥳";
  const larrtl$1 = "↢";
  const latail$1 = "⤙";
  const lAtail$1 = "⤛";
  const lat$1 = "⪫";
  const late$1 = "⪭";
  const lates$1 = "⪭︀";
  const lbarr$1 = "⤌";
  const lBarr$1 = "⤎";
  const lbbrk$1 = "❲";
  const lbrace$1 = "{";
  const lbrack$1 = "[";
  const lbrke$1 = "⦋";
  const lbrksld$1 = "⦏";
  const lbrkslu$1 = "⦍";
  const Lcaron$1 = "Ľ";
  const lcaron$1 = "ľ";
  const Lcedil$1 = "Ļ";
  const lcedil$1 = "ļ";
  const lceil$1 = "⌈";
  const lcub$1 = "{";
  const Lcy$1 = "Л";
  const lcy$1 = "л";
  const ldca$1 = "⤶";
  const ldquo$1 = "“";
  const ldquor$1 = "„";
  const ldrdhar$1 = "⥧";
  const ldrushar$1 = "⥋";
  const ldsh$1 = "↲";
  const le$1 = "≤";
  const lE$1 = "≦";
  const LeftAngleBracket$1 = "⟨";
  const LeftArrowBar$1 = "⇤";
  const leftarrow$1 = "←";
  const LeftArrow$1 = "←";
  const Leftarrow$1 = "⇐";
  const LeftArrowRightArrow$1 = "⇆";
  const leftarrowtail$1 = "↢";
  const LeftCeiling$1 = "⌈";
  const LeftDoubleBracket$1 = "⟦";
  const LeftDownTeeVector$1 = "⥡";
  const LeftDownVectorBar$1 = "⥙";
  const LeftDownVector$1 = "⇃";
  const LeftFloor$1 = "⌊";
  const leftharpoondown$1 = "↽";
  const leftharpoonup$1 = "↼";
  const leftleftarrows$1 = "⇇";
  const leftrightarrow$1 = "↔";
  const LeftRightArrow$1 = "↔";
  const Leftrightarrow$1 = "⇔";
  const leftrightarrows$1 = "⇆";
  const leftrightharpoons$1 = "⇋";
  const leftrightsquigarrow$1 = "↭";
  const LeftRightVector$1 = "⥎";
  const LeftTeeArrow$1 = "↤";
  const LeftTee$1 = "⊣";
  const LeftTeeVector$1 = "⥚";
  const leftthreetimes$1 = "⋋";
  const LeftTriangleBar$1 = "⧏";
  const LeftTriangle$1 = "⊲";
  const LeftTriangleEqual$1 = "⊴";
  const LeftUpDownVector$1 = "⥑";
  const LeftUpTeeVector$1 = "⥠";
  const LeftUpVectorBar$1 = "⥘";
  const LeftUpVector$1 = "↿";
  const LeftVectorBar$1 = "⥒";
  const LeftVector$1 = "↼";
  const lEg$1 = "⪋";
  const leg$1 = "⋚";
  const leq$1 = "≤";
  const leqq$1 = "≦";
  const leqslant$1 = "⩽";
  const lescc$1 = "⪨";
  const les$1 = "⩽";
  const lesdot$1 = "⩿";
  const lesdoto$1 = "⪁";
  const lesdotor$1 = "⪃";
  const lesg$1 = "⋚︀";
  const lesges$1 = "⪓";
  const lessapprox$1 = "⪅";
  const lessdot$1 = "⋖";
  const lesseqgtr$1 = "⋚";
  const lesseqqgtr$1 = "⪋";
  const LessEqualGreater$1 = "⋚";
  const LessFullEqual$1 = "≦";
  const LessGreater$1 = "≶";
  const lessgtr$1 = "≶";
  const LessLess$1 = "⪡";
  const lesssim$1 = "≲";
  const LessSlantEqual$1 = "⩽";
  const LessTilde$1 = "≲";
  const lfisht$1 = "⥼";
  const lfloor$1 = "⌊";
  const Lfr$1 = "𝔏";
  const lfr$1 = "𝔩";
  const lg$1 = "≶";
  const lgE$1 = "⪑";
  const lHar$1 = "⥢";
  const lhard$1 = "↽";
  const lharu$1 = "↼";
  const lharul$1 = "⥪";
  const lhblk$1 = "▄";
  const LJcy$1 = "Љ";
  const ljcy$1 = "љ";
  const llarr$1 = "⇇";
  const ll$1 = "≪";
  const Ll$1 = "⋘";
  const llcorner$1 = "⌞";
  const Lleftarrow$1 = "⇚";
  const llhard$1 = "⥫";
  const lltri$1 = "◺";
  const Lmidot$1 = "Ŀ";
  const lmidot$1 = "ŀ";
  const lmoustache$1 = "⎰";
  const lmoust$1 = "⎰";
  const lnap$1 = "⪉";
  const lnapprox$1 = "⪉";
  const lne$1 = "⪇";
  const lnE$1 = "≨";
  const lneq$1 = "⪇";
  const lneqq$1 = "≨";
  const lnsim$1 = "⋦";
  const loang$1 = "⟬";
  const loarr$1 = "⇽";
  const lobrk$1 = "⟦";
  const longleftarrow$1 = "⟵";
  const LongLeftArrow$1 = "⟵";
  const Longleftarrow$1 = "⟸";
  const longleftrightarrow$1 = "⟷";
  const LongLeftRightArrow$1 = "⟷";
  const Longleftrightarrow$1 = "⟺";
  const longmapsto$1 = "⟼";
  const longrightarrow$1 = "⟶";
  const LongRightArrow$1 = "⟶";
  const Longrightarrow$1 = "⟹";
  const looparrowleft$1 = "↫";
  const looparrowright$1 = "↬";
  const lopar$1 = "⦅";
  const Lopf$1 = "𝕃";
  const lopf$1 = "𝕝";
  const loplus$1 = "⨭";
  const lotimes$1 = "⨴";
  const lowast$1 = "∗";
  const lowbar$1 = "_";
  const LowerLeftArrow$1 = "↙";
  const LowerRightArrow$1 = "↘";
  const loz$1 = "◊";
  const lozenge$1 = "◊";
  const lozf$1 = "⧫";
  const lpar$1 = "(";
  const lparlt$1 = "⦓";
  const lrarr$1 = "⇆";
  const lrcorner$1 = "⌟";
  const lrhar$1 = "⇋";
  const lrhard$1 = "⥭";
  const lrm$1 = "‎";
  const lrtri$1 = "⊿";
  const lsaquo$1 = "‹";
  const lscr$1 = "𝓁";
  const Lscr$1 = "ℒ";
  const lsh$1 = "↰";
  const Lsh$1 = "↰";
  const lsim$1 = "≲";
  const lsime$1 = "⪍";
  const lsimg$1 = "⪏";
  const lsqb$1 = "[";
  const lsquo$1 = "‘";
  const lsquor$1 = "‚";
  const Lstrok$1 = "Ł";
  const lstrok$1 = "ł";
  const ltcc$1 = "⪦";
  const ltcir$1 = "⩹";
  const lt$5 = "<";
  const LT$3 = "<";
  const Lt$1 = "≪";
  const ltdot$1 = "⋖";
  const lthree$1 = "⋋";
  const ltimes$1 = "⋉";
  const ltlarr$1 = "⥶";
  const ltquest$1 = "⩻";
  const ltri$1 = "◃";
  const ltrie$1 = "⊴";
  const ltrif$1 = "◂";
  const ltrPar$1 = "⦖";
  const lurdshar$1 = "⥊";
  const luruhar$1 = "⥦";
  const lvertneqq$1 = "≨︀";
  const lvnE$1 = "≨︀";
  const macr$3 = "¯";
  const male$1 = "♂";
  const malt$1 = "✠";
  const maltese$1 = "✠";
  const map$1 = "↦";
  const mapsto$1 = "↦";
  const mapstodown$1 = "↧";
  const mapstoleft$1 = "↤";
  const mapstoup$1 = "↥";
  const marker$1 = "▮";
  const mcomma$1 = "⨩";
  const Mcy$1 = "М";
  const mcy$1 = "м";
  const mdash$1 = "—";
  const mDDot$1 = "∺";
  const measuredangle$1 = "∡";
  const MediumSpace$1 = " ";
  const Mellintrf$1 = "ℳ";
  const Mfr$1 = "𝔐";
  const mfr$1 = "𝔪";
  const mho$1 = "℧";
  const micro$3 = "µ";
  const midast$1 = "*";
  const midcir$1 = "⫰";
  const mid$1 = "∣";
  const middot$3 = "·";
  const minusb$1 = "⊟";
  const minus$1 = "−";
  const minusd$1 = "∸";
  const minusdu$1 = "⨪";
  const MinusPlus$1 = "∓";
  const mlcp$1 = "⫛";
  const mldr$1 = "…";
  const mnplus$1 = "∓";
  const models$1 = "⊧";
  const Mopf$1 = "𝕄";
  const mopf$1 = "𝕞";
  const mp$1 = "∓";
  const mscr$1 = "𝓂";
  const Mscr$1 = "ℳ";
  const mstpos$1 = "∾";
  const Mu$1 = "Μ";
  const mu$1 = "μ";
  const multimap$1 = "⊸";
  const mumap$1 = "⊸";
  const nabla$1 = "∇";
  const Nacute$1 = "Ń";
  const nacute$1 = "ń";
  const nang$1 = "∠⃒";
  const nap$1 = "≉";
  const napE$1 = "⩰̸";
  const napid$1 = "≋̸";
  const napos$1 = "ŉ";
  const napprox$1 = "≉";
  const natural$1 = "♮";
  const naturals$1 = "ℕ";
  const natur$1 = "♮";
  const nbsp$3 = " ";
  const nbump$1 = "≎̸";
  const nbumpe$1 = "≏̸";
  const ncap$1 = "⩃";
  const Ncaron$1 = "Ň";
  const ncaron$1 = "ň";
  const Ncedil$1 = "Ņ";
  const ncedil$1 = "ņ";
  const ncong$1 = "≇";
  const ncongdot$1 = "⩭̸";
  const ncup$1 = "⩂";
  const Ncy$1 = "Н";
  const ncy$1 = "н";
  const ndash$1 = "–";
  const nearhk$1 = "⤤";
  const nearr$1 = "↗";
  const neArr$1 = "⇗";
  const nearrow$1 = "↗";
  const ne$1 = "≠";
  const nedot$1 = "≐̸";
  const NegativeMediumSpace$1 = "​";
  const NegativeThickSpace$1 = "​";
  const NegativeThinSpace$1 = "​";
  const NegativeVeryThinSpace$1 = "​";
  const nequiv$1 = "≢";
  const nesear$1 = "⤨";
  const nesim$1 = "≂̸";
  const NestedGreaterGreater$1 = "≫";
  const NestedLessLess$1 = "≪";
  const NewLine$1 = "\n";
  const nexist$1 = "∄";
  const nexists$1 = "∄";
  const Nfr$1 = "𝔑";
  const nfr$1 = "𝔫";
  const ngE$1 = "≧̸";
  const nge$1 = "≱";
  const ngeq$1 = "≱";
  const ngeqq$1 = "≧̸";
  const ngeqslant$1 = "⩾̸";
  const nges$1 = "⩾̸";
  const nGg$1 = "⋙̸";
  const ngsim$1 = "≵";
  const nGt$1 = "≫⃒";
  const ngt$1 = "≯";
  const ngtr$1 = "≯";
  const nGtv$1 = "≫̸";
  const nharr$1 = "↮";
  const nhArr$1 = "⇎";
  const nhpar$1 = "⫲";
  const ni$1 = "∋";
  const nis$1 = "⋼";
  const nisd$1 = "⋺";
  const niv$1 = "∋";
  const NJcy$1 = "Њ";
  const njcy$1 = "њ";
  const nlarr$1 = "↚";
  const nlArr$1 = "⇍";
  const nldr$1 = "‥";
  const nlE$1 = "≦̸";
  const nle$1 = "≰";
  const nleftarrow$1 = "↚";
  const nLeftarrow$1 = "⇍";
  const nleftrightarrow$1 = "↮";
  const nLeftrightarrow$1 = "⇎";
  const nleq$1 = "≰";
  const nleqq$1 = "≦̸";
  const nleqslant$1 = "⩽̸";
  const nles$1 = "⩽̸";
  const nless$1 = "≮";
  const nLl$1 = "⋘̸";
  const nlsim$1 = "≴";
  const nLt$1 = "≪⃒";
  const nlt$1 = "≮";
  const nltri$1 = "⋪";
  const nltrie$1 = "⋬";
  const nLtv$1 = "≪̸";
  const nmid$1 = "∤";
  const NoBreak$1 = "⁠";
  const NonBreakingSpace$1 = " ";
  const nopf$1 = "𝕟";
  const Nopf$1 = "ℕ";
  const Not$1 = "⫬";
  const not$3 = "¬";
  const NotCongruent$1 = "≢";
  const NotCupCap$1 = "≭";
  const NotDoubleVerticalBar$1 = "∦";
  const NotElement$1 = "∉";
  const NotEqual$1 = "≠";
  const NotEqualTilde$1 = "≂̸";
  const NotExists$1 = "∄";
  const NotGreater$1 = "≯";
  const NotGreaterEqual$1 = "≱";
  const NotGreaterFullEqual$1 = "≧̸";
  const NotGreaterGreater$1 = "≫̸";
  const NotGreaterLess$1 = "≹";
  const NotGreaterSlantEqual$1 = "⩾̸";
  const NotGreaterTilde$1 = "≵";
  const NotHumpDownHump$1 = "≎̸";
  const NotHumpEqual$1 = "≏̸";
  const notin$1 = "∉";
  const notindot$1 = "⋵̸";
  const notinE$1 = "⋹̸";
  const notinva$1 = "∉";
  const notinvb$1 = "⋷";
  const notinvc$1 = "⋶";
  const NotLeftTriangleBar$1 = "⧏̸";
  const NotLeftTriangle$1 = "⋪";
  const NotLeftTriangleEqual$1 = "⋬";
  const NotLess$1 = "≮";
  const NotLessEqual$1 = "≰";
  const NotLessGreater$1 = "≸";
  const NotLessLess$1 = "≪̸";
  const NotLessSlantEqual$1 = "⩽̸";
  const NotLessTilde$1 = "≴";
  const NotNestedGreaterGreater$1 = "⪢̸";
  const NotNestedLessLess$1 = "⪡̸";
  const notni$1 = "∌";
  const notniva$1 = "∌";
  const notnivb$1 = "⋾";
  const notnivc$1 = "⋽";
  const NotPrecedes$1 = "⊀";
  const NotPrecedesEqual$1 = "⪯̸";
  const NotPrecedesSlantEqual$1 = "⋠";
  const NotReverseElement$1 = "∌";
  const NotRightTriangleBar$1 = "⧐̸";
  const NotRightTriangle$1 = "⋫";
  const NotRightTriangleEqual$1 = "⋭";
  const NotSquareSubset$1 = "⊏̸";
  const NotSquareSubsetEqual$1 = "⋢";
  const NotSquareSuperset$1 = "⊐̸";
  const NotSquareSupersetEqual$1 = "⋣";
  const NotSubset$1 = "⊂⃒";
  const NotSubsetEqual$1 = "⊈";
  const NotSucceeds$1 = "⊁";
  const NotSucceedsEqual$1 = "⪰̸";
  const NotSucceedsSlantEqual$1 = "⋡";
  const NotSucceedsTilde$1 = "≿̸";
  const NotSuperset$1 = "⊃⃒";
  const NotSupersetEqual$1 = "⊉";
  const NotTilde$1 = "≁";
  const NotTildeEqual$1 = "≄";
  const NotTildeFullEqual$1 = "≇";
  const NotTildeTilde$1 = "≉";
  const NotVerticalBar$1 = "∤";
  const nparallel$1 = "∦";
  const npar$1 = "∦";
  const nparsl$1 = "⫽⃥";
  const npart$1 = "∂̸";
  const npolint$1 = "⨔";
  const npr$1 = "⊀";
  const nprcue$1 = "⋠";
  const nprec$1 = "⊀";
  const npreceq$1 = "⪯̸";
  const npre$1 = "⪯̸";
  const nrarrc$1 = "⤳̸";
  const nrarr$1 = "↛";
  const nrArr$1 = "⇏";
  const nrarrw$1 = "↝̸";
  const nrightarrow$1 = "↛";
  const nRightarrow$1 = "⇏";
  const nrtri$1 = "⋫";
  const nrtrie$1 = "⋭";
  const nsc$1 = "⊁";
  const nsccue$1 = "⋡";
  const nsce$1 = "⪰̸";
  const Nscr$1 = "𝒩";
  const nscr$1 = "𝓃";
  const nshortmid$1 = "∤";
  const nshortparallel$1 = "∦";
  const nsim$1 = "≁";
  const nsime$1 = "≄";
  const nsimeq$1 = "≄";
  const nsmid$1 = "∤";
  const nspar$1 = "∦";
  const nsqsube$1 = "⋢";
  const nsqsupe$1 = "⋣";
  const nsub$1 = "⊄";
  const nsubE$1 = "⫅̸";
  const nsube$1 = "⊈";
  const nsubset$1 = "⊂⃒";
  const nsubseteq$1 = "⊈";
  const nsubseteqq$1 = "⫅̸";
  const nsucc$1 = "⊁";
  const nsucceq$1 = "⪰̸";
  const nsup$1 = "⊅";
  const nsupE$1 = "⫆̸";
  const nsupe$1 = "⊉";
  const nsupset$1 = "⊃⃒";
  const nsupseteq$1 = "⊉";
  const nsupseteqq$1 = "⫆̸";
  const ntgl$1 = "≹";
  const Ntilde$3 = "Ñ";
  const ntilde$3 = "ñ";
  const ntlg$1 = "≸";
  const ntriangleleft$1 = "⋪";
  const ntrianglelefteq$1 = "⋬";
  const ntriangleright$1 = "⋫";
  const ntrianglerighteq$1 = "⋭";
  const Nu$1 = "Ν";
  const nu$1 = "ν";
  const num$1 = "#";
  const numero$1 = "№";
  const numsp$1 = " ";
  const nvap$1 = "≍⃒";
  const nvdash$1 = "⊬";
  const nvDash$1 = "⊭";
  const nVdash$1 = "⊮";
  const nVDash$1 = "⊯";
  const nvge$1 = "≥⃒";
  const nvgt$1 = ">⃒";
  const nvHarr$1 = "⤄";
  const nvinfin$1 = "⧞";
  const nvlArr$1 = "⤂";
  const nvle$1 = "≤⃒";
  const nvlt$1 = "<⃒";
  const nvltrie$1 = "⊴⃒";
  const nvrArr$1 = "⤃";
  const nvrtrie$1 = "⊵⃒";
  const nvsim$1 = "∼⃒";
  const nwarhk$1 = "⤣";
  const nwarr$1 = "↖";
  const nwArr$1 = "⇖";
  const nwarrow$1 = "↖";
  const nwnear$1 = "⤧";
  const Oacute$3 = "Ó";
  const oacute$3 = "ó";
  const oast$1 = "⊛";
  const Ocirc$3 = "Ô";
  const ocirc$3 = "ô";
  const ocir$1 = "⊚";
  const Ocy$1 = "О";
  const ocy$1 = "о";
  const odash$1 = "⊝";
  const Odblac$1 = "Ő";
  const odblac$1 = "ő";
  const odiv$1 = "⨸";
  const odot$1 = "⊙";
  const odsold$1 = "⦼";
  const OElig$1 = "Œ";
  const oelig$1 = "œ";
  const ofcir$1 = "⦿";
  const Ofr$1 = "𝔒";
  const ofr$1 = "𝔬";
  const ogon$1 = "˛";
  const Ograve$3 = "Ò";
  const ograve$3 = "ò";
  const ogt$1 = "⧁";
  const ohbar$1 = "⦵";
  const ohm$1 = "Ω";
  const oint$1 = "∮";
  const olarr$1 = "↺";
  const olcir$1 = "⦾";
  const olcross$1 = "⦻";
  const oline$1 = "‾";
  const olt$1 = "⧀";
  const Omacr$1 = "Ō";
  const omacr$1 = "ō";
  const Omega$1 = "Ω";
  const omega$1 = "ω";
  const Omicron$1 = "Ο";
  const omicron$1 = "ο";
  const omid$1 = "⦶";
  const ominus$1 = "⊖";
  const Oopf$1 = "𝕆";
  const oopf$1 = "𝕠";
  const opar$1 = "⦷";
  const OpenCurlyDoubleQuote$1 = "“";
  const OpenCurlyQuote$1 = "‘";
  const operp$1 = "⦹";
  const oplus$1 = "⊕";
  const orarr$1 = "↻";
  const Or$1 = "⩔";
  const or$1 = "∨";
  const ord$1 = "⩝";
  const order$1 = "ℴ";
  const orderof$1 = "ℴ";
  const ordf$3 = "ª";
  const ordm$3 = "º";
  const origof$1 = "⊶";
  const oror$1 = "⩖";
  const orslope$1 = "⩗";
  const orv$1 = "⩛";
  const oS$1 = "Ⓢ";
  const Oscr$1 = "𝒪";
  const oscr$1 = "ℴ";
  const Oslash$3 = "Ø";
  const oslash$3 = "ø";
  const osol$1 = "⊘";
  const Otilde$3 = "Õ";
  const otilde$3 = "õ";
  const otimesas$1 = "⨶";
  const Otimes$1 = "⨷";
  const otimes$1 = "⊗";
  const Ouml$3 = "Ö";
  const ouml$3 = "ö";
  const ovbar$1 = "⌽";
  const OverBar$1 = "‾";
  const OverBrace$1 = "⏞";
  const OverBracket$1 = "⎴";
  const OverParenthesis$1 = "⏜";
  const para$3 = "¶";
  const parallel$1 = "∥";
  const par$1 = "∥";
  const parsim$1 = "⫳";
  const parsl$1 = "⫽";
  const part$1 = "∂";
  const PartialD$1 = "∂";
  const Pcy$1 = "П";
  const pcy$1 = "п";
  const percnt$1 = "%";
  const period$1 = ".";
  const permil$1 = "‰";
  const perp$1 = "⊥";
  const pertenk$1 = "‱";
  const Pfr$1 = "𝔓";
  const pfr$1 = "𝔭";
  const Phi$1 = "Φ";
  const phi$1 = "φ";
  const phiv$1 = "ϕ";
  const phmmat$1 = "ℳ";
  const phone$1 = "☎";
  const Pi$1 = "Π";
  const pi$1 = "π";
  const pitchfork$1 = "⋔";
  const piv$1 = "ϖ";
  const planck$1 = "ℏ";
  const planckh$1 = "ℎ";
  const plankv$1 = "ℏ";
  const plusacir$1 = "⨣";
  const plusb$1 = "⊞";
  const pluscir$1 = "⨢";
  const plus$1 = "+";
  const plusdo$1 = "∔";
  const plusdu$1 = "⨥";
  const pluse$1 = "⩲";
  const PlusMinus$1 = "±";
  const plusmn$3 = "±";
  const plussim$1 = "⨦";
  const plustwo$1 = "⨧";
  const pm$1 = "±";
  const Poincareplane$1 = "ℌ";
  const pointint$1 = "⨕";
  const popf$1 = "𝕡";
  const Popf$1 = "ℙ";
  const pound$3 = "£";
  const prap$1 = "⪷";
  const Pr$1 = "⪻";
  const pr$1 = "≺";
  const prcue$1 = "≼";
  const precapprox$1 = "⪷";
  const prec$1 = "≺";
  const preccurlyeq$1 = "≼";
  const Precedes$1 = "≺";
  const PrecedesEqual$1 = "⪯";
  const PrecedesSlantEqual$1 = "≼";
  const PrecedesTilde$1 = "≾";
  const preceq$1 = "⪯";
  const precnapprox$1 = "⪹";
  const precneqq$1 = "⪵";
  const precnsim$1 = "⋨";
  const pre$1 = "⪯";
  const prE$1 = "⪳";
  const precsim$1 = "≾";
  const prime$1 = "′";
  const Prime$1 = "″";
  const primes$1 = "ℙ";
  const prnap$1 = "⪹";
  const prnE$1 = "⪵";
  const prnsim$1 = "⋨";
  const prod$1 = "∏";
  const Product$2 = "∏";
  const profalar$1 = "⌮";
  const profline$1 = "⌒";
  const profsurf$1 = "⌓";
  const prop$1 = "∝";
  const Proportional$1 = "∝";
  const Proportion$1 = "∷";
  const propto$1 = "∝";
  const prsim$1 = "≾";
  const prurel$1 = "⊰";
  const Pscr$1 = "𝒫";
  const pscr$1 = "𝓅";
  const Psi$1 = "Ψ";
  const psi$1 = "ψ";
  const puncsp$1 = " ";
  const Qfr$1 = "𝔔";
  const qfr$1 = "𝔮";
  const qint$1 = "⨌";
  const qopf$1 = "𝕢";
  const Qopf$1 = "ℚ";
  const qprime$1 = "⁗";
  const Qscr$1 = "𝒬";
  const qscr$1 = "𝓆";
  const quaternions$1 = "ℍ";
  const quatint$1 = "⨖";
  const quest$1 = "?";
  const questeq$1 = "≟";
  const quot$5 = '"';
  const QUOT$3 = '"';
  const rAarr$1 = "⇛";
  const race$1 = "∽̱";
  const Racute$1 = "Ŕ";
  const racute$1 = "ŕ";
  const radic$1 = "√";
  const raemptyv$1 = "⦳";
  const rang$1 = "⟩";
  const Rang$1 = "⟫";
  const rangd$1 = "⦒";
  const range$1 = "⦥";
  const rangle$1 = "⟩";
  const raquo$3 = "»";
  const rarrap$1 = "⥵";
  const rarrb$1 = "⇥";
  const rarrbfs$1 = "⤠";
  const rarrc$1 = "⤳";
  const rarr$1 = "→";
  const Rarr$1 = "↠";
  const rArr$1 = "⇒";
  const rarrfs$1 = "⤞";
  const rarrhk$1 = "↪";
  const rarrlp$1 = "↬";
  const rarrpl$1 = "⥅";
  const rarrsim$1 = "⥴";
  const Rarrtl$1 = "⤖";
  const rarrtl$1 = "↣";
  const rarrw$1 = "↝";
  const ratail$1 = "⤚";
  const rAtail$1 = "⤜";
  const ratio$1 = "∶";
  const rationals$1 = "ℚ";
  const rbarr$1 = "⤍";
  const rBarr$1 = "⤏";
  const RBarr$1 = "⤐";
  const rbbrk$1 = "❳";
  const rbrace$1 = "}";
  const rbrack$1 = "]";
  const rbrke$1 = "⦌";
  const rbrksld$1 = "⦎";
  const rbrkslu$1 = "⦐";
  const Rcaron$1 = "Ř";
  const rcaron$1 = "ř";
  const Rcedil$1 = "Ŗ";
  const rcedil$1 = "ŗ";
  const rceil$1 = "⌉";
  const rcub$1 = "}";
  const Rcy$1 = "Р";
  const rcy$1 = "р";
  const rdca$1 = "⤷";
  const rdldhar$1 = "⥩";
  const rdquo$1 = "”";
  const rdquor$1 = "”";
  const rdsh$1 = "↳";
  const real$1 = "ℜ";
  const realine$1 = "ℛ";
  const realpart$1 = "ℜ";
  const reals$1 = "ℝ";
  const Re$1 = "ℜ";
  const rect$1 = "▭";
  const reg$3 = "®";
  const REG$3 = "®";
  const ReverseElement$1 = "∋";
  const ReverseEquilibrium$1 = "⇋";
  const ReverseUpEquilibrium$1 = "⥯";
  const rfisht$1 = "⥽";
  const rfloor$1 = "⌋";
  const rfr$1 = "𝔯";
  const Rfr$1 = "ℜ";
  const rHar$1 = "⥤";
  const rhard$1 = "⇁";
  const rharu$1 = "⇀";
  const rharul$1 = "⥬";
  const Rho$1 = "Ρ";
  const rho$1 = "ρ";
  const rhov$1 = "ϱ";
  const RightAngleBracket$1 = "⟩";
  const RightArrowBar$1 = "⇥";
  const rightarrow$1 = "→";
  const RightArrow$1 = "→";
  const Rightarrow$1 = "⇒";
  const RightArrowLeftArrow$1 = "⇄";
  const rightarrowtail$1 = "↣";
  const RightCeiling$1 = "⌉";
  const RightDoubleBracket$1 = "⟧";
  const RightDownTeeVector$1 = "⥝";
  const RightDownVectorBar$1 = "⥕";
  const RightDownVector$1 = "⇂";
  const RightFloor$1 = "⌋";
  const rightharpoondown$1 = "⇁";
  const rightharpoonup$1 = "⇀";
  const rightleftarrows$1 = "⇄";
  const rightleftharpoons$1 = "⇌";
  const rightrightarrows$1 = "⇉";
  const rightsquigarrow$1 = "↝";
  const RightTeeArrow$1 = "↦";
  const RightTee$1 = "⊢";
  const RightTeeVector$1 = "⥛";
  const rightthreetimes$1 = "⋌";
  const RightTriangleBar$1 = "⧐";
  const RightTriangle$1 = "⊳";
  const RightTriangleEqual$1 = "⊵";
  const RightUpDownVector$1 = "⥏";
  const RightUpTeeVector$1 = "⥜";
  const RightUpVectorBar$1 = "⥔";
  const RightUpVector$1 = "↾";
  const RightVectorBar$1 = "⥓";
  const RightVector$1 = "⇀";
  const ring$1 = "˚";
  const risingdotseq$1 = "≓";
  const rlarr$1 = "⇄";
  const rlhar$1 = "⇌";
  const rlm$1 = "‏";
  const rmoustache$1 = "⎱";
  const rmoust$1 = "⎱";
  const rnmid$1 = "⫮";
  const roang$1 = "⟭";
  const roarr$1 = "⇾";
  const robrk$1 = "⟧";
  const ropar$1 = "⦆";
  const ropf$1 = "𝕣";
  const Ropf$1 = "ℝ";
  const roplus$1 = "⨮";
  const rotimes$1 = "⨵";
  const RoundImplies$1 = "⥰";
  const rpar$1 = ")";
  const rpargt$1 = "⦔";
  const rppolint$1 = "⨒";
  const rrarr$1 = "⇉";
  const Rrightarrow$1 = "⇛";
  const rsaquo$1 = "›";
  const rscr$1 = "𝓇";
  const Rscr$1 = "ℛ";
  const rsh$1 = "↱";
  const Rsh$1 = "↱";
  const rsqb$1 = "]";
  const rsquo$1 = "’";
  const rsquor$1 = "’";
  const rthree$1 = "⋌";
  const rtimes$1 = "⋊";
  const rtri$1 = "▹";
  const rtrie$1 = "⊵";
  const rtrif$1 = "▸";
  const rtriltri$1 = "⧎";
  const RuleDelayed$1 = "⧴";
  const ruluhar$1 = "⥨";
  const rx$1 = "℞";
  const Sacute$1 = "Ś";
  const sacute$1 = "ś";
  const sbquo$1 = "‚";
  const scap$1 = "⪸";
  const Scaron$1 = "Š";
  const scaron$1 = "š";
  const Sc$1 = "⪼";
  const sc$1 = "≻";
  const sccue$1 = "≽";
  const sce$1 = "⪰";
  const scE$1 = "⪴";
  const Scedil$1 = "Ş";
  const scedil$1 = "ş";
  const Scirc$1 = "Ŝ";
  const scirc$1 = "ŝ";
  const scnap$1 = "⪺";
  const scnE$1 = "⪶";
  const scnsim$1 = "⋩";
  const scpolint$1 = "⨓";
  const scsim$1 = "≿";
  const Scy$1 = "С";
  const scy$1 = "с";
  const sdotb$1 = "⊡";
  const sdot$1 = "⋅";
  const sdote$1 = "⩦";
  const searhk$1 = "⤥";
  const searr$1 = "↘";
  const seArr$1 = "⇘";
  const searrow$1 = "↘";
  const sect$3 = "§";
  const semi$1 = ";";
  const seswar$1 = "⤩";
  const setminus$1 = "∖";
  const setmn$1 = "∖";
  const sext$1 = "✶";
  const Sfr$1 = "𝔖";
  const sfr$1 = "𝔰";
  const sfrown$1 = "⌢";
  const sharp$1 = "♯";
  const SHCHcy$1 = "Щ";
  const shchcy$1 = "щ";
  const SHcy$1 = "Ш";
  const shcy$1 = "ш";
  const ShortDownArrow$1 = "↓";
  const ShortLeftArrow$1 = "←";
  const shortmid$1 = "∣";
  const shortparallel$1 = "∥";
  const ShortRightArrow$1 = "→";
  const ShortUpArrow$1 = "↑";
  const shy$3 = "­";
  const Sigma$1 = "Σ";
  const sigma$1 = "σ";
  const sigmaf$1 = "ς";
  const sigmav$1 = "ς";
  const sim$1 = "∼";
  const simdot$1 = "⩪";
  const sime$1 = "≃";
  const simeq$1 = "≃";
  const simg$1 = "⪞";
  const simgE$1 = "⪠";
  const siml$1 = "⪝";
  const simlE$1 = "⪟";
  const simne$1 = "≆";
  const simplus$1 = "⨤";
  const simrarr$1 = "⥲";
  const slarr$1 = "←";
  const SmallCircle$1 = "∘";
  const smallsetminus$1 = "∖";
  const smashp$1 = "⨳";
  const smeparsl$1 = "⧤";
  const smid$1 = "∣";
  const smile$1 = "⌣";
  const smt$1 = "⪪";
  const smte$1 = "⪬";
  const smtes$1 = "⪬︀";
  const SOFTcy$1 = "Ь";
  const softcy$1 = "ь";
  const solbar$1 = "⌿";
  const solb$1 = "⧄";
  const sol$1 = "/";
  const Sopf$1 = "𝕊";
  const sopf$1 = "𝕤";
  const spades$1 = "♠";
  const spadesuit$1 = "♠";
  const spar$1 = "∥";
  const sqcap$1 = "⊓";
  const sqcaps$1 = "⊓︀";
  const sqcup$1 = "⊔";
  const sqcups$1 = "⊔︀";
  const Sqrt$1 = "√";
  const sqsub$1 = "⊏";
  const sqsube$1 = "⊑";
  const sqsubset$1 = "⊏";
  const sqsubseteq$1 = "⊑";
  const sqsup$1 = "⊐";
  const sqsupe$1 = "⊒";
  const sqsupset$1 = "⊐";
  const sqsupseteq$1 = "⊒";
  const square$1 = "□";
  const Square$1 = "□";
  const SquareIntersection$1 = "⊓";
  const SquareSubset$1 = "⊏";
  const SquareSubsetEqual$1 = "⊑";
  const SquareSuperset$1 = "⊐";
  const SquareSupersetEqual$1 = "⊒";
  const SquareUnion$1 = "⊔";
  const squarf$1 = "▪";
  const squ$1 = "□";
  const squf$1 = "▪";
  const srarr$1 = "→";
  const Sscr$1 = "𝒮";
  const sscr$1 = "𝓈";
  const ssetmn$1 = "∖";
  const ssmile$1 = "⌣";
  const sstarf$1 = "⋆";
  const Star$1 = "⋆";
  const star$1 = "☆";
  const starf$1 = "★";
  const straightepsilon$1 = "ϵ";
  const straightphi$1 = "ϕ";
  const strns$1 = "¯";
  const sub$1 = "⊂";
  const Sub$1 = "⋐";
  const subdot$1 = "⪽";
  const subE$1 = "⫅";
  const sube$1 = "⊆";
  const subedot$1 = "⫃";
  const submult$1 = "⫁";
  const subnE$1 = "⫋";
  const subne$1 = "⊊";
  const subplus$1 = "⪿";
  const subrarr$1 = "⥹";
  const subset$1 = "⊂";
  const Subset$1 = "⋐";
  const subseteq$1 = "⊆";
  const subseteqq$1 = "⫅";
  const SubsetEqual$1 = "⊆";
  const subsetneq$1 = "⊊";
  const subsetneqq$1 = "⫋";
  const subsim$1 = "⫇";
  const subsub$1 = "⫕";
  const subsup$1 = "⫓";
  const succapprox$1 = "⪸";
  const succ$1 = "≻";
  const succcurlyeq$1 = "≽";
  const Succeeds$1 = "≻";
  const SucceedsEqual$1 = "⪰";
  const SucceedsSlantEqual$1 = "≽";
  const SucceedsTilde$1 = "≿";
  const succeq$1 = "⪰";
  const succnapprox$1 = "⪺";
  const succneqq$1 = "⪶";
  const succnsim$1 = "⋩";
  const succsim$1 = "≿";
  const SuchThat$1 = "∋";
  const sum$1 = "∑";
  const Sum$1 = "∑";
  const sung$1 = "♪";
  const sup1$3 = "¹";
  const sup2$3 = "²";
  const sup3$3 = "³";
  const sup$1 = "⊃";
  const Sup$1 = "⋑";
  const supdot$1 = "⪾";
  const supdsub$1 = "⫘";
  const supE$1 = "⫆";
  const supe$1 = "⊇";
  const supedot$1 = "⫄";
  const Superset$1 = "⊃";
  const SupersetEqual$1 = "⊇";
  const suphsol$1 = "⟉";
  const suphsub$1 = "⫗";
  const suplarr$1 = "⥻";
  const supmult$1 = "⫂";
  const supnE$1 = "⫌";
  const supne$1 = "⊋";
  const supplus$1 = "⫀";
  const supset$1 = "⊃";
  const Supset$1 = "⋑";
  const supseteq$1 = "⊇";
  const supseteqq$1 = "⫆";
  const supsetneq$1 = "⊋";
  const supsetneqq$1 = "⫌";
  const supsim$1 = "⫈";
  const supsub$1 = "⫔";
  const supsup$1 = "⫖";
  const swarhk$1 = "⤦";
  const swarr$1 = "↙";
  const swArr$1 = "⇙";
  const swarrow$1 = "↙";
  const swnwar$1 = "⤪";
  const szlig$3 = "ß";
  const Tab$1 = "	";
  const target$1 = "⌖";
  const Tau$1 = "Τ";
  const tau$1 = "τ";
  const tbrk$1 = "⎴";
  const Tcaron$1 = "Ť";
  const tcaron$1 = "ť";
  const Tcedil$1 = "Ţ";
  const tcedil$1 = "ţ";
  const Tcy$1 = "Т";
  const tcy$1 = "т";
  const tdot$1 = "⃛";
  const telrec$1 = "⌕";
  const Tfr$1 = "𝔗";
  const tfr$1 = "𝔱";
  const there4$1 = "∴";
  const therefore$1 = "∴";
  const Therefore$1 = "∴";
  const Theta$1 = "Θ";
  const theta$1 = "θ";
  const thetasym$1 = "ϑ";
  const thetav$1 = "ϑ";
  const thickapprox$1 = "≈";
  const thicksim$1 = "∼";
  const ThickSpace$1 = "  ";
  const ThinSpace$1 = " ";
  const thinsp$1 = " ";
  const thkap$1 = "≈";
  const thksim$1 = "∼";
  const THORN$3 = "Þ";
  const thorn$3 = "þ";
  const tilde$1 = "˜";
  const Tilde$1 = "∼";
  const TildeEqual$1 = "≃";
  const TildeFullEqual$1 = "≅";
  const TildeTilde$1 = "≈";
  const timesbar$1 = "⨱";
  const timesb$1 = "⊠";
  const times$3 = "×";
  const timesd$1 = "⨰";
  const tint$1 = "∭";
  const toea$1 = "⤨";
  const topbot$1 = "⌶";
  const topcir$1 = "⫱";
  const top$1 = "⊤";
  const Topf$1 = "𝕋";
  const topf$1 = "𝕥";
  const topfork$1 = "⫚";
  const tosa$1 = "⤩";
  const tprime$1 = "‴";
  const trade$1 = "™";
  const TRADE$1 = "™";
  const triangle$1 = "▵";
  const triangledown$1 = "▿";
  const triangleleft$1 = "◃";
  const trianglelefteq$1 = "⊴";
  const triangleq$1 = "≜";
  const triangleright$1 = "▹";
  const trianglerighteq$1 = "⊵";
  const tridot$1 = "◬";
  const trie$1 = "≜";
  const triminus$1 = "⨺";
  const TripleDot$1 = "⃛";
  const triplus$1 = "⨹";
  const trisb$1 = "⧍";
  const tritime$1 = "⨻";
  const trpezium$1 = "⏢";
  const Tscr$1 = "𝒯";
  const tscr$1 = "𝓉";
  const TScy$1 = "Ц";
  const tscy$1 = "ц";
  const TSHcy$1 = "Ћ";
  const tshcy$1 = "ћ";
  const Tstrok$1 = "Ŧ";
  const tstrok$1 = "ŧ";
  const twixt$1 = "≬";
  const twoheadleftarrow$1 = "↞";
  const twoheadrightarrow$1 = "↠";
  const Uacute$3 = "Ú";
  const uacute$3 = "ú";
  const uarr$1 = "↑";
  const Uarr$1 = "↟";
  const uArr$1 = "⇑";
  const Uarrocir$1 = "⥉";
  const Ubrcy$1 = "Ў";
  const ubrcy$1 = "ў";
  const Ubreve$1 = "Ŭ";
  const ubreve$1 = "ŭ";
  const Ucirc$3 = "Û";
  const ucirc$3 = "û";
  const Ucy$1 = "У";
  const ucy$1 = "у";
  const udarr$1 = "⇅";
  const Udblac$1 = "Ű";
  const udblac$1 = "ű";
  const udhar$1 = "⥮";
  const ufisht$1 = "⥾";
  const Ufr$1 = "𝔘";
  const ufr$1 = "𝔲";
  const Ugrave$3 = "Ù";
  const ugrave$3 = "ù";
  const uHar$1 = "⥣";
  const uharl$1 = "↿";
  const uharr$1 = "↾";
  const uhblk$1 = "▀";
  const ulcorn$1 = "⌜";
  const ulcorner$1 = "⌜";
  const ulcrop$1 = "⌏";
  const ultri$1 = "◸";
  const Umacr$1 = "Ū";
  const umacr$1 = "ū";
  const uml$3 = "¨";
  const UnderBar$1 = "_";
  const UnderBrace$1 = "⏟";
  const UnderBracket$1 = "⎵";
  const UnderParenthesis$1 = "⏝";
  const Union$1 = "⋃";
  const UnionPlus$1 = "⊎";
  const Uogon$1 = "Ų";
  const uogon$1 = "ų";
  const Uopf$1 = "𝕌";
  const uopf$1 = "𝕦";
  const UpArrowBar$1 = "⤒";
  const uparrow$1 = "↑";
  const UpArrow$1 = "↑";
  const Uparrow$1 = "⇑";
  const UpArrowDownArrow$1 = "⇅";
  const updownarrow$1 = "↕";
  const UpDownArrow$1 = "↕";
  const Updownarrow$1 = "⇕";
  const UpEquilibrium$1 = "⥮";
  const upharpoonleft$1 = "↿";
  const upharpoonright$1 = "↾";
  const uplus$1 = "⊎";
  const UpperLeftArrow$1 = "↖";
  const UpperRightArrow$1 = "↗";
  const upsi$1 = "υ";
  const Upsi$1 = "ϒ";
  const upsih$1 = "ϒ";
  const Upsilon$1 = "Υ";
  const upsilon$1 = "υ";
  const UpTeeArrow$1 = "↥";
  const UpTee$1 = "⊥";
  const upuparrows$1 = "⇈";
  const urcorn$1 = "⌝";
  const urcorner$1 = "⌝";
  const urcrop$1 = "⌎";
  const Uring$1 = "Ů";
  const uring$1 = "ů";
  const urtri$1 = "◹";
  const Uscr$1 = "𝒰";
  const uscr$1 = "𝓊";
  const utdot$1 = "⋰";
  const Utilde$1 = "Ũ";
  const utilde$1 = "ũ";
  const utri$1 = "▵";
  const utrif$1 = "▴";
  const uuarr$1 = "⇈";
  const Uuml$3 = "Ü";
  const uuml$3 = "ü";
  const uwangle$1 = "⦧";
  const vangrt$1 = "⦜";
  const varepsilon$1 = "ϵ";
  const varkappa$1 = "ϰ";
  const varnothing$1 = "∅";
  const varphi$1 = "ϕ";
  const varpi$1 = "ϖ";
  const varpropto$1 = "∝";
  const varr$1 = "↕";
  const vArr$1 = "⇕";
  const varrho$1 = "ϱ";
  const varsigma$1 = "ς";
  const varsubsetneq$1 = "⊊︀";
  const varsubsetneqq$1 = "⫋︀";
  const varsupsetneq$1 = "⊋︀";
  const varsupsetneqq$1 = "⫌︀";
  const vartheta$1 = "ϑ";
  const vartriangleleft$1 = "⊲";
  const vartriangleright$1 = "⊳";
  const vBar$1 = "⫨";
  const Vbar$1 = "⫫";
  const vBarv$1 = "⫩";
  const Vcy$1 = "В";
  const vcy$1 = "в";
  const vdash$1 = "⊢";
  const vDash$1 = "⊨";
  const Vdash$1 = "⊩";
  const VDash$1 = "⊫";
  const Vdashl$1 = "⫦";
  const veebar$1 = "⊻";
  const vee$1 = "∨";
  const Vee$1 = "⋁";
  const veeeq$1 = "≚";
  const vellip$1 = "⋮";
  const verbar$1 = "|";
  const Verbar$1 = "‖";
  const vert$1 = "|";
  const Vert$1 = "‖";
  const VerticalBar$1 = "∣";
  const VerticalLine$1 = "|";
  const VerticalSeparator$1 = "❘";
  const VerticalTilde$1 = "≀";
  const VeryThinSpace$1 = " ";
  const Vfr$1 = "𝔙";
  const vfr$1 = "𝔳";
  const vltri$1 = "⊲";
  const vnsub$1 = "⊂⃒";
  const vnsup$1 = "⊃⃒";
  const Vopf$1 = "𝕍";
  const vopf$1 = "𝕧";
  const vprop$1 = "∝";
  const vrtri$1 = "⊳";
  const Vscr$1 = "𝒱";
  const vscr$1 = "𝓋";
  const vsubnE$1 = "⫋︀";
  const vsubne$1 = "⊊︀";
  const vsupnE$1 = "⫌︀";
  const vsupne$1 = "⊋︀";
  const Vvdash$1 = "⊪";
  const vzigzag$1 = "⦚";
  const Wcirc$1 = "Ŵ";
  const wcirc$1 = "ŵ";
  const wedbar$1 = "⩟";
  const wedge$1 = "∧";
  const Wedge$1 = "⋀";
  const wedgeq$1 = "≙";
  const weierp$1 = "℘";
  const Wfr$1 = "𝔚";
  const wfr$1 = "𝔴";
  const Wopf$1 = "𝕎";
  const wopf$1 = "𝕨";
  const wp$1 = "℘";
  const wr$1 = "≀";
  const wreath$1 = "≀";
  const Wscr$1 = "𝒲";
  const wscr$1 = "𝓌";
  const xcap$1 = "⋂";
  const xcirc$1 = "◯";
  const xcup$1 = "⋃";
  const xdtri$1 = "▽";
  const Xfr$1 = "𝔛";
  const xfr$1 = "𝔵";
  const xharr$1 = "⟷";
  const xhArr$1 = "⟺";
  const Xi$1 = "Ξ";
  const xi$1 = "ξ";
  const xlarr$1 = "⟵";
  const xlArr$1 = "⟸";
  const xmap$1 = "⟼";
  const xnis$1 = "⋻";
  const xodot$1 = "⨀";
  const Xopf$1 = "𝕏";
  const xopf$1 = "𝕩";
  const xoplus$1 = "⨁";
  const xotime$1 = "⨂";
  const xrarr$1 = "⟶";
  const xrArr$1 = "⟹";
  const Xscr$1 = "𝒳";
  const xscr$1 = "𝓍";
  const xsqcup$1 = "⨆";
  const xuplus$1 = "⨄";
  const xutri$1 = "△";
  const xvee$1 = "⋁";
  const xwedge$1 = "⋀";
  const Yacute$3 = "Ý";
  const yacute$3 = "ý";
  const YAcy$1 = "Я";
  const yacy$1 = "я";
  const Ycirc$1 = "Ŷ";
  const ycirc$1 = "ŷ";
  const Ycy$1 = "Ы";
  const ycy$1 = "ы";
  const yen$3 = "¥";
  const Yfr$1 = "𝔜";
  const yfr$1 = "𝔶";
  const YIcy$1 = "Ї";
  const yicy$1 = "ї";
  const Yopf$1 = "𝕐";
  const yopf$1 = "𝕪";
  const Yscr$1 = "𝒴";
  const yscr$1 = "𝓎";
  const YUcy$1 = "Ю";
  const yucy$1 = "ю";
  const yuml$3 = "ÿ";
  const Yuml$1 = "Ÿ";
  const Zacute$1 = "Ź";
  const zacute$1 = "ź";
  const Zcaron$1 = "Ž";
  const zcaron$1 = "ž";
  const Zcy$1 = "З";
  const zcy$1 = "з";
  const Zdot$1 = "Ż";
  const zdot$1 = "ż";
  const zeetrf$1 = "ℨ";
  const ZeroWidthSpace$1 = "​";
  const Zeta$1 = "Ζ";
  const zeta$1 = "ζ";
  const zfr$1 = "𝔷";
  const Zfr$1 = "ℨ";
  const ZHcy$1 = "Ж";
  const zhcy$1 = "ж";
  const zigrarr$1 = "⇝";
  const zopf$1 = "𝕫";
  const Zopf$1 = "ℤ";
  const Zscr$1 = "𝒵";
  const zscr$1 = "𝓏";
  const zwj$1 = "‍";
  const zwnj$1 = "‌";
  const require$$1$2 = {
    Aacute: Aacute$3,
    aacute: aacute$3,
    Abreve: Abreve$1,
    abreve: abreve$1,
    ac: ac$1,
    acd: acd$1,
    acE: acE$1,
    Acirc: Acirc$3,
    acirc: acirc$3,
    acute: acute$3,
    Acy: Acy$1,
    acy: acy$1,
    AElig: AElig$3,
    aelig: aelig$3,
    af: af$1,
    Afr: Afr$1,
    afr: afr$1,
    Agrave: Agrave$3,
    agrave: agrave$3,
    alefsym: alefsym$1,
    aleph: aleph$1,
    Alpha: Alpha$1,
    alpha: alpha$1,
    Amacr: Amacr$1,
    amacr: amacr$1,
    amalg: amalg$1,
    amp: amp$5,
    AMP: AMP$3,
    andand: andand$1,
    And: And$1,
    and: and$1,
    andd: andd$1,
    andslope: andslope$1,
    andv: andv$1,
    ang: ang$1,
    ange: ange$1,
    angle: angle$1,
    angmsdaa: angmsdaa$1,
    angmsdab: angmsdab$1,
    angmsdac: angmsdac$1,
    angmsdad: angmsdad$1,
    angmsdae: angmsdae$1,
    angmsdaf: angmsdaf$1,
    angmsdag: angmsdag$1,
    angmsdah: angmsdah$1,
    angmsd: angmsd$1,
    angrt: angrt$1,
    angrtvb: angrtvb$1,
    angrtvbd: angrtvbd$1,
    angsph: angsph$1,
    angst: angst$1,
    angzarr: angzarr$1,
    Aogon: Aogon$1,
    aogon: aogon$1,
    Aopf: Aopf$1,
    aopf: aopf$1,
    apacir: apacir$1,
    ap: ap$1,
    apE: apE$1,
    ape: ape$1,
    apid: apid$1,
    apos: apos$3,
    ApplyFunction: ApplyFunction$1,
    approx: approx$1,
    approxeq: approxeq$1,
    Aring: Aring$3,
    aring: aring$3,
    Ascr: Ascr$1,
    ascr: ascr$1,
    Assign: Assign$1,
    ast: ast$1,
    asymp: asymp$1,
    asympeq: asympeq$1,
    Atilde: Atilde$3,
    atilde: atilde$3,
    Auml: Auml$3,
    auml: auml$3,
    awconint: awconint$1,
    awint: awint$1,
    backcong: backcong$1,
    backepsilon: backepsilon$1,
    backprime: backprime$1,
    backsim: backsim$1,
    backsimeq: backsimeq$1,
    Backslash: Backslash$1,
    Barv: Barv$1,
    barvee: barvee$1,
    barwed: barwed$1,
    Barwed: Barwed$1,
    barwedge: barwedge$1,
    bbrk: bbrk$1,
    bbrktbrk: bbrktbrk$1,
    bcong: bcong$1,
    Bcy: Bcy$1,
    bcy: bcy$1,
    bdquo: bdquo$1,
    becaus: becaus$1,
    because: because$1,
    Because: Because$1,
    bemptyv: bemptyv$1,
    bepsi: bepsi$1,
    bernou: bernou$1,
    Bernoullis: Bernoullis$1,
    Beta: Beta$1,
    beta: beta$1,
    beth: beth$1,
    between: between$1,
    Bfr: Bfr$1,
    bfr: bfr$1,
    bigcap: bigcap$1,
    bigcirc: bigcirc$1,
    bigcup: bigcup$1,
    bigodot: bigodot$1,
    bigoplus: bigoplus$1,
    bigotimes: bigotimes$1,
    bigsqcup: bigsqcup$1,
    bigstar: bigstar$1,
    bigtriangledown: bigtriangledown$1,
    bigtriangleup: bigtriangleup$1,
    biguplus: biguplus$1,
    bigvee: bigvee$1,
    bigwedge: bigwedge$1,
    bkarow: bkarow$1,
    blacklozenge: blacklozenge$1,
    blacksquare: blacksquare$1,
    blacktriangle: blacktriangle$1,
    blacktriangledown: blacktriangledown$1,
    blacktriangleleft: blacktriangleleft$1,
    blacktriangleright: blacktriangleright$1,
    blank: blank$1,
    blk12: blk12$1,
    blk14: blk14$1,
    blk34: blk34$1,
    block: block$1,
    bne: bne$1,
    bnequiv: bnequiv$1,
    bNot: bNot$1,
    bnot: bnot$1,
    Bopf: Bopf$1,
    bopf: bopf$1,
    bot: bot$1,
    bottom: bottom$1,
    bowtie: bowtie$1,
    boxbox: boxbox$1,
    boxdl: boxdl$1,
    boxdL: boxdL$1,
    boxDl: boxDl$1,
    boxDL: boxDL$1,
    boxdr: boxdr$1,
    boxdR: boxdR$1,
    boxDr: boxDr$1,
    boxDR: boxDR$1,
    boxh: boxh$1,
    boxH: boxH$1,
    boxhd: boxhd$1,
    boxHd: boxHd$1,
    boxhD: boxhD$1,
    boxHD: boxHD$1,
    boxhu: boxhu$1,
    boxHu: boxHu$1,
    boxhU: boxhU$1,
    boxHU: boxHU$1,
    boxminus: boxminus$1,
    boxplus: boxplus$1,
    boxtimes: boxtimes$1,
    boxul: boxul$1,
    boxuL: boxuL$1,
    boxUl: boxUl$1,
    boxUL: boxUL$1,
    boxur: boxur$1,
    boxuR: boxuR$1,
    boxUr: boxUr$1,
    boxUR: boxUR$1,
    boxv: boxv$1,
    boxV: boxV$1,
    boxvh: boxvh$1,
    boxvH: boxvH$1,
    boxVh: boxVh$1,
    boxVH: boxVH$1,
    boxvl: boxvl$1,
    boxvL: boxvL$1,
    boxVl: boxVl$1,
    boxVL: boxVL$1,
    boxvr: boxvr$1,
    boxvR: boxvR$1,
    boxVr: boxVr$1,
    boxVR: boxVR$1,
    bprime: bprime$1,
    breve: breve$1,
    Breve: Breve$1,
    brvbar: brvbar$3,
    bscr: bscr$1,
    Bscr: Bscr$1,
    bsemi: bsemi$1,
    bsim: bsim$1,
    bsime: bsime$1,
    bsolb: bsolb$1,
    bsol: bsol$1,
    bsolhsub: bsolhsub$1,
    bull: bull$1,
    bullet: bullet$1,
    bump: bump$1,
    bumpE: bumpE$1,
    bumpe: bumpe$1,
    Bumpeq: Bumpeq$1,
    bumpeq: bumpeq$1,
    Cacute: Cacute$1,
    cacute: cacute$1,
    capand: capand$1,
    capbrcup: capbrcup$1,
    capcap: capcap$1,
    cap: cap$1,
    Cap: Cap$1,
    capcup: capcup$1,
    capdot: capdot$1,
    CapitalDifferentialD: CapitalDifferentialD$1,
    caps: caps$1,
    caret: caret$1,
    caron: caron$1,
    Cayleys: Cayleys$1,
    ccaps: ccaps$1,
    Ccaron: Ccaron$1,
    ccaron: ccaron$1,
    Ccedil: Ccedil$3,
    ccedil: ccedil$3,
    Ccirc: Ccirc$1,
    ccirc: ccirc$1,
    Cconint: Cconint$1,
    ccups: ccups$1,
    ccupssm: ccupssm$1,
    Cdot: Cdot$1,
    cdot: cdot$1,
    cedil: cedil$3,
    Cedilla: Cedilla$1,
    cemptyv: cemptyv$1,
    cent: cent$3,
    centerdot: centerdot$1,
    CenterDot: CenterDot$1,
    cfr: cfr$1,
    Cfr: Cfr$1,
    CHcy: CHcy$1,
    chcy: chcy$1,
    check: check$1,
    checkmark: checkmark$1,
    Chi: Chi$1,
    chi: chi$1,
    circ: circ$1,
    circeq: circeq$1,
    circlearrowleft: circlearrowleft$1,
    circlearrowright: circlearrowright$1,
    circledast: circledast$1,
    circledcirc: circledcirc$1,
    circleddash: circleddash$1,
    CircleDot: CircleDot$1,
    circledR: circledR$1,
    circledS: circledS$1,
    CircleMinus: CircleMinus$1,
    CirclePlus: CirclePlus$1,
    CircleTimes: CircleTimes$1,
    cir: cir$1,
    cirE: cirE$1,
    cire: cire$1,
    cirfnint: cirfnint$1,
    cirmid: cirmid$1,
    cirscir: cirscir$1,
    ClockwiseContourIntegral: ClockwiseContourIntegral$1,
    CloseCurlyDoubleQuote: CloseCurlyDoubleQuote$1,
    CloseCurlyQuote: CloseCurlyQuote$1,
    clubs: clubs$1,
    clubsuit: clubsuit$1,
    colon: colon$1,
    Colon: Colon$1,
    Colone: Colone$1,
    colone: colone$1,
    coloneq: coloneq$1,
    comma: comma$1,
    commat: commat$1,
    comp: comp$1,
    compfn: compfn$1,
    complement: complement$1,
    complexes: complexes$1,
    cong: cong$1,
    congdot: congdot$1,
    Congruent: Congruent$1,
    conint: conint$1,
    Conint: Conint$1,
    ContourIntegral: ContourIntegral$1,
    copf: copf$1,
    Copf: Copf$1,
    coprod: coprod$1,
    Coproduct: Coproduct$1,
    copy: copy$3,
    COPY: COPY$3,
    copysr: copysr$1,
    CounterClockwiseContourIntegral: CounterClockwiseContourIntegral$1,
    crarr: crarr$1,
    cross: cross$1,
    Cross: Cross$1,
    Cscr: Cscr$1,
    cscr: cscr$1,
    csub: csub$1,
    csube: csube$1,
    csup: csup$1,
    csupe: csupe$1,
    ctdot: ctdot$1,
    cudarrl: cudarrl$1,
    cudarrr: cudarrr$1,
    cuepr: cuepr$1,
    cuesc: cuesc$1,
    cularr: cularr$1,
    cularrp: cularrp$1,
    cupbrcap: cupbrcap$1,
    cupcap: cupcap$1,
    CupCap: CupCap$1,
    cup: cup$1,
    Cup: Cup$1,
    cupcup: cupcup$1,
    cupdot: cupdot$1,
    cupor: cupor$1,
    cups: cups$1,
    curarr: curarr$1,
    curarrm: curarrm$1,
    curlyeqprec: curlyeqprec$1,
    curlyeqsucc: curlyeqsucc$1,
    curlyvee: curlyvee$1,
    curlywedge: curlywedge$1,
    curren: curren$3,
    curvearrowleft: curvearrowleft$1,
    curvearrowright: curvearrowright$1,
    cuvee: cuvee$1,
    cuwed: cuwed$1,
    cwconint: cwconint$1,
    cwint: cwint$1,
    cylcty: cylcty$1,
    dagger: dagger$1,
    Dagger: Dagger$1,
    daleth: daleth$1,
    darr: darr$1,
    Darr: Darr$1,
    dArr: dArr$1,
    dash: dash$1,
    Dashv: Dashv$1,
    dashv: dashv$1,
    dbkarow: dbkarow$1,
    dblac: dblac$1,
    Dcaron: Dcaron$1,
    dcaron: dcaron$1,
    Dcy: Dcy$1,
    dcy: dcy$1,
    ddagger: ddagger$1,
    ddarr: ddarr$1,
    DD: DD$1,
    dd: dd$1,
    DDotrahd: DDotrahd$1,
    ddotseq: ddotseq$1,
    deg: deg$3,
    Del: Del$1,
    Delta: Delta$1,
    delta: delta$1,
    demptyv: demptyv$1,
    dfisht: dfisht$1,
    Dfr: Dfr$1,
    dfr: dfr$1,
    dHar: dHar$1,
    dharl: dharl$1,
    dharr: dharr$1,
    DiacriticalAcute: DiacriticalAcute$1,
    DiacriticalDot: DiacriticalDot$1,
    DiacriticalDoubleAcute: DiacriticalDoubleAcute$1,
    DiacriticalGrave: DiacriticalGrave$1,
    DiacriticalTilde: DiacriticalTilde$1,
    diam: diam$1,
    diamond: diamond$1,
    Diamond: Diamond$1,
    diamondsuit: diamondsuit$1,
    diams: diams$1,
    die: die$1,
    DifferentialD: DifferentialD$1,
    digamma: digamma$1,
    disin: disin$1,
    div: div$1,
    divide: divide$3,
    divideontimes: divideontimes$1,
    divonx: divonx$1,
    DJcy: DJcy$1,
    djcy: djcy$1,
    dlcorn: dlcorn$1,
    dlcrop: dlcrop$1,
    dollar: dollar$1,
    Dopf: Dopf$1,
    dopf: dopf$1,
    Dot: Dot$1,
    dot: dot$1,
    DotDot: DotDot$1,
    doteq: doteq$1,
    doteqdot: doteqdot$1,
    DotEqual: DotEqual$1,
    dotminus: dotminus$1,
    dotplus: dotplus$1,
    dotsquare: dotsquare$1,
    doublebarwedge: doublebarwedge$1,
    DoubleContourIntegral: DoubleContourIntegral$1,
    DoubleDot: DoubleDot$1,
    DoubleDownArrow: DoubleDownArrow$1,
    DoubleLeftArrow: DoubleLeftArrow$1,
    DoubleLeftRightArrow: DoubleLeftRightArrow$1,
    DoubleLeftTee: DoubleLeftTee$1,
    DoubleLongLeftArrow: DoubleLongLeftArrow$1,
    DoubleLongLeftRightArrow: DoubleLongLeftRightArrow$1,
    DoubleLongRightArrow: DoubleLongRightArrow$1,
    DoubleRightArrow: DoubleRightArrow$1,
    DoubleRightTee: DoubleRightTee$1,
    DoubleUpArrow: DoubleUpArrow$1,
    DoubleUpDownArrow: DoubleUpDownArrow$1,
    DoubleVerticalBar: DoubleVerticalBar$1,
    DownArrowBar: DownArrowBar$1,
    downarrow: downarrow$1,
    DownArrow: DownArrow$1,
    Downarrow: Downarrow$1,
    DownArrowUpArrow: DownArrowUpArrow$1,
    DownBreve: DownBreve$1,
    downdownarrows: downdownarrows$1,
    downharpoonleft: downharpoonleft$1,
    downharpoonright: downharpoonright$1,
    DownLeftRightVector: DownLeftRightVector$1,
    DownLeftTeeVector: DownLeftTeeVector$1,
    DownLeftVectorBar: DownLeftVectorBar$1,
    DownLeftVector: DownLeftVector$1,
    DownRightTeeVector: DownRightTeeVector$1,
    DownRightVectorBar: DownRightVectorBar$1,
    DownRightVector: DownRightVector$1,
    DownTeeArrow: DownTeeArrow$1,
    DownTee: DownTee$1,
    drbkarow: drbkarow$1,
    drcorn: drcorn$1,
    drcrop: drcrop$1,
    Dscr: Dscr$1,
    dscr: dscr$1,
    DScy: DScy$1,
    dscy: dscy$1,
    dsol: dsol$1,
    Dstrok: Dstrok$1,
    dstrok: dstrok$1,
    dtdot: dtdot$1,
    dtri: dtri$1,
    dtrif: dtrif$1,
    duarr: duarr$1,
    duhar: duhar$1,
    dwangle: dwangle$1,
    DZcy: DZcy$1,
    dzcy: dzcy$1,
    dzigrarr: dzigrarr$1,
    Eacute: Eacute$3,
    eacute: eacute$3,
    easter: easter$1,
    Ecaron: Ecaron$1,
    ecaron: ecaron$1,
    Ecirc: Ecirc$3,
    ecirc: ecirc$3,
    ecir: ecir$1,
    ecolon: ecolon$1,
    Ecy: Ecy$1,
    ecy: ecy$1,
    eDDot: eDDot$1,
    Edot: Edot$1,
    edot: edot$1,
    eDot: eDot$1,
    ee: ee$1,
    efDot: efDot$1,
    Efr: Efr$1,
    efr: efr$1,
    eg: eg$1,
    Egrave: Egrave$3,
    egrave: egrave$3,
    egs: egs$1,
    egsdot: egsdot$1,
    el: el$1,
    Element: Element$1,
    elinters: elinters$1,
    ell: ell$1,
    els: els$1,
    elsdot: elsdot$1,
    Emacr: Emacr$1,
    emacr: emacr$1,
    empty: empty$1,
    emptyset: emptyset$1,
    EmptySmallSquare: EmptySmallSquare$1,
    emptyv: emptyv$1,
    EmptyVerySmallSquare: EmptyVerySmallSquare$1,
    emsp13: emsp13$1,
    emsp14: emsp14$1,
    emsp: emsp$1,
    ENG: ENG$1,
    eng: eng$1,
    ensp: ensp$1,
    Eogon: Eogon$1,
    eogon: eogon$1,
    Eopf: Eopf$1,
    eopf: eopf$1,
    epar: epar$1,
    eparsl: eparsl$1,
    eplus: eplus$1,
    epsi: epsi$1,
    Epsilon: Epsilon$1,
    epsilon: epsilon$1,
    epsiv: epsiv$1,
    eqcirc: eqcirc$1,
    eqcolon: eqcolon$1,
    eqsim: eqsim$1,
    eqslantgtr: eqslantgtr$1,
    eqslantless: eqslantless$1,
    Equal: Equal$1,
    equals: equals$1,
    EqualTilde: EqualTilde$1,
    equest: equest$1,
    Equilibrium: Equilibrium$1,
    equiv: equiv$1,
    equivDD: equivDD$1,
    eqvparsl: eqvparsl$1,
    erarr: erarr$1,
    erDot: erDot$1,
    escr: escr$1,
    Escr: Escr$1,
    esdot: esdot$1,
    Esim: Esim$1,
    esim: esim$1,
    Eta: Eta$1,
    eta: eta$1,
    ETH: ETH$3,
    eth: eth$3,
    Euml: Euml$3,
    euml: euml$3,
    euro: euro$1,
    excl: excl$1,
    exist: exist$1,
    Exists: Exists$1,
    expectation: expectation$1,
    exponentiale: exponentiale$1,
    ExponentialE: ExponentialE$1,
    fallingdotseq: fallingdotseq$1,
    Fcy: Fcy$1,
    fcy: fcy$1,
    female: female$1,
    ffilig: ffilig$1,
    fflig: fflig$1,
    ffllig: ffllig$1,
    Ffr: Ffr$1,
    ffr: ffr$1,
    filig: filig$1,
    FilledSmallSquare: FilledSmallSquare$1,
    FilledVerySmallSquare: FilledVerySmallSquare$1,
    fjlig: fjlig$1,
    flat: flat$1,
    fllig: fllig$1,
    fltns: fltns$1,
    fnof: fnof$1,
    Fopf: Fopf$1,
    fopf: fopf$1,
    forall: forall$1,
    ForAll: ForAll$1,
    fork: fork$1,
    forkv: forkv$1,
    Fouriertrf: Fouriertrf$1,
    fpartint: fpartint$1,
    frac12: frac12$3,
    frac13: frac13$1,
    frac14: frac14$3,
    frac15: frac15$1,
    frac16: frac16$1,
    frac18: frac18$1,
    frac23: frac23$1,
    frac25: frac25$1,
    frac34: frac34$3,
    frac35: frac35$1,
    frac38: frac38$1,
    frac45: frac45$1,
    frac56: frac56$1,
    frac58: frac58$1,
    frac78: frac78$1,
    frasl: frasl$1,
    frown: frown$1,
    fscr: fscr$1,
    Fscr: Fscr$1,
    gacute: gacute$1,
    Gamma: Gamma$1,
    gamma: gamma$1,
    Gammad: Gammad$1,
    gammad: gammad$1,
    gap: gap$1,
    Gbreve: Gbreve$1,
    gbreve: gbreve$1,
    Gcedil: Gcedil$1,
    Gcirc: Gcirc$1,
    gcirc: gcirc$1,
    Gcy: Gcy$1,
    gcy: gcy$1,
    Gdot: Gdot$1,
    gdot: gdot$1,
    ge: ge$1,
    gE: gE$1,
    gEl: gEl$1,
    gel: gel$1,
    geq: geq$1,
    geqq: geqq$1,
    geqslant: geqslant$1,
    gescc: gescc$1,
    ges: ges$1,
    gesdot: gesdot$1,
    gesdoto: gesdoto$1,
    gesdotol: gesdotol$1,
    gesl: gesl$1,
    gesles: gesles$1,
    Gfr: Gfr$1,
    gfr: gfr$1,
    gg: gg$1,
    Gg: Gg$1,
    ggg: ggg$1,
    gimel: gimel$1,
    GJcy: GJcy$1,
    gjcy: gjcy$1,
    gla: gla$1,
    gl: gl$1,
    glE: glE$1,
    glj: glj$1,
    gnap: gnap$1,
    gnapprox: gnapprox$1,
    gne: gne$1,
    gnE: gnE$1,
    gneq: gneq$1,
    gneqq: gneqq$1,
    gnsim: gnsim$1,
    Gopf: Gopf$1,
    gopf: gopf$1,
    grave: grave$1,
    GreaterEqual: GreaterEqual$1,
    GreaterEqualLess: GreaterEqualLess$1,
    GreaterFullEqual: GreaterFullEqual$1,
    GreaterGreater: GreaterGreater$1,
    GreaterLess: GreaterLess$1,
    GreaterSlantEqual: GreaterSlantEqual$1,
    GreaterTilde: GreaterTilde$1,
    Gscr: Gscr$1,
    gscr: gscr$1,
    gsim: gsim$1,
    gsime: gsime$1,
    gsiml: gsiml$1,
    gtcc: gtcc$1,
    gtcir: gtcir$1,
    gt: gt$5,
    GT: GT$3,
    Gt: Gt$1,
    gtdot: gtdot$1,
    gtlPar: gtlPar$1,
    gtquest: gtquest$1,
    gtrapprox: gtrapprox$1,
    gtrarr: gtrarr$1,
    gtrdot: gtrdot$1,
    gtreqless: gtreqless$1,
    gtreqqless: gtreqqless$1,
    gtrless: gtrless$1,
    gtrsim: gtrsim$1,
    gvertneqq: gvertneqq$1,
    gvnE: gvnE$1,
    Hacek: Hacek$1,
    hairsp: hairsp$1,
    half: half$1,
    hamilt: hamilt$1,
    HARDcy: HARDcy$1,
    hardcy: hardcy$1,
    harrcir: harrcir$1,
    harr: harr$1,
    hArr: hArr$1,
    harrw: harrw$1,
    Hat: Hat$1,
    hbar: hbar$1,
    Hcirc: Hcirc$1,
    hcirc: hcirc$1,
    hearts: hearts$1,
    heartsuit: heartsuit$1,
    hellip: hellip$1,
    hercon: hercon$1,
    hfr: hfr$1,
    Hfr: Hfr$1,
    HilbertSpace: HilbertSpace$1,
    hksearow: hksearow$1,
    hkswarow: hkswarow$1,
    hoarr: hoarr$1,
    homtht: homtht$1,
    hookleftarrow: hookleftarrow$1,
    hookrightarrow: hookrightarrow$1,
    hopf: hopf$1,
    Hopf: Hopf$1,
    horbar: horbar$1,
    HorizontalLine: HorizontalLine$1,
    hscr: hscr$1,
    Hscr: Hscr$1,
    hslash: hslash$1,
    Hstrok: Hstrok$1,
    hstrok: hstrok$1,
    HumpDownHump: HumpDownHump$1,
    HumpEqual: HumpEqual$1,
    hybull: hybull$1,
    hyphen: hyphen$1,
    Iacute: Iacute$3,
    iacute: iacute$3,
    ic: ic$1,
    Icirc: Icirc$3,
    icirc: icirc$3,
    Icy: Icy$1,
    icy: icy$1,
    Idot: Idot$1,
    IEcy: IEcy$1,
    iecy: iecy$1,
    iexcl: iexcl$3,
    iff: iff$1,
    ifr: ifr$1,
    Ifr: Ifr$1,
    Igrave: Igrave$3,
    igrave: igrave$3,
    ii: ii$1,
    iiiint: iiiint$1,
    iiint: iiint$1,
    iinfin: iinfin$1,
    iiota: iiota$1,
    IJlig: IJlig$1,
    ijlig: ijlig$1,
    Imacr: Imacr$1,
    imacr: imacr$1,
    image: image$1,
    ImaginaryI: ImaginaryI$1,
    imagline: imagline$1,
    imagpart: imagpart$1,
    imath: imath$1,
    Im: Im$1,
    imof: imof$1,
    imped: imped$1,
    Implies: Implies$1,
    incare: incare$1,
    "in": "∈",
    infin: infin$1,
    infintie: infintie$1,
    inodot: inodot$1,
    intcal: intcal$1,
    int: int$1,
    Int: Int$1,
    integers: integers$1,
    Integral: Integral$1,
    intercal: intercal$1,
    Intersection: Intersection$1,
    intlarhk: intlarhk$1,
    intprod: intprod$1,
    InvisibleComma: InvisibleComma$1,
    InvisibleTimes: InvisibleTimes$1,
    IOcy: IOcy$1,
    iocy: iocy$1,
    Iogon: Iogon$1,
    iogon: iogon$1,
    Iopf: Iopf$1,
    iopf: iopf$1,
    Iota: Iota$1,
    iota: iota$1,
    iprod: iprod$1,
    iquest: iquest$3,
    iscr: iscr$1,
    Iscr: Iscr$1,
    isin: isin$1,
    isindot: isindot$1,
    isinE: isinE$1,
    isins: isins$1,
    isinsv: isinsv$1,
    isinv: isinv$1,
    it: it$1,
    Itilde: Itilde$1,
    itilde: itilde$1,
    Iukcy: Iukcy$1,
    iukcy: iukcy$1,
    Iuml: Iuml$3,
    iuml: iuml$3,
    Jcirc: Jcirc$1,
    jcirc: jcirc$1,
    Jcy: Jcy$1,
    jcy: jcy$1,
    Jfr: Jfr$1,
    jfr: jfr$1,
    jmath: jmath$1,
    Jopf: Jopf$1,
    jopf: jopf$1,
    Jscr: Jscr$1,
    jscr: jscr$1,
    Jsercy: Jsercy$1,
    jsercy: jsercy$1,
    Jukcy: Jukcy$1,
    jukcy: jukcy$1,
    Kappa: Kappa$1,
    kappa: kappa$1,
    kappav: kappav$1,
    Kcedil: Kcedil$1,
    kcedil: kcedil$1,
    Kcy: Kcy$1,
    kcy: kcy$1,
    Kfr: Kfr$1,
    kfr: kfr$1,
    kgreen: kgreen$1,
    KHcy: KHcy$1,
    khcy: khcy$1,
    KJcy: KJcy$1,
    kjcy: kjcy$1,
    Kopf: Kopf$1,
    kopf: kopf$1,
    Kscr: Kscr$1,
    kscr: kscr$1,
    lAarr: lAarr$1,
    Lacute: Lacute$1,
    lacute: lacute$1,
    laemptyv: laemptyv$1,
    lagran: lagran$1,
    Lambda: Lambda$1,
    lambda: lambda$1,
    lang: lang$1,
    Lang: Lang$1,
    langd: langd$1,
    langle: langle$1,
    lap: lap$1,
    Laplacetrf: Laplacetrf$1,
    laquo: laquo$3,
    larrb: larrb$1,
    larrbfs: larrbfs$1,
    larr: larr$1,
    Larr: Larr$1,
    lArr: lArr$1,
    larrfs: larrfs$1,
    larrhk: larrhk$1,
    larrlp: larrlp$1,
    larrpl: larrpl$1,
    larrsim: larrsim$1,
    larrtl: larrtl$1,
    latail: latail$1,
    lAtail: lAtail$1,
    lat: lat$1,
    late: late$1,
    lates: lates$1,
    lbarr: lbarr$1,
    lBarr: lBarr$1,
    lbbrk: lbbrk$1,
    lbrace: lbrace$1,
    lbrack: lbrack$1,
    lbrke: lbrke$1,
    lbrksld: lbrksld$1,
    lbrkslu: lbrkslu$1,
    Lcaron: Lcaron$1,
    lcaron: lcaron$1,
    Lcedil: Lcedil$1,
    lcedil: lcedil$1,
    lceil: lceil$1,
    lcub: lcub$1,
    Lcy: Lcy$1,
    lcy: lcy$1,
    ldca: ldca$1,
    ldquo: ldquo$1,
    ldquor: ldquor$1,
    ldrdhar: ldrdhar$1,
    ldrushar: ldrushar$1,
    ldsh: ldsh$1,
    le: le$1,
    lE: lE$1,
    LeftAngleBracket: LeftAngleBracket$1,
    LeftArrowBar: LeftArrowBar$1,
    leftarrow: leftarrow$1,
    LeftArrow: LeftArrow$1,
    Leftarrow: Leftarrow$1,
    LeftArrowRightArrow: LeftArrowRightArrow$1,
    leftarrowtail: leftarrowtail$1,
    LeftCeiling: LeftCeiling$1,
    LeftDoubleBracket: LeftDoubleBracket$1,
    LeftDownTeeVector: LeftDownTeeVector$1,
    LeftDownVectorBar: LeftDownVectorBar$1,
    LeftDownVector: LeftDownVector$1,
    LeftFloor: LeftFloor$1,
    leftharpoondown: leftharpoondown$1,
    leftharpoonup: leftharpoonup$1,
    leftleftarrows: leftleftarrows$1,
    leftrightarrow: leftrightarrow$1,
    LeftRightArrow: LeftRightArrow$1,
    Leftrightarrow: Leftrightarrow$1,
    leftrightarrows: leftrightarrows$1,
    leftrightharpoons: leftrightharpoons$1,
    leftrightsquigarrow: leftrightsquigarrow$1,
    LeftRightVector: LeftRightVector$1,
    LeftTeeArrow: LeftTeeArrow$1,
    LeftTee: LeftTee$1,
    LeftTeeVector: LeftTeeVector$1,
    leftthreetimes: leftthreetimes$1,
    LeftTriangleBar: LeftTriangleBar$1,
    LeftTriangle: LeftTriangle$1,
    LeftTriangleEqual: LeftTriangleEqual$1,
    LeftUpDownVector: LeftUpDownVector$1,
    LeftUpTeeVector: LeftUpTeeVector$1,
    LeftUpVectorBar: LeftUpVectorBar$1,
    LeftUpVector: LeftUpVector$1,
    LeftVectorBar: LeftVectorBar$1,
    LeftVector: LeftVector$1,
    lEg: lEg$1,
    leg: leg$1,
    leq: leq$1,
    leqq: leqq$1,
    leqslant: leqslant$1,
    lescc: lescc$1,
    les: les$1,
    lesdot: lesdot$1,
    lesdoto: lesdoto$1,
    lesdotor: lesdotor$1,
    lesg: lesg$1,
    lesges: lesges$1,
    lessapprox: lessapprox$1,
    lessdot: lessdot$1,
    lesseqgtr: lesseqgtr$1,
    lesseqqgtr: lesseqqgtr$1,
    LessEqualGreater: LessEqualGreater$1,
    LessFullEqual: LessFullEqual$1,
    LessGreater: LessGreater$1,
    lessgtr: lessgtr$1,
    LessLess: LessLess$1,
    lesssim: lesssim$1,
    LessSlantEqual: LessSlantEqual$1,
    LessTilde: LessTilde$1,
    lfisht: lfisht$1,
    lfloor: lfloor$1,
    Lfr: Lfr$1,
    lfr: lfr$1,
    lg: lg$1,
    lgE: lgE$1,
    lHar: lHar$1,
    lhard: lhard$1,
    lharu: lharu$1,
    lharul: lharul$1,
    lhblk: lhblk$1,
    LJcy: LJcy$1,
    ljcy: ljcy$1,
    llarr: llarr$1,
    ll: ll$1,
    Ll: Ll$1,
    llcorner: llcorner$1,
    Lleftarrow: Lleftarrow$1,
    llhard: llhard$1,
    lltri: lltri$1,
    Lmidot: Lmidot$1,
    lmidot: lmidot$1,
    lmoustache: lmoustache$1,
    lmoust: lmoust$1,
    lnap: lnap$1,
    lnapprox: lnapprox$1,
    lne: lne$1,
    lnE: lnE$1,
    lneq: lneq$1,
    lneqq: lneqq$1,
    lnsim: lnsim$1,
    loang: loang$1,
    loarr: loarr$1,
    lobrk: lobrk$1,
    longleftarrow: longleftarrow$1,
    LongLeftArrow: LongLeftArrow$1,
    Longleftarrow: Longleftarrow$1,
    longleftrightarrow: longleftrightarrow$1,
    LongLeftRightArrow: LongLeftRightArrow$1,
    Longleftrightarrow: Longleftrightarrow$1,
    longmapsto: longmapsto$1,
    longrightarrow: longrightarrow$1,
    LongRightArrow: LongRightArrow$1,
    Longrightarrow: Longrightarrow$1,
    looparrowleft: looparrowleft$1,
    looparrowright: looparrowright$1,
    lopar: lopar$1,
    Lopf: Lopf$1,
    lopf: lopf$1,
    loplus: loplus$1,
    lotimes: lotimes$1,
    lowast: lowast$1,
    lowbar: lowbar$1,
    LowerLeftArrow: LowerLeftArrow$1,
    LowerRightArrow: LowerRightArrow$1,
    loz: loz$1,
    lozenge: lozenge$1,
    lozf: lozf$1,
    lpar: lpar$1,
    lparlt: lparlt$1,
    lrarr: lrarr$1,
    lrcorner: lrcorner$1,
    lrhar: lrhar$1,
    lrhard: lrhard$1,
    lrm: lrm$1,
    lrtri: lrtri$1,
    lsaquo: lsaquo$1,
    lscr: lscr$1,
    Lscr: Lscr$1,
    lsh: lsh$1,
    Lsh: Lsh$1,
    lsim: lsim$1,
    lsime: lsime$1,
    lsimg: lsimg$1,
    lsqb: lsqb$1,
    lsquo: lsquo$1,
    lsquor: lsquor$1,
    Lstrok: Lstrok$1,
    lstrok: lstrok$1,
    ltcc: ltcc$1,
    ltcir: ltcir$1,
    lt: lt$5,
    LT: LT$3,
    Lt: Lt$1,
    ltdot: ltdot$1,
    lthree: lthree$1,
    ltimes: ltimes$1,
    ltlarr: ltlarr$1,
    ltquest: ltquest$1,
    ltri: ltri$1,
    ltrie: ltrie$1,
    ltrif: ltrif$1,
    ltrPar: ltrPar$1,
    lurdshar: lurdshar$1,
    luruhar: luruhar$1,
    lvertneqq: lvertneqq$1,
    lvnE: lvnE$1,
    macr: macr$3,
    male: male$1,
    malt: malt$1,
    maltese: maltese$1,
    "Map": "⤅",
    map: map$1,
    mapsto: mapsto$1,
    mapstodown: mapstodown$1,
    mapstoleft: mapstoleft$1,
    mapstoup: mapstoup$1,
    marker: marker$1,
    mcomma: mcomma$1,
    Mcy: Mcy$1,
    mcy: mcy$1,
    mdash: mdash$1,
    mDDot: mDDot$1,
    measuredangle: measuredangle$1,
    MediumSpace: MediumSpace$1,
    Mellintrf: Mellintrf$1,
    Mfr: Mfr$1,
    mfr: mfr$1,
    mho: mho$1,
    micro: micro$3,
    midast: midast$1,
    midcir: midcir$1,
    mid: mid$1,
    middot: middot$3,
    minusb: minusb$1,
    minus: minus$1,
    minusd: minusd$1,
    minusdu: minusdu$1,
    MinusPlus: MinusPlus$1,
    mlcp: mlcp$1,
    mldr: mldr$1,
    mnplus: mnplus$1,
    models: models$1,
    Mopf: Mopf$1,
    mopf: mopf$1,
    mp: mp$1,
    mscr: mscr$1,
    Mscr: Mscr$1,
    mstpos: mstpos$1,
    Mu: Mu$1,
    mu: mu$1,
    multimap: multimap$1,
    mumap: mumap$1,
    nabla: nabla$1,
    Nacute: Nacute$1,
    nacute: nacute$1,
    nang: nang$1,
    nap: nap$1,
    napE: napE$1,
    napid: napid$1,
    napos: napos$1,
    napprox: napprox$1,
    natural: natural$1,
    naturals: naturals$1,
    natur: natur$1,
    nbsp: nbsp$3,
    nbump: nbump$1,
    nbumpe: nbumpe$1,
    ncap: ncap$1,
    Ncaron: Ncaron$1,
    ncaron: ncaron$1,
    Ncedil: Ncedil$1,
    ncedil: ncedil$1,
    ncong: ncong$1,
    ncongdot: ncongdot$1,
    ncup: ncup$1,
    Ncy: Ncy$1,
    ncy: ncy$1,
    ndash: ndash$1,
    nearhk: nearhk$1,
    nearr: nearr$1,
    neArr: neArr$1,
    nearrow: nearrow$1,
    ne: ne$1,
    nedot: nedot$1,
    NegativeMediumSpace: NegativeMediumSpace$1,
    NegativeThickSpace: NegativeThickSpace$1,
    NegativeThinSpace: NegativeThinSpace$1,
    NegativeVeryThinSpace: NegativeVeryThinSpace$1,
    nequiv: nequiv$1,
    nesear: nesear$1,
    nesim: nesim$1,
    NestedGreaterGreater: NestedGreaterGreater$1,
    NestedLessLess: NestedLessLess$1,
    NewLine: NewLine$1,
    nexist: nexist$1,
    nexists: nexists$1,
    Nfr: Nfr$1,
    nfr: nfr$1,
    ngE: ngE$1,
    nge: nge$1,
    ngeq: ngeq$1,
    ngeqq: ngeqq$1,
    ngeqslant: ngeqslant$1,
    nges: nges$1,
    nGg: nGg$1,
    ngsim: ngsim$1,
    nGt: nGt$1,
    ngt: ngt$1,
    ngtr: ngtr$1,
    nGtv: nGtv$1,
    nharr: nharr$1,
    nhArr: nhArr$1,
    nhpar: nhpar$1,
    ni: ni$1,
    nis: nis$1,
    nisd: nisd$1,
    niv: niv$1,
    NJcy: NJcy$1,
    njcy: njcy$1,
    nlarr: nlarr$1,
    nlArr: nlArr$1,
    nldr: nldr$1,
    nlE: nlE$1,
    nle: nle$1,
    nleftarrow: nleftarrow$1,
    nLeftarrow: nLeftarrow$1,
    nleftrightarrow: nleftrightarrow$1,
    nLeftrightarrow: nLeftrightarrow$1,
    nleq: nleq$1,
    nleqq: nleqq$1,
    nleqslant: nleqslant$1,
    nles: nles$1,
    nless: nless$1,
    nLl: nLl$1,
    nlsim: nlsim$1,
    nLt: nLt$1,
    nlt: nlt$1,
    nltri: nltri$1,
    nltrie: nltrie$1,
    nLtv: nLtv$1,
    nmid: nmid$1,
    NoBreak: NoBreak$1,
    NonBreakingSpace: NonBreakingSpace$1,
    nopf: nopf$1,
    Nopf: Nopf$1,
    Not: Not$1,
    not: not$3,
    NotCongruent: NotCongruent$1,
    NotCupCap: NotCupCap$1,
    NotDoubleVerticalBar: NotDoubleVerticalBar$1,
    NotElement: NotElement$1,
    NotEqual: NotEqual$1,
    NotEqualTilde: NotEqualTilde$1,
    NotExists: NotExists$1,
    NotGreater: NotGreater$1,
    NotGreaterEqual: NotGreaterEqual$1,
    NotGreaterFullEqual: NotGreaterFullEqual$1,
    NotGreaterGreater: NotGreaterGreater$1,
    NotGreaterLess: NotGreaterLess$1,
    NotGreaterSlantEqual: NotGreaterSlantEqual$1,
    NotGreaterTilde: NotGreaterTilde$1,
    NotHumpDownHump: NotHumpDownHump$1,
    NotHumpEqual: NotHumpEqual$1,
    notin: notin$1,
    notindot: notindot$1,
    notinE: notinE$1,
    notinva: notinva$1,
    notinvb: notinvb$1,
    notinvc: notinvc$1,
    NotLeftTriangleBar: NotLeftTriangleBar$1,
    NotLeftTriangle: NotLeftTriangle$1,
    NotLeftTriangleEqual: NotLeftTriangleEqual$1,
    NotLess: NotLess$1,
    NotLessEqual: NotLessEqual$1,
    NotLessGreater: NotLessGreater$1,
    NotLessLess: NotLessLess$1,
    NotLessSlantEqual: NotLessSlantEqual$1,
    NotLessTilde: NotLessTilde$1,
    NotNestedGreaterGreater: NotNestedGreaterGreater$1,
    NotNestedLessLess: NotNestedLessLess$1,
    notni: notni$1,
    notniva: notniva$1,
    notnivb: notnivb$1,
    notnivc: notnivc$1,
    NotPrecedes: NotPrecedes$1,
    NotPrecedesEqual: NotPrecedesEqual$1,
    NotPrecedesSlantEqual: NotPrecedesSlantEqual$1,
    NotReverseElement: NotReverseElement$1,
    NotRightTriangleBar: NotRightTriangleBar$1,
    NotRightTriangle: NotRightTriangle$1,
    NotRightTriangleEqual: NotRightTriangleEqual$1,
    NotSquareSubset: NotSquareSubset$1,
    NotSquareSubsetEqual: NotSquareSubsetEqual$1,
    NotSquareSuperset: NotSquareSuperset$1,
    NotSquareSupersetEqual: NotSquareSupersetEqual$1,
    NotSubset: NotSubset$1,
    NotSubsetEqual: NotSubsetEqual$1,
    NotSucceeds: NotSucceeds$1,
    NotSucceedsEqual: NotSucceedsEqual$1,
    NotSucceedsSlantEqual: NotSucceedsSlantEqual$1,
    NotSucceedsTilde: NotSucceedsTilde$1,
    NotSuperset: NotSuperset$1,
    NotSupersetEqual: NotSupersetEqual$1,
    NotTilde: NotTilde$1,
    NotTildeEqual: NotTildeEqual$1,
    NotTildeFullEqual: NotTildeFullEqual$1,
    NotTildeTilde: NotTildeTilde$1,
    NotVerticalBar: NotVerticalBar$1,
    nparallel: nparallel$1,
    npar: npar$1,
    nparsl: nparsl$1,
    npart: npart$1,
    npolint: npolint$1,
    npr: npr$1,
    nprcue: nprcue$1,
    nprec: nprec$1,
    npreceq: npreceq$1,
    npre: npre$1,
    nrarrc: nrarrc$1,
    nrarr: nrarr$1,
    nrArr: nrArr$1,
    nrarrw: nrarrw$1,
    nrightarrow: nrightarrow$1,
    nRightarrow: nRightarrow$1,
    nrtri: nrtri$1,
    nrtrie: nrtrie$1,
    nsc: nsc$1,
    nsccue: nsccue$1,
    nsce: nsce$1,
    Nscr: Nscr$1,
    nscr: nscr$1,
    nshortmid: nshortmid$1,
    nshortparallel: nshortparallel$1,
    nsim: nsim$1,
    nsime: nsime$1,
    nsimeq: nsimeq$1,
    nsmid: nsmid$1,
    nspar: nspar$1,
    nsqsube: nsqsube$1,
    nsqsupe: nsqsupe$1,
    nsub: nsub$1,
    nsubE: nsubE$1,
    nsube: nsube$1,
    nsubset: nsubset$1,
    nsubseteq: nsubseteq$1,
    nsubseteqq: nsubseteqq$1,
    nsucc: nsucc$1,
    nsucceq: nsucceq$1,
    nsup: nsup$1,
    nsupE: nsupE$1,
    nsupe: nsupe$1,
    nsupset: nsupset$1,
    nsupseteq: nsupseteq$1,
    nsupseteqq: nsupseteqq$1,
    ntgl: ntgl$1,
    Ntilde: Ntilde$3,
    ntilde: ntilde$3,
    ntlg: ntlg$1,
    ntriangleleft: ntriangleleft$1,
    ntrianglelefteq: ntrianglelefteq$1,
    ntriangleright: ntriangleright$1,
    ntrianglerighteq: ntrianglerighteq$1,
    Nu: Nu$1,
    nu: nu$1,
    num: num$1,
    numero: numero$1,
    numsp: numsp$1,
    nvap: nvap$1,
    nvdash: nvdash$1,
    nvDash: nvDash$1,
    nVdash: nVdash$1,
    nVDash: nVDash$1,
    nvge: nvge$1,
    nvgt: nvgt$1,
    nvHarr: nvHarr$1,
    nvinfin: nvinfin$1,
    nvlArr: nvlArr$1,
    nvle: nvle$1,
    nvlt: nvlt$1,
    nvltrie: nvltrie$1,
    nvrArr: nvrArr$1,
    nvrtrie: nvrtrie$1,
    nvsim: nvsim$1,
    nwarhk: nwarhk$1,
    nwarr: nwarr$1,
    nwArr: nwArr$1,
    nwarrow: nwarrow$1,
    nwnear: nwnear$1,
    Oacute: Oacute$3,
    oacute: oacute$3,
    oast: oast$1,
    Ocirc: Ocirc$3,
    ocirc: ocirc$3,
    ocir: ocir$1,
    Ocy: Ocy$1,
    ocy: ocy$1,
    odash: odash$1,
    Odblac: Odblac$1,
    odblac: odblac$1,
    odiv: odiv$1,
    odot: odot$1,
    odsold: odsold$1,
    OElig: OElig$1,
    oelig: oelig$1,
    ofcir: ofcir$1,
    Ofr: Ofr$1,
    ofr: ofr$1,
    ogon: ogon$1,
    Ograve: Ograve$3,
    ograve: ograve$3,
    ogt: ogt$1,
    ohbar: ohbar$1,
    ohm: ohm$1,
    oint: oint$1,
    olarr: olarr$1,
    olcir: olcir$1,
    olcross: olcross$1,
    oline: oline$1,
    olt: olt$1,
    Omacr: Omacr$1,
    omacr: omacr$1,
    Omega: Omega$1,
    omega: omega$1,
    Omicron: Omicron$1,
    omicron: omicron$1,
    omid: omid$1,
    ominus: ominus$1,
    Oopf: Oopf$1,
    oopf: oopf$1,
    opar: opar$1,
    OpenCurlyDoubleQuote: OpenCurlyDoubleQuote$1,
    OpenCurlyQuote: OpenCurlyQuote$1,
    operp: operp$1,
    oplus: oplus$1,
    orarr: orarr$1,
    Or: Or$1,
    or: or$1,
    ord: ord$1,
    order: order$1,
    orderof: orderof$1,
    ordf: ordf$3,
    ordm: ordm$3,
    origof: origof$1,
    oror: oror$1,
    orslope: orslope$1,
    orv: orv$1,
    oS: oS$1,
    Oscr: Oscr$1,
    oscr: oscr$1,
    Oslash: Oslash$3,
    oslash: oslash$3,
    osol: osol$1,
    Otilde: Otilde$3,
    otilde: otilde$3,
    otimesas: otimesas$1,
    Otimes: Otimes$1,
    otimes: otimes$1,
    Ouml: Ouml$3,
    ouml: ouml$3,
    ovbar: ovbar$1,
    OverBar: OverBar$1,
    OverBrace: OverBrace$1,
    OverBracket: OverBracket$1,
    OverParenthesis: OverParenthesis$1,
    para: para$3,
    parallel: parallel$1,
    par: par$1,
    parsim: parsim$1,
    parsl: parsl$1,
    part: part$1,
    PartialD: PartialD$1,
    Pcy: Pcy$1,
    pcy: pcy$1,
    percnt: percnt$1,
    period: period$1,
    permil: permil$1,
    perp: perp$1,
    pertenk: pertenk$1,
    Pfr: Pfr$1,
    pfr: pfr$1,
    Phi: Phi$1,
    phi: phi$1,
    phiv: phiv$1,
    phmmat: phmmat$1,
    phone: phone$1,
    Pi: Pi$1,
    pi: pi$1,
    pitchfork: pitchfork$1,
    piv: piv$1,
    planck: planck$1,
    planckh: planckh$1,
    plankv: plankv$1,
    plusacir: plusacir$1,
    plusb: plusb$1,
    pluscir: pluscir$1,
    plus: plus$1,
    plusdo: plusdo$1,
    plusdu: plusdu$1,
    pluse: pluse$1,
    PlusMinus: PlusMinus$1,
    plusmn: plusmn$3,
    plussim: plussim$1,
    plustwo: plustwo$1,
    pm: pm$1,
    Poincareplane: Poincareplane$1,
    pointint: pointint$1,
    popf: popf$1,
    Popf: Popf$1,
    pound: pound$3,
    prap: prap$1,
    Pr: Pr$1,
    pr: pr$1,
    prcue: prcue$1,
    precapprox: precapprox$1,
    prec: prec$1,
    preccurlyeq: preccurlyeq$1,
    Precedes: Precedes$1,
    PrecedesEqual: PrecedesEqual$1,
    PrecedesSlantEqual: PrecedesSlantEqual$1,
    PrecedesTilde: PrecedesTilde$1,
    preceq: preceq$1,
    precnapprox: precnapprox$1,
    precneqq: precneqq$1,
    precnsim: precnsim$1,
    pre: pre$1,
    prE: prE$1,
    precsim: precsim$1,
    prime: prime$1,
    Prime: Prime$1,
    primes: primes$1,
    prnap: prnap$1,
    prnE: prnE$1,
    prnsim: prnsim$1,
    prod: prod$1,
    Product: Product$2,
    profalar: profalar$1,
    profline: profline$1,
    profsurf: profsurf$1,
    prop: prop$1,
    Proportional: Proportional$1,
    Proportion: Proportion$1,
    propto: propto$1,
    prsim: prsim$1,
    prurel: prurel$1,
    Pscr: Pscr$1,
    pscr: pscr$1,
    Psi: Psi$1,
    psi: psi$1,
    puncsp: puncsp$1,
    Qfr: Qfr$1,
    qfr: qfr$1,
    qint: qint$1,
    qopf: qopf$1,
    Qopf: Qopf$1,
    qprime: qprime$1,
    Qscr: Qscr$1,
    qscr: qscr$1,
    quaternions: quaternions$1,
    quatint: quatint$1,
    quest: quest$1,
    questeq: questeq$1,
    quot: quot$5,
    QUOT: QUOT$3,
    rAarr: rAarr$1,
    race: race$1,
    Racute: Racute$1,
    racute: racute$1,
    radic: radic$1,
    raemptyv: raemptyv$1,
    rang: rang$1,
    Rang: Rang$1,
    rangd: rangd$1,
    range: range$1,
    rangle: rangle$1,
    raquo: raquo$3,
    rarrap: rarrap$1,
    rarrb: rarrb$1,
    rarrbfs: rarrbfs$1,
    rarrc: rarrc$1,
    rarr: rarr$1,
    Rarr: Rarr$1,
    rArr: rArr$1,
    rarrfs: rarrfs$1,
    rarrhk: rarrhk$1,
    rarrlp: rarrlp$1,
    rarrpl: rarrpl$1,
    rarrsim: rarrsim$1,
    Rarrtl: Rarrtl$1,
    rarrtl: rarrtl$1,
    rarrw: rarrw$1,
    ratail: ratail$1,
    rAtail: rAtail$1,
    ratio: ratio$1,
    rationals: rationals$1,
    rbarr: rbarr$1,
    rBarr: rBarr$1,
    RBarr: RBarr$1,
    rbbrk: rbbrk$1,
    rbrace: rbrace$1,
    rbrack: rbrack$1,
    rbrke: rbrke$1,
    rbrksld: rbrksld$1,
    rbrkslu: rbrkslu$1,
    Rcaron: Rcaron$1,
    rcaron: rcaron$1,
    Rcedil: Rcedil$1,
    rcedil: rcedil$1,
    rceil: rceil$1,
    rcub: rcub$1,
    Rcy: Rcy$1,
    rcy: rcy$1,
    rdca: rdca$1,
    rdldhar: rdldhar$1,
    rdquo: rdquo$1,
    rdquor: rdquor$1,
    rdsh: rdsh$1,
    real: real$1,
    realine: realine$1,
    realpart: realpart$1,
    reals: reals$1,
    Re: Re$1,
    rect: rect$1,
    reg: reg$3,
    REG: REG$3,
    ReverseElement: ReverseElement$1,
    ReverseEquilibrium: ReverseEquilibrium$1,
    ReverseUpEquilibrium: ReverseUpEquilibrium$1,
    rfisht: rfisht$1,
    rfloor: rfloor$1,
    rfr: rfr$1,
    Rfr: Rfr$1,
    rHar: rHar$1,
    rhard: rhard$1,
    rharu: rharu$1,
    rharul: rharul$1,
    Rho: Rho$1,
    rho: rho$1,
    rhov: rhov$1,
    RightAngleBracket: RightAngleBracket$1,
    RightArrowBar: RightArrowBar$1,
    rightarrow: rightarrow$1,
    RightArrow: RightArrow$1,
    Rightarrow: Rightarrow$1,
    RightArrowLeftArrow: RightArrowLeftArrow$1,
    rightarrowtail: rightarrowtail$1,
    RightCeiling: RightCeiling$1,
    RightDoubleBracket: RightDoubleBracket$1,
    RightDownTeeVector: RightDownTeeVector$1,
    RightDownVectorBar: RightDownVectorBar$1,
    RightDownVector: RightDownVector$1,
    RightFloor: RightFloor$1,
    rightharpoondown: rightharpoondown$1,
    rightharpoonup: rightharpoonup$1,
    rightleftarrows: rightleftarrows$1,
    rightleftharpoons: rightleftharpoons$1,
    rightrightarrows: rightrightarrows$1,
    rightsquigarrow: rightsquigarrow$1,
    RightTeeArrow: RightTeeArrow$1,
    RightTee: RightTee$1,
    RightTeeVector: RightTeeVector$1,
    rightthreetimes: rightthreetimes$1,
    RightTriangleBar: RightTriangleBar$1,
    RightTriangle: RightTriangle$1,
    RightTriangleEqual: RightTriangleEqual$1,
    RightUpDownVector: RightUpDownVector$1,
    RightUpTeeVector: RightUpTeeVector$1,
    RightUpVectorBar: RightUpVectorBar$1,
    RightUpVector: RightUpVector$1,
    RightVectorBar: RightVectorBar$1,
    RightVector: RightVector$1,
    ring: ring$1,
    risingdotseq: risingdotseq$1,
    rlarr: rlarr$1,
    rlhar: rlhar$1,
    rlm: rlm$1,
    rmoustache: rmoustache$1,
    rmoust: rmoust$1,
    rnmid: rnmid$1,
    roang: roang$1,
    roarr: roarr$1,
    robrk: robrk$1,
    ropar: ropar$1,
    ropf: ropf$1,
    Ropf: Ropf$1,
    roplus: roplus$1,
    rotimes: rotimes$1,
    RoundImplies: RoundImplies$1,
    rpar: rpar$1,
    rpargt: rpargt$1,
    rppolint: rppolint$1,
    rrarr: rrarr$1,
    Rrightarrow: Rrightarrow$1,
    rsaquo: rsaquo$1,
    rscr: rscr$1,
    Rscr: Rscr$1,
    rsh: rsh$1,
    Rsh: Rsh$1,
    rsqb: rsqb$1,
    rsquo: rsquo$1,
    rsquor: rsquor$1,
    rthree: rthree$1,
    rtimes: rtimes$1,
    rtri: rtri$1,
    rtrie: rtrie$1,
    rtrif: rtrif$1,
    rtriltri: rtriltri$1,
    RuleDelayed: RuleDelayed$1,
    ruluhar: ruluhar$1,
    rx: rx$1,
    Sacute: Sacute$1,
    sacute: sacute$1,
    sbquo: sbquo$1,
    scap: scap$1,
    Scaron: Scaron$1,
    scaron: scaron$1,
    Sc: Sc$1,
    sc: sc$1,
    sccue: sccue$1,
    sce: sce$1,
    scE: scE$1,
    Scedil: Scedil$1,
    scedil: scedil$1,
    Scirc: Scirc$1,
    scirc: scirc$1,
    scnap: scnap$1,
    scnE: scnE$1,
    scnsim: scnsim$1,
    scpolint: scpolint$1,
    scsim: scsim$1,
    Scy: Scy$1,
    scy: scy$1,
    sdotb: sdotb$1,
    sdot: sdot$1,
    sdote: sdote$1,
    searhk: searhk$1,
    searr: searr$1,
    seArr: seArr$1,
    searrow: searrow$1,
    sect: sect$3,
    semi: semi$1,
    seswar: seswar$1,
    setminus: setminus$1,
    setmn: setmn$1,
    sext: sext$1,
    Sfr: Sfr$1,
    sfr: sfr$1,
    sfrown: sfrown$1,
    sharp: sharp$1,
    SHCHcy: SHCHcy$1,
    shchcy: shchcy$1,
    SHcy: SHcy$1,
    shcy: shcy$1,
    ShortDownArrow: ShortDownArrow$1,
    ShortLeftArrow: ShortLeftArrow$1,
    shortmid: shortmid$1,
    shortparallel: shortparallel$1,
    ShortRightArrow: ShortRightArrow$1,
    ShortUpArrow: ShortUpArrow$1,
    shy: shy$3,
    Sigma: Sigma$1,
    sigma: sigma$1,
    sigmaf: sigmaf$1,
    sigmav: sigmav$1,
    sim: sim$1,
    simdot: simdot$1,
    sime: sime$1,
    simeq: simeq$1,
    simg: simg$1,
    simgE: simgE$1,
    siml: siml$1,
    simlE: simlE$1,
    simne: simne$1,
    simplus: simplus$1,
    simrarr: simrarr$1,
    slarr: slarr$1,
    SmallCircle: SmallCircle$1,
    smallsetminus: smallsetminus$1,
    smashp: smashp$1,
    smeparsl: smeparsl$1,
    smid: smid$1,
    smile: smile$1,
    smt: smt$1,
    smte: smte$1,
    smtes: smtes$1,
    SOFTcy: SOFTcy$1,
    softcy: softcy$1,
    solbar: solbar$1,
    solb: solb$1,
    sol: sol$1,
    Sopf: Sopf$1,
    sopf: sopf$1,
    spades: spades$1,
    spadesuit: spadesuit$1,
    spar: spar$1,
    sqcap: sqcap$1,
    sqcaps: sqcaps$1,
    sqcup: sqcup$1,
    sqcups: sqcups$1,
    Sqrt: Sqrt$1,
    sqsub: sqsub$1,
    sqsube: sqsube$1,
    sqsubset: sqsubset$1,
    sqsubseteq: sqsubseteq$1,
    sqsup: sqsup$1,
    sqsupe: sqsupe$1,
    sqsupset: sqsupset$1,
    sqsupseteq: sqsupseteq$1,
    square: square$1,
    Square: Square$1,
    SquareIntersection: SquareIntersection$1,
    SquareSubset: SquareSubset$1,
    SquareSubsetEqual: SquareSubsetEqual$1,
    SquareSuperset: SquareSuperset$1,
    SquareSupersetEqual: SquareSupersetEqual$1,
    SquareUnion: SquareUnion$1,
    squarf: squarf$1,
    squ: squ$1,
    squf: squf$1,
    srarr: srarr$1,
    Sscr: Sscr$1,
    sscr: sscr$1,
    ssetmn: ssetmn$1,
    ssmile: ssmile$1,
    sstarf: sstarf$1,
    Star: Star$1,
    star: star$1,
    starf: starf$1,
    straightepsilon: straightepsilon$1,
    straightphi: straightphi$1,
    strns: strns$1,
    sub: sub$1,
    Sub: Sub$1,
    subdot: subdot$1,
    subE: subE$1,
    sube: sube$1,
    subedot: subedot$1,
    submult: submult$1,
    subnE: subnE$1,
    subne: subne$1,
    subplus: subplus$1,
    subrarr: subrarr$1,
    subset: subset$1,
    Subset: Subset$1,
    subseteq: subseteq$1,
    subseteqq: subseteqq$1,
    SubsetEqual: SubsetEqual$1,
    subsetneq: subsetneq$1,
    subsetneqq: subsetneqq$1,
    subsim: subsim$1,
    subsub: subsub$1,
    subsup: subsup$1,
    succapprox: succapprox$1,
    succ: succ$1,
    succcurlyeq: succcurlyeq$1,
    Succeeds: Succeeds$1,
    SucceedsEqual: SucceedsEqual$1,
    SucceedsSlantEqual: SucceedsSlantEqual$1,
    SucceedsTilde: SucceedsTilde$1,
    succeq: succeq$1,
    succnapprox: succnapprox$1,
    succneqq: succneqq$1,
    succnsim: succnsim$1,
    succsim: succsim$1,
    SuchThat: SuchThat$1,
    sum: sum$1,
    Sum: Sum$1,
    sung: sung$1,
    sup1: sup1$3,
    sup2: sup2$3,
    sup3: sup3$3,
    sup: sup$1,
    Sup: Sup$1,
    supdot: supdot$1,
    supdsub: supdsub$1,
    supE: supE$1,
    supe: supe$1,
    supedot: supedot$1,
    Superset: Superset$1,
    SupersetEqual: SupersetEqual$1,
    suphsol: suphsol$1,
    suphsub: suphsub$1,
    suplarr: suplarr$1,
    supmult: supmult$1,
    supnE: supnE$1,
    supne: supne$1,
    supplus: supplus$1,
    supset: supset$1,
    Supset: Supset$1,
    supseteq: supseteq$1,
    supseteqq: supseteqq$1,
    supsetneq: supsetneq$1,
    supsetneqq: supsetneqq$1,
    supsim: supsim$1,
    supsub: supsub$1,
    supsup: supsup$1,
    swarhk: swarhk$1,
    swarr: swarr$1,
    swArr: swArr$1,
    swarrow: swarrow$1,
    swnwar: swnwar$1,
    szlig: szlig$3,
    Tab: Tab$1,
    target: target$1,
    Tau: Tau$1,
    tau: tau$1,
    tbrk: tbrk$1,
    Tcaron: Tcaron$1,
    tcaron: tcaron$1,
    Tcedil: Tcedil$1,
    tcedil: tcedil$1,
    Tcy: Tcy$1,
    tcy: tcy$1,
    tdot: tdot$1,
    telrec: telrec$1,
    Tfr: Tfr$1,
    tfr: tfr$1,
    there4: there4$1,
    therefore: therefore$1,
    Therefore: Therefore$1,
    Theta: Theta$1,
    theta: theta$1,
    thetasym: thetasym$1,
    thetav: thetav$1,
    thickapprox: thickapprox$1,
    thicksim: thicksim$1,
    ThickSpace: ThickSpace$1,
    ThinSpace: ThinSpace$1,
    thinsp: thinsp$1,
    thkap: thkap$1,
    thksim: thksim$1,
    THORN: THORN$3,
    thorn: thorn$3,
    tilde: tilde$1,
    Tilde: Tilde$1,
    TildeEqual: TildeEqual$1,
    TildeFullEqual: TildeFullEqual$1,
    TildeTilde: TildeTilde$1,
    timesbar: timesbar$1,
    timesb: timesb$1,
    times: times$3,
    timesd: timesd$1,
    tint: tint$1,
    toea: toea$1,
    topbot: topbot$1,
    topcir: topcir$1,
    top: top$1,
    Topf: Topf$1,
    topf: topf$1,
    topfork: topfork$1,
    tosa: tosa$1,
    tprime: tprime$1,
    trade: trade$1,
    TRADE: TRADE$1,
    triangle: triangle$1,
    triangledown: triangledown$1,
    triangleleft: triangleleft$1,
    trianglelefteq: trianglelefteq$1,
    triangleq: triangleq$1,
    triangleright: triangleright$1,
    trianglerighteq: trianglerighteq$1,
    tridot: tridot$1,
    trie: trie$1,
    triminus: triminus$1,
    TripleDot: TripleDot$1,
    triplus: triplus$1,
    trisb: trisb$1,
    tritime: tritime$1,
    trpezium: trpezium$1,
    Tscr: Tscr$1,
    tscr: tscr$1,
    TScy: TScy$1,
    tscy: tscy$1,
    TSHcy: TSHcy$1,
    tshcy: tshcy$1,
    Tstrok: Tstrok$1,
    tstrok: tstrok$1,
    twixt: twixt$1,
    twoheadleftarrow: twoheadleftarrow$1,
    twoheadrightarrow: twoheadrightarrow$1,
    Uacute: Uacute$3,
    uacute: uacute$3,
    uarr: uarr$1,
    Uarr: Uarr$1,
    uArr: uArr$1,
    Uarrocir: Uarrocir$1,
    Ubrcy: Ubrcy$1,
    ubrcy: ubrcy$1,
    Ubreve: Ubreve$1,
    ubreve: ubreve$1,
    Ucirc: Ucirc$3,
    ucirc: ucirc$3,
    Ucy: Ucy$1,
    ucy: ucy$1,
    udarr: udarr$1,
    Udblac: Udblac$1,
    udblac: udblac$1,
    udhar: udhar$1,
    ufisht: ufisht$1,
    Ufr: Ufr$1,
    ufr: ufr$1,
    Ugrave: Ugrave$3,
    ugrave: ugrave$3,
    uHar: uHar$1,
    uharl: uharl$1,
    uharr: uharr$1,
    uhblk: uhblk$1,
    ulcorn: ulcorn$1,
    ulcorner: ulcorner$1,
    ulcrop: ulcrop$1,
    ultri: ultri$1,
    Umacr: Umacr$1,
    umacr: umacr$1,
    uml: uml$3,
    UnderBar: UnderBar$1,
    UnderBrace: UnderBrace$1,
    UnderBracket: UnderBracket$1,
    UnderParenthesis: UnderParenthesis$1,
    Union: Union$1,
    UnionPlus: UnionPlus$1,
    Uogon: Uogon$1,
    uogon: uogon$1,
    Uopf: Uopf$1,
    uopf: uopf$1,
    UpArrowBar: UpArrowBar$1,
    uparrow: uparrow$1,
    UpArrow: UpArrow$1,
    Uparrow: Uparrow$1,
    UpArrowDownArrow: UpArrowDownArrow$1,
    updownarrow: updownarrow$1,
    UpDownArrow: UpDownArrow$1,
    Updownarrow: Updownarrow$1,
    UpEquilibrium: UpEquilibrium$1,
    upharpoonleft: upharpoonleft$1,
    upharpoonright: upharpoonright$1,
    uplus: uplus$1,
    UpperLeftArrow: UpperLeftArrow$1,
    UpperRightArrow: UpperRightArrow$1,
    upsi: upsi$1,
    Upsi: Upsi$1,
    upsih: upsih$1,
    Upsilon: Upsilon$1,
    upsilon: upsilon$1,
    UpTeeArrow: UpTeeArrow$1,
    UpTee: UpTee$1,
    upuparrows: upuparrows$1,
    urcorn: urcorn$1,
    urcorner: urcorner$1,
    urcrop: urcrop$1,
    Uring: Uring$1,
    uring: uring$1,
    urtri: urtri$1,
    Uscr: Uscr$1,
    uscr: uscr$1,
    utdot: utdot$1,
    Utilde: Utilde$1,
    utilde: utilde$1,
    utri: utri$1,
    utrif: utrif$1,
    uuarr: uuarr$1,
    Uuml: Uuml$3,
    uuml: uuml$3,
    uwangle: uwangle$1,
    vangrt: vangrt$1,
    varepsilon: varepsilon$1,
    varkappa: varkappa$1,
    varnothing: varnothing$1,
    varphi: varphi$1,
    varpi: varpi$1,
    varpropto: varpropto$1,
    varr: varr$1,
    vArr: vArr$1,
    varrho: varrho$1,
    varsigma: varsigma$1,
    varsubsetneq: varsubsetneq$1,
    varsubsetneqq: varsubsetneqq$1,
    varsupsetneq: varsupsetneq$1,
    varsupsetneqq: varsupsetneqq$1,
    vartheta: vartheta$1,
    vartriangleleft: vartriangleleft$1,
    vartriangleright: vartriangleright$1,
    vBar: vBar$1,
    Vbar: Vbar$1,
    vBarv: vBarv$1,
    Vcy: Vcy$1,
    vcy: vcy$1,
    vdash: vdash$1,
    vDash: vDash$1,
    Vdash: Vdash$1,
    VDash: VDash$1,
    Vdashl: Vdashl$1,
    veebar: veebar$1,
    vee: vee$1,
    Vee: Vee$1,
    veeeq: veeeq$1,
    vellip: vellip$1,
    verbar: verbar$1,
    Verbar: Verbar$1,
    vert: vert$1,
    Vert: Vert$1,
    VerticalBar: VerticalBar$1,
    VerticalLine: VerticalLine$1,
    VerticalSeparator: VerticalSeparator$1,
    VerticalTilde: VerticalTilde$1,
    VeryThinSpace: VeryThinSpace$1,
    Vfr: Vfr$1,
    vfr: vfr$1,
    vltri: vltri$1,
    vnsub: vnsub$1,
    vnsup: vnsup$1,
    Vopf: Vopf$1,
    vopf: vopf$1,
    vprop: vprop$1,
    vrtri: vrtri$1,
    Vscr: Vscr$1,
    vscr: vscr$1,
    vsubnE: vsubnE$1,
    vsubne: vsubne$1,
    vsupnE: vsupnE$1,
    vsupne: vsupne$1,
    Vvdash: Vvdash$1,
    vzigzag: vzigzag$1,
    Wcirc: Wcirc$1,
    wcirc: wcirc$1,
    wedbar: wedbar$1,
    wedge: wedge$1,
    Wedge: Wedge$1,
    wedgeq: wedgeq$1,
    weierp: weierp$1,
    Wfr: Wfr$1,
    wfr: wfr$1,
    Wopf: Wopf$1,
    wopf: wopf$1,
    wp: wp$1,
    wr: wr$1,
    wreath: wreath$1,
    Wscr: Wscr$1,
    wscr: wscr$1,
    xcap: xcap$1,
    xcirc: xcirc$1,
    xcup: xcup$1,
    xdtri: xdtri$1,
    Xfr: Xfr$1,
    xfr: xfr$1,
    xharr: xharr$1,
    xhArr: xhArr$1,
    Xi: Xi$1,
    xi: xi$1,
    xlarr: xlarr$1,
    xlArr: xlArr$1,
    xmap: xmap$1,
    xnis: xnis$1,
    xodot: xodot$1,
    Xopf: Xopf$1,
    xopf: xopf$1,
    xoplus: xoplus$1,
    xotime: xotime$1,
    xrarr: xrarr$1,
    xrArr: xrArr$1,
    Xscr: Xscr$1,
    xscr: xscr$1,
    xsqcup: xsqcup$1,
    xuplus: xuplus$1,
    xutri: xutri$1,
    xvee: xvee$1,
    xwedge: xwedge$1,
    Yacute: Yacute$3,
    yacute: yacute$3,
    YAcy: YAcy$1,
    yacy: yacy$1,
    Ycirc: Ycirc$1,
    ycirc: ycirc$1,
    Ycy: Ycy$1,
    ycy: ycy$1,
    yen: yen$3,
    Yfr: Yfr$1,
    yfr: yfr$1,
    YIcy: YIcy$1,
    yicy: yicy$1,
    Yopf: Yopf$1,
    yopf: yopf$1,
    Yscr: Yscr$1,
    yscr: yscr$1,
    YUcy: YUcy$1,
    yucy: yucy$1,
    yuml: yuml$3,
    Yuml: Yuml$1,
    Zacute: Zacute$1,
    zacute: zacute$1,
    Zcaron: Zcaron$1,
    zcaron: zcaron$1,
    Zcy: Zcy$1,
    zcy: zcy$1,
    Zdot: Zdot$1,
    zdot: zdot$1,
    zeetrf: zeetrf$1,
    ZeroWidthSpace: ZeroWidthSpace$1,
    Zeta: Zeta$1,
    zeta: zeta$1,
    zfr: zfr$1,
    Zfr: Zfr$1,
    ZHcy: ZHcy$1,
    zhcy: zhcy$1,
    zigrarr: zigrarr$1,
    zopf: zopf$1,
    Zopf: Zopf$1,
    Zscr: Zscr$1,
    zscr: zscr$1,
    zwj: zwj$1,
    zwnj: zwnj$1
  };
  const Aacute$2 = "Á";
  const aacute$2 = "á";
  const Acirc$2 = "Â";
  const acirc$2 = "â";
  const acute$2 = "´";
  const AElig$2 = "Æ";
  const aelig$2 = "æ";
  const Agrave$2 = "À";
  const agrave$2 = "à";
  const amp$4 = "&";
  const AMP$2 = "&";
  const Aring$2 = "Å";
  const aring$2 = "å";
  const Atilde$2 = "Ã";
  const atilde$2 = "ã";
  const Auml$2 = "Ä";
  const auml$2 = "ä";
  const brvbar$2 = "¦";
  const Ccedil$2 = "Ç";
  const ccedil$2 = "ç";
  const cedil$2 = "¸";
  const cent$2 = "¢";
  const copy$2 = "©";
  const COPY$2 = "©";
  const curren$2 = "¤";
  const deg$2 = "°";
  const divide$2 = "÷";
  const Eacute$2 = "É";
  const eacute$2 = "é";
  const Ecirc$2 = "Ê";
  const ecirc$2 = "ê";
  const Egrave$2 = "È";
  const egrave$2 = "è";
  const ETH$2 = "Ð";
  const eth$2 = "ð";
  const Euml$2 = "Ë";
  const euml$2 = "ë";
  const frac12$2 = "½";
  const frac14$2 = "¼";
  const frac34$2 = "¾";
  const gt$4 = ">";
  const GT$2 = ">";
  const Iacute$2 = "Í";
  const iacute$2 = "í";
  const Icirc$2 = "Î";
  const icirc$2 = "î";
  const iexcl$2 = "¡";
  const Igrave$2 = "Ì";
  const igrave$2 = "ì";
  const iquest$2 = "¿";
  const Iuml$2 = "Ï";
  const iuml$2 = "ï";
  const laquo$2 = "«";
  const lt$4 = "<";
  const LT$2 = "<";
  const macr$2 = "¯";
  const micro$2 = "µ";
  const middot$2 = "·";
  const nbsp$2 = " ";
  const not$2 = "¬";
  const Ntilde$2 = "Ñ";
  const ntilde$2 = "ñ";
  const Oacute$2 = "Ó";
  const oacute$2 = "ó";
  const Ocirc$2 = "Ô";
  const ocirc$2 = "ô";
  const Ograve$2 = "Ò";
  const ograve$2 = "ò";
  const ordf$2 = "ª";
  const ordm$2 = "º";
  const Oslash$2 = "Ø";
  const oslash$2 = "ø";
  const Otilde$2 = "Õ";
  const otilde$2 = "õ";
  const Ouml$2 = "Ö";
  const ouml$2 = "ö";
  const para$2 = "¶";
  const plusmn$2 = "±";
  const pound$2 = "£";
  const quot$4 = '"';
  const QUOT$2 = '"';
  const raquo$2 = "»";
  const reg$2 = "®";
  const REG$2 = "®";
  const sect$2 = "§";
  const shy$2 = "­";
  const sup1$2 = "¹";
  const sup2$2 = "²";
  const sup3$2 = "³";
  const szlig$2 = "ß";
  const THORN$2 = "Þ";
  const thorn$2 = "þ";
  const times$2 = "×";
  const Uacute$2 = "Ú";
  const uacute$2 = "ú";
  const Ucirc$2 = "Û";
  const ucirc$2 = "û";
  const Ugrave$2 = "Ù";
  const ugrave$2 = "ù";
  const uml$2 = "¨";
  const Uuml$2 = "Ü";
  const uuml$2 = "ü";
  const Yacute$2 = "Ý";
  const yacute$2 = "ý";
  const yen$2 = "¥";
  const yuml$2 = "ÿ";
  const require$$2$1 = {
    Aacute: Aacute$2,
    aacute: aacute$2,
    Acirc: Acirc$2,
    acirc: acirc$2,
    acute: acute$2,
    AElig: AElig$2,
    aelig: aelig$2,
    Agrave: Agrave$2,
    agrave: agrave$2,
    amp: amp$4,
    AMP: AMP$2,
    Aring: Aring$2,
    aring: aring$2,
    Atilde: Atilde$2,
    atilde: atilde$2,
    Auml: Auml$2,
    auml: auml$2,
    brvbar: brvbar$2,
    Ccedil: Ccedil$2,
    ccedil: ccedil$2,
    cedil: cedil$2,
    cent: cent$2,
    copy: copy$2,
    COPY: COPY$2,
    curren: curren$2,
    deg: deg$2,
    divide: divide$2,
    Eacute: Eacute$2,
    eacute: eacute$2,
    Ecirc: Ecirc$2,
    ecirc: ecirc$2,
    Egrave: Egrave$2,
    egrave: egrave$2,
    ETH: ETH$2,
    eth: eth$2,
    Euml: Euml$2,
    euml: euml$2,
    frac12: frac12$2,
    frac14: frac14$2,
    frac34: frac34$2,
    gt: gt$4,
    GT: GT$2,
    Iacute: Iacute$2,
    iacute: iacute$2,
    Icirc: Icirc$2,
    icirc: icirc$2,
    iexcl: iexcl$2,
    Igrave: Igrave$2,
    igrave: igrave$2,
    iquest: iquest$2,
    Iuml: Iuml$2,
    iuml: iuml$2,
    laquo: laquo$2,
    lt: lt$4,
    LT: LT$2,
    macr: macr$2,
    micro: micro$2,
    middot: middot$2,
    nbsp: nbsp$2,
    not: not$2,
    Ntilde: Ntilde$2,
    ntilde: ntilde$2,
    Oacute: Oacute$2,
    oacute: oacute$2,
    Ocirc: Ocirc$2,
    ocirc: ocirc$2,
    Ograve: Ograve$2,
    ograve: ograve$2,
    ordf: ordf$2,
    ordm: ordm$2,
    Oslash: Oslash$2,
    oslash: oslash$2,
    Otilde: Otilde$2,
    otilde: otilde$2,
    Ouml: Ouml$2,
    ouml: ouml$2,
    para: para$2,
    plusmn: plusmn$2,
    pound: pound$2,
    quot: quot$4,
    QUOT: QUOT$2,
    raquo: raquo$2,
    reg: reg$2,
    REG: REG$2,
    sect: sect$2,
    shy: shy$2,
    sup1: sup1$2,
    sup2: sup2$2,
    sup3: sup3$2,
    szlig: szlig$2,
    THORN: THORN$2,
    thorn: thorn$2,
    times: times$2,
    Uacute: Uacute$2,
    uacute: uacute$2,
    Ucirc: Ucirc$2,
    ucirc: ucirc$2,
    Ugrave: Ugrave$2,
    ugrave: ugrave$2,
    uml: uml$2,
    Uuml: Uuml$2,
    uuml: uuml$2,
    Yacute: Yacute$2,
    yacute: yacute$2,
    yen: yen$2,
    yuml: yuml$2
  };
  const amp$3 = "&";
  const apos$2 = "'";
  const gt$3 = ">";
  const lt$3 = "<";
  const quot$3 = '"';
  const require$$3$1 = {
    amp: amp$3,
    apos: apos$2,
    gt: gt$3,
    lt: lt$3,
    quot: quot$3
  };
  var Tokenizer_1 = Tokenizer$1;
  var decodeCodePoint = decode_codepoint$1;
  var entityMap = require$$1$2;
  var legacyMap = require$$2$1;
  var xmlMap = require$$3$1;
  var i$1 = 0;
  var TEXT = i$1++;
  var BEFORE_TAG_NAME = i$1++;
  var IN_TAG_NAME = i$1++;
  var IN_SELF_CLOSING_TAG = i$1++;
  var BEFORE_CLOSING_TAG_NAME = i$1++;
  var IN_CLOSING_TAG_NAME = i$1++;
  var AFTER_CLOSING_TAG_NAME = i$1++;
  var BEFORE_ATTRIBUTE_NAME = i$1++;
  var IN_ATTRIBUTE_NAME = i$1++;
  var AFTER_ATTRIBUTE_NAME = i$1++;
  var BEFORE_ATTRIBUTE_VALUE = i$1++;
  var IN_ATTRIBUTE_VALUE_DQ = i$1++;
  var IN_ATTRIBUTE_VALUE_SQ = i$1++;
  var IN_ATTRIBUTE_VALUE_NQ = i$1++;
  var BEFORE_DECLARATION = i$1++;
  var IN_DECLARATION = i$1++;
  var IN_PROCESSING_INSTRUCTION = i$1++;
  var BEFORE_COMMENT = i$1++;
  var IN_COMMENT = i$1++;
  var AFTER_COMMENT_1 = i$1++;
  var AFTER_COMMENT_2 = i$1++;
  var BEFORE_CDATA_1 = i$1++;
  var BEFORE_CDATA_2 = i$1++;
  var BEFORE_CDATA_3 = i$1++;
  var BEFORE_CDATA_4 = i$1++;
  var BEFORE_CDATA_5 = i$1++;
  var BEFORE_CDATA_6 = i$1++;
  var IN_CDATA = i$1++;
  var AFTER_CDATA_1 = i$1++;
  var AFTER_CDATA_2 = i$1++;
  var BEFORE_SPECIAL = i$1++;
  var BEFORE_SPECIAL_END = i$1++;
  var BEFORE_SCRIPT_1 = i$1++;
  var BEFORE_SCRIPT_2 = i$1++;
  var BEFORE_SCRIPT_3 = i$1++;
  var BEFORE_SCRIPT_4 = i$1++;
  var BEFORE_SCRIPT_5 = i$1++;
  var AFTER_SCRIPT_1 = i$1++;
  var AFTER_SCRIPT_2 = i$1++;
  var AFTER_SCRIPT_3 = i$1++;
  var AFTER_SCRIPT_4 = i$1++;
  var AFTER_SCRIPT_5 = i$1++;
  var BEFORE_STYLE_1 = i$1++;
  var BEFORE_STYLE_2 = i$1++;
  var BEFORE_STYLE_3 = i$1++;
  var BEFORE_STYLE_4 = i$1++;
  var AFTER_STYLE_1 = i$1++;
  var AFTER_STYLE_2 = i$1++;
  var AFTER_STYLE_3 = i$1++;
  var AFTER_STYLE_4 = i$1++;
  var BEFORE_ENTITY = i$1++;
  var BEFORE_NUMERIC_ENTITY = i$1++;
  var IN_NAMED_ENTITY = i$1++;
  var IN_NUMERIC_ENTITY = i$1++;
  var IN_HEX_ENTITY = i$1++;
  var j = 0;
  var SPECIAL_NONE = j++;
  var SPECIAL_SCRIPT = j++;
  var SPECIAL_STYLE = j++;
  function whitespace(c2) {
    return c2 === " " || c2 === "\n" || c2 === "	" || c2 === "\f" || c2 === "\r";
  }
  function ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();
    if (upper === lower) {
      return function(c2) {
        if (c2 === lower) {
          this._state = SUCCESS;
        } else {
          this._state = FAILURE;
          this._index--;
        }
      };
    } else {
      return function(c2) {
        if (c2 === lower || c2 === upper) {
          this._state = SUCCESS;
        } else {
          this._state = FAILURE;
          this._index--;
        }
      };
    }
  }
  function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();
    return function(c2) {
      if (c2 === lower || c2 === upper) {
        this._state = NEXT_STATE;
      } else {
        this._state = IN_TAG_NAME;
        this._index--;
      }
    };
  }
  function Tokenizer$1(options, cbs) {
    this._state = TEXT;
    this._buffer = "";
    this._sectionStart = 0;
    this._index = 0;
    this._bufferOffset = 0;
    this._baseState = TEXT;
    this._special = SPECIAL_NONE;
    this._cbs = cbs;
    this._running = true;
    this._ended = false;
    this._xmlMode = !!(options && options.xmlMode);
    this._decodeEntities = !!(options && options.decodeEntities);
  }
  Tokenizer$1.prototype._stateText = function(c2) {
    if (c2 === "<") {
      if (this._index > this._sectionStart) {
        this._cbs.ontext(this._getSection());
      }
      this._state = BEFORE_TAG_NAME;
      this._sectionStart = this._index;
    } else if (this._decodeEntities && this._special === SPECIAL_NONE && c2 === "&") {
      if (this._index > this._sectionStart) {
        this._cbs.ontext(this._getSection());
      }
      this._baseState = TEXT;
      this._state = BEFORE_ENTITY;
      this._sectionStart = this._index;
    }
  };
  Tokenizer$1.prototype._stateBeforeTagName = function(c2) {
    if (c2 === "/") {
      this._state = BEFORE_CLOSING_TAG_NAME;
    } else if (c2 === "<") {
      this._cbs.ontext(this._getSection());
      this._sectionStart = this._index;
    } else if (c2 === ">" || this._special !== SPECIAL_NONE || whitespace(c2)) {
      this._state = TEXT;
    } else if (c2 === "!") {
      this._state = BEFORE_DECLARATION;
      this._sectionStart = this._index + 1;
    } else if (c2 === "?") {
      this._state = IN_PROCESSING_INSTRUCTION;
      this._sectionStart = this._index + 1;
    } else {
      this._state = !this._xmlMode && (c2 === "s" || c2 === "S") ? BEFORE_SPECIAL : IN_TAG_NAME;
      this._sectionStart = this._index;
    }
  };
  Tokenizer$1.prototype._stateInTagName = function(c2) {
    if (c2 === "/" || c2 === ">" || whitespace(c2)) {
      this._emitToken("onopentagname");
      this._state = BEFORE_ATTRIBUTE_NAME;
      this._index--;
    }
  };
  Tokenizer$1.prototype._stateBeforeCloseingTagName = function(c2) {
    if (whitespace(c2))
      ;
    else if (c2 === ">") {
      this._state = TEXT;
    } else if (this._special !== SPECIAL_NONE) {
      if (c2 === "s" || c2 === "S") {
        this._state = BEFORE_SPECIAL_END;
      } else {
        this._state = TEXT;
        this._index--;
      }
    } else {
      this._state = IN_CLOSING_TAG_NAME;
      this._sectionStart = this._index;
    }
  };
  Tokenizer$1.prototype._stateInCloseingTagName = function(c2) {
    if (c2 === ">" || whitespace(c2)) {
      this._emitToken("onclosetag");
      this._state = AFTER_CLOSING_TAG_NAME;
      this._index--;
    }
  };
  Tokenizer$1.prototype._stateAfterCloseingTagName = function(c2) {
    if (c2 === ">") {
      this._state = TEXT;
      this._sectionStart = this._index + 1;
    }
  };
  Tokenizer$1.prototype._stateBeforeAttributeName = function(c2) {
    if (c2 === ">") {
      this._cbs.onopentagend();
      this._state = TEXT;
      this._sectionStart = this._index + 1;
    } else if (c2 === "/") {
      this._state = IN_SELF_CLOSING_TAG;
    } else if (!whitespace(c2)) {
      this._state = IN_ATTRIBUTE_NAME;
      this._sectionStart = this._index;
    }
  };
  Tokenizer$1.prototype._stateInSelfClosingTag = function(c2) {
    if (c2 === ">") {
      this._cbs.onselfclosingtag();
      this._state = TEXT;
      this._sectionStart = this._index + 1;
    } else if (!whitespace(c2)) {
      this._state = BEFORE_ATTRIBUTE_NAME;
      this._index--;
    }
  };
  Tokenizer$1.prototype._stateInAttributeName = function(c2) {
    if (c2 === "=" || c2 === "/" || c2 === ">" || whitespace(c2)) {
      this._cbs.onattribname(this._getSection());
      this._sectionStart = -1;
      this._state = AFTER_ATTRIBUTE_NAME;
      this._index--;
    }
  };
  Tokenizer$1.prototype._stateAfterAttributeName = function(c2) {
    if (c2 === "=") {
      this._state = BEFORE_ATTRIBUTE_VALUE;
    } else if (c2 === "/" || c2 === ">") {
      this._cbs.onattribend();
      this._state = BEFORE_ATTRIBUTE_NAME;
      this._index--;
    } else if (!whitespace(c2)) {
      this._cbs.onattribend();
      this._state = IN_ATTRIBUTE_NAME;
      this._sectionStart = this._index;
    }
  };
  Tokenizer$1.prototype._stateBeforeAttributeValue = function(c2) {
    if (c2 === '"') {
      this._state = IN_ATTRIBUTE_VALUE_DQ;
      this._sectionStart = this._index + 1;
    } else if (c2 === "'") {
      this._state = IN_ATTRIBUTE_VALUE_SQ;
      this._sectionStart = this._index + 1;
    } else if (!whitespace(c2)) {
      this._state = IN_ATTRIBUTE_VALUE_NQ;
      this._sectionStart = this._index;
      this._index--;
    }
  };
  Tokenizer$1.prototype._stateInAttributeValueDoubleQuotes = function(c2) {
    if (c2 === '"') {
      this._emitToken("onattribdata");
      this._cbs.onattribend();
      this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c2 === "&") {
      this._emitToken("onattribdata");
      this._baseState = this._state;
      this._state = BEFORE_ENTITY;
      this._sectionStart = this._index;
    }
  };
  Tokenizer$1.prototype._stateInAttributeValueSingleQuotes = function(c2) {
    if (c2 === "'") {
      this._emitToken("onattribdata");
      this._cbs.onattribend();
      this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c2 === "&") {
      this._emitToken("onattribdata");
      this._baseState = this._state;
      this._state = BEFORE_ENTITY;
      this._sectionStart = this._index;
    }
  };
  Tokenizer$1.prototype._stateInAttributeValueNoQuotes = function(c2) {
    if (whitespace(c2) || c2 === ">") {
      this._emitToken("onattribdata");
      this._cbs.onattribend();
      this._state = BEFORE_ATTRIBUTE_NAME;
      this._index--;
    } else if (this._decodeEntities && c2 === "&") {
      this._emitToken("onattribdata");
      this._baseState = this._state;
      this._state = BEFORE_ENTITY;
      this._sectionStart = this._index;
    }
  };
  Tokenizer$1.prototype._stateBeforeDeclaration = function(c2) {
    this._state = c2 === "[" ? BEFORE_CDATA_1 : c2 === "-" ? BEFORE_COMMENT : IN_DECLARATION;
  };
  Tokenizer$1.prototype._stateInDeclaration = function(c2) {
    if (c2 === ">") {
      this._cbs.ondeclaration(this._getSection());
      this._state = TEXT;
      this._sectionStart = this._index + 1;
    }
  };
  Tokenizer$1.prototype._stateInProcessingInstruction = function(c2) {
    if (c2 === ">") {
      this._cbs.onprocessinginstruction(this._getSection());
      this._state = TEXT;
      this._sectionStart = this._index + 1;
    }
  };
  Tokenizer$1.prototype._stateBeforeComment = function(c2) {
    if (c2 === "-") {
      this._state = IN_COMMENT;
      this._sectionStart = this._index + 1;
    } else {
      this._state = IN_DECLARATION;
    }
  };
  Tokenizer$1.prototype._stateInComment = function(c2) {
    if (c2 === "-")
      this._state = AFTER_COMMENT_1;
  };
  Tokenizer$1.prototype._stateAfterComment1 = function(c2) {
    if (c2 === "-") {
      this._state = AFTER_COMMENT_2;
    } else {
      this._state = IN_COMMENT;
    }
  };
  Tokenizer$1.prototype._stateAfterComment2 = function(c2) {
    if (c2 === ">") {
      this._cbs.oncomment(
        this._buffer.substring(this._sectionStart, this._index - 2)
      );
      this._state = TEXT;
      this._sectionStart = this._index + 1;
    } else if (c2 !== "-") {
      this._state = IN_COMMENT;
    }
  };
  Tokenizer$1.prototype._stateBeforeCdata1 = ifElseState(
    "C",
    BEFORE_CDATA_2,
    IN_DECLARATION
  );
  Tokenizer$1.prototype._stateBeforeCdata2 = ifElseState(
    "D",
    BEFORE_CDATA_3,
    IN_DECLARATION
  );
  Tokenizer$1.prototype._stateBeforeCdata3 = ifElseState(
    "A",
    BEFORE_CDATA_4,
    IN_DECLARATION
  );
  Tokenizer$1.prototype._stateBeforeCdata4 = ifElseState(
    "T",
    BEFORE_CDATA_5,
    IN_DECLARATION
  );
  Tokenizer$1.prototype._stateBeforeCdata5 = ifElseState(
    "A",
    BEFORE_CDATA_6,
    IN_DECLARATION
  );
  Tokenizer$1.prototype._stateBeforeCdata6 = function(c2) {
    if (c2 === "[") {
      this._state = IN_CDATA;
      this._sectionStart = this._index + 1;
    } else {
      this._state = IN_DECLARATION;
      this._index--;
    }
  };
  Tokenizer$1.prototype._stateInCdata = function(c2) {
    if (c2 === "]")
      this._state = AFTER_CDATA_1;
  };
  Tokenizer$1.prototype._stateAfterCdata1 = function(c2) {
    if (c2 === "]")
      this._state = AFTER_CDATA_2;
    else
      this._state = IN_CDATA;
  };
  Tokenizer$1.prototype._stateAfterCdata2 = function(c2) {
    if (c2 === ">") {
      this._cbs.oncdata(
        this._buffer.substring(this._sectionStart, this._index - 2)
      );
      this._state = TEXT;
      this._sectionStart = this._index + 1;
    } else if (c2 !== "]") {
      this._state = IN_CDATA;
    }
  };
  Tokenizer$1.prototype._stateBeforeSpecial = function(c2) {
    if (c2 === "c" || c2 === "C") {
      this._state = BEFORE_SCRIPT_1;
    } else if (c2 === "t" || c2 === "T") {
      this._state = BEFORE_STYLE_1;
    } else {
      this._state = IN_TAG_NAME;
      this._index--;
    }
  };
  Tokenizer$1.prototype._stateBeforeSpecialEnd = function(c2) {
    if (this._special === SPECIAL_SCRIPT && (c2 === "c" || c2 === "C")) {
      this._state = AFTER_SCRIPT_1;
    } else if (this._special === SPECIAL_STYLE && (c2 === "t" || c2 === "T")) {
      this._state = AFTER_STYLE_1;
    } else
      this._state = TEXT;
  };
  Tokenizer$1.prototype._stateBeforeScript1 = consumeSpecialNameChar(
    "R",
    BEFORE_SCRIPT_2
  );
  Tokenizer$1.prototype._stateBeforeScript2 = consumeSpecialNameChar(
    "I",
    BEFORE_SCRIPT_3
  );
  Tokenizer$1.prototype._stateBeforeScript3 = consumeSpecialNameChar(
    "P",
    BEFORE_SCRIPT_4
  );
  Tokenizer$1.prototype._stateBeforeScript4 = consumeSpecialNameChar(
    "T",
    BEFORE_SCRIPT_5
  );
  Tokenizer$1.prototype._stateBeforeScript5 = function(c2) {
    if (c2 === "/" || c2 === ">" || whitespace(c2)) {
      this._special = SPECIAL_SCRIPT;
    }
    this._state = IN_TAG_NAME;
    this._index--;
  };
  Tokenizer$1.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
  Tokenizer$1.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
  Tokenizer$1.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
  Tokenizer$1.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
  Tokenizer$1.prototype._stateAfterScript5 = function(c2) {
    if (c2 === ">" || whitespace(c2)) {
      this._special = SPECIAL_NONE;
      this._state = IN_CLOSING_TAG_NAME;
      this._sectionStart = this._index - 6;
      this._index--;
    } else
      this._state = TEXT;
  };
  Tokenizer$1.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
    "Y",
    BEFORE_STYLE_2
  );
  Tokenizer$1.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
    "L",
    BEFORE_STYLE_3
  );
  Tokenizer$1.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
    "E",
    BEFORE_STYLE_4
  );
  Tokenizer$1.prototype._stateBeforeStyle4 = function(c2) {
    if (c2 === "/" || c2 === ">" || whitespace(c2)) {
      this._special = SPECIAL_STYLE;
    }
    this._state = IN_TAG_NAME;
    this._index--;
  };
  Tokenizer$1.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
  Tokenizer$1.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
  Tokenizer$1.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
  Tokenizer$1.prototype._stateAfterStyle4 = function(c2) {
    if (c2 === ">" || whitespace(c2)) {
      this._special = SPECIAL_NONE;
      this._state = IN_CLOSING_TAG_NAME;
      this._sectionStart = this._index - 5;
      this._index--;
    } else
      this._state = TEXT;
  };
  Tokenizer$1.prototype._stateBeforeEntity = ifElseState(
    "#",
    BEFORE_NUMERIC_ENTITY,
    IN_NAMED_ENTITY
  );
  Tokenizer$1.prototype._stateBeforeNumericEntity = ifElseState(
    "X",
    IN_HEX_ENTITY,
    IN_NUMERIC_ENTITY
  );
  Tokenizer$1.prototype._parseNamedEntityStrict = function() {
    if (this._sectionStart + 1 < this._index) {
      var entity = this._buffer.substring(
        this._sectionStart + 1,
        this._index
      ), map2 = this._xmlMode ? xmlMap : entityMap;
      if (map2.hasOwnProperty(entity)) {
        this._emitPartial(map2[entity]);
        this._sectionStart = this._index + 1;
      }
    }
  };
  Tokenizer$1.prototype._parseLegacyEntity = function() {
    var start = this._sectionStart + 1, limit = this._index - start;
    if (limit > 6)
      limit = 6;
    while (limit >= 2) {
      var entity = this._buffer.substr(start, limit);
      if (legacyMap.hasOwnProperty(entity)) {
        this._emitPartial(legacyMap[entity]);
        this._sectionStart += limit + 1;
        return;
      } else {
        limit--;
      }
    }
  };
  Tokenizer$1.prototype._stateInNamedEntity = function(c2) {
    if (c2 === ";") {
      this._parseNamedEntityStrict();
      if (this._sectionStart + 1 < this._index && !this._xmlMode) {
        this._parseLegacyEntity();
      }
      this._state = this._baseState;
    } else if ((c2 < "a" || c2 > "z") && (c2 < "A" || c2 > "Z") && (c2 < "0" || c2 > "9")) {
      if (this._xmlMode)
        ;
      else if (this._sectionStart + 1 === this._index)
        ;
      else if (this._baseState !== TEXT) {
        if (c2 !== "=") {
          this._parseNamedEntityStrict();
        }
      } else {
        this._parseLegacyEntity();
      }
      this._state = this._baseState;
      this._index--;
    }
  };
  Tokenizer$1.prototype._decodeNumericEntity = function(offset, base) {
    var sectionStart = this._sectionStart + offset;
    if (sectionStart !== this._index) {
      var entity = this._buffer.substring(sectionStart, this._index);
      var parsed = parseInt(entity, base);
      this._emitPartial(decodeCodePoint(parsed));
      this._sectionStart = this._index;
    } else {
      this._sectionStart--;
    }
    this._state = this._baseState;
  };
  Tokenizer$1.prototype._stateInNumericEntity = function(c2) {
    if (c2 === ";") {
      this._decodeNumericEntity(2, 10);
      this._sectionStart++;
    } else if (c2 < "0" || c2 > "9") {
      if (!this._xmlMode) {
        this._decodeNumericEntity(2, 10);
      } else {
        this._state = this._baseState;
      }
      this._index--;
    }
  };
  Tokenizer$1.prototype._stateInHexEntity = function(c2) {
    if (c2 === ";") {
      this._decodeNumericEntity(3, 16);
      this._sectionStart++;
    } else if ((c2 < "a" || c2 > "f") && (c2 < "A" || c2 > "F") && (c2 < "0" || c2 > "9")) {
      if (!this._xmlMode) {
        this._decodeNumericEntity(3, 16);
      } else {
        this._state = this._baseState;
      }
      this._index--;
    }
  };
  Tokenizer$1.prototype._cleanup = function() {
    if (this._sectionStart < 0) {
      this._buffer = "";
      this._bufferOffset += this._index;
      this._index = 0;
    } else if (this._running) {
      if (this._state === TEXT) {
        if (this._sectionStart !== this._index) {
          this._cbs.ontext(this._buffer.substr(this._sectionStart));
        }
        this._buffer = "";
        this._bufferOffset += this._index;
        this._index = 0;
      } else if (this._sectionStart === this._index) {
        this._buffer = "";
        this._bufferOffset += this._index;
        this._index = 0;
      } else {
        this._buffer = this._buffer.substr(this._sectionStart);
        this._index -= this._sectionStart;
        this._bufferOffset += this._sectionStart;
      }
      this._sectionStart = 0;
    }
  };
  Tokenizer$1.prototype.write = function(chunk) {
    if (this._ended)
      this._cbs.onerror(Error(".write() after done!"));
    this._buffer += chunk;
    this._parse();
  };
  Tokenizer$1.prototype._parse = function() {
    while (this._index < this._buffer.length && this._running) {
      var c2 = this._buffer.charAt(this._index);
      if (this._state === TEXT) {
        this._stateText(c2);
      } else if (this._state === BEFORE_TAG_NAME) {
        this._stateBeforeTagName(c2);
      } else if (this._state === IN_TAG_NAME) {
        this._stateInTagName(c2);
      } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
        this._stateBeforeCloseingTagName(c2);
      } else if (this._state === IN_CLOSING_TAG_NAME) {
        this._stateInCloseingTagName(c2);
      } else if (this._state === AFTER_CLOSING_TAG_NAME) {
        this._stateAfterCloseingTagName(c2);
      } else if (this._state === IN_SELF_CLOSING_TAG) {
        this._stateInSelfClosingTag(c2);
      } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
        this._stateBeforeAttributeName(c2);
      } else if (this._state === IN_ATTRIBUTE_NAME) {
        this._stateInAttributeName(c2);
      } else if (this._state === AFTER_ATTRIBUTE_NAME) {
        this._stateAfterAttributeName(c2);
      } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
        this._stateBeforeAttributeValue(c2);
      } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
        this._stateInAttributeValueDoubleQuotes(c2);
      } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
        this._stateInAttributeValueSingleQuotes(c2);
      } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
        this._stateInAttributeValueNoQuotes(c2);
      } else if (this._state === BEFORE_DECLARATION) {
        this._stateBeforeDeclaration(c2);
      } else if (this._state === IN_DECLARATION) {
        this._stateInDeclaration(c2);
      } else if (this._state === IN_PROCESSING_INSTRUCTION) {
        this._stateInProcessingInstruction(c2);
      } else if (this._state === BEFORE_COMMENT) {
        this._stateBeforeComment(c2);
      } else if (this._state === IN_COMMENT) {
        this._stateInComment(c2);
      } else if (this._state === AFTER_COMMENT_1) {
        this._stateAfterComment1(c2);
      } else if (this._state === AFTER_COMMENT_2) {
        this._stateAfterComment2(c2);
      } else if (this._state === BEFORE_CDATA_1) {
        this._stateBeforeCdata1(c2);
      } else if (this._state === BEFORE_CDATA_2) {
        this._stateBeforeCdata2(c2);
      } else if (this._state === BEFORE_CDATA_3) {
        this._stateBeforeCdata3(c2);
      } else if (this._state === BEFORE_CDATA_4) {
        this._stateBeforeCdata4(c2);
      } else if (this._state === BEFORE_CDATA_5) {
        this._stateBeforeCdata5(c2);
      } else if (this._state === BEFORE_CDATA_6) {
        this._stateBeforeCdata6(c2);
      } else if (this._state === IN_CDATA) {
        this._stateInCdata(c2);
      } else if (this._state === AFTER_CDATA_1) {
        this._stateAfterCdata1(c2);
      } else if (this._state === AFTER_CDATA_2) {
        this._stateAfterCdata2(c2);
      } else if (this._state === BEFORE_SPECIAL) {
        this._stateBeforeSpecial(c2);
      } else if (this._state === BEFORE_SPECIAL_END) {
        this._stateBeforeSpecialEnd(c2);
      } else if (this._state === BEFORE_SCRIPT_1) {
        this._stateBeforeScript1(c2);
      } else if (this._state === BEFORE_SCRIPT_2) {
        this._stateBeforeScript2(c2);
      } else if (this._state === BEFORE_SCRIPT_3) {
        this._stateBeforeScript3(c2);
      } else if (this._state === BEFORE_SCRIPT_4) {
        this._stateBeforeScript4(c2);
      } else if (this._state === BEFORE_SCRIPT_5) {
        this._stateBeforeScript5(c2);
      } else if (this._state === AFTER_SCRIPT_1) {
        this._stateAfterScript1(c2);
      } else if (this._state === AFTER_SCRIPT_2) {
        this._stateAfterScript2(c2);
      } else if (this._state === AFTER_SCRIPT_3) {
        this._stateAfterScript3(c2);
      } else if (this._state === AFTER_SCRIPT_4) {
        this._stateAfterScript4(c2);
      } else if (this._state === AFTER_SCRIPT_5) {
        this._stateAfterScript5(c2);
      } else if (this._state === BEFORE_STYLE_1) {
        this._stateBeforeStyle1(c2);
      } else if (this._state === BEFORE_STYLE_2) {
        this._stateBeforeStyle2(c2);
      } else if (this._state === BEFORE_STYLE_3) {
        this._stateBeforeStyle3(c2);
      } else if (this._state === BEFORE_STYLE_4) {
        this._stateBeforeStyle4(c2);
      } else if (this._state === AFTER_STYLE_1) {
        this._stateAfterStyle1(c2);
      } else if (this._state === AFTER_STYLE_2) {
        this._stateAfterStyle2(c2);
      } else if (this._state === AFTER_STYLE_3) {
        this._stateAfterStyle3(c2);
      } else if (this._state === AFTER_STYLE_4) {
        this._stateAfterStyle4(c2);
      } else if (this._state === BEFORE_ENTITY) {
        this._stateBeforeEntity(c2);
      } else if (this._state === BEFORE_NUMERIC_ENTITY) {
        this._stateBeforeNumericEntity(c2);
      } else if (this._state === IN_NAMED_ENTITY) {
        this._stateInNamedEntity(c2);
      } else if (this._state === IN_NUMERIC_ENTITY) {
        this._stateInNumericEntity(c2);
      } else if (this._state === IN_HEX_ENTITY) {
        this._stateInHexEntity(c2);
      } else {
        this._cbs.onerror(Error("unknown _state"), this._state);
      }
      this._index++;
    }
    this._cleanup();
  };
  Tokenizer$1.prototype.pause = function() {
    this._running = false;
  };
  Tokenizer$1.prototype.resume = function() {
    this._running = true;
    if (this._index < this._buffer.length) {
      this._parse();
    }
    if (this._ended) {
      this._finish();
    }
  };
  Tokenizer$1.prototype.end = function(chunk) {
    if (this._ended)
      this._cbs.onerror(Error(".end() after done!"));
    if (chunk)
      this.write(chunk);
    this._ended = true;
    if (this._running)
      this._finish();
  };
  Tokenizer$1.prototype._finish = function() {
    if (this._sectionStart < this._index) {
      this._handleTrailingData();
    }
    this._cbs.onend();
  };
  Tokenizer$1.prototype._handleTrailingData = function() {
    var data = this._buffer.substr(this._sectionStart);
    if (this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2) {
      this._cbs.oncdata(data);
    } else if (this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2) {
      this._cbs.oncomment(data);
    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
      this._parseLegacyEntity();
      if (this._sectionStart < this._index) {
        this._state = this._baseState;
        this._handleTrailingData();
      }
    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
      this._decodeNumericEntity(2, 10);
      if (this._sectionStart < this._index) {
        this._state = this._baseState;
        this._handleTrailingData();
      }
    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
      this._decodeNumericEntity(3, 16);
      if (this._sectionStart < this._index) {
        this._state = this._baseState;
        this._handleTrailingData();
      }
    } else if (this._state !== IN_TAG_NAME && this._state !== BEFORE_ATTRIBUTE_NAME && this._state !== BEFORE_ATTRIBUTE_VALUE && this._state !== AFTER_ATTRIBUTE_NAME && this._state !== IN_ATTRIBUTE_NAME && this._state !== IN_ATTRIBUTE_VALUE_SQ && this._state !== IN_ATTRIBUTE_VALUE_DQ && this._state !== IN_ATTRIBUTE_VALUE_NQ && this._state !== IN_CLOSING_TAG_NAME) {
      this._cbs.ontext(data);
    }
  };
  Tokenizer$1.prototype.reset = function() {
    Tokenizer$1.call(
      this,
      { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
      this._cbs
    );
  };
  Tokenizer$1.prototype.getAbsoluteIndex = function() {
    return this._bufferOffset + this._index;
  };
  Tokenizer$1.prototype._getSection = function() {
    return this._buffer.substring(this._sectionStart, this._index);
  };
  Tokenizer$1.prototype._emitToken = function(name) {
    this._cbs[name](this._getSection());
    this._sectionStart = -1;
  };
  Tokenizer$1.prototype._emitPartial = function(value) {
    if (this._baseState !== TEXT) {
      this._cbs.onattribdata(value);
    } else {
      this._cbs.ontext(value);
    }
  };
  var inherits_browserExports = {};
  var inherits_browser = {
    get exports() {
      return inherits_browserExports;
    },
    set exports(v2) {
      inherits_browserExports = v2;
    }
  };
  if (typeof Object.create === "function") {
    inherits_browser.exports = function inherits2(ctor, superCtor) {
      if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
          constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
      }
    };
  } else {
    inherits_browser.exports = function inherits2(ctor, superCtor) {
      if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {
        };
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      }
    };
  }
  const __viteBrowserExternal = {};
  const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: __viteBrowserExternal
  }, Symbol.toStringTag, { value: "Module" }));
  const require$$3 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
  var Tokenizer = Tokenizer_1;
  var formTags = {
    input: true,
    option: true,
    optgroup: true,
    select: true,
    button: true,
    datalist: true,
    textarea: true
  };
  var openImpliesClose = {
    tr: { tr: true, th: true, td: true },
    th: { th: true },
    td: { thead: true, th: true, td: true },
    body: { head: true, link: true, script: true },
    li: { li: true },
    p: { p: true },
    h1: { p: true },
    h2: { p: true },
    h3: { p: true },
    h4: { p: true },
    h5: { p: true },
    h6: { p: true },
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: { option: true },
    optgroup: { optgroup: true }
  };
  var voidElements = {
    __proto__: null,
    area: true,
    base: true,
    basefont: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    isindex: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
  };
  var foreignContextElements = {
    __proto__: null,
    math: true,
    svg: true
  };
  var htmlIntegrationElements = {
    __proto__: null,
    mi: true,
    mo: true,
    mn: true,
    ms: true,
    mtext: true,
    "annotation-xml": true,
    foreignObject: true,
    desc: true,
    title: true
  };
  var re_nameEnd = /\s|\//;
  function Parser(cbs, options) {
    this._options = options || {};
    this._cbs = cbs || {};
    this._tagname = "";
    this._attribname = "";
    this._attribvalue = "";
    this._attribs = null;
    this._stack = [];
    this._foreignContext = [];
    this.startIndex = 0;
    this.endIndex = null;
    this._lowerCaseTagNames = "lowerCaseTags" in this._options ? !!this._options.lowerCaseTags : !this._options.xmlMode;
    this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ? !!this._options.lowerCaseAttributeNames : !this._options.xmlMode;
    if (this._options.Tokenizer) {
      Tokenizer = this._options.Tokenizer;
    }
    this._tokenizer = new Tokenizer(this._options, this);
    if (this._cbs.onparserinit)
      this._cbs.onparserinit(this);
  }
  inherits_browserExports(Parser, require$$3.EventEmitter);
  Parser.prototype._updatePosition = function(initialOffset) {
    if (this.endIndex === null) {
      if (this._tokenizer._sectionStart <= initialOffset) {
        this.startIndex = 0;
      } else {
        this.startIndex = this._tokenizer._sectionStart - initialOffset;
      }
    } else
      this.startIndex = this.endIndex + 1;
    this.endIndex = this._tokenizer.getAbsoluteIndex();
  };
  Parser.prototype.ontext = function(data) {
    this._updatePosition(1);
    this.endIndex--;
    if (this._cbs.ontext)
      this._cbs.ontext(data);
  };
  Parser.prototype.onopentagname = function(name) {
    if (this._lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    this._tagname = name;
    if (!this._options.xmlMode && name in openImpliesClose) {
      for (var el2; (el2 = this._stack[this._stack.length - 1]) in openImpliesClose[name]; this.onclosetag(el2))
        ;
    }
    if (this._options.xmlMode || !(name in voidElements)) {
      this._stack.push(name);
      if (name in foreignContextElements)
        this._foreignContext.push(true);
      else if (name in htmlIntegrationElements)
        this._foreignContext.push(false);
    }
    if (this._cbs.onopentagname)
      this._cbs.onopentagname(name);
    if (this._cbs.onopentag)
      this._attribs = {};
  };
  Parser.prototype.onopentagend = function() {
    this._updatePosition(1);
    if (this._attribs) {
      if (this._cbs.onopentag)
        this._cbs.onopentag(this._tagname, this._attribs);
      this._attribs = null;
    }
    if (!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements) {
      this._cbs.onclosetag(this._tagname);
    }
    this._tagname = "";
  };
  Parser.prototype.onclosetag = function(name) {
    this._updatePosition(1);
    if (this._lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    if (name in foreignContextElements || name in htmlIntegrationElements) {
      this._foreignContext.pop();
    }
    if (this._stack.length && (!(name in voidElements) || this._options.xmlMode)) {
      var pos = this._stack.lastIndexOf(name);
      if (pos !== -1) {
        if (this._cbs.onclosetag) {
          pos = this._stack.length - pos;
          while (pos--)
            this._cbs.onclosetag(this._stack.pop());
        } else
          this._stack.length = pos;
      } else if (name === "p" && !this._options.xmlMode) {
        this.onopentagname(name);
        this._closeCurrentTag();
      }
    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
      this.onopentagname(name);
      this._closeCurrentTag();
    }
  };
  Parser.prototype.onselfclosingtag = function() {
    if (this._options.xmlMode || this._options.recognizeSelfClosing || this._foreignContext[this._foreignContext.length - 1]) {
      this._closeCurrentTag();
    } else {
      this.onopentagend();
    }
  };
  Parser.prototype._closeCurrentTag = function() {
    var name = this._tagname;
    this.onopentagend();
    if (this._stack[this._stack.length - 1] === name) {
      if (this._cbs.onclosetag) {
        this._cbs.onclosetag(name);
      }
      this._stack.pop();
    }
  };
  Parser.prototype.onattribname = function(name) {
    if (this._lowerCaseAttributeNames) {
      name = name.toLowerCase();
    }
    this._attribname = name;
  };
  Parser.prototype.onattribdata = function(value) {
    this._attribvalue += value;
  };
  Parser.prototype.onattribend = function() {
    if (this._cbs.onattribute)
      this._cbs.onattribute(this._attribname, this._attribvalue);
    if (this._attribs && !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)) {
      this._attribs[this._attribname] = this._attribvalue;
    }
    this._attribname = "";
    this._attribvalue = "";
  };
  Parser.prototype._getInstructionName = function(value) {
    var idx = value.search(re_nameEnd), name = idx < 0 ? value : value.substr(0, idx);
    if (this._lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    return name;
  };
  Parser.prototype.ondeclaration = function(value) {
    if (this._cbs.onprocessinginstruction) {
      var name = this._getInstructionName(value);
      this._cbs.onprocessinginstruction("!" + name, "!" + value);
    }
  };
  Parser.prototype.onprocessinginstruction = function(value) {
    if (this._cbs.onprocessinginstruction) {
      var name = this._getInstructionName(value);
      this._cbs.onprocessinginstruction("?" + name, "?" + value);
    }
  };
  Parser.prototype.oncomment = function(value) {
    this._updatePosition(4);
    if (this._cbs.oncomment)
      this._cbs.oncomment(value);
    if (this._cbs.oncommentend)
      this._cbs.oncommentend();
  };
  Parser.prototype.oncdata = function(value) {
    this._updatePosition(1);
    if (this._options.xmlMode || this._options.recognizeCDATA) {
      if (this._cbs.oncdatastart)
        this._cbs.oncdatastart();
      if (this._cbs.ontext)
        this._cbs.ontext(value);
      if (this._cbs.oncdataend)
        this._cbs.oncdataend();
    } else {
      this.oncomment("[CDATA[" + value + "]]");
    }
  };
  Parser.prototype.onerror = function(err) {
    if (this._cbs.onerror)
      this._cbs.onerror(err);
  };
  Parser.prototype.onend = function() {
    if (this._cbs.onclosetag) {
      for (var i2 = this._stack.length; i2 > 0; this._cbs.onclosetag(this._stack[--i2]))
        ;
    }
    if (this._cbs.onend)
      this._cbs.onend();
  };
  Parser.prototype.reset = function() {
    if (this._cbs.onreset)
      this._cbs.onreset();
    this._tokenizer.reset();
    this._tagname = "";
    this._attribname = "";
    this._attribs = null;
    this._stack = [];
    if (this._cbs.onparserinit)
      this._cbs.onparserinit(this);
  };
  Parser.prototype.parseComplete = function(data) {
    this.reset();
    this.end(data);
  };
  Parser.prototype.write = function(chunk) {
    this._tokenizer.write(chunk);
  };
  Parser.prototype.end = function(chunk) {
    this._tokenizer.end(chunk);
  };
  Parser.prototype.pause = function() {
    this._tokenizer.pause();
  };
  Parser.prototype.resume = function() {
    this._tokenizer.resume();
  };
  Parser.prototype.parseChunk = Parser.prototype.write;
  Parser.prototype.done = Parser.prototype.end;
  var Parser_1 = Parser;
  var domelementtype = {
    Text: "text",
    //Text
    Directive: "directive",
    //<? ... ?>
    Comment: "comment",
    //<!-- ... -->
    Script: "script",
    //<script> tags
    Style: "style",
    //<style> tags
    Tag: "tag",
    //Any tag
    CDATA: "cdata",
    //<![CDATA[ ... ]]>
    Doctype: "doctype",
    isTag: function(elem) {
      return elem.type === "tag" || elem.type === "script" || elem.type === "style";
    }
  };
  var nodeExports = {};
  var node = {
    get exports() {
      return nodeExports;
    },
    set exports(v2) {
      nodeExports = v2;
    }
  };
  node.exports = {
    get firstChild() {
      var children = this.children;
      return children && children[0] || null;
    },
    get lastChild() {
      var children = this.children;
      return children && children[children.length - 1] || null;
    },
    get nodeType() {
      return nodeTypes[this.type] || nodeTypes.element;
    }
  };
  var domLvl1$1 = {
    tagName: "name",
    childNodes: "children",
    parentNode: "parent",
    previousSibling: "prev",
    nextSibling: "next",
    nodeValue: "data"
  };
  var nodeTypes = {
    element: 1,
    text: 3,
    cdata: 4,
    comment: 8
  };
  Object.keys(domLvl1$1).forEach(function(key) {
  });
  var elementExports = {};
  var element = {
    get exports() {
      return elementExports;
    },
    set exports(v2) {
      elementExports = v2;
    }
  };
  var NodePrototype$1 = nodeExports;
  var ElementPrototype$1 = element.exports = Object.create(NodePrototype$1);
  var domLvl1 = {
    tagName: "name"
  };
  Object.keys(domLvl1).forEach(function(key) {
    var shorthand = domLvl1[key];
    Object.defineProperty(ElementPrototype$1, key, {
      get: function() {
        return this[shorthand] || null;
      },
      set: function(val) {
        this[shorthand] = val;
        return val;
      }
    });
  });
  var ElementType = domelementtype;
  var re_whitespace = /\s+/g;
  var NodePrototype = nodeExports;
  var ElementPrototype = elementExports;
  function DomHandler(callback2, options, elementCB) {
    if (typeof callback2 === "object") {
      elementCB = options;
      options = callback2;
      callback2 = null;
    } else if (typeof options === "function") {
      elementCB = options;
      options = defaultOpts;
    }
    this._callback = callback2;
    this._options = options || defaultOpts;
    this._elementCB = elementCB;
    this.dom = [];
    this._done = false;
    this._tagStack = [];
    this._parser = this._parser || null;
  }
  var defaultOpts = {
    normalizeWhitespace: false,
    //Replace all whitespace with single spaces
    withStartIndices: false,
    //Add startIndex properties to nodes
    withEndIndices: false
    //Add endIndex properties to nodes
  };
  DomHandler.prototype.onparserinit = function(parser) {
    this._parser = parser;
  };
  DomHandler.prototype.onreset = function() {
    DomHandler.call(this, this._callback, this._options, this._elementCB);
  };
  DomHandler.prototype.onend = function() {
    if (this._done)
      return;
    this._done = true;
    this._parser = null;
    this._handleCallback(null);
  };
  DomHandler.prototype._handleCallback = DomHandler.prototype.onerror = function(error) {
    if (typeof this._callback === "function") {
      this._callback(error, this.dom);
    } else {
      if (error)
        throw error;
    }
  };
  DomHandler.prototype.onclosetag = function() {
    var elem = this._tagStack.pop();
    if (this._options.withEndIndices && elem) {
      elem.endIndex = this._parser.endIndex;
    }
    if (this._elementCB)
      this._elementCB(elem);
  };
  DomHandler.prototype._createDomElement = function(properties) {
    if (!this._options.withDomLvl1)
      return properties;
    var element2;
    if (properties.type === "tag") {
      element2 = Object.create(ElementPrototype);
    } else {
      element2 = Object.create(NodePrototype);
    }
    for (var key in properties) {
      if (properties.hasOwnProperty(key)) {
        element2[key] = properties[key];
      }
    }
    return element2;
  };
  DomHandler.prototype._addDomElement = function(element2) {
    var parent = this._tagStack[this._tagStack.length - 1];
    var siblings = parent ? parent.children : this.dom;
    var previousSibling = siblings[siblings.length - 1];
    element2.next = null;
    if (this._options.withStartIndices) {
      element2.startIndex = this._parser.startIndex;
    }
    if (this._options.withEndIndices) {
      element2.endIndex = this._parser.endIndex;
    }
    if (previousSibling) {
      element2.prev = previousSibling;
      previousSibling.next = element2;
    } else {
      element2.prev = null;
    }
    siblings.push(element2);
    element2.parent = parent || null;
  };
  DomHandler.prototype.onopentag = function(name, attribs) {
    var properties = {
      type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
      name,
      attribs,
      children: []
    };
    var element2 = this._createDomElement(properties);
    this._addDomElement(element2);
    this._tagStack.push(element2);
  };
  DomHandler.prototype.ontext = function(data) {
    var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
    var lastTag;
    if (!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length - 1]).type === ElementType.Text) {
      if (normalize) {
        lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
      } else {
        lastTag.data += data;
      }
    } else {
      if (this._tagStack.length && (lastTag = this._tagStack[this._tagStack.length - 1]) && (lastTag = lastTag.children[lastTag.children.length - 1]) && lastTag.type === ElementType.Text) {
        if (normalize) {
          lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
        } else {
          lastTag.data += data;
        }
      } else {
        if (normalize) {
          data = data.replace(re_whitespace, " ");
        }
        var element2 = this._createDomElement({
          data,
          type: ElementType.Text
        });
        this._addDomElement(element2);
      }
    }
  };
  DomHandler.prototype.oncomment = function(data) {
    var lastTag = this._tagStack[this._tagStack.length - 1];
    if (lastTag && lastTag.type === ElementType.Comment) {
      lastTag.data += data;
      return;
    }
    var properties = {
      data,
      type: ElementType.Comment
    };
    var element2 = this._createDomElement(properties);
    this._addDomElement(element2);
    this._tagStack.push(element2);
  };
  DomHandler.prototype.oncdatastart = function() {
    var properties = {
      children: [{
        data: "",
        type: ElementType.Text
      }],
      type: ElementType.CDATA
    };
    var element2 = this._createDomElement(properties);
    this._addDomElement(element2);
    this._tagStack.push(element2);
  };
  DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function() {
    this._tagStack.pop();
  };
  DomHandler.prototype.onprocessinginstruction = function(name, data) {
    var element2 = this._createDomElement({
      name,
      data,
      type: ElementType.Directive
    });
    this._addDomElement(element2);
  };
  var domhandler = DomHandler;
  var domutilsExports = {};
  var domutils = {
    get exports() {
      return domutilsExports;
    },
    set exports(v2) {
      domutilsExports = v2;
    }
  };
  var domSerializerExports = {};
  var domSerializer = {
    get exports() {
      return domSerializerExports;
    },
    set exports(v2) {
      domSerializerExports = v2;
    }
  };
  var lib$1 = {};
  var hasRequiredLib$2;
  function requireLib$2() {
    if (hasRequiredLib$2)
      return lib$1;
    hasRequiredLib$2 = 1;
    (function(exports) {
      Object.defineProperty(exports, "__esModule", { value: true });
      exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
      var ElementType2;
      (function(ElementType3) {
        ElementType3["Root"] = "root";
        ElementType3["Text"] = "text";
        ElementType3["Directive"] = "directive";
        ElementType3["Comment"] = "comment";
        ElementType3["Script"] = "script";
        ElementType3["Style"] = "style";
        ElementType3["Tag"] = "tag";
        ElementType3["CDATA"] = "cdata";
        ElementType3["Doctype"] = "doctype";
      })(ElementType2 = exports.ElementType || (exports.ElementType = {}));
      function isTag(elem) {
        return elem.type === ElementType2.Tag || elem.type === ElementType2.Script || elem.type === ElementType2.Style;
      }
      exports.isTag = isTag;
      exports.Root = ElementType2.Root;
      exports.Text = ElementType2.Text;
      exports.Directive = ElementType2.Directive;
      exports.Comment = ElementType2.Comment;
      exports.Script = ElementType2.Script;
      exports.Style = ElementType2.Style;
      exports.Tag = ElementType2.Tag;
      exports.CDATA = ElementType2.CDATA;
      exports.Doctype = ElementType2.Doctype;
    })(lib$1);
    return lib$1;
  }
  var lib = {};
  var decode = {};
  const Aacute$1 = "Á";
  const aacute$1 = "á";
  const Abreve = "Ă";
  const abreve = "ă";
  const ac = "∾";
  const acd = "∿";
  const acE = "∾̳";
  const Acirc$1 = "Â";
  const acirc$1 = "â";
  const acute$1 = "´";
  const Acy = "А";
  const acy = "а";
  const AElig$1 = "Æ";
  const aelig$1 = "æ";
  const af = "⁡";
  const Afr = "𝔄";
  const afr = "𝔞";
  const Agrave$1 = "À";
  const agrave$1 = "à";
  const alefsym = "ℵ";
  const aleph = "ℵ";
  const Alpha = "Α";
  const alpha = "α";
  const Amacr = "Ā";
  const amacr = "ā";
  const amalg = "⨿";
  const amp$2 = "&";
  const AMP$1 = "&";
  const andand = "⩕";
  const And = "⩓";
  const and = "∧";
  const andd = "⩜";
  const andslope = "⩘";
  const andv = "⩚";
  const ang = "∠";
  const ange = "⦤";
  const angle = "∠";
  const angmsdaa = "⦨";
  const angmsdab = "⦩";
  const angmsdac = "⦪";
  const angmsdad = "⦫";
  const angmsdae = "⦬";
  const angmsdaf = "⦭";
  const angmsdag = "⦮";
  const angmsdah = "⦯";
  const angmsd = "∡";
  const angrt = "∟";
  const angrtvb = "⊾";
  const angrtvbd = "⦝";
  const angsph = "∢";
  const angst = "Å";
  const angzarr = "⍼";
  const Aogon = "Ą";
  const aogon = "ą";
  const Aopf = "𝔸";
  const aopf = "𝕒";
  const apacir = "⩯";
  const ap = "≈";
  const apE = "⩰";
  const ape = "≊";
  const apid = "≋";
  const apos$1 = "'";
  const ApplyFunction = "⁡";
  const approx = "≈";
  const approxeq = "≊";
  const Aring$1 = "Å";
  const aring$1 = "å";
  const Ascr = "𝒜";
  const ascr = "𝒶";
  const Assign = "≔";
  const ast = "*";
  const asymp = "≈";
  const asympeq = "≍";
  const Atilde$1 = "Ã";
  const atilde$1 = "ã";
  const Auml$1 = "Ä";
  const auml$1 = "ä";
  const awconint = "∳";
  const awint = "⨑";
  const backcong = "≌";
  const backepsilon = "϶";
  const backprime = "‵";
  const backsim = "∽";
  const backsimeq = "⋍";
  const Backslash = "∖";
  const Barv = "⫧";
  const barvee = "⊽";
  const barwed = "⌅";
  const Barwed = "⌆";
  const barwedge = "⌅";
  const bbrk = "⎵";
  const bbrktbrk = "⎶";
  const bcong = "≌";
  const Bcy = "Б";
  const bcy = "б";
  const bdquo = "„";
  const becaus = "∵";
  const because = "∵";
  const Because = "∵";
  const bemptyv = "⦰";
  const bepsi = "϶";
  const bernou = "ℬ";
  const Bernoullis = "ℬ";
  const Beta = "Β";
  const beta = "β";
  const beth = "ℶ";
  const between = "≬";
  const Bfr = "𝔅";
  const bfr = "𝔟";
  const bigcap = "⋂";
  const bigcirc = "◯";
  const bigcup = "⋃";
  const bigodot = "⨀";
  const bigoplus = "⨁";
  const bigotimes = "⨂";
  const bigsqcup = "⨆";
  const bigstar = "★";
  const bigtriangledown = "▽";
  const bigtriangleup = "△";
  const biguplus = "⨄";
  const bigvee = "⋁";
  const bigwedge = "⋀";
  const bkarow = "⤍";
  const blacklozenge = "⧫";
  const blacksquare = "▪";
  const blacktriangle = "▴";
  const blacktriangledown = "▾";
  const blacktriangleleft = "◂";
  const blacktriangleright = "▸";
  const blank = "␣";
  const blk12 = "▒";
  const blk14 = "░";
  const blk34 = "▓";
  const block = "█";
  const bne = "=⃥";
  const bnequiv = "≡⃥";
  const bNot = "⫭";
  const bnot = "⌐";
  const Bopf = "𝔹";
  const bopf = "𝕓";
  const bot = "⊥";
  const bottom = "⊥";
  const bowtie = "⋈";
  const boxbox = "⧉";
  const boxdl = "┐";
  const boxdL = "╕";
  const boxDl = "╖";
  const boxDL = "╗";
  const boxdr = "┌";
  const boxdR = "╒";
  const boxDr = "╓";
  const boxDR = "╔";
  const boxh = "─";
  const boxH = "═";
  const boxhd = "┬";
  const boxHd = "╤";
  const boxhD = "╥";
  const boxHD = "╦";
  const boxhu = "┴";
  const boxHu = "╧";
  const boxhU = "╨";
  const boxHU = "╩";
  const boxminus = "⊟";
  const boxplus = "⊞";
  const boxtimes = "⊠";
  const boxul = "┘";
  const boxuL = "╛";
  const boxUl = "╜";
  const boxUL = "╝";
  const boxur = "└";
  const boxuR = "╘";
  const boxUr = "╙";
  const boxUR = "╚";
  const boxv = "│";
  const boxV = "║";
  const boxvh = "┼";
  const boxvH = "╪";
  const boxVh = "╫";
  const boxVH = "╬";
  const boxvl = "┤";
  const boxvL = "╡";
  const boxVl = "╢";
  const boxVL = "╣";
  const boxvr = "├";
  const boxvR = "╞";
  const boxVr = "╟";
  const boxVR = "╠";
  const bprime = "‵";
  const breve = "˘";
  const Breve = "˘";
  const brvbar$1 = "¦";
  const bscr = "𝒷";
  const Bscr = "ℬ";
  const bsemi = "⁏";
  const bsim = "∽";
  const bsime = "⋍";
  const bsolb = "⧅";
  const bsol = "\\";
  const bsolhsub = "⟈";
  const bull = "•";
  const bullet = "•";
  const bump = "≎";
  const bumpE = "⪮";
  const bumpe = "≏";
  const Bumpeq = "≎";
  const bumpeq = "≏";
  const Cacute = "Ć";
  const cacute = "ć";
  const capand = "⩄";
  const capbrcup = "⩉";
  const capcap = "⩋";
  const cap = "∩";
  const Cap = "⋒";
  const capcup = "⩇";
  const capdot = "⩀";
  const CapitalDifferentialD = "ⅅ";
  const caps = "∩︀";
  const caret = "⁁";
  const caron = "ˇ";
  const Cayleys = "ℭ";
  const ccaps = "⩍";
  const Ccaron = "Č";
  const ccaron = "č";
  const Ccedil$1 = "Ç";
  const ccedil$1 = "ç";
  const Ccirc = "Ĉ";
  const ccirc = "ĉ";
  const Cconint = "∰";
  const ccups = "⩌";
  const ccupssm = "⩐";
  const Cdot = "Ċ";
  const cdot = "ċ";
  const cedil$1 = "¸";
  const Cedilla = "¸";
  const cemptyv = "⦲";
  const cent$1 = "¢";
  const centerdot = "·";
  const CenterDot = "·";
  const cfr = "𝔠";
  const Cfr = "ℭ";
  const CHcy = "Ч";
  const chcy = "ч";
  const check = "✓";
  const checkmark = "✓";
  const Chi = "Χ";
  const chi = "χ";
  const circ = "ˆ";
  const circeq = "≗";
  const circlearrowleft = "↺";
  const circlearrowright = "↻";
  const circledast = "⊛";
  const circledcirc = "⊚";
  const circleddash = "⊝";
  const CircleDot = "⊙";
  const circledR = "®";
  const circledS = "Ⓢ";
  const CircleMinus = "⊖";
  const CirclePlus = "⊕";
  const CircleTimes = "⊗";
  const cir = "○";
  const cirE = "⧃";
  const cire = "≗";
  const cirfnint = "⨐";
  const cirmid = "⫯";
  const cirscir = "⧂";
  const ClockwiseContourIntegral = "∲";
  const CloseCurlyDoubleQuote = "”";
  const CloseCurlyQuote = "’";
  const clubs = "♣";
  const clubsuit = "♣";
  const colon = ":";
  const Colon = "∷";
  const Colone = "⩴";
  const colone = "≔";
  const coloneq = "≔";
  const comma = ",";
  const commat = "@";
  const comp = "∁";
  const compfn = "∘";
  const complement = "∁";
  const complexes = "ℂ";
  const cong = "≅";
  const congdot = "⩭";
  const Congruent = "≡";
  const conint = "∮";
  const Conint = "∯";
  const ContourIntegral = "∮";
  const copf = "𝕔";
  const Copf = "ℂ";
  const coprod = "∐";
  const Coproduct = "∐";
  const copy$1 = "©";
  const COPY$1 = "©";
  const copysr = "℗";
  const CounterClockwiseContourIntegral = "∳";
  const crarr = "↵";
  const cross = "✗";
  const Cross = "⨯";
  const Cscr = "𝒞";
  const cscr = "𝒸";
  const csub = "⫏";
  const csube = "⫑";
  const csup = "⫐";
  const csupe = "⫒";
  const ctdot = "⋯";
  const cudarrl = "⤸";
  const cudarrr = "⤵";
  const cuepr = "⋞";
  const cuesc = "⋟";
  const cularr = "↶";
  const cularrp = "⤽";
  const cupbrcap = "⩈";
  const cupcap = "⩆";
  const CupCap = "≍";
  const cup = "∪";
  const Cup = "⋓";
  const cupcup = "⩊";
  const cupdot = "⊍";
  const cupor = "⩅";
  const cups = "∪︀";
  const curarr = "↷";
  const curarrm = "⤼";
  const curlyeqprec = "⋞";
  const curlyeqsucc = "⋟";
  const curlyvee = "⋎";
  const curlywedge = "⋏";
  const curren$1 = "¤";
  const curvearrowleft = "↶";
  const curvearrowright = "↷";
  const cuvee = "⋎";
  const cuwed = "⋏";
  const cwconint = "∲";
  const cwint = "∱";
  const cylcty = "⌭";
  const dagger = "†";
  const Dagger = "‡";
  const daleth = "ℸ";
  const darr = "↓";
  const Darr = "↡";
  const dArr = "⇓";
  const dash = "‐";
  const Dashv = "⫤";
  const dashv = "⊣";
  const dbkarow = "⤏";
  const dblac = "˝";
  const Dcaron = "Ď";
  const dcaron = "ď";
  const Dcy = "Д";
  const dcy = "д";
  const ddagger = "‡";
  const ddarr = "⇊";
  const DD = "ⅅ";
  const dd = "ⅆ";
  const DDotrahd = "⤑";
  const ddotseq = "⩷";
  const deg$1 = "°";
  const Del = "∇";
  const Delta = "Δ";
  const delta = "δ";
  const demptyv = "⦱";
  const dfisht = "⥿";
  const Dfr = "𝔇";
  const dfr = "𝔡";
  const dHar = "⥥";
  const dharl = "⇃";
  const dharr = "⇂";
  const DiacriticalAcute = "´";
  const DiacriticalDot = "˙";
  const DiacriticalDoubleAcute = "˝";
  const DiacriticalGrave = "`";
  const DiacriticalTilde = "˜";
  const diam = "⋄";
  const diamond = "⋄";
  const Diamond = "⋄";
  const diamondsuit = "♦";
  const diams = "♦";
  const die = "¨";
  const DifferentialD = "ⅆ";
  const digamma = "ϝ";
  const disin = "⋲";
  const div = "÷";
  const divide$1 = "÷";
  const divideontimes = "⋇";
  const divonx = "⋇";
  const DJcy = "Ђ";
  const djcy = "ђ";
  const dlcorn = "⌞";
  const dlcrop = "⌍";
  const dollar = "$";
  const Dopf = "𝔻";
  const dopf = "𝕕";
  const Dot = "¨";
  const dot = "˙";
  const DotDot = "⃜";
  const doteq = "≐";
  const doteqdot = "≑";
  const DotEqual = "≐";
  const dotminus = "∸";
  const dotplus = "∔";
  const dotsquare = "⊡";
  const doublebarwedge = "⌆";
  const DoubleContourIntegral = "∯";
  const DoubleDot = "¨";
  const DoubleDownArrow = "⇓";
  const DoubleLeftArrow = "⇐";
  const DoubleLeftRightArrow = "⇔";
  const DoubleLeftTee = "⫤";
  const DoubleLongLeftArrow = "⟸";
  const DoubleLongLeftRightArrow = "⟺";
  const DoubleLongRightArrow = "⟹";
  const DoubleRightArrow = "⇒";
  const DoubleRightTee = "⊨";
  const DoubleUpArrow = "⇑";
  const DoubleUpDownArrow = "⇕";
  const DoubleVerticalBar = "∥";
  const DownArrowBar = "⤓";
  const downarrow = "↓";
  const DownArrow = "↓";
  const Downarrow = "⇓";
  const DownArrowUpArrow = "⇵";
  const DownBreve = "̑";
  const downdownarrows = "⇊";
  const downharpoonleft = "⇃";
  const downharpoonright = "⇂";
  const DownLeftRightVector = "⥐";
  const DownLeftTeeVector = "⥞";
  const DownLeftVectorBar = "⥖";
  const DownLeftVector = "↽";
  const DownRightTeeVector = "⥟";
  const DownRightVectorBar = "⥗";
  const DownRightVector = "⇁";
  const DownTeeArrow = "↧";
  const DownTee = "⊤";
  const drbkarow = "⤐";
  const drcorn = "⌟";
  const drcrop = "⌌";
  const Dscr = "𝒟";
  const dscr = "𝒹";
  const DScy = "Ѕ";
  const dscy = "ѕ";
  const dsol = "⧶";
  const Dstrok = "Đ";
  const dstrok = "đ";
  const dtdot = "⋱";
  const dtri = "▿";
  const dtrif = "▾";
  const duarr = "⇵";
  const duhar = "⥯";
  const dwangle = "⦦";
  const DZcy = "Џ";
  const dzcy = "џ";
  const dzigrarr = "⟿";
  const Eacute$1 = "É";
  const eacute$1 = "é";
  const easter = "⩮";
  const Ecaron = "Ě";
  const ecaron = "ě";
  const Ecirc$1 = "Ê";
  const ecirc$1 = "ê";
  const ecir = "≖";
  const ecolon = "≕";
  const Ecy = "Э";
  const ecy = "э";
  const eDDot = "⩷";
  const Edot = "Ė";
  const edot = "ė";
  const eDot = "≑";
  const ee = "ⅇ";
  const efDot = "≒";
  const Efr = "𝔈";
  const efr = "𝔢";
  const eg = "⪚";
  const Egrave$1 = "È";
  const egrave$1 = "è";
  const egs = "⪖";
  const egsdot = "⪘";
  const el = "⪙";
  const Element = "∈";
  const elinters = "⏧";
  const ell = "ℓ";
  const els = "⪕";
  const elsdot = "⪗";
  const Emacr = "Ē";
  const emacr = "ē";
  const empty = "∅";
  const emptyset = "∅";
  const EmptySmallSquare = "◻";
  const emptyv = "∅";
  const EmptyVerySmallSquare = "▫";
  const emsp13 = " ";
  const emsp14 = " ";
  const emsp = " ";
  const ENG = "Ŋ";
  const eng = "ŋ";
  const ensp = " ";
  const Eogon = "Ę";
  const eogon = "ę";
  const Eopf = "𝔼";
  const eopf = "𝕖";
  const epar = "⋕";
  const eparsl = "⧣";
  const eplus = "⩱";
  const epsi = "ε";
  const Epsilon = "Ε";
  const epsilon = "ε";
  const epsiv = "ϵ";
  const eqcirc = "≖";
  const eqcolon = "≕";
  const eqsim = "≂";
  const eqslantgtr = "⪖";
  const eqslantless = "⪕";
  const Equal = "⩵";
  const equals = "=";
  const EqualTilde = "≂";
  const equest = "≟";
  const Equilibrium = "⇌";
  const equiv = "≡";
  const equivDD = "⩸";
  const eqvparsl = "⧥";
  const erarr = "⥱";
  const erDot = "≓";
  const escr = "ℯ";
  const Escr = "ℰ";
  const esdot = "≐";
  const Esim = "⩳";
  const esim = "≂";
  const Eta = "Η";
  const eta = "η";
  const ETH$1 = "Ð";
  const eth$1 = "ð";
  const Euml$1 = "Ë";
  const euml$1 = "ë";
  const euro = "€";
  const excl = "!";
  const exist = "∃";
  const Exists = "∃";
  const expectation = "ℰ";
  const exponentiale = "ⅇ";
  const ExponentialE = "ⅇ";
  const fallingdotseq = "≒";
  const Fcy = "Ф";
  const fcy = "ф";
  const female = "♀";
  const ffilig = "ﬃ";
  const fflig = "ﬀ";
  const ffllig = "ﬄ";
  const Ffr = "𝔉";
  const ffr = "𝔣";
  const filig = "ﬁ";
  const FilledSmallSquare = "◼";
  const FilledVerySmallSquare = "▪";
  const fjlig = "fj";
  const flat = "♭";
  const fllig = "ﬂ";
  const fltns = "▱";
  const fnof = "ƒ";
  const Fopf = "𝔽";
  const fopf = "𝕗";
  const forall = "∀";
  const ForAll = "∀";
  const fork = "⋔";
  const forkv = "⫙";
  const Fouriertrf = "ℱ";
  const fpartint = "⨍";
  const frac12$1 = "½";
  const frac13 = "⅓";
  const frac14$1 = "¼";
  const frac15 = "⅕";
  const frac16 = "⅙";
  const frac18 = "⅛";
  const frac23 = "⅔";
  const frac25 = "⅖";
  const frac34$1 = "¾";
  const frac35 = "⅗";
  const frac38 = "⅜";
  const frac45 = "⅘";
  const frac56 = "⅚";
  const frac58 = "⅝";
  const frac78 = "⅞";
  const frasl = "⁄";
  const frown = "⌢";
  const fscr = "𝒻";
  const Fscr = "ℱ";
  const gacute = "ǵ";
  const Gamma = "Γ";
  const gamma = "γ";
  const Gammad = "Ϝ";
  const gammad = "ϝ";
  const gap = "⪆";
  const Gbreve = "Ğ";
  const gbreve = "ğ";
  const Gcedil = "Ģ";
  const Gcirc = "Ĝ";
  const gcirc = "ĝ";
  const Gcy = "Г";
  const gcy = "г";
  const Gdot = "Ġ";
  const gdot = "ġ";
  const ge = "≥";
  const gE = "≧";
  const gEl = "⪌";
  const gel = "⋛";
  const geq = "≥";
  const geqq = "≧";
  const geqslant = "⩾";
  const gescc = "⪩";
  const ges = "⩾";
  const gesdot = "⪀";
  const gesdoto = "⪂";
  const gesdotol = "⪄";
  const gesl = "⋛︀";
  const gesles = "⪔";
  const Gfr = "𝔊";
  const gfr = "𝔤";
  const gg = "≫";
  const Gg = "⋙";
  const ggg = "⋙";
  const gimel = "ℷ";
  const GJcy = "Ѓ";
  const gjcy = "ѓ";
  const gla = "⪥";
  const gl = "≷";
  const glE = "⪒";
  const glj = "⪤";
  const gnap = "⪊";
  const gnapprox = "⪊";
  const gne = "⪈";
  const gnE = "≩";
  const gneq = "⪈";
  const gneqq = "≩";
  const gnsim = "⋧";
  const Gopf = "𝔾";
  const gopf = "𝕘";
  const grave = "`";
  const GreaterEqual = "≥";
  const GreaterEqualLess = "⋛";
  const GreaterFullEqual = "≧";
  const GreaterGreater = "⪢";
  const GreaterLess = "≷";
  const GreaterSlantEqual = "⩾";
  const GreaterTilde = "≳";
  const Gscr = "𝒢";
  const gscr = "ℊ";
  const gsim = "≳";
  const gsime = "⪎";
  const gsiml = "⪐";
  const gtcc = "⪧";
  const gtcir = "⩺";
  const gt$2 = ">";
  const GT$1 = ">";
  const Gt = "≫";
  const gtdot = "⋗";
  const gtlPar = "⦕";
  const gtquest = "⩼";
  const gtrapprox = "⪆";
  const gtrarr = "⥸";
  const gtrdot = "⋗";
  const gtreqless = "⋛";
  const gtreqqless = "⪌";
  const gtrless = "≷";
  const gtrsim = "≳";
  const gvertneqq = "≩︀";
  const gvnE = "≩︀";
  const Hacek = "ˇ";
  const hairsp = " ";
  const half = "½";
  const hamilt = "ℋ";
  const HARDcy = "Ъ";
  const hardcy = "ъ";
  const harrcir = "⥈";
  const harr = "↔";
  const hArr = "⇔";
  const harrw = "↭";
  const Hat = "^";
  const hbar = "ℏ";
  const Hcirc = "Ĥ";
  const hcirc = "ĥ";
  const hearts = "♥";
  const heartsuit = "♥";
  const hellip = "…";
  const hercon = "⊹";
  const hfr = "𝔥";
  const Hfr = "ℌ";
  const HilbertSpace = "ℋ";
  const hksearow = "⤥";
  const hkswarow = "⤦";
  const hoarr = "⇿";
  const homtht = "∻";
  const hookleftarrow = "↩";
  const hookrightarrow = "↪";
  const hopf = "𝕙";
  const Hopf = "ℍ";
  const horbar = "―";
  const HorizontalLine = "─";
  const hscr = "𝒽";
  const Hscr = "ℋ";
  const hslash = "ℏ";
  const Hstrok = "Ħ";
  const hstrok = "ħ";
  const HumpDownHump = "≎";
  const HumpEqual = "≏";
  const hybull = "⁃";
  const hyphen = "‐";
  const Iacute$1 = "Í";
  const iacute$1 = "í";
  const ic = "⁣";
  const Icirc$1 = "Î";
  const icirc$1 = "î";
  const Icy = "И";
  const icy = "и";
  const Idot = "İ";
  const IEcy = "Е";
  const iecy = "е";
  const iexcl$1 = "¡";
  const iff = "⇔";
  const ifr = "𝔦";
  const Ifr = "ℑ";
  const Igrave$1 = "Ì";
  const igrave$1 = "ì";
  const ii = "ⅈ";
  const iiiint = "⨌";
  const iiint = "∭";
  const iinfin = "⧜";
  const iiota = "℩";
  const IJlig = "Ĳ";
  const ijlig = "ĳ";
  const Imacr = "Ī";
  const imacr = "ī";
  const image = "ℑ";
  const ImaginaryI = "ⅈ";
  const imagline = "ℐ";
  const imagpart = "ℑ";
  const imath = "ı";
  const Im = "ℑ";
  const imof = "⊷";
  const imped = "Ƶ";
  const Implies = "⇒";
  const incare = "℅";
  const infin = "∞";
  const infintie = "⧝";
  const inodot = "ı";
  const intcal = "⊺";
  const int = "∫";
  const Int = "∬";
  const integers = "ℤ";
  const Integral = "∫";
  const intercal = "⊺";
  const Intersection = "⋂";
  const intlarhk = "⨗";
  const intprod = "⨼";
  const InvisibleComma = "⁣";
  const InvisibleTimes = "⁢";
  const IOcy = "Ё";
  const iocy = "ё";
  const Iogon = "Į";
  const iogon = "į";
  const Iopf = "𝕀";
  const iopf = "𝕚";
  const Iota = "Ι";
  const iota = "ι";
  const iprod = "⨼";
  const iquest$1 = "¿";
  const iscr = "𝒾";
  const Iscr = "ℐ";
  const isin = "∈";
  const isindot = "⋵";
  const isinE = "⋹";
  const isins = "⋴";
  const isinsv = "⋳";
  const isinv = "∈";
  const it = "⁢";
  const Itilde = "Ĩ";
  const itilde = "ĩ";
  const Iukcy = "І";
  const iukcy = "і";
  const Iuml$1 = "Ï";
  const iuml$1 = "ï";
  const Jcirc = "Ĵ";
  const jcirc = "ĵ";
  const Jcy = "Й";
  const jcy = "й";
  const Jfr = "𝔍";
  const jfr = "𝔧";
  const jmath = "ȷ";
  const Jopf = "𝕁";
  const jopf = "𝕛";
  const Jscr = "𝒥";
  const jscr = "𝒿";
  const Jsercy = "Ј";
  const jsercy = "ј";
  const Jukcy = "Є";
  const jukcy = "є";
  const Kappa = "Κ";
  const kappa = "κ";
  const kappav = "ϰ";
  const Kcedil = "Ķ";
  const kcedil = "ķ";
  const Kcy = "К";
  const kcy = "к";
  const Kfr = "𝔎";
  const kfr = "𝔨";
  const kgreen = "ĸ";
  const KHcy = "Х";
  const khcy = "х";
  const KJcy = "Ќ";
  const kjcy = "ќ";
  const Kopf = "𝕂";
  const kopf = "𝕜";
  const Kscr = "𝒦";
  const kscr = "𝓀";
  const lAarr = "⇚";
  const Lacute = "Ĺ";
  const lacute = "ĺ";
  const laemptyv = "⦴";
  const lagran = "ℒ";
  const Lambda = "Λ";
  const lambda = "λ";
  const lang = "⟨";
  const Lang = "⟪";
  const langd = "⦑";
  const langle = "⟨";
  const lap = "⪅";
  const Laplacetrf = "ℒ";
  const laquo$1 = "«";
  const larrb = "⇤";
  const larrbfs = "⤟";
  const larr = "←";
  const Larr = "↞";
  const lArr = "⇐";
  const larrfs = "⤝";
  const larrhk = "↩";
  const larrlp = "↫";
  const larrpl = "⤹";
  const larrsim = "⥳";
  const larrtl = "↢";
  const latail = "⤙";
  const lAtail = "⤛";
  const lat = "⪫";
  const late = "⪭";
  const lates = "⪭︀";
  const lbarr = "⤌";
  const lBarr = "⤎";
  const lbbrk = "❲";
  const lbrace = "{";
  const lbrack = "[";
  const lbrke = "⦋";
  const lbrksld = "⦏";
  const lbrkslu = "⦍";
  const Lcaron = "Ľ";
  const lcaron = "ľ";
  const Lcedil = "Ļ";
  const lcedil = "ļ";
  const lceil = "⌈";
  const lcub = "{";
  const Lcy = "Л";
  const lcy = "л";
  const ldca = "⤶";
  const ldquo = "“";
  const ldquor = "„";
  const ldrdhar = "⥧";
  const ldrushar = "⥋";
  const ldsh = "↲";
  const le = "≤";
  const lE = "≦";
  const LeftAngleBracket = "⟨";
  const LeftArrowBar = "⇤";
  const leftarrow = "←";
  const LeftArrow = "←";
  const Leftarrow = "⇐";
  const LeftArrowRightArrow = "⇆";
  const leftarrowtail = "↢";
  const LeftCeiling = "⌈";
  const LeftDoubleBracket = "⟦";
  const LeftDownTeeVector = "⥡";
  const LeftDownVectorBar = "⥙";
  const LeftDownVector = "⇃";
  const LeftFloor = "⌊";
  const leftharpoondown = "↽";
  const leftharpoonup = "↼";
  const leftleftarrows = "⇇";
  const leftrightarrow = "↔";
  const LeftRightArrow = "↔";
  const Leftrightarrow = "⇔";
  const leftrightarrows = "⇆";
  const leftrightharpoons = "⇋";
  const leftrightsquigarrow = "↭";
  const LeftRightVector = "⥎";
  const LeftTeeArrow = "↤";
  const LeftTee = "⊣";
  const LeftTeeVector = "⥚";
  const leftthreetimes = "⋋";
  const LeftTriangleBar = "⧏";
  const LeftTriangle = "⊲";
  const LeftTriangleEqual = "⊴";
  const LeftUpDownVector = "⥑";
  const LeftUpTeeVector = "⥠";
  const LeftUpVectorBar = "⥘";
  const LeftUpVector = "↿";
  const LeftVectorBar = "⥒";
  const LeftVector = "↼";
  const lEg = "⪋";
  const leg = "⋚";
  const leq = "≤";
  const leqq = "≦";
  const leqslant = "⩽";
  const lescc = "⪨";
  const les = "⩽";
  const lesdot = "⩿";
  const lesdoto = "⪁";
  const lesdotor = "⪃";
  const lesg = "⋚︀";
  const lesges = "⪓";
  const lessapprox = "⪅";
  const lessdot = "⋖";
  const lesseqgtr = "⋚";
  const lesseqqgtr = "⪋";
  const LessEqualGreater = "⋚";
  const LessFullEqual = "≦";
  const LessGreater = "≶";
  const lessgtr = "≶";
  const LessLess = "⪡";
  const lesssim = "≲";
  const LessSlantEqual = "⩽";
  const LessTilde = "≲";
  const lfisht = "⥼";
  const lfloor = "⌊";
  const Lfr = "𝔏";
  const lfr = "𝔩";
  const lg = "≶";
  const lgE = "⪑";
  const lHar = "⥢";
  const lhard = "↽";
  const lharu = "↼";
  const lharul = "⥪";
  const lhblk = "▄";
  const LJcy = "Љ";
  const ljcy = "љ";
  const llarr = "⇇";
  const ll = "≪";
  const Ll = "⋘";
  const llcorner = "⌞";
  const Lleftarrow = "⇚";
  const llhard = "⥫";
  const lltri = "◺";
  const Lmidot = "Ŀ";
  const lmidot = "ŀ";
  const lmoustache = "⎰";
  const lmoust = "⎰";
  const lnap = "⪉";
  const lnapprox = "⪉";
  const lne = "⪇";
  const lnE = "≨";
  const lneq = "⪇";
  const lneqq = "≨";
  const lnsim = "⋦";
  const loang = "⟬";
  const loarr = "⇽";
  const lobrk = "⟦";
  const longleftarrow = "⟵";
  const LongLeftArrow = "⟵";
  const Longleftarrow = "⟸";
  const longleftrightarrow = "⟷";
  const LongLeftRightArrow = "⟷";
  const Longleftrightarrow = "⟺";
  const longmapsto = "⟼";
  const longrightarrow = "⟶";
  const LongRightArrow = "⟶";
  const Longrightarrow = "⟹";
  const looparrowleft = "↫";
  const looparrowright = "↬";
  const lopar = "⦅";
  const Lopf = "𝕃";
  const lopf = "𝕝";
  const loplus = "⨭";
  const lotimes = "⨴";
  const lowast = "∗";
  const lowbar = "_";
  const LowerLeftArrow = "↙";
  const LowerRightArrow = "↘";
  const loz = "◊";
  const lozenge = "◊";
  const lozf = "⧫";
  const lpar = "(";
  const lparlt = "⦓";
  const lrarr = "⇆";
  const lrcorner = "⌟";
  const lrhar = "⇋";
  const lrhard = "⥭";
  const lrm = "‎";
  const lrtri = "⊿";
  const lsaquo = "‹";
  const lscr = "𝓁";
  const Lscr = "ℒ";
  const lsh = "↰";
  const Lsh = "↰";
  const lsim = "≲";
  const lsime = "⪍";
  const lsimg = "⪏";
  const lsqb = "[";
  const lsquo = "‘";
  const lsquor = "‚";
  const Lstrok = "Ł";
  const lstrok = "ł";
  const ltcc = "⪦";
  const ltcir = "⩹";
  const lt$2 = "<";
  const LT$1 = "<";
  const Lt = "≪";
  const ltdot = "⋖";
  const lthree = "⋋";
  const ltimes = "⋉";
  const ltlarr = "⥶";
  const ltquest = "⩻";
  const ltri = "◃";
  const ltrie = "⊴";
  const ltrif = "◂";
  const ltrPar = "⦖";
  const lurdshar = "⥊";
  const luruhar = "⥦";
  const lvertneqq = "≨︀";
  const lvnE = "≨︀";
  const macr$1 = "¯";
  const male = "♂";
  const malt = "✠";
  const maltese = "✠";
  const map = "↦";
  const mapsto = "↦";
  const mapstodown = "↧";
  const mapstoleft = "↤";
  const mapstoup = "↥";
  const marker = "▮";
  const mcomma = "⨩";
  const Mcy = "М";
  const mcy = "м";
  const mdash = "—";
  const mDDot = "∺";
  const measuredangle = "∡";
  const MediumSpace = " ";
  const Mellintrf = "ℳ";
  const Mfr = "𝔐";
  const mfr = "𝔪";
  const mho = "℧";
  const micro$1 = "µ";
  const midast = "*";
  const midcir = "⫰";
  const mid = "∣";
  const middot$1 = "·";
  const minusb = "⊟";
  const minus = "−";
  const minusd = "∸";
  const minusdu = "⨪";
  const MinusPlus = "∓";
  const mlcp = "⫛";
  const mldr = "…";
  const mnplus = "∓";
  const models = "⊧";
  const Mopf = "𝕄";
  const mopf = "𝕞";
  const mp = "∓";
  const mscr = "𝓂";
  const Mscr = "ℳ";
  const mstpos = "∾";
  const Mu = "Μ";
  const mu = "μ";
  const multimap = "⊸";
  const mumap = "⊸";
  const nabla = "∇";
  const Nacute = "Ń";
  const nacute = "ń";
  const nang = "∠⃒";
  const nap = "≉";
  const napE = "⩰̸";
  const napid = "≋̸";
  const napos = "ŉ";
  const napprox = "≉";
  const natural = "♮";
  const naturals = "ℕ";
  const natur = "♮";
  const nbsp$1 = " ";
  const nbump = "≎̸";
  const nbumpe = "≏̸";
  const ncap = "⩃";
  const Ncaron = "Ň";
  const ncaron = "ň";
  const Ncedil = "Ņ";
  const ncedil = "ņ";
  const ncong = "≇";
  const ncongdot = "⩭̸";
  const ncup = "⩂";
  const Ncy = "Н";
  const ncy = "н";
  const ndash = "–";
  const nearhk = "⤤";
  const nearr = "↗";
  const neArr = "⇗";
  const nearrow = "↗";
  const ne = "≠";
  const nedot = "≐̸";
  const NegativeMediumSpace = "​";
  const NegativeThickSpace = "​";
  const NegativeThinSpace = "​";
  const NegativeVeryThinSpace = "​";
  const nequiv = "≢";
  const nesear = "⤨";
  const nesim = "≂̸";
  const NestedGreaterGreater = "≫";
  const NestedLessLess = "≪";
  const NewLine = "\n";
  const nexist = "∄";
  const nexists = "∄";
  const Nfr = "𝔑";
  const nfr = "𝔫";
  const ngE = "≧̸";
  const nge = "≱";
  const ngeq = "≱";
  const ngeqq = "≧̸";
  const ngeqslant = "⩾̸";
  const nges = "⩾̸";
  const nGg = "⋙̸";
  const ngsim = "≵";
  const nGt = "≫⃒";
  const ngt = "≯";
  const ngtr = "≯";
  const nGtv = "≫̸";
  const nharr = "↮";
  const nhArr = "⇎";
  const nhpar = "⫲";
  const ni = "∋";
  const nis = "⋼";
  const nisd = "⋺";
  const niv = "∋";
  const NJcy = "Њ";
  const njcy = "њ";
  const nlarr = "↚";
  const nlArr = "⇍";
  const nldr = "‥";
  const nlE = "≦̸";
  const nle = "≰";
  const nleftarrow = "↚";
  const nLeftarrow = "⇍";
  const nleftrightarrow = "↮";
  const nLeftrightarrow = "⇎";
  const nleq = "≰";
  const nleqq = "≦̸";
  const nleqslant = "⩽̸";
  const nles = "⩽̸";
  const nless = "≮";
  const nLl = "⋘̸";
  const nlsim = "≴";
  const nLt = "≪⃒";
  const nlt = "≮";
  const nltri = "⋪";
  const nltrie = "⋬";
  const nLtv = "≪̸";
  const nmid = "∤";
  const NoBreak = "⁠";
  const NonBreakingSpace = " ";
  const nopf = "𝕟";
  const Nopf = "ℕ";
  const Not = "⫬";
  const not$1 = "¬";
  const NotCongruent = "≢";
  const NotCupCap = "≭";
  const NotDoubleVerticalBar = "∦";
  const NotElement = "∉";
  const NotEqual = "≠";
  const NotEqualTilde = "≂̸";
  const NotExists = "∄";
  const NotGreater = "≯";
  const NotGreaterEqual = "≱";
  const NotGreaterFullEqual = "≧̸";
  const NotGreaterGreater = "≫̸";
  const NotGreaterLess = "≹";
  const NotGreaterSlantEqual = "⩾̸";
  const NotGreaterTilde = "≵";
  const NotHumpDownHump = "≎̸";
  const NotHumpEqual = "≏̸";
  const notin = "∉";
  const notindot = "⋵̸";
  const notinE = "⋹̸";
  const notinva = "∉";
  const notinvb = "⋷";
  const notinvc = "⋶";
  const NotLeftTriangleBar = "⧏̸";
  const NotLeftTriangle = "⋪";
  const NotLeftTriangleEqual = "⋬";
  const NotLess = "≮";
  const NotLessEqual = "≰";
  const NotLessGreater = "≸";
  const NotLessLess = "≪̸";
  const NotLessSlantEqual = "⩽̸";
  const NotLessTilde = "≴";
  const NotNestedGreaterGreater = "⪢̸";
  const NotNestedLessLess = "⪡̸";
  const notni = "∌";
  const notniva = "∌";
  const notnivb = "⋾";
  const notnivc = "⋽";
  const NotPrecedes = "⊀";
  const NotPrecedesEqual = "⪯̸";
  const NotPrecedesSlantEqual = "⋠";
  const NotReverseElement = "∌";
  const NotRightTriangleBar = "⧐̸";
  const NotRightTriangle = "⋫";
  const NotRightTriangleEqual = "⋭";
  const NotSquareSubset = "⊏̸";
  const NotSquareSubsetEqual = "⋢";
  const NotSquareSuperset = "⊐̸";
  const NotSquareSupersetEqual = "⋣";
  const NotSubset = "⊂⃒";
  const NotSubsetEqual = "⊈";
  const NotSucceeds = "⊁";
  const NotSucceedsEqual = "⪰̸";
  const NotSucceedsSlantEqual = "⋡";
  const NotSucceedsTilde = "≿̸";
  const NotSuperset = "⊃⃒";
  const NotSupersetEqual = "⊉";
  const NotTilde = "≁";
  const NotTildeEqual = "≄";
  const NotTildeFullEqual = "≇";
  const NotTildeTilde = "≉";
  const NotVerticalBar = "∤";
  const nparallel = "∦";
  const npar = "∦";
  const nparsl = "⫽⃥";
  const npart = "∂̸";
  const npolint = "⨔";
  const npr = "⊀";
  const nprcue = "⋠";
  const nprec = "⊀";
  const npreceq = "⪯̸";
  const npre = "⪯̸";
  const nrarrc = "⤳̸";
  const nrarr = "↛";
  const nrArr = "⇏";
  const nrarrw = "↝̸";
  const nrightarrow = "↛";
  const nRightarrow = "⇏";
  const nrtri = "⋫";
  const nrtrie = "⋭";
  const nsc = "⊁";
  const nsccue = "⋡";
  const nsce = "⪰̸";
  const Nscr = "𝒩";
  const nscr = "𝓃";
  const nshortmid = "∤";
  const nshortparallel = "∦";
  const nsim = "≁";
  const nsime = "≄";
  const nsimeq = "≄";
  const nsmid = "∤";
  const nspar = "∦";
  const nsqsube = "⋢";
  const nsqsupe = "⋣";
  const nsub = "⊄";
  const nsubE = "⫅̸";
  const nsube = "⊈";
  const nsubset = "⊂⃒";
  const nsubseteq = "⊈";
  const nsubseteqq = "⫅̸";
  const nsucc = "⊁";
  const nsucceq = "⪰̸";
  const nsup = "⊅";
  const nsupE = "⫆̸";
  const nsupe = "⊉";
  const nsupset = "⊃⃒";
  const nsupseteq = "⊉";
  const nsupseteqq = "⫆̸";
  const ntgl = "≹";
  const Ntilde$1 = "Ñ";
  const ntilde$1 = "ñ";
  const ntlg = "≸";
  const ntriangleleft = "⋪";
  const ntrianglelefteq = "⋬";
  const ntriangleright = "⋫";
  const ntrianglerighteq = "⋭";
  const Nu = "Ν";
  const nu = "ν";
  const num = "#";
  const numero = "№";
  const numsp = " ";
  const nvap = "≍⃒";
  const nvdash = "⊬";
  const nvDash = "⊭";
  const nVdash = "⊮";
  const nVDash = "⊯";
  const nvge = "≥⃒";
  const nvgt = ">⃒";
  const nvHarr = "⤄";
  const nvinfin = "⧞";
  const nvlArr = "⤂";
  const nvle = "≤⃒";
  const nvlt = "<⃒";
  const nvltrie = "⊴⃒";
  const nvrArr = "⤃";
  const nvrtrie = "⊵⃒";
  const nvsim = "∼⃒";
  const nwarhk = "⤣";
  const nwarr = "↖";
  const nwArr = "⇖";
  const nwarrow = "↖";
  const nwnear = "⤧";
  const Oacute$1 = "Ó";
  const oacute$1 = "ó";
  const oast = "⊛";
  const Ocirc$1 = "Ô";
  const ocirc$1 = "ô";
  const ocir = "⊚";
  const Ocy = "О";
  const ocy = "о";
  const odash = "⊝";
  const Odblac = "Ő";
  const odblac = "ő";
  const odiv = "⨸";
  const odot = "⊙";
  const odsold = "⦼";
  const OElig = "Œ";
  const oelig = "œ";
  const ofcir = "⦿";
  const Ofr = "𝔒";
  const ofr = "𝔬";
  const ogon = "˛";
  const Ograve$1 = "Ò";
  const ograve$1 = "ò";
  const ogt = "⧁";
  const ohbar = "⦵";
  const ohm = "Ω";
  const oint = "∮";
  const olarr = "↺";
  const olcir = "⦾";
  const olcross = "⦻";
  const oline = "‾";
  const olt = "⧀";
  const Omacr = "Ō";
  const omacr = "ō";
  const Omega = "Ω";
  const omega = "ω";
  const Omicron = "Ο";
  const omicron = "ο";
  const omid = "⦶";
  const ominus = "⊖";
  const Oopf = "𝕆";
  const oopf = "𝕠";
  const opar = "⦷";
  const OpenCurlyDoubleQuote = "“";
  const OpenCurlyQuote = "‘";
  const operp = "⦹";
  const oplus = "⊕";
  const orarr = "↻";
  const Or = "⩔";
  const or = "∨";
  const ord = "⩝";
  const order = "ℴ";
  const orderof = "ℴ";
  const ordf$1 = "ª";
  const ordm$1 = "º";
  const origof = "⊶";
  const oror = "⩖";
  const orslope = "⩗";
  const orv = "⩛";
  const oS = "Ⓢ";
  const Oscr = "𝒪";
  const oscr = "ℴ";
  const Oslash$1 = "Ø";
  const oslash$1 = "ø";
  const osol = "⊘";
  const Otilde$1 = "Õ";
  const otilde$1 = "õ";
  const otimesas = "⨶";
  const Otimes = "⨷";
  const otimes = "⊗";
  const Ouml$1 = "Ö";
  const ouml$1 = "ö";
  const ovbar = "⌽";
  const OverBar = "‾";
  const OverBrace = "⏞";
  const OverBracket = "⎴";
  const OverParenthesis = "⏜";
  const para$1 = "¶";
  const parallel = "∥";
  const par = "∥";
  const parsim = "⫳";
  const parsl = "⫽";
  const part = "∂";
  const PartialD = "∂";
  const Pcy = "П";
  const pcy = "п";
  const percnt = "%";
  const period = ".";
  const permil = "‰";
  const perp = "⊥";
  const pertenk = "‱";
  const Pfr = "𝔓";
  const pfr = "𝔭";
  const Phi = "Φ";
  const phi = "φ";
  const phiv = "ϕ";
  const phmmat = "ℳ";
  const phone = "☎";
  const Pi = "Π";
  const pi = "π";
  const pitchfork = "⋔";
  const piv = "ϖ";
  const planck = "ℏ";
  const planckh = "ℎ";
  const plankv = "ℏ";
  const plusacir = "⨣";
  const plusb = "⊞";
  const pluscir = "⨢";
  const plus = "+";
  const plusdo = "∔";
  const plusdu = "⨥";
  const pluse = "⩲";
  const PlusMinus = "±";
  const plusmn$1 = "±";
  const plussim = "⨦";
  const plustwo = "⨧";
  const pm = "±";
  const Poincareplane = "ℌ";
  const pointint = "⨕";
  const popf = "𝕡";
  const Popf = "ℙ";
  const pound$1 = "£";
  const prap = "⪷";
  const Pr = "⪻";
  const pr = "≺";
  const prcue = "≼";
  const precapprox = "⪷";
  const prec = "≺";
  const preccurlyeq = "≼";
  const Precedes = "≺";
  const PrecedesEqual = "⪯";
  const PrecedesSlantEqual = "≼";
  const PrecedesTilde = "≾";
  const preceq = "⪯";
  const precnapprox = "⪹";
  const precneqq = "⪵";
  const precnsim = "⋨";
  const pre = "⪯";
  const prE = "⪳";
  const precsim = "≾";
  const prime = "′";
  const Prime = "″";
  const primes = "ℙ";
  const prnap = "⪹";
  const prnE = "⪵";
  const prnsim = "⋨";
  const prod = "∏";
  const Product$1 = "∏";
  const profalar = "⌮";
  const profline = "⌒";
  const profsurf = "⌓";
  const prop = "∝";
  const Proportional = "∝";
  const Proportion = "∷";
  const propto = "∝";
  const prsim = "≾";
  const prurel = "⊰";
  const Pscr = "𝒫";
  const pscr = "𝓅";
  const Psi = "Ψ";
  const psi = "ψ";
  const puncsp = " ";
  const Qfr = "𝔔";
  const qfr = "𝔮";
  const qint = "⨌";
  const qopf = "𝕢";
  const Qopf = "ℚ";
  const qprime = "⁗";
  const Qscr = "𝒬";
  const qscr = "𝓆";
  const quaternions = "ℍ";
  const quatint = "⨖";
  const quest = "?";
  const questeq = "≟";
  const quot$2 = '"';
  const QUOT$1 = '"';
  const rAarr = "⇛";
  const race = "∽̱";
  const Racute = "Ŕ";
  const racute = "ŕ";
  const radic = "√";
  const raemptyv = "⦳";
  const rang = "⟩";
  const Rang = "⟫";
  const rangd = "⦒";
  const range = "⦥";
  const rangle = "⟩";
  const raquo$1 = "»";
  const rarrap = "⥵";
  const rarrb = "⇥";
  const rarrbfs = "⤠";
  const rarrc = "⤳";
  const rarr = "→";
  const Rarr = "↠";
  const rArr = "⇒";
  const rarrfs = "⤞";
  const rarrhk = "↪";
  const rarrlp = "↬";
  const rarrpl = "⥅";
  const rarrsim = "⥴";
  const Rarrtl = "⤖";
  const rarrtl = "↣";
  const rarrw = "↝";
  const ratail = "⤚";
  const rAtail = "⤜";
  const ratio = "∶";
  const rationals = "ℚ";
  const rbarr = "⤍";
  const rBarr = "⤏";
  const RBarr = "⤐";
  const rbbrk = "❳";
  const rbrace = "}";
  const rbrack = "]";
  const rbrke = "⦌";
  const rbrksld = "⦎";
  const rbrkslu = "⦐";
  const Rcaron = "Ř";
  const rcaron = "ř";
  const Rcedil = "Ŗ";
  const rcedil = "ŗ";
  const rceil = "⌉";
  const rcub = "}";
  const Rcy = "Р";
  const rcy = "р";
  const rdca = "⤷";
  const rdldhar = "⥩";
  const rdquo = "”";
  const rdquor = "”";
  const rdsh = "↳";
  const real = "ℜ";
  const realine = "ℛ";
  const realpart = "ℜ";
  const reals = "ℝ";
  const Re = "ℜ";
  const rect = "▭";
  const reg$1 = "®";
  const REG$1 = "®";
  const ReverseElement = "∋";
  const ReverseEquilibrium = "⇋";
  const ReverseUpEquilibrium = "⥯";
  const rfisht = "⥽";
  const rfloor = "⌋";
  const rfr = "𝔯";
  const Rfr = "ℜ";
  const rHar = "⥤";
  const rhard = "⇁";
  const rharu = "⇀";
  const rharul = "⥬";
  const Rho = "Ρ";
  const rho = "ρ";
  const rhov = "ϱ";
  const RightAngleBracket = "⟩";
  const RightArrowBar = "⇥";
  const rightarrow = "→";
  const RightArrow = "→";
  const Rightarrow = "⇒";
  const RightArrowLeftArrow = "⇄";
  const rightarrowtail = "↣";
  const RightCeiling = "⌉";
  const RightDoubleBracket = "⟧";
  const RightDownTeeVector = "⥝";
  const RightDownVectorBar = "⥕";
  const RightDownVector = "⇂";
  const RightFloor = "⌋";
  const rightharpoondown = "⇁";
  const rightharpoonup = "⇀";
  const rightleftarrows = "⇄";
  const rightleftharpoons = "⇌";
  const rightrightarrows = "⇉";
  const rightsquigarrow = "↝";
  const RightTeeArrow = "↦";
  const RightTee = "⊢";
  const RightTeeVector = "⥛";
  const rightthreetimes = "⋌";
  const RightTriangleBar = "⧐";
  const RightTriangle = "⊳";
  const RightTriangleEqual = "⊵";
  const RightUpDownVector = "⥏";
  const RightUpTeeVector = "⥜";
  const RightUpVectorBar = "⥔";
  const RightUpVector = "↾";
  const RightVectorBar = "⥓";
  const RightVector = "⇀";
  const ring = "˚";
  const risingdotseq = "≓";
  const rlarr = "⇄";
  const rlhar = "⇌";
  const rlm = "‏";
  const rmoustache = "⎱";
  const rmoust = "⎱";
  const rnmid = "⫮";
  const roang = "⟭";
  const roarr = "⇾";
  const robrk = "⟧";
  const ropar = "⦆";
  const ropf = "𝕣";
  const Ropf = "ℝ";
  const roplus = "⨮";
  const rotimes = "⨵";
  const RoundImplies = "⥰";
  const rpar = ")";
  const rpargt = "⦔";
  const rppolint = "⨒";
  const rrarr = "⇉";
  const Rrightarrow = "⇛";
  const rsaquo = "›";
  const rscr = "𝓇";
  const Rscr = "ℛ";
  const rsh = "↱";
  const Rsh = "↱";
  const rsqb = "]";
  const rsquo = "’";
  const rsquor = "’";
  const rthree = "⋌";
  const rtimes = "⋊";
  const rtri = "▹";
  const rtrie = "⊵";
  const rtrif = "▸";
  const rtriltri = "⧎";
  const RuleDelayed = "⧴";
  const ruluhar = "⥨";
  const rx = "℞";
  const Sacute = "Ś";
  const sacute = "ś";
  const sbquo = "‚";
  const scap = "⪸";
  const Scaron = "Š";
  const scaron = "š";
  const Sc = "⪼";
  const sc = "≻";
  const sccue = "≽";
  const sce = "⪰";
  const scE = "⪴";
  const Scedil = "Ş";
  const scedil = "ş";
  const Scirc = "Ŝ";
  const scirc = "ŝ";
  const scnap = "⪺";
  const scnE = "⪶";
  const scnsim = "⋩";
  const scpolint = "⨓";
  const scsim = "≿";
  const Scy = "С";
  const scy = "с";
  const sdotb = "⊡";
  const sdot = "⋅";
  const sdote = "⩦";
  const searhk = "⤥";
  const searr = "↘";
  const seArr = "⇘";
  const searrow = "↘";
  const sect$1 = "§";
  const semi = ";";
  const seswar = "⤩";
  const setminus = "∖";
  const setmn = "∖";
  const sext = "✶";
  const Sfr = "𝔖";
  const sfr = "𝔰";
  const sfrown = "⌢";
  const sharp = "♯";
  const SHCHcy = "Щ";
  const shchcy = "щ";
  const SHcy = "Ш";
  const shcy = "ш";
  const ShortDownArrow = "↓";
  const ShortLeftArrow = "←";
  const shortmid = "∣";
  const shortparallel = "∥";
  const ShortRightArrow = "→";
  const ShortUpArrow = "↑";
  const shy$1 = "­";
  const Sigma = "Σ";
  const sigma = "σ";
  const sigmaf = "ς";
  const sigmav = "ς";
  const sim = "∼";
  const simdot = "⩪";
  const sime = "≃";
  const simeq = "≃";
  const simg = "⪞";
  const simgE = "⪠";
  const siml = "⪝";
  const simlE = "⪟";
  const simne = "≆";
  const simplus = "⨤";
  const simrarr = "⥲";
  const slarr = "←";
  const SmallCircle = "∘";
  const smallsetminus = "∖";
  const smashp = "⨳";
  const smeparsl = "⧤";
  const smid = "∣";
  const smile = "⌣";
  const smt = "⪪";
  const smte = "⪬";
  const smtes = "⪬︀";
  const SOFTcy = "Ь";
  const softcy = "ь";
  const solbar = "⌿";
  const solb = "⧄";
  const sol = "/";
  const Sopf = "𝕊";
  const sopf = "𝕤";
  const spades = "♠";
  const spadesuit = "♠";
  const spar = "∥";
  const sqcap = "⊓";
  const sqcaps = "⊓︀";
  const sqcup = "⊔";
  const sqcups = "⊔︀";
  const Sqrt = "√";
  const sqsub = "⊏";
  const sqsube = "⊑";
  const sqsubset = "⊏";
  const sqsubseteq = "⊑";
  const sqsup = "⊐";
  const sqsupe = "⊒";
  const sqsupset = "⊐";
  const sqsupseteq = "⊒";
  const square = "□";
  const Square = "□";
  const SquareIntersection = "⊓";
  const SquareSubset = "⊏";
  const SquareSubsetEqual = "⊑";
  const SquareSuperset = "⊐";
  const SquareSupersetEqual = "⊒";
  const SquareUnion = "⊔";
  const squarf = "▪";
  const squ = "□";
  const squf = "▪";
  const srarr = "→";
  const Sscr = "𝒮";
  const sscr = "𝓈";
  const ssetmn = "∖";
  const ssmile = "⌣";
  const sstarf = "⋆";
  const Star = "⋆";
  const star = "☆";
  const starf = "★";
  const straightepsilon = "ϵ";
  const straightphi = "ϕ";
  const strns = "¯";
  const sub = "⊂";
  const Sub = "⋐";
  const subdot = "⪽";
  const subE = "⫅";
  const sube = "⊆";
  const subedot = "⫃";
  const submult = "⫁";
  const subnE = "⫋";
  const subne = "⊊";
  const subplus = "⪿";
  const subrarr = "⥹";
  const subset = "⊂";
  const Subset = "⋐";
  const subseteq = "⊆";
  const subseteqq = "⫅";
  const SubsetEqual = "⊆";
  const subsetneq = "⊊";
  const subsetneqq = "⫋";
  const subsim = "⫇";
  const subsub = "⫕";
  const subsup = "⫓";
  const succapprox = "⪸";
  const succ = "≻";
  const succcurlyeq = "≽";
  const Succeeds = "≻";
  const SucceedsEqual = "⪰";
  const SucceedsSlantEqual = "≽";
  const SucceedsTilde = "≿";
  const succeq = "⪰";
  const succnapprox = "⪺";
  const succneqq = "⪶";
  const succnsim = "⋩";
  const succsim = "≿";
  const SuchThat = "∋";
  const sum = "∑";
  const Sum = "∑";
  const sung = "♪";
  const sup1$1 = "¹";
  const sup2$1 = "²";
  const sup3$1 = "³";
  const sup = "⊃";
  const Sup = "⋑";
  const supdot = "⪾";
  const supdsub = "⫘";
  const supE = "⫆";
  const supe = "⊇";
  const supedot = "⫄";
  const Superset = "⊃";
  const SupersetEqual = "⊇";
  const suphsol = "⟉";
  const suphsub = "⫗";
  const suplarr = "⥻";
  const supmult = "⫂";
  const supnE = "⫌";
  const supne = "⊋";
  const supplus = "⫀";
  const supset = "⊃";
  const Supset = "⋑";
  const supseteq = "⊇";
  const supseteqq = "⫆";
  const supsetneq = "⊋";
  const supsetneqq = "⫌";
  const supsim = "⫈";
  const supsub = "⫔";
  const supsup = "⫖";
  const swarhk = "⤦";
  const swarr = "↙";
  const swArr = "⇙";
  const swarrow = "↙";
  const swnwar = "⤪";
  const szlig$1 = "ß";
  const Tab = "	";
  const target = "⌖";
  const Tau = "Τ";
  const tau = "τ";
  const tbrk = "⎴";
  const Tcaron = "Ť";
  const tcaron = "ť";
  const Tcedil = "Ţ";
  const tcedil = "ţ";
  const Tcy = "Т";
  const tcy = "т";
  const tdot = "⃛";
  const telrec = "⌕";
  const Tfr = "𝔗";
  const tfr = "𝔱";
  const there4 = "∴";
  const therefore = "∴";
  const Therefore = "∴";
  const Theta = "Θ";
  const theta = "θ";
  const thetasym = "ϑ";
  const thetav = "ϑ";
  const thickapprox = "≈";
  const thicksim = "∼";
  const ThickSpace = "  ";
  const ThinSpace = " ";
  const thinsp = " ";
  const thkap = "≈";
  const thksim = "∼";
  const THORN$1 = "Þ";
  const thorn$1 = "þ";
  const tilde = "˜";
  const Tilde = "∼";
  const TildeEqual = "≃";
  const TildeFullEqual = "≅";
  const TildeTilde = "≈";
  const timesbar = "⨱";
  const timesb = "⊠";
  const times$1 = "×";
  const timesd = "⨰";
  const tint = "∭";
  const toea = "⤨";
  const topbot = "⌶";
  const topcir = "⫱";
  const top = "⊤";
  const Topf = "𝕋";
  const topf = "𝕥";
  const topfork = "⫚";
  const tosa = "⤩";
  const tprime = "‴";
  const trade = "™";
  const TRADE = "™";
  const triangle = "▵";
  const triangledown = "▿";
  const triangleleft = "◃";
  const trianglelefteq = "⊴";
  const triangleq = "≜";
  const triangleright = "▹";
  const trianglerighteq = "⊵";
  const tridot = "◬";
  const trie = "≜";
  const triminus = "⨺";
  const TripleDot = "⃛";
  const triplus = "⨹";
  const trisb = "⧍";
  const tritime = "⨻";
  const trpezium = "⏢";
  const Tscr = "𝒯";
  const tscr = "𝓉";
  const TScy = "Ц";
  const tscy = "ц";
  const TSHcy = "Ћ";
  const tshcy = "ћ";
  const Tstrok = "Ŧ";
  const tstrok = "ŧ";
  const twixt = "≬";
  const twoheadleftarrow = "↞";
  const twoheadrightarrow = "↠";
  const Uacute$1 = "Ú";
  const uacute$1 = "ú";
  const uarr = "↑";
  const Uarr = "↟";
  const uArr = "⇑";
  const Uarrocir = "⥉";
  const Ubrcy = "Ў";
  const ubrcy = "ў";
  const Ubreve = "Ŭ";
  const ubreve = "ŭ";
  const Ucirc$1 = "Û";
  const ucirc$1 = "û";
  const Ucy = "У";
  const ucy = "у";
  const udarr = "⇅";
  const Udblac = "Ű";
  const udblac = "ű";
  const udhar = "⥮";
  const ufisht = "⥾";
  const Ufr = "𝔘";
  const ufr = "𝔲";
  const Ugrave$1 = "Ù";
  const ugrave$1 = "ù";
  const uHar = "⥣";
  const uharl = "↿";
  const uharr = "↾";
  const uhblk = "▀";
  const ulcorn = "⌜";
  const ulcorner = "⌜";
  const ulcrop = "⌏";
  const ultri = "◸";
  const Umacr = "Ū";
  const umacr = "ū";
  const uml$1 = "¨";
  const UnderBar = "_";
  const UnderBrace = "⏟";
  const UnderBracket = "⎵";
  const UnderParenthesis = "⏝";
  const Union = "⋃";
  const UnionPlus = "⊎";
  const Uogon = "Ų";
  const uogon = "ų";
  const Uopf = "𝕌";
  const uopf = "𝕦";
  const UpArrowBar = "⤒";
  const uparrow = "↑";
  const UpArrow = "↑";
  const Uparrow = "⇑";
  const UpArrowDownArrow = "⇅";
  const updownarrow = "↕";
  const UpDownArrow = "↕";
  const Updownarrow = "⇕";
  const UpEquilibrium = "⥮";
  const upharpoonleft = "↿";
  const upharpoonright = "↾";
  const uplus = "⊎";
  const UpperLeftArrow = "↖";
  const UpperRightArrow = "↗";
  const upsi = "υ";
  const Upsi = "ϒ";
  const upsih = "ϒ";
  const Upsilon = "Υ";
  const upsilon = "υ";
  const UpTeeArrow = "↥";
  const UpTee = "⊥";
  const upuparrows = "⇈";
  const urcorn = "⌝";
  const urcorner = "⌝";
  const urcrop = "⌎";
  const Uring = "Ů";
  const uring = "ů";
  const urtri = "◹";
  const Uscr = "𝒰";
  const uscr = "𝓊";
  const utdot = "⋰";
  const Utilde = "Ũ";
  const utilde = "ũ";
  const utri = "▵";
  const utrif = "▴";
  const uuarr = "⇈";
  const Uuml$1 = "Ü";
  const uuml$1 = "ü";
  const uwangle = "⦧";
  const vangrt = "⦜";
  const varepsilon = "ϵ";
  const varkappa = "ϰ";
  const varnothing = "∅";
  const varphi = "ϕ";
  const varpi = "ϖ";
  const varpropto = "∝";
  const varr = "↕";
  const vArr = "⇕";
  const varrho = "ϱ";
  const varsigma = "ς";
  const varsubsetneq = "⊊︀";
  const varsubsetneqq = "⫋︀";
  const varsupsetneq = "⊋︀";
  const varsupsetneqq = "⫌︀";
  const vartheta = "ϑ";
  const vartriangleleft = "⊲";
  const vartriangleright = "⊳";
  const vBar = "⫨";
  const Vbar = "⫫";
  const vBarv = "⫩";
  const Vcy = "В";
  const vcy = "в";
  const vdash = "⊢";
  const vDash = "⊨";
  const Vdash = "⊩";
  const VDash = "⊫";
  const Vdashl = "⫦";
  const veebar = "⊻";
  const vee = "∨";
  const Vee = "⋁";
  const veeeq = "≚";
  const vellip = "⋮";
  const verbar = "|";
  const Verbar = "‖";
  const vert = "|";
  const Vert = "‖";
  const VerticalBar = "∣";
  const VerticalLine = "|";
  const VerticalSeparator = "❘";
  const VerticalTilde = "≀";
  const VeryThinSpace = " ";
  const Vfr = "𝔙";
  const vfr = "𝔳";
  const vltri = "⊲";
  const vnsub = "⊂⃒";
  const vnsup = "⊃⃒";
  const Vopf = "𝕍";
  const vopf = "𝕧";
  const vprop = "∝";
  const vrtri = "⊳";
  const Vscr = "𝒱";
  const vscr = "𝓋";
  const vsubnE = "⫋︀";
  const vsubne = "⊊︀";
  const vsupnE = "⫌︀";
  const vsupne = "⊋︀";
  const Vvdash = "⊪";
  const vzigzag = "⦚";
  const Wcirc = "Ŵ";
  const wcirc = "ŵ";
  const wedbar = "⩟";
  const wedge = "∧";
  const Wedge = "⋀";
  const wedgeq = "≙";
  const weierp = "℘";
  const Wfr = "𝔚";
  const wfr = "𝔴";
  const Wopf = "𝕎";
  const wopf = "𝕨";
  const wp = "℘";
  const wr = "≀";
  const wreath = "≀";
  const Wscr = "𝒲";
  const wscr = "𝓌";
  const xcap = "⋂";
  const xcirc = "◯";
  const xcup = "⋃";
  const xdtri = "▽";
  const Xfr = "𝔛";
  const xfr = "𝔵";
  const xharr = "⟷";
  const xhArr = "⟺";
  const Xi = "Ξ";
  const xi = "ξ";
  const xlarr = "⟵";
  const xlArr = "⟸";
  const xmap = "⟼";
  const xnis = "⋻";
  const xodot = "⨀";
  const Xopf = "𝕏";
  const xopf = "𝕩";
  const xoplus = "⨁";
  const xotime = "⨂";
  const xrarr = "⟶";
  const xrArr = "⟹";
  const Xscr = "𝒳";
  const xscr = "𝓍";
  const xsqcup = "⨆";
  const xuplus = "⨄";
  const xutri = "△";
  const xvee = "⋁";
  const xwedge = "⋀";
  const Yacute$1 = "Ý";
  const yacute$1 = "ý";
  const YAcy = "Я";
  const yacy = "я";
  const Ycirc = "Ŷ";
  const ycirc = "ŷ";
  const Ycy = "Ы";
  const ycy = "ы";
  const yen$1 = "¥";
  const Yfr = "𝔜";
  const yfr = "𝔶";
  const YIcy = "Ї";
  const yicy = "ї";
  const Yopf = "𝕐";
  const yopf = "𝕪";
  const Yscr = "𝒴";
  const yscr = "𝓎";
  const YUcy = "Ю";
  const yucy = "ю";
  const yuml$1 = "ÿ";
  const Yuml = "Ÿ";
  const Zacute = "Ź";
  const zacute = "ź";
  const Zcaron = "Ž";
  const zcaron = "ž";
  const Zcy = "З";
  const zcy = "з";
  const Zdot = "Ż";
  const zdot = "ż";
  const zeetrf = "ℨ";
  const ZeroWidthSpace = "​";
  const Zeta = "Ζ";
  const zeta = "ζ";
  const zfr = "𝔷";
  const Zfr = "ℨ";
  const ZHcy = "Ж";
  const zhcy = "ж";
  const zigrarr = "⇝";
  const zopf = "𝕫";
  const Zopf = "ℤ";
  const Zscr = "𝒵";
  const zscr = "𝓏";
  const zwj = "‍";
  const zwnj = "‌";
  const require$$1$1 = {
    Aacute: Aacute$1,
    aacute: aacute$1,
    Abreve,
    abreve,
    ac,
    acd,
    acE,
    Acirc: Acirc$1,
    acirc: acirc$1,
    acute: acute$1,
    Acy,
    acy,
    AElig: AElig$1,
    aelig: aelig$1,
    af,
    Afr,
    afr,
    Agrave: Agrave$1,
    agrave: agrave$1,
    alefsym,
    aleph,
    Alpha,
    alpha,
    Amacr,
    amacr,
    amalg,
    amp: amp$2,
    AMP: AMP$1,
    andand,
    And,
    and,
    andd,
    andslope,
    andv,
    ang,
    ange,
    angle,
    angmsdaa,
    angmsdab,
    angmsdac,
    angmsdad,
    angmsdae,
    angmsdaf,
    angmsdag,
    angmsdah,
    angmsd,
    angrt,
    angrtvb,
    angrtvbd,
    angsph,
    angst,
    angzarr,
    Aogon,
    aogon,
    Aopf,
    aopf,
    apacir,
    ap,
    apE,
    ape,
    apid,
    apos: apos$1,
    ApplyFunction,
    approx,
    approxeq,
    Aring: Aring$1,
    aring: aring$1,
    Ascr,
    ascr,
    Assign,
    ast,
    asymp,
    asympeq,
    Atilde: Atilde$1,
    atilde: atilde$1,
    Auml: Auml$1,
    auml: auml$1,
    awconint,
    awint,
    backcong,
    backepsilon,
    backprime,
    backsim,
    backsimeq,
    Backslash,
    Barv,
    barvee,
    barwed,
    Barwed,
    barwedge,
    bbrk,
    bbrktbrk,
    bcong,
    Bcy,
    bcy,
    bdquo,
    becaus,
    because,
    Because,
    bemptyv,
    bepsi,
    bernou,
    Bernoullis,
    Beta,
    beta,
    beth,
    between,
    Bfr,
    bfr,
    bigcap,
    bigcirc,
    bigcup,
    bigodot,
    bigoplus,
    bigotimes,
    bigsqcup,
    bigstar,
    bigtriangledown,
    bigtriangleup,
    biguplus,
    bigvee,
    bigwedge,
    bkarow,
    blacklozenge,
    blacksquare,
    blacktriangle,
    blacktriangledown,
    blacktriangleleft,
    blacktriangleright,
    blank,
    blk12,
    blk14,
    blk34,
    block,
    bne,
    bnequiv,
    bNot,
    bnot,
    Bopf,
    bopf,
    bot,
    bottom,
    bowtie,
    boxbox,
    boxdl,
    boxdL,
    boxDl,
    boxDL,
    boxdr,
    boxdR,
    boxDr,
    boxDR,
    boxh,
    boxH,
    boxhd,
    boxHd,
    boxhD,
    boxHD,
    boxhu,
    boxHu,
    boxhU,
    boxHU,
    boxminus,
    boxplus,
    boxtimes,
    boxul,
    boxuL,
    boxUl,
    boxUL,
    boxur,
    boxuR,
    boxUr,
    boxUR,
    boxv,
    boxV,
    boxvh,
    boxvH,
    boxVh,
    boxVH,
    boxvl,
    boxvL,
    boxVl,
    boxVL,
    boxvr,
    boxvR,
    boxVr,
    boxVR,
    bprime,
    breve,
    Breve,
    brvbar: brvbar$1,
    bscr,
    Bscr,
    bsemi,
    bsim,
    bsime,
    bsolb,
    bsol,
    bsolhsub,
    bull,
    bullet,
    bump,
    bumpE,
    bumpe,
    Bumpeq,
    bumpeq,
    Cacute,
    cacute,
    capand,
    capbrcup,
    capcap,
    cap,
    Cap,
    capcup,
    capdot,
    CapitalDifferentialD,
    caps,
    caret,
    caron,
    Cayleys,
    ccaps,
    Ccaron,
    ccaron,
    Ccedil: Ccedil$1,
    ccedil: ccedil$1,
    Ccirc,
    ccirc,
    Cconint,
    ccups,
    ccupssm,
    Cdot,
    cdot,
    cedil: cedil$1,
    Cedilla,
    cemptyv,
    cent: cent$1,
    centerdot,
    CenterDot,
    cfr,
    Cfr,
    CHcy,
    chcy,
    check,
    checkmark,
    Chi,
    chi,
    circ,
    circeq,
    circlearrowleft,
    circlearrowright,
    circledast,
    circledcirc,
    circleddash,
    CircleDot,
    circledR,
    circledS,
    CircleMinus,
    CirclePlus,
    CircleTimes,
    cir,
    cirE,
    cire,
    cirfnint,
    cirmid,
    cirscir,
    ClockwiseContourIntegral,
    CloseCurlyDoubleQuote,
    CloseCurlyQuote,
    clubs,
    clubsuit,
    colon,
    Colon,
    Colone,
    colone,
    coloneq,
    comma,
    commat,
    comp,
    compfn,
    complement,
    complexes,
    cong,
    congdot,
    Congruent,
    conint,
    Conint,
    ContourIntegral,
    copf,
    Copf,
    coprod,
    Coproduct,
    copy: copy$1,
    COPY: COPY$1,
    copysr,
    CounterClockwiseContourIntegral,
    crarr,
    cross,
    Cross,
    Cscr,
    cscr,
    csub,
    csube,
    csup,
    csupe,
    ctdot,
    cudarrl,
    cudarrr,
    cuepr,
    cuesc,
    cularr,
    cularrp,
    cupbrcap,
    cupcap,
    CupCap,
    cup,
    Cup,
    cupcup,
    cupdot,
    cupor,
    cups,
    curarr,
    curarrm,
    curlyeqprec,
    curlyeqsucc,
    curlyvee,
    curlywedge,
    curren: curren$1,
    curvearrowleft,
    curvearrowright,
    cuvee,
    cuwed,
    cwconint,
    cwint,
    cylcty,
    dagger,
    Dagger,
    daleth,
    darr,
    Darr,
    dArr,
    dash,
    Dashv,
    dashv,
    dbkarow,
    dblac,
    Dcaron,
    dcaron,
    Dcy,
    dcy,
    ddagger,
    ddarr,
    DD,
    dd,
    DDotrahd,
    ddotseq,
    deg: deg$1,
    Del,
    Delta,
    delta,
    demptyv,
    dfisht,
    Dfr,
    dfr,
    dHar,
    dharl,
    dharr,
    DiacriticalAcute,
    DiacriticalDot,
    DiacriticalDoubleAcute,
    DiacriticalGrave,
    DiacriticalTilde,
    diam,
    diamond,
    Diamond,
    diamondsuit,
    diams,
    die,
    DifferentialD,
    digamma,
    disin,
    div,
    divide: divide$1,
    divideontimes,
    divonx,
    DJcy,
    djcy,
    dlcorn,
    dlcrop,
    dollar,
    Dopf,
    dopf,
    Dot,
    dot,
    DotDot,
    doteq,
    doteqdot,
    DotEqual,
    dotminus,
    dotplus,
    dotsquare,
    doublebarwedge,
    DoubleContourIntegral,
    DoubleDot,
    DoubleDownArrow,
    DoubleLeftArrow,
    DoubleLeftRightArrow,
    DoubleLeftTee,
    DoubleLongLeftArrow,
    DoubleLongLeftRightArrow,
    DoubleLongRightArrow,
    DoubleRightArrow,
    DoubleRightTee,
    DoubleUpArrow,
    DoubleUpDownArrow,
    DoubleVerticalBar,
    DownArrowBar,
    downarrow,
    DownArrow,
    Downarrow,
    DownArrowUpArrow,
    DownBreve,
    downdownarrows,
    downharpoonleft,
    downharpoonright,
    DownLeftRightVector,
    DownLeftTeeVector,
    DownLeftVectorBar,
    DownLeftVector,
    DownRightTeeVector,
    DownRightVectorBar,
    DownRightVector,
    DownTeeArrow,
    DownTee,
    drbkarow,
    drcorn,
    drcrop,
    Dscr,
    dscr,
    DScy,
    dscy,
    dsol,
    Dstrok,
    dstrok,
    dtdot,
    dtri,
    dtrif,
    duarr,
    duhar,
    dwangle,
    DZcy,
    dzcy,
    dzigrarr,
    Eacute: Eacute$1,
    eacute: eacute$1,
    easter,
    Ecaron,
    ecaron,
    Ecirc: Ecirc$1,
    ecirc: ecirc$1,
    ecir,
    ecolon,
    Ecy,
    ecy,
    eDDot,
    Edot,
    edot,
    eDot,
    ee,
    efDot,
    Efr,
    efr,
    eg,
    Egrave: Egrave$1,
    egrave: egrave$1,
    egs,
    egsdot,
    el,
    Element,
    elinters,
    ell,
    els,
    elsdot,
    Emacr,
    emacr,
    empty,
    emptyset,
    EmptySmallSquare,
    emptyv,
    EmptyVerySmallSquare,
    emsp13,
    emsp14,
    emsp,
    ENG,
    eng,
    ensp,
    Eogon,
    eogon,
    Eopf,
    eopf,
    epar,
    eparsl,
    eplus,
    epsi,
    Epsilon,
    epsilon,
    epsiv,
    eqcirc,
    eqcolon,
    eqsim,
    eqslantgtr,
    eqslantless,
    Equal,
    equals,
    EqualTilde,
    equest,
    Equilibrium,
    equiv,
    equivDD,
    eqvparsl,
    erarr,
    erDot,
    escr,
    Escr,
    esdot,
    Esim,
    esim,
    Eta,
    eta,
    ETH: ETH$1,
    eth: eth$1,
    Euml: Euml$1,
    euml: euml$1,
    euro,
    excl,
    exist,
    Exists,
    expectation,
    exponentiale,
    ExponentialE,
    fallingdotseq,
    Fcy,
    fcy,
    female,
    ffilig,
    fflig,
    ffllig,
    Ffr,
    ffr,
    filig,
    FilledSmallSquare,
    FilledVerySmallSquare,
    fjlig,
    flat,
    fllig,
    fltns,
    fnof,
    Fopf,
    fopf,
    forall,
    ForAll,
    fork,
    forkv,
    Fouriertrf,
    fpartint,
    frac12: frac12$1,
    frac13,
    frac14: frac14$1,
    frac15,
    frac16,
    frac18,
    frac23,
    frac25,
    frac34: frac34$1,
    frac35,
    frac38,
    frac45,
    frac56,
    frac58,
    frac78,
    frasl,
    frown,
    fscr,
    Fscr,
    gacute,
    Gamma,
    gamma,
    Gammad,
    gammad,
    gap,
    Gbreve,
    gbreve,
    Gcedil,
    Gcirc,
    gcirc,
    Gcy,
    gcy,
    Gdot,
    gdot,
    ge,
    gE,
    gEl,
    gel,
    geq,
    geqq,
    geqslant,
    gescc,
    ges,
    gesdot,
    gesdoto,
    gesdotol,
    gesl,
    gesles,
    Gfr,
    gfr,
    gg,
    Gg,
    ggg,
    gimel,
    GJcy,
    gjcy,
    gla,
    gl,
    glE,
    glj,
    gnap,
    gnapprox,
    gne,
    gnE,
    gneq,
    gneqq,
    gnsim,
    Gopf,
    gopf,
    grave,
    GreaterEqual,
    GreaterEqualLess,
    GreaterFullEqual,
    GreaterGreater,
    GreaterLess,
    GreaterSlantEqual,
    GreaterTilde,
    Gscr,
    gscr,
    gsim,
    gsime,
    gsiml,
    gtcc,
    gtcir,
    gt: gt$2,
    GT: GT$1,
    Gt,
    gtdot,
    gtlPar,
    gtquest,
    gtrapprox,
    gtrarr,
    gtrdot,
    gtreqless,
    gtreqqless,
    gtrless,
    gtrsim,
    gvertneqq,
    gvnE,
    Hacek,
    hairsp,
    half,
    hamilt,
    HARDcy,
    hardcy,
    harrcir,
    harr,
    hArr,
    harrw,
    Hat,
    hbar,
    Hcirc,
    hcirc,
    hearts,
    heartsuit,
    hellip,
    hercon,
    hfr,
    Hfr,
    HilbertSpace,
    hksearow,
    hkswarow,
    hoarr,
    homtht,
    hookleftarrow,
    hookrightarrow,
    hopf,
    Hopf,
    horbar,
    HorizontalLine,
    hscr,
    Hscr,
    hslash,
    Hstrok,
    hstrok,
    HumpDownHump,
    HumpEqual,
    hybull,
    hyphen,
    Iacute: Iacute$1,
    iacute: iacute$1,
    ic,
    Icirc: Icirc$1,
    icirc: icirc$1,
    Icy,
    icy,
    Idot,
    IEcy,
    iecy,
    iexcl: iexcl$1,
    iff,
    ifr,
    Ifr,
    Igrave: Igrave$1,
    igrave: igrave$1,
    ii,
    iiiint,
    iiint,
    iinfin,
    iiota,
    IJlig,
    ijlig,
    Imacr,
    imacr,
    image,
    ImaginaryI,
    imagline,
    imagpart,
    imath,
    Im,
    imof,
    imped,
    Implies,
    incare,
    "in": "∈",
    infin,
    infintie,
    inodot,
    intcal,
    int,
    Int,
    integers,
    Integral,
    intercal,
    Intersection,
    intlarhk,
    intprod,
    InvisibleComma,
    InvisibleTimes,
    IOcy,
    iocy,
    Iogon,
    iogon,
    Iopf,
    iopf,
    Iota,
    iota,
    iprod,
    iquest: iquest$1,
    iscr,
    Iscr,
    isin,
    isindot,
    isinE,
    isins,
    isinsv,
    isinv,
    it,
    Itilde,
    itilde,
    Iukcy,
    iukcy,
    Iuml: Iuml$1,
    iuml: iuml$1,
    Jcirc,
    jcirc,
    Jcy,
    jcy,
    Jfr,
    jfr,
    jmath,
    Jopf,
    jopf,
    Jscr,
    jscr,
    Jsercy,
    jsercy,
    Jukcy,
    jukcy,
    Kappa,
    kappa,
    kappav,
    Kcedil,
    kcedil,
    Kcy,
    kcy,
    Kfr,
    kfr,
    kgreen,
    KHcy,
    khcy,
    KJcy,
    kjcy,
    Kopf,
    kopf,
    Kscr,
    kscr,
    lAarr,
    Lacute,
    lacute,
    laemptyv,
    lagran,
    Lambda,
    lambda,
    lang,
    Lang,
    langd,
    langle,
    lap,
    Laplacetrf,
    laquo: laquo$1,
    larrb,
    larrbfs,
    larr,
    Larr,
    lArr,
    larrfs,
    larrhk,
    larrlp,
    larrpl,
    larrsim,
    larrtl,
    latail,
    lAtail,
    lat,
    late,
    lates,
    lbarr,
    lBarr,
    lbbrk,
    lbrace,
    lbrack,
    lbrke,
    lbrksld,
    lbrkslu,
    Lcaron,
    lcaron,
    Lcedil,
    lcedil,
    lceil,
    lcub,
    Lcy,
    lcy,
    ldca,
    ldquo,
    ldquor,
    ldrdhar,
    ldrushar,
    ldsh,
    le,
    lE,
    LeftAngleBracket,
    LeftArrowBar,
    leftarrow,
    LeftArrow,
    Leftarrow,
    LeftArrowRightArrow,
    leftarrowtail,
    LeftCeiling,
    LeftDoubleBracket,
    LeftDownTeeVector,
    LeftDownVectorBar,
    LeftDownVector,
    LeftFloor,
    leftharpoondown,
    leftharpoonup,
    leftleftarrows,
    leftrightarrow,
    LeftRightArrow,
    Leftrightarrow,
    leftrightarrows,
    leftrightharpoons,
    leftrightsquigarrow,
    LeftRightVector,
    LeftTeeArrow,
    LeftTee,
    LeftTeeVector,
    leftthreetimes,
    LeftTriangleBar,
    LeftTriangle,
    LeftTriangleEqual,
    LeftUpDownVector,
    LeftUpTeeVector,
    LeftUpVectorBar,
    LeftUpVector,
    LeftVectorBar,
    LeftVector,
    lEg,
    leg,
    leq,
    leqq,
    leqslant,
    lescc,
    les,
    lesdot,
    lesdoto,
    lesdotor,
    lesg,
    lesges,
    lessapprox,
    lessdot,
    lesseqgtr,
    lesseqqgtr,
    LessEqualGreater,
    LessFullEqual,
    LessGreater,
    lessgtr,
    LessLess,
    lesssim,
    LessSlantEqual,
    LessTilde,
    lfisht,
    lfloor,
    Lfr,
    lfr,
    lg,
    lgE,
    lHar,
    lhard,
    lharu,
    lharul,
    lhblk,
    LJcy,
    ljcy,
    llarr,
    ll,
    Ll,
    llcorner,
    Lleftarrow,
    llhard,
    lltri,
    Lmidot,
    lmidot,
    lmoustache,
    lmoust,
    lnap,
    lnapprox,
    lne,
    lnE,
    lneq,
    lneqq,
    lnsim,
    loang,
    loarr,
    lobrk,
    longleftarrow,
    LongLeftArrow,
    Longleftarrow,
    longleftrightarrow,
    LongLeftRightArrow,
    Longleftrightarrow,
    longmapsto,
    longrightarrow,
    LongRightArrow,
    Longrightarrow,
    looparrowleft,
    looparrowright,
    lopar,
    Lopf,
    lopf,
    loplus,
    lotimes,
    lowast,
    lowbar,
    LowerLeftArrow,
    LowerRightArrow,
    loz,
    lozenge,
    lozf,
    lpar,
    lparlt,
    lrarr,
    lrcorner,
    lrhar,
    lrhard,
    lrm,
    lrtri,
    lsaquo,
    lscr,
    Lscr,
    lsh,
    Lsh,
    lsim,
    lsime,
    lsimg,
    lsqb,
    lsquo,
    lsquor,
    Lstrok,
    lstrok,
    ltcc,
    ltcir,
    lt: lt$2,
    LT: LT$1,
    Lt,
    ltdot,
    lthree,
    ltimes,
    ltlarr,
    ltquest,
    ltri,
    ltrie,
    ltrif,
    ltrPar,
    lurdshar,
    luruhar,
    lvertneqq,
    lvnE,
    macr: macr$1,
    male,
    malt,
    maltese,
    "Map": "⤅",
    map,
    mapsto,
    mapstodown,
    mapstoleft,
    mapstoup,
    marker,
    mcomma,
    Mcy,
    mcy,
    mdash,
    mDDot,
    measuredangle,
    MediumSpace,
    Mellintrf,
    Mfr,
    mfr,
    mho,
    micro: micro$1,
    midast,
    midcir,
    mid,
    middot: middot$1,
    minusb,
    minus,
    minusd,
    minusdu,
    MinusPlus,
    mlcp,
    mldr,
    mnplus,
    models,
    Mopf,
    mopf,
    mp,
    mscr,
    Mscr,
    mstpos,
    Mu,
    mu,
    multimap,
    mumap,
    nabla,
    Nacute,
    nacute,
    nang,
    nap,
    napE,
    napid,
    napos,
    napprox,
    natural,
    naturals,
    natur,
    nbsp: nbsp$1,
    nbump,
    nbumpe,
    ncap,
    Ncaron,
    ncaron,
    Ncedil,
    ncedil,
    ncong,
    ncongdot,
    ncup,
    Ncy,
    ncy,
    ndash,
    nearhk,
    nearr,
    neArr,
    nearrow,
    ne,
    nedot,
    NegativeMediumSpace,
    NegativeThickSpace,
    NegativeThinSpace,
    NegativeVeryThinSpace,
    nequiv,
    nesear,
    nesim,
    NestedGreaterGreater,
    NestedLessLess,
    NewLine,
    nexist,
    nexists,
    Nfr,
    nfr,
    ngE,
    nge,
    ngeq,
    ngeqq,
    ngeqslant,
    nges,
    nGg,
    ngsim,
    nGt,
    ngt,
    ngtr,
    nGtv,
    nharr,
    nhArr,
    nhpar,
    ni,
    nis,
    nisd,
    niv,
    NJcy,
    njcy,
    nlarr,
    nlArr,
    nldr,
    nlE,
    nle,
    nleftarrow,
    nLeftarrow,
    nleftrightarrow,
    nLeftrightarrow,
    nleq,
    nleqq,
    nleqslant,
    nles,
    nless,
    nLl,
    nlsim,
    nLt,
    nlt,
    nltri,
    nltrie,
    nLtv,
    nmid,
    NoBreak,
    NonBreakingSpace,
    nopf,
    Nopf,
    Not,
    not: not$1,
    NotCongruent,
    NotCupCap,
    NotDoubleVerticalBar,
    NotElement,
    NotEqual,
    NotEqualTilde,
    NotExists,
    NotGreater,
    NotGreaterEqual,
    NotGreaterFullEqual,
    NotGreaterGreater,
    NotGreaterLess,
    NotGreaterSlantEqual,
    NotGreaterTilde,
    NotHumpDownHump,
    NotHumpEqual,
    notin,
    notindot,
    notinE,
    notinva,
    notinvb,
    notinvc,
    NotLeftTriangleBar,
    NotLeftTriangle,
    NotLeftTriangleEqual,
    NotLess,
    NotLessEqual,
    NotLessGreater,
    NotLessLess,
    NotLessSlantEqual,
    NotLessTilde,
    NotNestedGreaterGreater,
    NotNestedLessLess,
    notni,
    notniva,
    notnivb,
    notnivc,
    NotPrecedes,
    NotPrecedesEqual,
    NotPrecedesSlantEqual,
    NotReverseElement,
    NotRightTriangleBar,
    NotRightTriangle,
    NotRightTriangleEqual,
    NotSquareSubset,
    NotSquareSubsetEqual,
    NotSquareSuperset,
    NotSquareSupersetEqual,
    NotSubset,
    NotSubsetEqual,
    NotSucceeds,
    NotSucceedsEqual,
    NotSucceedsSlantEqual,
    NotSucceedsTilde,
    NotSuperset,
    NotSupersetEqual,
    NotTilde,
    NotTildeEqual,
    NotTildeFullEqual,
    NotTildeTilde,
    NotVerticalBar,
    nparallel,
    npar,
    nparsl,
    npart,
    npolint,
    npr,
    nprcue,
    nprec,
    npreceq,
    npre,
    nrarrc,
    nrarr,
    nrArr,
    nrarrw,
    nrightarrow,
    nRightarrow,
    nrtri,
    nrtrie,
    nsc,
    nsccue,
    nsce,
    Nscr,
    nscr,
    nshortmid,
    nshortparallel,
    nsim,
    nsime,
    nsimeq,
    nsmid,
    nspar,
    nsqsube,
    nsqsupe,
    nsub,
    nsubE,
    nsube,
    nsubset,
    nsubseteq,
    nsubseteqq,
    nsucc,
    nsucceq,
    nsup,
    nsupE,
    nsupe,
    nsupset,
    nsupseteq,
    nsupseteqq,
    ntgl,
    Ntilde: Ntilde$1,
    ntilde: ntilde$1,
    ntlg,
    ntriangleleft,
    ntrianglelefteq,
    ntriangleright,
    ntrianglerighteq,
    Nu,
    nu,
    num,
    numero,
    numsp,
    nvap,
    nvdash,
    nvDash,
    nVdash,
    nVDash,
    nvge,
    nvgt,
    nvHarr,
    nvinfin,
    nvlArr,
    nvle,
    nvlt,
    nvltrie,
    nvrArr,
    nvrtrie,
    nvsim,
    nwarhk,
    nwarr,
    nwArr,
    nwarrow,
    nwnear,
    Oacute: Oacute$1,
    oacute: oacute$1,
    oast,
    Ocirc: Ocirc$1,
    ocirc: ocirc$1,
    ocir,
    Ocy,
    ocy,
    odash,
    Odblac,
    odblac,
    odiv,
    odot,
    odsold,
    OElig,
    oelig,
    ofcir,
    Ofr,
    ofr,
    ogon,
    Ograve: Ograve$1,
    ograve: ograve$1,
    ogt,
    ohbar,
    ohm,
    oint,
    olarr,
    olcir,
    olcross,
    oline,
    olt,
    Omacr,
    omacr,
    Omega,
    omega,
    Omicron,
    omicron,
    omid,
    ominus,
    Oopf,
    oopf,
    opar,
    OpenCurlyDoubleQuote,
    OpenCurlyQuote,
    operp,
    oplus,
    orarr,
    Or,
    or,
    ord,
    order,
    orderof,
    ordf: ordf$1,
    ordm: ordm$1,
    origof,
    oror,
    orslope,
    orv,
    oS,
    Oscr,
    oscr,
    Oslash: Oslash$1,
    oslash: oslash$1,
    osol,
    Otilde: Otilde$1,
    otilde: otilde$1,
    otimesas,
    Otimes,
    otimes,
    Ouml: Ouml$1,
    ouml: ouml$1,
    ovbar,
    OverBar,
    OverBrace,
    OverBracket,
    OverParenthesis,
    para: para$1,
    parallel,
    par,
    parsim,
    parsl,
    part,
    PartialD,
    Pcy,
    pcy,
    percnt,
    period,
    permil,
    perp,
    pertenk,
    Pfr,
    pfr,
    Phi,
    phi,
    phiv,
    phmmat,
    phone,
    Pi,
    pi,
    pitchfork,
    piv,
    planck,
    planckh,
    plankv,
    plusacir,
    plusb,
    pluscir,
    plus,
    plusdo,
    plusdu,
    pluse,
    PlusMinus,
    plusmn: plusmn$1,
    plussim,
    plustwo,
    pm,
    Poincareplane,
    pointint,
    popf,
    Popf,
    pound: pound$1,
    prap,
    Pr,
    pr,
    prcue,
    precapprox,
    prec,
    preccurlyeq,
    Precedes,
    PrecedesEqual,
    PrecedesSlantEqual,
    PrecedesTilde,
    preceq,
    precnapprox,
    precneqq,
    precnsim,
    pre,
    prE,
    precsim,
    prime,
    Prime,
    primes,
    prnap,
    prnE,
    prnsim,
    prod,
    Product: Product$1,
    profalar,
    profline,
    profsurf,
    prop,
    Proportional,
    Proportion,
    propto,
    prsim,
    prurel,
    Pscr,
    pscr,
    Psi,
    psi,
    puncsp,
    Qfr,
    qfr,
    qint,
    qopf,
    Qopf,
    qprime,
    Qscr,
    qscr,
    quaternions,
    quatint,
    quest,
    questeq,
    quot: quot$2,
    QUOT: QUOT$1,
    rAarr,
    race,
    Racute,
    racute,
    radic,
    raemptyv,
    rang,
    Rang,
    rangd,
    range,
    rangle,
    raquo: raquo$1,
    rarrap,
    rarrb,
    rarrbfs,
    rarrc,
    rarr,
    Rarr,
    rArr,
    rarrfs,
    rarrhk,
    rarrlp,
    rarrpl,
    rarrsim,
    Rarrtl,
    rarrtl,
    rarrw,
    ratail,
    rAtail,
    ratio,
    rationals,
    rbarr,
    rBarr,
    RBarr,
    rbbrk,
    rbrace,
    rbrack,
    rbrke,
    rbrksld,
    rbrkslu,
    Rcaron,
    rcaron,
    Rcedil,
    rcedil,
    rceil,
    rcub,
    Rcy,
    rcy,
    rdca,
    rdldhar,
    rdquo,
    rdquor,
    rdsh,
    real,
    realine,
    realpart,
    reals,
    Re,
    rect,
    reg: reg$1,
    REG: REG$1,
    ReverseElement,
    ReverseEquilibrium,
    ReverseUpEquilibrium,
    rfisht,
    rfloor,
    rfr,
    Rfr,
    rHar,
    rhard,
    rharu,
    rharul,
    Rho,
    rho,
    rhov,
    RightAngleBracket,
    RightArrowBar,
    rightarrow,
    RightArrow,
    Rightarrow,
    RightArrowLeftArrow,
    rightarrowtail,
    RightCeiling,
    RightDoubleBracket,
    RightDownTeeVector,
    RightDownVectorBar,
    RightDownVector,
    RightFloor,
    rightharpoondown,
    rightharpoonup,
    rightleftarrows,
    rightleftharpoons,
    rightrightarrows,
    rightsquigarrow,
    RightTeeArrow,
    RightTee,
    RightTeeVector,
    rightthreetimes,
    RightTriangleBar,
    RightTriangle,
    RightTriangleEqual,
    RightUpDownVector,
    RightUpTeeVector,
    RightUpVectorBar,
    RightUpVector,
    RightVectorBar,
    RightVector,
    ring,
    risingdotseq,
    rlarr,
    rlhar,
    rlm,
    rmoustache,
    rmoust,
    rnmid,
    roang,
    roarr,
    robrk,
    ropar,
    ropf,
    Ropf,
    roplus,
    rotimes,
    RoundImplies,
    rpar,
    rpargt,
    rppolint,
    rrarr,
    Rrightarrow,
    rsaquo,
    rscr,
    Rscr,
    rsh,
    Rsh,
    rsqb,
    rsquo,
    rsquor,
    rthree,
    rtimes,
    rtri,
    rtrie,
    rtrif,
    rtriltri,
    RuleDelayed,
    ruluhar,
    rx,
    Sacute,
    sacute,
    sbquo,
    scap,
    Scaron,
    scaron,
    Sc,
    sc,
    sccue,
    sce,
    scE,
    Scedil,
    scedil,
    Scirc,
    scirc,
    scnap,
    scnE,
    scnsim,
    scpolint,
    scsim,
    Scy,
    scy,
    sdotb,
    sdot,
    sdote,
    searhk,
    searr,
    seArr,
    searrow,
    sect: sect$1,
    semi,
    seswar,
    setminus,
    setmn,
    sext,
    Sfr,
    sfr,
    sfrown,
    sharp,
    SHCHcy,
    shchcy,
    SHcy,
    shcy,
    ShortDownArrow,
    ShortLeftArrow,
    shortmid,
    shortparallel,
    ShortRightArrow,
    ShortUpArrow,
    shy: shy$1,
    Sigma,
    sigma,
    sigmaf,
    sigmav,
    sim,
    simdot,
    sime,
    simeq,
    simg,
    simgE,
    siml,
    simlE,
    simne,
    simplus,
    simrarr,
    slarr,
    SmallCircle,
    smallsetminus,
    smashp,
    smeparsl,
    smid,
    smile,
    smt,
    smte,
    smtes,
    SOFTcy,
    softcy,
    solbar,
    solb,
    sol,
    Sopf,
    sopf,
    spades,
    spadesuit,
    spar,
    sqcap,
    sqcaps,
    sqcup,
    sqcups,
    Sqrt,
    sqsub,
    sqsube,
    sqsubset,
    sqsubseteq,
    sqsup,
    sqsupe,
    sqsupset,
    sqsupseteq,
    square,
    Square,
    SquareIntersection,
    SquareSubset,
    SquareSubsetEqual,
    SquareSuperset,
    SquareSupersetEqual,
    SquareUnion,
    squarf,
    squ,
    squf,
    srarr,
    Sscr,
    sscr,
    ssetmn,
    ssmile,
    sstarf,
    Star,
    star,
    starf,
    straightepsilon,
    straightphi,
    strns,
    sub,
    Sub,
    subdot,
    subE,
    sube,
    subedot,
    submult,
    subnE,
    subne,
    subplus,
    subrarr,
    subset,
    Subset,
    subseteq,
    subseteqq,
    SubsetEqual,
    subsetneq,
    subsetneqq,
    subsim,
    subsub,
    subsup,
    succapprox,
    succ,
    succcurlyeq,
    Succeeds,
    SucceedsEqual,
    SucceedsSlantEqual,
    SucceedsTilde,
    succeq,
    succnapprox,
    succneqq,
    succnsim,
    succsim,
    SuchThat,
    sum,
    Sum,
    sung,
    sup1: sup1$1,
    sup2: sup2$1,
    sup3: sup3$1,
    sup,
    Sup,
    supdot,
    supdsub,
    supE,
    supe,
    supedot,
    Superset,
    SupersetEqual,
    suphsol,
    suphsub,
    suplarr,
    supmult,
    supnE,
    supne,
    supplus,
    supset,
    Supset,
    supseteq,
    supseteqq,
    supsetneq,
    supsetneqq,
    supsim,
    supsub,
    supsup,
    swarhk,
    swarr,
    swArr,
    swarrow,
    swnwar,
    szlig: szlig$1,
    Tab,
    target,
    Tau,
    tau,
    tbrk,
    Tcaron,
    tcaron,
    Tcedil,
    tcedil,
    Tcy,
    tcy,
    tdot,
    telrec,
    Tfr,
    tfr,
    there4,
    therefore,
    Therefore,
    Theta,
    theta,
    thetasym,
    thetav,
    thickapprox,
    thicksim,
    ThickSpace,
    ThinSpace,
    thinsp,
    thkap,
    thksim,
    THORN: THORN$1,
    thorn: thorn$1,
    tilde,
    Tilde,
    TildeEqual,
    TildeFullEqual,
    TildeTilde,
    timesbar,
    timesb,
    times: times$1,
    timesd,
    tint,
    toea,
    topbot,
    topcir,
    top,
    Topf,
    topf,
    topfork,
    tosa,
    tprime,
    trade,
    TRADE,
    triangle,
    triangledown,
    triangleleft,
    trianglelefteq,
    triangleq,
    triangleright,
    trianglerighteq,
    tridot,
    trie,
    triminus,
    TripleDot,
    triplus,
    trisb,
    tritime,
    trpezium,
    Tscr,
    tscr,
    TScy,
    tscy,
    TSHcy,
    tshcy,
    Tstrok,
    tstrok,
    twixt,
    twoheadleftarrow,
    twoheadrightarrow,
    Uacute: Uacute$1,
    uacute: uacute$1,
    uarr,
    Uarr,
    uArr,
    Uarrocir,
    Ubrcy,
    ubrcy,
    Ubreve,
    ubreve,
    Ucirc: Ucirc$1,
    ucirc: ucirc$1,
    Ucy,
    ucy,
    udarr,
    Udblac,
    udblac,
    udhar,
    ufisht,
    Ufr,
    ufr,
    Ugrave: Ugrave$1,
    ugrave: ugrave$1,
    uHar,
    uharl,
    uharr,
    uhblk,
    ulcorn,
    ulcorner,
    ulcrop,
    ultri,
    Umacr,
    umacr,
    uml: uml$1,
    UnderBar,
    UnderBrace,
    UnderBracket,
    UnderParenthesis,
    Union,
    UnionPlus,
    Uogon,
    uogon,
    Uopf,
    uopf,
    UpArrowBar,
    uparrow,
    UpArrow,
    Uparrow,
    UpArrowDownArrow,
    updownarrow,
    UpDownArrow,
    Updownarrow,
    UpEquilibrium,
    upharpoonleft,
    upharpoonright,
    uplus,
    UpperLeftArrow,
    UpperRightArrow,
    upsi,
    Upsi,
    upsih,
    Upsilon,
    upsilon,
    UpTeeArrow,
    UpTee,
    upuparrows,
    urcorn,
    urcorner,
    urcrop,
    Uring,
    uring,
    urtri,
    Uscr,
    uscr,
    utdot,
    Utilde,
    utilde,
    utri,
    utrif,
    uuarr,
    Uuml: Uuml$1,
    uuml: uuml$1,
    uwangle,
    vangrt,
    varepsilon,
    varkappa,
    varnothing,
    varphi,
    varpi,
    varpropto,
    varr,
    vArr,
    varrho,
    varsigma,
    varsubsetneq,
    varsubsetneqq,
    varsupsetneq,
    varsupsetneqq,
    vartheta,
    vartriangleleft,
    vartriangleright,
    vBar,
    Vbar,
    vBarv,
    Vcy,
    vcy,
    vdash,
    vDash,
    Vdash,
    VDash,
    Vdashl,
    veebar,
    vee,
    Vee,
    veeeq,
    vellip,
    verbar,
    Verbar,
    vert,
    Vert,
    VerticalBar,
    VerticalLine,
    VerticalSeparator,
    VerticalTilde,
    VeryThinSpace,
    Vfr,
    vfr,
    vltri,
    vnsub,
    vnsup,
    Vopf,
    vopf,
    vprop,
    vrtri,
    Vscr,
    vscr,
    vsubnE,
    vsubne,
    vsupnE,
    vsupne,
    Vvdash,
    vzigzag,
    Wcirc,
    wcirc,
    wedbar,
    wedge,
    Wedge,
    wedgeq,
    weierp,
    Wfr,
    wfr,
    Wopf,
    wopf,
    wp,
    wr,
    wreath,
    Wscr,
    wscr,
    xcap,
    xcirc,
    xcup,
    xdtri,
    Xfr,
    xfr,
    xharr,
    xhArr,
    Xi,
    xi,
    xlarr,
    xlArr,
    xmap,
    xnis,
    xodot,
    Xopf,
    xopf,
    xoplus,
    xotime,
    xrarr,
    xrArr,
    Xscr,
    xscr,
    xsqcup,
    xuplus,
    xutri,
    xvee,
    xwedge,
    Yacute: Yacute$1,
    yacute: yacute$1,
    YAcy,
    yacy,
    Ycirc,
    ycirc,
    Ycy,
    ycy,
    yen: yen$1,
    Yfr,
    yfr,
    YIcy,
    yicy,
    Yopf,
    yopf,
    Yscr,
    yscr,
    YUcy,
    yucy,
    yuml: yuml$1,
    Yuml,
    Zacute,
    zacute,
    Zcaron,
    zcaron,
    Zcy,
    zcy,
    Zdot,
    zdot,
    zeetrf,
    ZeroWidthSpace,
    Zeta,
    zeta,
    zfr,
    Zfr,
    ZHcy,
    zhcy,
    zigrarr,
    zopf,
    Zopf,
    Zscr,
    zscr,
    zwj,
    zwnj
  };
  const Aacute = "Á";
  const aacute = "á";
  const Acirc = "Â";
  const acirc = "â";
  const acute = "´";
  const AElig = "Æ";
  const aelig = "æ";
  const Agrave = "À";
  const agrave = "à";
  const amp$1 = "&";
  const AMP = "&";
  const Aring = "Å";
  const aring = "å";
  const Atilde = "Ã";
  const atilde = "ã";
  const Auml = "Ä";
  const auml = "ä";
  const brvbar = "¦";
  const Ccedil = "Ç";
  const ccedil = "ç";
  const cedil = "¸";
  const cent = "¢";
  const copy = "©";
  const COPY = "©";
  const curren = "¤";
  const deg = "°";
  const divide = "÷";
  const Eacute = "É";
  const eacute = "é";
  const Ecirc = "Ê";
  const ecirc = "ê";
  const Egrave = "È";
  const egrave = "è";
  const ETH = "Ð";
  const eth = "ð";
  const Euml = "Ë";
  const euml = "ë";
  const frac12 = "½";
  const frac14 = "¼";
  const frac34 = "¾";
  const gt$1 = ">";
  const GT = ">";
  const Iacute = "Í";
  const iacute = "í";
  const Icirc = "Î";
  const icirc = "î";
  const iexcl = "¡";
  const Igrave = "Ì";
  const igrave = "ì";
  const iquest = "¿";
  const Iuml = "Ï";
  const iuml = "ï";
  const laquo = "«";
  const lt$1 = "<";
  const LT = "<";
  const macr = "¯";
  const micro = "µ";
  const middot = "·";
  const nbsp = " ";
  const not = "¬";
  const Ntilde = "Ñ";
  const ntilde = "ñ";
  const Oacute = "Ó";
  const oacute = "ó";
  const Ocirc = "Ô";
  const ocirc = "ô";
  const Ograve = "Ò";
  const ograve = "ò";
  const ordf = "ª";
  const ordm = "º";
  const Oslash = "Ø";
  const oslash = "ø";
  const Otilde = "Õ";
  const otilde = "õ";
  const Ouml = "Ö";
  const ouml = "ö";
  const para = "¶";
  const plusmn = "±";
  const pound = "£";
  const quot$1 = '"';
  const QUOT = '"';
  const raquo = "»";
  const reg = "®";
  const REG = "®";
  const sect = "§";
  const shy = "­";
  const sup1 = "¹";
  const sup2 = "²";
  const sup3 = "³";
  const szlig = "ß";
  const THORN = "Þ";
  const thorn = "þ";
  const times = "×";
  const Uacute = "Ú";
  const uacute = "ú";
  const Ucirc = "Û";
  const ucirc = "û";
  const Ugrave = "Ù";
  const ugrave = "ù";
  const uml = "¨";
  const Uuml = "Ü";
  const uuml = "ü";
  const Yacute = "Ý";
  const yacute = "ý";
  const yen = "¥";
  const yuml = "ÿ";
  const require$$1 = {
    Aacute,
    aacute,
    Acirc,
    acirc,
    acute,
    AElig,
    aelig,
    Agrave,
    agrave,
    amp: amp$1,
    AMP,
    Aring,
    aring,
    Atilde,
    atilde,
    Auml,
    auml,
    brvbar,
    Ccedil,
    ccedil,
    cedil,
    cent,
    copy,
    COPY,
    curren,
    deg,
    divide,
    Eacute,
    eacute,
    Ecirc,
    ecirc,
    Egrave,
    egrave,
    ETH,
    eth,
    Euml,
    euml,
    frac12,
    frac14,
    frac34,
    gt: gt$1,
    GT,
    Iacute,
    iacute,
    Icirc,
    icirc,
    iexcl,
    Igrave,
    igrave,
    iquest,
    Iuml,
    iuml,
    laquo,
    lt: lt$1,
    LT,
    macr,
    micro,
    middot,
    nbsp,
    not,
    Ntilde,
    ntilde,
    Oacute,
    oacute,
    Ocirc,
    ocirc,
    Ograve,
    ograve,
    ordf,
    ordm,
    Oslash,
    oslash,
    Otilde,
    otilde,
    Ouml,
    ouml,
    para,
    plusmn,
    pound,
    quot: quot$1,
    QUOT,
    raquo,
    reg,
    REG,
    sect,
    shy,
    sup1,
    sup2,
    sup3,
    szlig,
    THORN,
    thorn,
    times,
    Uacute,
    uacute,
    Ucirc,
    ucirc,
    Ugrave,
    ugrave,
    uml,
    Uuml,
    uuml,
    Yacute,
    yacute,
    yen,
    yuml
  };
  const amp = "&";
  const apos = "'";
  const gt = ">";
  const lt = "<";
  const quot = '"';
  const require$$0$1 = {
    amp,
    apos,
    gt,
    lt,
    quot
  };
  var decode_codepoint = {};
  const require$$0 = {
    "0": 65533,
    "128": 8364,
    "130": 8218,
    "131": 402,
    "132": 8222,
    "133": 8230,
    "134": 8224,
    "135": 8225,
    "136": 710,
    "137": 8240,
    "138": 352,
    "139": 8249,
    "140": 338,
    "142": 381,
    "145": 8216,
    "146": 8217,
    "147": 8220,
    "148": 8221,
    "149": 8226,
    "150": 8211,
    "151": 8212,
    "152": 732,
    "153": 8482,
    "154": 353,
    "155": 8250,
    "156": 339,
    "158": 382,
    "159": 376
  };
  var hasRequiredDecode_codepoint;
  function requireDecode_codepoint() {
    if (hasRequiredDecode_codepoint)
      return decode_codepoint;
    hasRequiredDecode_codepoint = 1;
    var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(decode_codepoint, "__esModule", { value: true });
    var decode_json_1 = __importDefault(require$$0);
    var fromCodePoint = (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      String.fromCodePoint || function(codePoint) {
        var output = "";
        if (codePoint > 65535) {
          codePoint -= 65536;
          output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        output += String.fromCharCode(codePoint);
        return output;
      }
    );
    function decodeCodePoint2(codePoint) {
      if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
        return "�";
      }
      if (codePoint in decode_json_1.default) {
        codePoint = decode_json_1.default[codePoint];
      }
      return fromCodePoint(codePoint);
    }
    decode_codepoint.default = decodeCodePoint2;
    return decode_codepoint;
  }
  var hasRequiredDecode;
  function requireDecode() {
    if (hasRequiredDecode)
      return decode;
    hasRequiredDecode = 1;
    var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(decode, "__esModule", { value: true });
    decode.decodeHTML = decode.decodeHTMLStrict = decode.decodeXML = void 0;
    var entities_json_1 = __importDefault(require$$1$1);
    var legacy_json_1 = __importDefault(require$$1);
    var xml_json_1 = __importDefault(require$$0$1);
    var decode_codepoint_1 = __importDefault(requireDecode_codepoint());
    var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
    decode.decodeXML = getStrictDecoder(xml_json_1.default);
    decode.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
    function getStrictDecoder(map2) {
      var replace = getReplacer(map2);
      return function(str) {
        return String(str).replace(strictEntityRe, replace);
      };
    }
    var sorter = function(a2, b2) {
      return a2 < b2 ? 1 : -1;
    };
    decode.decodeHTML = function() {
      var legacy2 = Object.keys(legacy_json_1.default).sort(sorter);
      var keys = Object.keys(entities_json_1.default).sort(sorter);
      for (var i2 = 0, j2 = 0; i2 < keys.length; i2++) {
        if (legacy2[j2] === keys[i2]) {
          keys[i2] += ";?";
          j2++;
        } else {
          keys[i2] += ";";
        }
      }
      var re2 = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
      var replace = getReplacer(entities_json_1.default);
      function replacer(str) {
        if (str.substr(-1) !== ";")
          str += ";";
        return replace(str);
      }
      return function(str) {
        return String(str).replace(re2, replacer);
      };
    }();
    function getReplacer(map2) {
      return function replace(str) {
        if (str.charAt(1) === "#") {
          var secondChar = str.charAt(2);
          if (secondChar === "X" || secondChar === "x") {
            return decode_codepoint_1.default(parseInt(str.substr(3), 16));
          }
          return decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        return map2[str.slice(1, -1)] || str;
      };
    }
    return decode;
  }
  var encode$2 = {};
  var hasRequiredEncode;
  function requireEncode() {
    if (hasRequiredEncode)
      return encode$2;
    hasRequiredEncode = 1;
    var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(encode$2, "__esModule", { value: true });
    encode$2.escapeUTF8 = encode$2.escape = encode$2.encodeNonAsciiHTML = encode$2.encodeHTML = encode$2.encodeXML = void 0;
    var xml_json_1 = __importDefault(require$$0$1);
    var inverseXML = getInverseObj(xml_json_1.default);
    var xmlReplacer = getInverseReplacer(inverseXML);
    encode$2.encodeXML = getASCIIEncoder(inverseXML);
    var entities_json_1 = __importDefault(require$$1$1);
    var inverseHTML = getInverseObj(entities_json_1.default);
    var htmlReplacer = getInverseReplacer(inverseHTML);
    encode$2.encodeHTML = getInverse(inverseHTML, htmlReplacer);
    encode$2.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
    function getInverseObj(obj) {
      return Object.keys(obj).sort().reduce(function(inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
      }, {});
    }
    function getInverseReplacer(inverse) {
      var single = [];
      var multiple = [];
      for (var _i = 0, _a2 = Object.keys(inverse); _i < _a2.length; _i++) {
        var k2 = _a2[_i];
        if (k2.length === 1) {
          single.push("\\" + k2);
        } else {
          multiple.push(k2);
        }
      }
      single.sort();
      for (var start = 0; start < single.length - 1; start++) {
        var end = start;
        while (end < single.length - 1 && single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
          end += 1;
        }
        var count = 1 + end - start;
        if (count < 3)
          continue;
        single.splice(start, count, single[start] + "-" + single[end]);
      }
      multiple.unshift("[" + single.join("") + "]");
      return new RegExp(multiple.join("|"), "g");
    }
    var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
    var getCodePoint = (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      String.prototype.codePointAt != null ? (
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        function(str) {
          return str.codePointAt(0);
        }
      ) : (
        // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        function(c2) {
          return (c2.charCodeAt(0) - 55296) * 1024 + c2.charCodeAt(1) - 56320 + 65536;
        }
      )
    );
    function singleCharReplacer(c2) {
      return "&#x" + (c2.length > 1 ? getCodePoint(c2) : c2.charCodeAt(0)).toString(16).toUpperCase() + ";";
    }
    function getInverse(inverse, re2) {
      return function(data) {
        return data.replace(re2, function(name) {
          return inverse[name];
        }).replace(reNonASCII, singleCharReplacer);
      };
    }
    var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
    function escape(data) {
      return data.replace(reEscapeChars, singleCharReplacer);
    }
    encode$2.escape = escape;
    function escapeUTF8(data) {
      return data.replace(xmlReplacer, singleCharReplacer);
    }
    encode$2.escapeUTF8 = escapeUTF8;
    function getASCIIEncoder(obj) {
      return function(data) {
        return data.replace(reEscapeChars, function(c2) {
          return obj[c2] || singleCharReplacer(c2);
        });
      };
    }
    return encode$2;
  }
  var hasRequiredLib$1;
  function requireLib$1() {
    if (hasRequiredLib$1)
      return lib;
    hasRequiredLib$1 = 1;
    (function(exports) {
      Object.defineProperty(exports, "__esModule", { value: true });
      exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
      var decode_1 = requireDecode();
      var encode_1 = requireEncode();
      function decode2(data, level) {
        return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
      }
      exports.decode = decode2;
      function decodeStrict(data, level) {
        return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
      }
      exports.decodeStrict = decodeStrict;
      function encode2(data, level) {
        return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
      }
      exports.encode = encode2;
      var encode_2 = requireEncode();
      Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function() {
        return encode_2.encodeXML;
      } });
      Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function() {
        return encode_2.encodeHTML;
      } });
      Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function() {
        return encode_2.encodeNonAsciiHTML;
      } });
      Object.defineProperty(exports, "escape", { enumerable: true, get: function() {
        return encode_2.escape;
      } });
      Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function() {
        return encode_2.escapeUTF8;
      } });
      Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function() {
        return encode_2.encodeHTML;
      } });
      Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function() {
        return encode_2.encodeHTML;
      } });
      var decode_2 = requireDecode();
      Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function() {
        return decode_2.decodeXML;
      } });
      Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function() {
        return decode_2.decodeHTML;
      } });
      Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function() {
        return decode_2.decodeHTMLStrict;
      } });
      Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function() {
        return decode_2.decodeHTML;
      } });
      Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function() {
        return decode_2.decodeHTML;
      } });
      Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function() {
        return decode_2.decodeHTMLStrict;
      } });
      Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function() {
        return decode_2.decodeHTMLStrict;
      } });
      Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function() {
        return decode_2.decodeXML;
      } });
    })(lib);
    return lib;
  }
  const elementNames = {
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    fedropshadow: "feDropShadow",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient",
    textpath: "textPath"
  };
  const attributeNames = {
    definitionurl: "definitionURL",
    attributename: "attributeName",
    attributetype: "attributeType",
    basefrequency: "baseFrequency",
    baseprofile: "baseProfile",
    calcmode: "calcMode",
    clippathunits: "clipPathUnits",
    diffuseconstant: "diffuseConstant",
    edgemode: "edgeMode",
    filterunits: "filterUnits",
    glyphref: "glyphRef",
    gradienttransform: "gradientTransform",
    gradientunits: "gradientUnits",
    kernelmatrix: "kernelMatrix",
    kernelunitlength: "kernelUnitLength",
    keypoints: "keyPoints",
    keysplines: "keySplines",
    keytimes: "keyTimes",
    lengthadjust: "lengthAdjust",
    limitingconeangle: "limitingConeAngle",
    markerheight: "markerHeight",
    markerunits: "markerUnits",
    markerwidth: "markerWidth",
    maskcontentunits: "maskContentUnits",
    maskunits: "maskUnits",
    numoctaves: "numOctaves",
    pathlength: "pathLength",
    patterncontentunits: "patternContentUnits",
    patterntransform: "patternTransform",
    patternunits: "patternUnits",
    pointsatx: "pointsAtX",
    pointsaty: "pointsAtY",
    pointsatz: "pointsAtZ",
    preservealpha: "preserveAlpha",
    preserveaspectratio: "preserveAspectRatio",
    primitiveunits: "primitiveUnits",
    refx: "refX",
    refy: "refY",
    repeatcount: "repeatCount",
    repeatdur: "repeatDur",
    requiredextensions: "requiredExtensions",
    requiredfeatures: "requiredFeatures",
    specularconstant: "specularConstant",
    specularexponent: "specularExponent",
    spreadmethod: "spreadMethod",
    startoffset: "startOffset",
    stddeviation: "stdDeviation",
    stitchtiles: "stitchTiles",
    surfacescale: "surfaceScale",
    systemlanguage: "systemLanguage",
    tablevalues: "tableValues",
    targetx: "targetX",
    targety: "targetY",
    textlength: "textLength",
    viewbox: "viewBox",
    viewtarget: "viewTarget",
    xchannelselector: "xChannelSelector",
    ychannelselector: "yChannelSelector",
    zoomandpan: "zoomAndPan"
  };
  const require$$2 = {
    elementNames,
    attributeNames
  };
  var hasRequiredDomSerializer;
  function requireDomSerializer() {
    if (hasRequiredDomSerializer)
      return domSerializerExports;
    hasRequiredDomSerializer = 1;
    var ElementType2 = requireLib$2();
    var entities = requireLib$1();
    var foreignNames = require$$2;
    foreignNames.elementNames.__proto__ = null;
    foreignNames.attributeNames.__proto__ = null;
    var unencodedElements = {
      __proto__: null,
      style: true,
      script: true,
      xmp: true,
      iframe: true,
      noembed: true,
      noframes: true,
      plaintext: true,
      noscript: true
    };
    function formatAttrs(attributes, opts) {
      if (!attributes)
        return;
      var output = "";
      var value;
      for (var key in attributes) {
        value = attributes[key];
        if (output) {
          output += " ";
        }
        if (opts.xmlMode === "foreign") {
          key = foreignNames.attributeNames[key] || key;
        }
        output += key;
        if (value !== null && value !== "" || opts.xmlMode) {
          output += '="' + (opts.decodeEntities ? entities.encodeXML(value) : value.replace(/\"/g, "&quot;")) + '"';
        }
      }
      return output;
    }
    var singleTag = {
      __proto__: null,
      area: true,
      base: true,
      basefont: true,
      br: true,
      col: true,
      command: true,
      embed: true,
      frame: true,
      hr: true,
      img: true,
      input: true,
      isindex: true,
      keygen: true,
      link: true,
      meta: true,
      param: true,
      source: true,
      track: true,
      wbr: true
    };
    var render = domSerializer.exports = function(dom, opts) {
      if (!Array.isArray(dom) && !dom.cheerio)
        dom = [dom];
      opts = opts || {};
      var output = "";
      for (var i2 = 0; i2 < dom.length; i2++) {
        var elem = dom[i2];
        if (elem.type === "root")
          output += render(elem.children, opts);
        else if (ElementType2.isTag(elem))
          output += renderTag(elem, opts);
        else if (elem.type === ElementType2.Directive)
          output += renderDirective(elem);
        else if (elem.type === ElementType2.Comment)
          output += renderComment(elem);
        else if (elem.type === ElementType2.CDATA)
          output += renderCdata(elem);
        else
          output += renderText(elem, opts);
      }
      return output;
    };
    var foreignModeIntegrationPoints = [
      "mi",
      "mo",
      "mn",
      "ms",
      "mtext",
      "annotation-xml",
      "foreignObject",
      "desc",
      "title"
    ];
    function renderTag(elem, opts) {
      if (opts.xmlMode === "foreign") {
        elem.name = foreignNames.elementNames[elem.name] || elem.name;
        if (elem.parent && foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0)
          opts = Object.assign({}, opts, { xmlMode: false });
      }
      if (!opts.xmlMode && ["svg", "math"].indexOf(elem.name) >= 0) {
        opts = Object.assign({}, opts, { xmlMode: "foreign" });
      }
      var tag = "<" + elem.name;
      var attribs = formatAttrs(elem.attribs, opts);
      if (attribs) {
        tag += " " + attribs;
      }
      if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
        tag += "/>";
      } else {
        tag += ">";
        if (elem.children) {
          tag += render(elem.children, opts);
        }
        if (!singleTag[elem.name] || opts.xmlMode) {
          tag += "</" + elem.name + ">";
        }
      }
      return tag;
    }
    function renderDirective(elem) {
      return "<" + elem.data + ">";
    }
    function renderText(elem, opts) {
      var data = elem.data || "";
      if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
        data = entities.encodeXML(data);
      }
      return data;
    }
    function renderCdata(elem) {
      return "<![CDATA[" + elem.children[0].data + "]]>";
    }
    function renderComment(elem) {
      return "<!--" + elem.data + "-->";
    }
    return domSerializerExports;
  }
  var stringify;
  var hasRequiredStringify;
  function requireStringify() {
    if (hasRequiredStringify)
      return stringify;
    hasRequiredStringify = 1;
    var ElementType2 = domelementtype, getOuterHTML = requireDomSerializer(), isTag = ElementType2.isTag;
    stringify = {
      getInnerHTML,
      getOuterHTML,
      getText
    };
    function getInnerHTML(elem, opts) {
      return elem.children ? elem.children.map(function(elem2) {
        return getOuterHTML(elem2, opts);
      }).join("") : "";
    }
    function getText(elem) {
      if (Array.isArray(elem))
        return elem.map(getText).join("");
      if (isTag(elem))
        return elem.name === "br" ? "\n" : getText(elem.children);
      if (elem.type === ElementType2.CDATA)
        return getText(elem.children);
      if (elem.type === ElementType2.Text)
        return elem.data;
      return "";
    }
    return stringify;
  }
  var traversal = {};
  var hasRequiredTraversal;
  function requireTraversal() {
    if (hasRequiredTraversal)
      return traversal;
    hasRequiredTraversal = 1;
    var getChildren = traversal.getChildren = function(elem) {
      return elem.children;
    };
    var getParent = traversal.getParent = function(elem) {
      return elem.parent;
    };
    traversal.getSiblings = function(elem) {
      var parent = getParent(elem);
      return parent ? getChildren(parent) : [elem];
    };
    traversal.getAttributeValue = function(elem, name) {
      return elem.attribs && elem.attribs[name];
    };
    traversal.hasAttrib = function(elem, name) {
      return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
    };
    traversal.getName = function(elem) {
      return elem.name;
    };
    return traversal;
  }
  var manipulation = {};
  var hasRequiredManipulation;
  function requireManipulation() {
    if (hasRequiredManipulation)
      return manipulation;
    hasRequiredManipulation = 1;
    manipulation.removeElement = function(elem) {
      if (elem.prev)
        elem.prev.next = elem.next;
      if (elem.next)
        elem.next.prev = elem.prev;
      if (elem.parent) {
        var childs = elem.parent.children;
        childs.splice(childs.lastIndexOf(elem), 1);
      }
    };
    manipulation.replaceElement = function(elem, replacement) {
      var prev = replacement.prev = elem.prev;
      if (prev) {
        prev.next = replacement;
      }
      var next = replacement.next = elem.next;
      if (next) {
        next.prev = replacement;
      }
      var parent = replacement.parent = elem.parent;
      if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
      }
    };
    manipulation.appendChild = function(elem, child) {
      child.parent = elem;
      if (elem.children.push(child) !== 1) {
        var sibling = elem.children[elem.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
        child.next = null;
      }
    };
    manipulation.append = function(elem, next) {
      var parent = elem.parent, currNext = elem.next;
      next.next = currNext;
      next.prev = elem;
      elem.next = next;
      next.parent = parent;
      if (currNext) {
        currNext.prev = next;
        if (parent) {
          var childs = parent.children;
          childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
      } else if (parent) {
        parent.children.push(next);
      }
    };
    manipulation.prepend = function(elem, prev) {
      var parent = elem.parent;
      if (parent) {
        var childs = parent.children;
        childs.splice(childs.lastIndexOf(elem), 0, prev);
      }
      if (elem.prev) {
        elem.prev.next = prev;
      }
      prev.parent = parent;
      prev.prev = elem.prev;
      prev.next = elem;
      elem.prev = prev;
    };
    return manipulation;
  }
  var querying;
  var hasRequiredQuerying;
  function requireQuerying() {
    if (hasRequiredQuerying)
      return querying;
    hasRequiredQuerying = 1;
    var isTag = domelementtype.isTag;
    querying = {
      filter,
      find,
      findOneChild,
      findOne,
      existsOne,
      findAll
    };
    function filter(test, element2, recurse, limit) {
      if (!Array.isArray(element2))
        element2 = [element2];
      if (typeof limit !== "number" || !isFinite(limit)) {
        limit = Infinity;
      }
      return find(test, element2, recurse !== false, limit);
    }
    function find(test, elems, recurse, limit) {
      var result = [], childs;
      for (var i2 = 0, j2 = elems.length; i2 < j2; i2++) {
        if (test(elems[i2])) {
          result.push(elems[i2]);
          if (--limit <= 0)
            break;
        }
        childs = elems[i2].children;
        if (recurse && childs && childs.length > 0) {
          childs = find(test, childs, recurse, limit);
          result = result.concat(childs);
          limit -= childs.length;
          if (limit <= 0)
            break;
        }
      }
      return result;
    }
    function findOneChild(test, elems) {
      for (var i2 = 0, l2 = elems.length; i2 < l2; i2++) {
        if (test(elems[i2]))
          return elems[i2];
      }
      return null;
    }
    function findOne(test, elems) {
      var elem = null;
      for (var i2 = 0, l2 = elems.length; i2 < l2 && !elem; i2++) {
        if (!isTag(elems[i2])) {
          continue;
        } else if (test(elems[i2])) {
          elem = elems[i2];
        } else if (elems[i2].children.length > 0) {
          elem = findOne(test, elems[i2].children);
        }
      }
      return elem;
    }
    function existsOne(test, elems) {
      for (var i2 = 0, l2 = elems.length; i2 < l2; i2++) {
        if (isTag(elems[i2]) && (test(elems[i2]) || elems[i2].children.length > 0 && existsOne(test, elems[i2].children))) {
          return true;
        }
      }
      return false;
    }
    function findAll(test, rootElems) {
      var result = [];
      var stack = rootElems.slice();
      while (stack.length) {
        var elem = stack.shift();
        if (!isTag(elem))
          continue;
        if (elem.children && elem.children.length > 0) {
          stack.unshift.apply(stack, elem.children);
        }
        if (test(elem))
          result.push(elem);
      }
      return result;
    }
    return querying;
  }
  var legacy = {};
  var hasRequiredLegacy;
  function requireLegacy() {
    if (hasRequiredLegacy)
      return legacy;
    hasRequiredLegacy = 1;
    var ElementType2 = domelementtype;
    var isTag = legacy.isTag = ElementType2.isTag;
    legacy.testElement = function(options, element2) {
      for (var key in options) {
        if (!options.hasOwnProperty(key))
          ;
        else if (key === "tag_name") {
          if (!isTag(element2) || !options.tag_name(element2.name)) {
            return false;
          }
        } else if (key === "tag_type") {
          if (!options.tag_type(element2.type))
            return false;
        } else if (key === "tag_contains") {
          if (isTag(element2) || !options.tag_contains(element2.data)) {
            return false;
          }
        } else if (!element2.attribs || !options[key](element2.attribs[key])) {
          return false;
        }
      }
      return true;
    };
    var Checks = {
      tag_name: function(name) {
        if (typeof name === "function") {
          return function(elem) {
            return isTag(elem) && name(elem.name);
          };
        } else if (name === "*") {
          return isTag;
        } else {
          return function(elem) {
            return isTag(elem) && elem.name === name;
          };
        }
      },
      tag_type: function(type) {
        if (typeof type === "function") {
          return function(elem) {
            return type(elem.type);
          };
        } else {
          return function(elem) {
            return elem.type === type;
          };
        }
      },
      tag_contains: function(data) {
        if (typeof data === "function") {
          return function(elem) {
            return !isTag(elem) && data(elem.data);
          };
        } else {
          return function(elem) {
            return !isTag(elem) && elem.data === data;
          };
        }
      }
    };
    function getAttribCheck(attrib, value) {
      if (typeof value === "function") {
        return function(elem) {
          return elem.attribs && value(elem.attribs[attrib]);
        };
      } else {
        return function(elem) {
          return elem.attribs && elem.attribs[attrib] === value;
        };
      }
    }
    function combineFuncs(a2, b2) {
      return function(elem) {
        return a2(elem) || b2(elem);
      };
    }
    legacy.getElements = function(options, element2, recurse, limit) {
      var funcs = Object.keys(options).map(function(key) {
        var value = options[key];
        return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
      });
      return funcs.length === 0 ? [] : this.filter(
        funcs.reduce(combineFuncs),
        element2,
        recurse,
        limit
      );
    };
    legacy.getElementById = function(id2, element2, recurse) {
      if (!Array.isArray(element2))
        element2 = [element2];
      return this.findOne(getAttribCheck("id", id2), element2, recurse !== false);
    };
    legacy.getElementsByTagName = function(name, element2, recurse, limit) {
      return this.filter(Checks.tag_name(name), element2, recurse, limit);
    };
    legacy.getElementsByTagType = function(type, element2, recurse, limit) {
      return this.filter(Checks.tag_type(type), element2, recurse, limit);
    };
    return legacy;
  }
  var helpers = {};
  var hasRequiredHelpers;
  function requireHelpers() {
    if (hasRequiredHelpers)
      return helpers;
    hasRequiredHelpers = 1;
    helpers.removeSubsets = function(nodes) {
      var idx = nodes.length, node2, ancestor, replace;
      while (--idx > -1) {
        node2 = ancestor = nodes[idx];
        nodes[idx] = null;
        replace = true;
        while (ancestor) {
          if (nodes.indexOf(ancestor) > -1) {
            replace = false;
            nodes.splice(idx, 1);
            break;
          }
          ancestor = ancestor.parent;
        }
        if (replace) {
          nodes[idx] = node2;
        }
      }
      return nodes;
    };
    var POSITION = {
      DISCONNECTED: 1,
      PRECEDING: 2,
      FOLLOWING: 4,
      CONTAINS: 8,
      CONTAINED_BY: 16
    };
    var comparePos = helpers.compareDocumentPosition = function(nodeA, nodeB) {
      var aParents = [];
      var bParents = [];
      var current, sharedParent, siblings, aSibling, bSibling, idx;
      if (nodeA === nodeB) {
        return 0;
      }
      current = nodeA;
      while (current) {
        aParents.unshift(current);
        current = current.parent;
      }
      current = nodeB;
      while (current) {
        bParents.unshift(current);
        current = current.parent;
      }
      idx = 0;
      while (aParents[idx] === bParents[idx]) {
        idx++;
      }
      if (idx === 0) {
        return POSITION.DISCONNECTED;
      }
      sharedParent = aParents[idx - 1];
      siblings = sharedParent.children;
      aSibling = aParents[idx];
      bSibling = bParents[idx];
      if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) {
          return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
        }
        return POSITION.FOLLOWING;
      } else {
        if (sharedParent === nodeA) {
          return POSITION.PRECEDING | POSITION.CONTAINS;
        }
        return POSITION.PRECEDING;
      }
    };
    helpers.uniqueSort = function(nodes) {
      var idx = nodes.length, node2, position;
      nodes = nodes.slice();
      while (--idx > -1) {
        node2 = nodes[idx];
        position = nodes.indexOf(node2);
        if (position > -1 && position < idx) {
          nodes.splice(idx, 1);
        }
      }
      nodes.sort(function(a2, b2) {
        var relative = comparePos(a2, b2);
        if (relative & POSITION.PRECEDING) {
          return -1;
        } else if (relative & POSITION.FOLLOWING) {
          return 1;
        }
        return 0;
      });
      return nodes;
    };
    return helpers;
  }
  var hasRequiredDomutils;
  function requireDomutils() {
    if (hasRequiredDomutils)
      return domutilsExports;
    hasRequiredDomutils = 1;
    (function(module) {
      var DomUtils = module.exports;
      [
        requireStringify(),
        requireTraversal(),
        requireManipulation(),
        requireQuerying(),
        requireLegacy(),
        requireHelpers()
      ].forEach(function(ext) {
        Object.keys(ext).forEach(function(key) {
          DomUtils[key] = ext[key].bind(DomUtils);
        });
      });
    })(domutils);
    return domutilsExports;
  }
  var FeedHandler_1;
  var hasRequiredFeedHandler;
  function requireFeedHandler() {
    if (hasRequiredFeedHandler)
      return FeedHandler_1;
    hasRequiredFeedHandler = 1;
    var DomHandler2 = domhandler;
    var DomUtils = requireDomutils();
    function FeedHandler(callback2, options) {
      this.init(callback2, options);
    }
    inherits_browserExports(FeedHandler, DomHandler2);
    FeedHandler.prototype.init = DomHandler2;
    function getElements(what, where) {
      return DomUtils.getElementsByTagName(what, where, true);
    }
    function getOneElement(what, where) {
      return DomUtils.getElementsByTagName(what, where, true, 1)[0];
    }
    function fetch2(what, where, recurse) {
      return DomUtils.getText(
        DomUtils.getElementsByTagName(what, where, recurse, 1)
      ).trim();
    }
    function addConditionally(obj, prop2, what, where, recurse) {
      var tmp = fetch2(what, where, recurse);
      if (tmp)
        obj[prop2] = tmp;
    }
    var isValidFeed = function(value) {
      return value === "rss" || value === "feed" || value === "rdf:RDF";
    };
    FeedHandler.prototype.onend = function() {
      var feed = {}, feedRoot = getOneElement(isValidFeed, this.dom), tmp, childs;
      if (feedRoot) {
        if (feedRoot.name === "feed") {
          childs = feedRoot.children;
          feed.type = "atom";
          addConditionally(feed, "id", "id", childs);
          addConditionally(feed, "title", "title", childs);
          if ((tmp = getOneElement("link", childs)) && (tmp = tmp.attribs) && (tmp = tmp.href))
            feed.link = tmp;
          addConditionally(feed, "description", "subtitle", childs);
          if (tmp = fetch2("updated", childs))
            feed.updated = new Date(tmp);
          addConditionally(feed, "author", "email", childs, true);
          feed.items = getElements("entry", childs).map(function(item) {
            var entry = {}, tmp2;
            item = item.children;
            addConditionally(entry, "id", "id", item);
            addConditionally(entry, "title", "title", item);
            if ((tmp2 = getOneElement("link", item)) && (tmp2 = tmp2.attribs) && (tmp2 = tmp2.href))
              entry.link = tmp2;
            if (tmp2 = fetch2("summary", item) || fetch2("content", item))
              entry.description = tmp2;
            if (tmp2 = fetch2("updated", item))
              entry.pubDate = new Date(tmp2);
            return entry;
          });
        } else {
          childs = getOneElement("channel", feedRoot.children).children;
          feed.type = feedRoot.name.substr(0, 3);
          feed.id = "";
          addConditionally(feed, "title", "title", childs);
          addConditionally(feed, "link", "link", childs);
          addConditionally(feed, "description", "description", childs);
          if (tmp = fetch2("lastBuildDate", childs))
            feed.updated = new Date(tmp);
          addConditionally(feed, "author", "managingEditor", childs, true);
          feed.items = getElements("item", feedRoot.children).map(function(item) {
            var entry = {}, tmp2;
            item = item.children;
            addConditionally(entry, "id", "guid", item);
            addConditionally(entry, "title", "title", item);
            addConditionally(entry, "link", "link", item);
            addConditionally(entry, "description", "description", item);
            if (tmp2 = fetch2("pubDate", item))
              entry.pubDate = new Date(tmp2);
            return entry;
          });
        }
      }
      this.dom = feed;
      DomHandler2.prototype._handleCallback.call(
        this,
        feedRoot ? null : Error("couldn't find root of feed")
      );
    };
    FeedHandler_1 = FeedHandler;
    return FeedHandler_1;
  }
  var string_decoder = {};
  var safeBufferExports = {};
  var safeBuffer = {
    get exports() {
      return safeBufferExports;
    },
    set exports(v2) {
      safeBufferExports = v2;
    }
  };
  /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
  var hasRequiredSafeBuffer;
  function requireSafeBuffer() {
    if (hasRequiredSafeBuffer)
      return safeBufferExports;
    hasRequiredSafeBuffer = 1;
    (function(module, exports) {
      var buffer = require$$3;
      var Buffer2 = buffer.Buffer;
      function copyProps(src, dst) {
        for (var key in src) {
          dst[key] = src[key];
        }
      }
      if (Buffer2.from && Buffer2.alloc && Buffer2.allocUnsafe && Buffer2.allocUnsafeSlow) {
        module.exports = buffer;
      } else {
        copyProps(buffer, exports);
        exports.Buffer = SafeBuffer;
      }
      function SafeBuffer(arg, encodingOrOffset, length) {
        return Buffer2(arg, encodingOrOffset, length);
      }
      SafeBuffer.prototype = Object.create(Buffer2.prototype);
      copyProps(Buffer2, SafeBuffer);
      SafeBuffer.from = function(arg, encodingOrOffset, length) {
        if (typeof arg === "number") {
          throw new TypeError("Argument must not be a number");
        }
        return Buffer2(arg, encodingOrOffset, length);
      };
      SafeBuffer.alloc = function(size, fill, encoding) {
        if (typeof size !== "number") {
          throw new TypeError("Argument must be a number");
        }
        var buf = Buffer2(size);
        if (fill !== void 0) {
          if (typeof encoding === "string") {
            buf.fill(fill, encoding);
          } else {
            buf.fill(fill);
          }
        } else {
          buf.fill(0);
        }
        return buf;
      };
      SafeBuffer.allocUnsafe = function(size) {
        if (typeof size !== "number") {
          throw new TypeError("Argument must be a number");
        }
        return Buffer2(size);
      };
      SafeBuffer.allocUnsafeSlow = function(size) {
        if (typeof size !== "number") {
          throw new TypeError("Argument must be a number");
        }
        return buffer.SlowBuffer(size);
      };
    })(safeBuffer, safeBufferExports);
    return safeBufferExports;
  }
  var hasRequiredString_decoder;
  function requireString_decoder() {
    if (hasRequiredString_decoder)
      return string_decoder;
    hasRequiredString_decoder = 1;
    var Buffer2 = requireSafeBuffer().Buffer;
    var isEncoding = Buffer2.isEncoding || function(encoding) {
      encoding = "" + encoding;
      switch (encoding && encoding.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return true;
        default:
          return false;
      }
    };
    function _normalizeEncoding(enc) {
      if (!enc)
        return "utf8";
      var retried;
      while (true) {
        switch (enc) {
          case "utf8":
          case "utf-8":
            return "utf8";
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return "utf16le";
          case "latin1":
          case "binary":
            return "latin1";
          case "base64":
          case "ascii":
          case "hex":
            return enc;
          default:
            if (retried)
              return;
            enc = ("" + enc).toLowerCase();
            retried = true;
        }
      }
    }
    function normalizeEncoding(enc) {
      var nenc = _normalizeEncoding(enc);
      if (typeof nenc !== "string" && (Buffer2.isEncoding === isEncoding || !isEncoding(enc)))
        throw new Error("Unknown encoding: " + enc);
      return nenc || enc;
    }
    string_decoder.StringDecoder = StringDecoder;
    function StringDecoder(encoding) {
      this.encoding = normalizeEncoding(encoding);
      var nb;
      switch (this.encoding) {
        case "utf16le":
          this.text = utf16Text;
          this.end = utf16End;
          nb = 4;
          break;
        case "utf8":
          this.fillLast = utf8FillLast;
          nb = 4;
          break;
        case "base64":
          this.text = base64Text;
          this.end = base64End;
          nb = 3;
          break;
        default:
          this.write = simpleWrite;
          this.end = simpleEnd;
          return;
      }
      this.lastNeed = 0;
      this.lastTotal = 0;
      this.lastChar = Buffer2.allocUnsafe(nb);
    }
    StringDecoder.prototype.write = function(buf) {
      if (buf.length === 0)
        return "";
      var r2;
      var i2;
      if (this.lastNeed) {
        r2 = this.fillLast(buf);
        if (r2 === void 0)
          return "";
        i2 = this.lastNeed;
        this.lastNeed = 0;
      } else {
        i2 = 0;
      }
      if (i2 < buf.length)
        return r2 ? r2 + this.text(buf, i2) : this.text(buf, i2);
      return r2 || "";
    };
    StringDecoder.prototype.end = utf8End;
    StringDecoder.prototype.text = utf8Text;
    StringDecoder.prototype.fillLast = function(buf) {
      if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
      }
      buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
      this.lastNeed -= buf.length;
    };
    function utf8CheckByte(byte) {
      if (byte <= 127)
        return 0;
      else if (byte >> 5 === 6)
        return 2;
      else if (byte >> 4 === 14)
        return 3;
      else if (byte >> 3 === 30)
        return 4;
      return byte >> 6 === 2 ? -1 : -2;
    }
    function utf8CheckIncomplete(self2, buf, i2) {
      var j2 = buf.length - 1;
      if (j2 < i2)
        return 0;
      var nb = utf8CheckByte(buf[j2]);
      if (nb >= 0) {
        if (nb > 0)
          self2.lastNeed = nb - 1;
        return nb;
      }
      if (--j2 < i2 || nb === -2)
        return 0;
      nb = utf8CheckByte(buf[j2]);
      if (nb >= 0) {
        if (nb > 0)
          self2.lastNeed = nb - 2;
        return nb;
      }
      if (--j2 < i2 || nb === -2)
        return 0;
      nb = utf8CheckByte(buf[j2]);
      if (nb >= 0) {
        if (nb > 0) {
          if (nb === 2)
            nb = 0;
          else
            self2.lastNeed = nb - 3;
        }
        return nb;
      }
      return 0;
    }
    function utf8CheckExtraBytes(self2, buf, p2) {
      if ((buf[0] & 192) !== 128) {
        self2.lastNeed = 0;
        return "�";
      }
      if (self2.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 192) !== 128) {
          self2.lastNeed = 1;
          return "�";
        }
        if (self2.lastNeed > 2 && buf.length > 2) {
          if ((buf[2] & 192) !== 128) {
            self2.lastNeed = 2;
            return "�";
          }
        }
      }
    }
    function utf8FillLast(buf) {
      var p2 = this.lastTotal - this.lastNeed;
      var r2 = utf8CheckExtraBytes(this, buf);
      if (r2 !== void 0)
        return r2;
      if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p2, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
      }
      buf.copy(this.lastChar, p2, 0, buf.length);
      this.lastNeed -= buf.length;
    }
    function utf8Text(buf, i2) {
      var total = utf8CheckIncomplete(this, buf, i2);
      if (!this.lastNeed)
        return buf.toString("utf8", i2);
      this.lastTotal = total;
      var end = buf.length - (total - this.lastNeed);
      buf.copy(this.lastChar, 0, end);
      return buf.toString("utf8", i2, end);
    }
    function utf8End(buf) {
      var r2 = buf && buf.length ? this.write(buf) : "";
      if (this.lastNeed)
        return r2 + "�";
      return r2;
    }
    function utf16Text(buf, i2) {
      if ((buf.length - i2) % 2 === 0) {
        var r2 = buf.toString("utf16le", i2);
        if (r2) {
          var c2 = r2.charCodeAt(r2.length - 1);
          if (c2 >= 55296 && c2 <= 56319) {
            this.lastNeed = 2;
            this.lastTotal = 4;
            this.lastChar[0] = buf[buf.length - 2];
            this.lastChar[1] = buf[buf.length - 1];
            return r2.slice(0, -1);
          }
        }
        return r2;
      }
      this.lastNeed = 1;
      this.lastTotal = 2;
      this.lastChar[0] = buf[buf.length - 1];
      return buf.toString("utf16le", i2, buf.length - 1);
    }
    function utf16End(buf) {
      var r2 = buf && buf.length ? this.write(buf) : "";
      if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r2 + this.lastChar.toString("utf16le", 0, end);
      }
      return r2;
    }
    function base64Text(buf, i2) {
      var n2 = (buf.length - i2) % 3;
      if (n2 === 0)
        return buf.toString("base64", i2);
      this.lastNeed = 3 - n2;
      this.lastTotal = 3;
      if (n2 === 1) {
        this.lastChar[0] = buf[buf.length - 1];
      } else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
      }
      return buf.toString("base64", i2, buf.length - n2);
    }
    function base64End(buf) {
      var r2 = buf && buf.length ? this.write(buf) : "";
      if (this.lastNeed)
        return r2 + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
      return r2;
    }
    function simpleWrite(buf) {
      return buf.toString(this.encoding);
    }
    function simpleEnd(buf) {
      return buf && buf.length ? this.write(buf) : "";
    }
    return string_decoder;
  }
  var WritableStream_1;
  var hasRequiredWritableStream;
  function requireWritableStream() {
    if (hasRequiredWritableStream)
      return WritableStream_1;
    hasRequiredWritableStream = 1;
    WritableStream_1 = Stream;
    var Parser2 = Parser_1;
    var WritableStream = require$$3.Writable;
    var StringDecoder = requireString_decoder().StringDecoder;
    var Buffer2 = require$$3.Buffer;
    function Stream(cbs, options) {
      var parser = this._parser = new Parser2(cbs, options);
      var decoder = this._decoder = new StringDecoder();
      WritableStream.call(this, { decodeStrings: false });
      this.once("finish", function() {
        parser.end(decoder.end());
      });
    }
    inherits_browserExports(Stream, WritableStream);
    Stream.prototype._write = function(chunk, encoding, cb) {
      if (chunk instanceof Buffer2)
        chunk = this._decoder.write(chunk);
      this._parser.write(chunk);
      cb();
    };
    return WritableStream_1;
  }
  var Stream_1;
  var hasRequiredStream;
  function requireStream() {
    if (hasRequiredStream)
      return Stream_1;
    hasRequiredStream = 1;
    Stream_1 = Stream;
    var Parser2 = requireWritableStream();
    function Stream(options) {
      Parser2.call(this, new Cbs(this), options);
    }
    inherits_browserExports(Stream, Parser2);
    Stream.prototype.readable = true;
    function Cbs(scope) {
      this.scope = scope;
    }
    var EVENTS = requireLib().EVENTS;
    Object.keys(EVENTS).forEach(function(name) {
      if (EVENTS[name] === 0) {
        Cbs.prototype["on" + name] = function() {
          this.scope.emit(name);
        };
      } else if (EVENTS[name] === 1) {
        Cbs.prototype["on" + name] = function(a2) {
          this.scope.emit(name, a2);
        };
      } else if (EVENTS[name] === 2) {
        Cbs.prototype["on" + name] = function(a2, b2) {
          this.scope.emit(name, a2, b2);
        };
      } else {
        throw Error("wrong number of arguments!");
      }
    });
    return Stream_1;
  }
  var ProxyHandler_1;
  var hasRequiredProxyHandler;
  function requireProxyHandler() {
    if (hasRequiredProxyHandler)
      return ProxyHandler_1;
    hasRequiredProxyHandler = 1;
    ProxyHandler_1 = ProxyHandler;
    function ProxyHandler(cbs) {
      this._cbs = cbs || {};
    }
    var EVENTS = requireLib().EVENTS;
    Object.keys(EVENTS).forEach(function(name) {
      if (EVENTS[name] === 0) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function() {
          if (this._cbs[name])
            this._cbs[name]();
        };
      } else if (EVENTS[name] === 1) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a2) {
          if (this._cbs[name])
            this._cbs[name](a2);
        };
      } else if (EVENTS[name] === 2) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a2, b2) {
          if (this._cbs[name])
            this._cbs[name](a2, b2);
        };
      } else {
        throw Error("wrong number of arguments");
      }
    });
    return ProxyHandler_1;
  }
  var CollectingHandler_1;
  var hasRequiredCollectingHandler;
  function requireCollectingHandler() {
    if (hasRequiredCollectingHandler)
      return CollectingHandler_1;
    hasRequiredCollectingHandler = 1;
    CollectingHandler_1 = CollectingHandler;
    function CollectingHandler(cbs) {
      this._cbs = cbs || {};
      this.events = [];
    }
    var EVENTS = requireLib().EVENTS;
    Object.keys(EVENTS).forEach(function(name) {
      if (EVENTS[name] === 0) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function() {
          this.events.push([name]);
          if (this._cbs[name])
            this._cbs[name]();
        };
      } else if (EVENTS[name] === 1) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a2) {
          this.events.push([name, a2]);
          if (this._cbs[name])
            this._cbs[name](a2);
        };
      } else if (EVENTS[name] === 2) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a2, b2) {
          this.events.push([name, a2, b2]);
          if (this._cbs[name])
            this._cbs[name](a2, b2);
        };
      } else {
        throw Error("wrong number of arguments");
      }
    });
    CollectingHandler.prototype.onreset = function() {
      this.events = [];
      if (this._cbs.onreset)
        this._cbs.onreset();
    };
    CollectingHandler.prototype.restart = function() {
      if (this._cbs.onreset)
        this._cbs.onreset();
      for (var i2 = 0, len2 = this.events.length; i2 < len2; i2++) {
        if (this._cbs[this.events[i2][0]]) {
          var num2 = this.events[i2].length;
          if (num2 === 1) {
            this._cbs[this.events[i2][0]]();
          } else if (num2 === 2) {
            this._cbs[this.events[i2][0]](this.events[i2][1]);
          } else {
            this._cbs[this.events[i2][0]](
              this.events[i2][1],
              this.events[i2][2]
            );
          }
        }
      }
    };
    return CollectingHandler_1;
  }
  var hasRequiredLib;
  function requireLib() {
    if (hasRequiredLib)
      return libExports$1;
    hasRequiredLib = 1;
    (function(module) {
      var Parser2 = Parser_1;
      var DomHandler2 = domhandler;
      function defineProp(name, value) {
        delete module.exports[name];
        module.exports[name] = value;
        return value;
      }
      module.exports = {
        Parser: Parser2,
        Tokenizer: Tokenizer_1,
        ElementType: domelementtype,
        DomHandler: DomHandler2,
        get FeedHandler() {
          return defineProp("FeedHandler", requireFeedHandler());
        },
        get Stream() {
          return defineProp("Stream", requireStream());
        },
        get WritableStream() {
          return defineProp("WritableStream", requireWritableStream());
        },
        get ProxyHandler() {
          return defineProp("ProxyHandler", requireProxyHandler());
        },
        get DomUtils() {
          return defineProp("DomUtils", requireDomutils());
        },
        get CollectingHandler() {
          return defineProp(
            "CollectingHandler",
            requireCollectingHandler()
          );
        },
        // For legacy support
        DefaultHandler: DomHandler2,
        get RssHandler() {
          return defineProp("RssHandler", this.FeedHandler);
        },
        //helper methods
        parseDOM: function(data, options) {
          var handler = new DomHandler2(options);
          new Parser2(handler, options).end(data);
          return handler.dom;
        },
        parseFeed: function(feed, options) {
          var handler = new module.exports.FeedHandler(options);
          new Parser2(handler, options).end(feed);
          return handler.dom;
        },
        createDomStream: function(cb, options, elementCb) {
          var handler = new DomHandler2(cb, options, elementCb);
          return new Parser2(handler, options);
        },
        // List of all events that the parser emits
        EVENTS: {
          /* Format: eventname: number of arguments */
          attribute: 2,
          cdatastart: 0,
          cdataend: 0,
          text: 1,
          processinginstruction: 2,
          comment: 1,
          commentend: 0,
          closetag: 1,
          opentag: 2,
          opentagname: 1,
          error: 1,
          end: 0
        }
      };
    })(lib$2);
    return libExports$1;
  }
  var libExports = requireLib();
  const htmlparser2 = /* @__PURE__ */ getDefaultExportFromCjs(libExports);
  function isEmptyTextNode(node2) {
    return node2.type === "text" && /\r?\n/.test(node2.data) && node2.data.trim() === "";
  }
  function TextElementType(node2) {
    return node2.data;
  }
  const BooleanAttributes = [
    "allowfullScreen",
    "async",
    "autoplay",
    "capture",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "hidden",
    "loop",
    "multiple",
    "muted",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    "selected",
    "itemscope"
  ];
  const ReactAttributes = {
    /**
     * Standard Properties
     */
    accept: "accept",
    "accept-charset": "acceptCharset",
    accesskey: "accessKey",
    action: "action",
    allowfullscreen: "allowFullScreen",
    allowtransparency: "allowTransparency",
    alt: "alt",
    as: "as",
    async: "async",
    autocomplete: "autoComplete",
    autoplay: "autoPlay",
    capture: "capture",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    charset: "charSet",
    challenge: "challenge",
    checked: "checked",
    cite: "cite",
    classid: "classID",
    class: "className",
    cols: "cols",
    colspan: "colSpan",
    content: "content",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    controls: "controls",
    controlsList: "controlsList",
    coords: "coords",
    crossorigin: "crossOrigin",
    data: "data",
    datetime: "dateTime",
    default: "default",
    defer: "defer",
    dir: "dir",
    disabled: "disabled",
    download: "download",
    draggable: "draggable",
    enctype: "encType",
    form: "form",
    formaction: "formAction",
    formenctype: "formEncType",
    formmethod: "formMethod",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    headers: "headers",
    height: "height",
    hidden: "hidden",
    high: "high",
    href: "href",
    hreflang: "hrefLang",
    for: "htmlFor",
    "http-equiv": "httpEquiv",
    icon: "icon",
    id: "id",
    inputmode: "inputMode",
    integrity: "integrity",
    is: "is",
    keyparams: "keyParams",
    keytype: "keyType",
    kind: "kind",
    label: "label",
    lang: "lang",
    list: "list",
    loop: "loop",
    low: "low",
    manifest: "manifest",
    marginheight: "marginHeight",
    marginwidth: "marginWidth",
    max: "max",
    maxlength: "maxLength",
    media: "media",
    mediagroup: "mediaGroup",
    method: "method",
    min: "min",
    minlength: "minLength",
    multiple: "multiple",
    muted: "muted",
    name: "name",
    nonce: "nonce",
    novalidate: "noValidate",
    open: "open",
    optimum: "optimum",
    pattern: "pattern",
    placeholder: "placeholder",
    playsinline: "playsInline",
    poster: "poster",
    preload: "preload",
    profile: "profile",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    referrerpolicy: "referrerPolicy",
    rel: "rel",
    required: "required",
    reversed: "reversed",
    role: "role",
    rows: "rows",
    rowspan: "rowSpan",
    sandbox: "sandbox",
    scope: "scope",
    scoped: "scoped",
    scrolling: "scrolling",
    seamless: "seamless",
    selected: "selected",
    shape: "shape",
    size: "size",
    sizes: "sizes",
    slot: "slot",
    span: "span",
    spellcheck: "spellCheck",
    src: "src",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    start: "start",
    step: "step",
    style: "style",
    summary: "summary",
    tabindex: "tabIndex",
    target: "target",
    title: "title",
    type: "type",
    usemap: "useMap",
    value: "value",
    width: "width",
    wmode: "wmode",
    wrap: "wrap",
    /**
     * RDFa Properties
     */
    about: "about",
    datatype: "datatype",
    inlist: "inlist",
    prefix: "prefix",
    property: "property",
    resource: "resource",
    typeof: "typeof",
    vocab: "vocab",
    /**
     * Non-standard Properties
     */
    autocapitalize: "autoCapitalize",
    autocorrect: "autoCorrect",
    autosave: "autoSave",
    color: "color",
    itemprop: "itemProp",
    itemscope: "itemScope",
    itemtype: "itemType",
    itemid: "itemID",
    itemref: "itemRef",
    results: "results",
    security: "security",
    unselectable: "unselectable"
  };
  const VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
  const nameCache = {};
  function isValidTagOrAttributeName(tagName) {
    if (!nameCache.hasOwnProperty(tagName)) {
      nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
    }
    return nameCache[tagName];
  }
  const getParsedAttributeValue = function(attribute, value) {
    let lowerBooleanAttributes = BooleanAttributes.map((attr) => attr.toLowerCase());
    if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
      value = attribute;
    }
    return value;
  };
  function htmlAttributesToReact(attributes) {
    return Object.keys(attributes).filter((attr) => isValidTagOrAttributeName(attr)).reduce(
      (mappedAttributes, attribute) => {
        const lowerCaseAttribute = attribute.toLowerCase();
        const name = ReactAttributes[lowerCaseAttribute] || lowerCaseAttribute;
        mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);
        return mappedAttributes;
      },
      {}
    );
  }
  function InlineStyleToObject(inlineStyle = "") {
    if (inlineStyle === "") {
      return {};
    }
    return inlineStyle.split(";").reduce(
      (styleObject, stylePropertyValue) => {
        let [property, value] = stylePropertyValue.split(/^([^:]+):/).filter((val, i2) => i2 > 0).map((item) => item.trim().toLowerCase());
        if (value === void 0) {
          return styleObject;
        }
        property = property.replace(/^-ms-/, "ms-").replace(/-(.)/g, (_2, character) => character.toUpperCase());
        styleObject[property] = value;
        return styleObject;
      },
      {}
    );
  }
  function generatePropsFromAttributes(attributes, key) {
    const props = Object.assign({}, htmlAttributesToReact(attributes), { key });
    if (typeof props.style === "string" || props.style instanceof String) {
      props.style = InlineStyleToObject(props.style);
    } else {
      delete props.style;
    }
    return props;
  }
  const VoidElements = [
    "area",
    "base",
    "br",
    "col",
    "command",
    "embed",
    "hr",
    "img",
    "input",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ];
  function TagElementType(node2, index2, transform) {
    const tagName = node2.name;
    if (!isValidTagOrAttributeName(tagName)) {
      return null;
    }
    const props = generatePropsFromAttributes(node2.attribs, index2);
    let children = null;
    if (VoidElements.indexOf(tagName) === -1) {
      children = processNodes(node2.children, transform);
    }
    return Cn.createElement(tagName, props, children);
  }
  function StyleElementType(node2, index2) {
    let styles2;
    if (node2.children.length > 0) {
      styles2 = node2.children[0].data;
    }
    const props = generatePropsFromAttributes(node2.attribs, index2);
    return Cn.createElement("style", props, styles2);
  }
  function UnsupportedElementType() {
    return null;
  }
  const ElementTypes = {
    [libExports.ElementType.Text]: TextElementType,
    [libExports.ElementType.Tag]: TagElementType,
    [libExports.ElementType.Style]: StyleElementType,
    [libExports.ElementType.Directive]: UnsupportedElementType,
    [libExports.ElementType.Comment]: UnsupportedElementType,
    [libExports.ElementType.Script]: UnsupportedElementType,
    [libExports.ElementType.CDATA]: UnsupportedElementType,
    [libExports.ElementType.Doctype]: UnsupportedElementType
  };
  function convertNodeToElement(node2, index2, transform) {
    return ElementTypes[node2.type](node2, index2, transform);
  }
  function processNodes(nodes, transform) {
    return nodes.filter((node2) => !isEmptyTextNode(node2)).map((node2, index2) => {
      let transformed;
      if (typeof transform === "function") {
        transformed = transform(node2, index2);
        if (transformed === null || !!transformed) {
          return transformed;
        }
      }
      return convertNodeToElement(node2, index2, transform);
    });
  }
  function HtmlParser(html, {
    decodeEntities = true,
    transform,
    preprocessNodes = (nodes) => nodes
  } = {}) {
    const nodes = preprocessNodes(htmlparser2.parseDOM(html, { decodeEntities }));
    return processNodes(nodes, transform);
  }
  const toolipIcon = o("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "84px",
    height: "85px",
    viewBox: "0 0 84 85",
    version: "1.1",
    children: [o("title", {
      children: "icons/3333AG"
    }), o("g", {
      id: "icons/3333AG",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd",
      children: o("path", {
        d: "M10.1494671,13.1655607 C11.1238173,12.6222855 12.2286942,12.5222936 13.2261424,12.801818 C14.2257641,13.0819514 15.1170457,13.7423843 15.6627631,14.7147232 C34.4103573,48.0053759 59.4412092,64.8040239 71.8629213,71.5434298 C76.4396618,74.0265426 79.2681045,75.1247289 79.3717666,75.1635585 C80.4193459,75.557344 81.2079045,76.3375173 81.6364729,77.279571 C82.0664241,78.2246643 82.134471,79.3327049 81.7395942,80.3786644 C81.4384032,81.177985 80.9091515,81.8274446 80.252695,82.2804472 C79.5810843,82.7439073 78.7755742,83 77.9393501,82.9999899 C77.46438,82.9984776 76.9814373,82.9145918 76.5150578,82.7377088 C74.7243735,82.0677728 35.8705517,67.1135735 8.59672584,18.6818422 C8.04653655,17.7056569 7.94573011,16.5999328 8.22664612,15.60166 C8.50746187,14.6037436 9.16991873,13.7127799 10.1494671,13.1655607 Z M4.01010086,3.55298809 C5.25269389,2.82566775 6.79575714,2.81625522 8.05023202,3.52507634 L25.7429989,13.5142811 C26.719755,14.0650879 27.37909,14.9592011 27.6560536,15.9577325 C27.933732,16.958841 27.8275386,18.0652861 27.2753025,19.0312446 C26.7252326,20.0036688 25.8301122,20.6620432 24.8280101,20.9385176 C23.8270016,21.2146902 22.720707,21.1089289 21.7519982,20.5605098 L10.1094107,13.9881651 L10.1094107,30.372224 C10.1094107,31.4909881 9.65501245,32.5036203 8.91973501,33.2364866 C8.18655804,33.9672593 7.17383479,34.4196551 6.05524345,34.4196551 C4.93659138,34.4196551 3.92386119,33.9672395 3.19067985,33.236469 C2.45535901,32.503566 2.00095561,31.4908845 2.00095562,30.3722041 L2,7.04841427 C2,5.60681934 2.76481981,4.27667275 4.01010086,3.55298809 Z",
        id: "Combined-Shape",
        stroke: "#FA7E7B",
        "stroke-width": "4",
        fill: "#FFFFFF",
        "fill-rule": "nonzero",
        transform: "translate(42.000000, 43.000000) scale(-1, -1) translate(-42.000000, -43.000000) "
      })
    })]
  });
  function Nav({
    toggleCartDrawer,
    toggleMessagePopup,
    isMessagePopupOpen
  }) {
    const navEL = _$3(null);
    const [isSummaryOpen, setIsSummaryOpen] = h$2(false);
    const {
      breakpoint
    } = useBreakpoint$1(Shopify.theme.BREAKPOINTS);
    const {
      config,
      setConfig
    } = q$4(ConfigContext);
    const [onboarding, setOboarding] = h$2({
      products: config.selected.products.length,
      card: config.selected.card.length,
      messageStep: config.selected.messageStep.length,
      message: false
    });
    Shopify.theme.BundleTranslations;
    let currentIndex = config.steps.findIndex((s2) => s2.active);
    let hasBox = config.selected.box.length;
    let hasCard = config.selected.card.length;
    let hasProducts = config.selected.products.length;
    config.selected.messageStep.length;
    let showSummaryBtn = false;
    let messageStep = false;
    let message = config.message;
    if (hasCard > 0) {
      if (message.skip == false) {
        if (!message.from.trim().length || !message.message.trim().length) {
          messageStep = false;
        } else {
          messageStep = true;
        }
      } else {
        messageStep = true;
      }
    }
    if (currentIndex == 3 && hasProducts > 0 && hasBox > 0 && hasCard > 0 && messageStep == true) {
      showSummaryBtn = true;
    } else {
      showSummaryBtn = false;
    }
    if (currentIndex == 2) {
      const body = document.querySelector("body");
      body.classList.add("onStep2");
    } else {
      const body = document.querySelector("body");
      body.classList.remove("onStep2");
    }
    const changeStep = (index2) => {
      setConfig(() => {
        let temp = {
          ...config
        };
        temp.steps.map((step, i2) => {
          if (i2 == index2)
            step.active = true;
          else
            step.active = false;
          return step;
        });
        return temp;
      });
      const stepsAndNavContainer = document.querySelector(".navigationAndSetps");
      const body = document.querySelector("body");
      const html = document.documentElement;
      if (stepsAndNavContainer) {
        stepsAndNavContainer.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        body.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        html.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    const toggleSummaryDrawer = () => {
      setIsSummaryOpen((prevState) => !prevState);
    };
    const selected = [config.selected.box, config.selected.products, config.selected.card, config.selected.messageStep];
    let sum2 = 0;
    selected.map((arr) => {
      let total = arr.reduce((sum22, item) => sum22 += item.price * item.quantity, 0);
      sum2 += total;
      return total;
    });
    p$2(() => {
      document.documentElement.style.setProperty("--nav-height", navEL.current.offsetHeight + "px");
    });
    return o(_$4, {
      children: [breakpoint == "small" ? o(EZDrawer, {
        lockBackgroundScroll: true,
        open: isSummaryOpen,
        onClose: toggleSummaryDrawer,
        direction: "bottom",
        className: "bundle__summary-drawer",
        children: [o("button", {
          class: `bundle__summary-toggle ${isSummaryOpen ? "is-active" : ""} button button--primary`,
          onClick: toggleSummaryDrawer,
          children: o("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 100 100",
            children: o("g", {
              id: "up-caret",
              children: o("polygon", {
                points: "92.15 77.1 50 34.3 7.85 77.1 2.15 71.49 50 22.9 97.85 71.49 92.15 77.1"
              })
            })
          })
        }), o(Summary, {})]
      }) : null, o("div", {
        class: "nav topStickyBar one-whole is-flex is-flex-wrap",
        ref: navEL,
        children: [breakpoint == "small" ? o("button", {
          class: `bundle__summary-toggle ${isSummaryOpen ? "is-active" : ""} button button--primary`,
          onClick: toggleSummaryDrawer,
          children: o("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 100 100",
            children: o("g", {
              id: "up-caret",
              children: o("polygon", {
                points: "92.15 77.1 50 34.3 7.85 77.1 2.15 71.49 50 22.9 97.85 71.49 92.15 77.1"
              })
            })
          })
        }) : null, o("div", {
          class: "nav__steps one-half column medium-down--one-whole",
          children: [o("div", {
            class: "nav__steps__progress",
            children: o("span", {
              class: "nav__steps__baloon",
              style: {
                left: 100 * (currentIndex / 3) + "%"
              }
            })
          }), config.steps.map((step, index2) => o(NavStep, {
            index: index2,
            selected: config.selected,
            changeStep,
            currentIndex,
            onboarding,
            setOboarding
          }, index2))]
        }), o("div", {
          class: "nav__meta one-half column medium-down--one-whole is-flex is-flex-wrap is-align-center is-justify-space-between",
          children: [o("h5", {
            class: "nav__meta__price is-h5",
            children: ["Total: ", Shopify.formatMoney(sum2)]
          }), showSummaryBtn ? o("div", {
            class: "nav__controls buttons is-right is-relative",
            children: o("button", {
              class: "button button--primary",
              onClick: toggleCartDrawer,
              children: "Review Box"
            })
          }) : null]
        })]
      })]
    });
  }
  const NavStep = function({
    index: index2,
    selected,
    changeStep,
    currentIndex,
    onboarding,
    setOboarding
  }) {
    let currentStep = Object.keys(selected)[index2];
    const box = selected.box.length;
    const products = selected.products.length;
    const card = selected.card.length;
    const messageStep = selected.messageStep.length;
    const translations = Shopify.theme.BundleTranslations;
    let showMessageToolTip = false;
    if (onboarding.card == false && currentIndex == 2 && card) {
      setOboarding((prev) => {
        return {
          ...prev,
          card: true
        };
      });
    }
    if (onboarding.messageStep == false && currentIndex == 3 && messageStep) {
      setOboarding((prev) => {
        return {
          ...prev,
          messageStep: true
        };
      });
    }
    if (onboarding.products == false && currentIndex == 1 && products) {
      setOboarding((prev) => {
        return {
          ...prev,
          products: true
        };
      });
    }
    o(_$4, {});
    if (card == 1) {
      showMessageToolTip = true;
    }
    if (onboarding.products == false && currentIndex == 0 && currentStep == "products" && box) {
      o("div", {
        class: "tooltip nav__steps__tooltip",
        children: [o("span", {
          class: "caption is-h6",
          children: HtmlParser(translations.nav.tooltips.products)
        }), o("span", {
          children: toolipIcon
        })]
      });
    }
    if (onboarding.card == false && currentIndex == 1 && currentStep == "card" && products) {
      o("div", {
        class: "tooltip nav__steps__tooltip",
        children: [o("span", {
          class: "caption is-h6",
          children: HtmlParser(translations.nav.tooltips.card)
        }), o("span", {
          children: toolipIcon
        })]
      });
    }
    if (onboarding.messageStep == false && currentIndex == 2 && currentStep == "messageStep" && showMessageToolTip) {
      o("div", {
        class: "tooltip nav__steps__tooltip",
        children: [o("span", {
          class: "caption is-h6",
          children: HtmlParser(translations.nav.tooltips.message)
        }), o("span", {
          children: toolipIcon
        })]
      });
    }
    return o(_$4, {
      children: o("span", {
        class: "nav__steps__step",
        onClick: () => {
          changeStep(index2);
        },
        children: [index2 === 0 && "Select Your Box", index2 === 1 && "Choose Products", index2 === 2 && "Select Card", index2 === 3 && "Greeting Card Message"]
      })
    });
  };
  const MessagePopup = ({
    toggleMessagePopup
  }) => {
    const {
      config,
      setConfig,
      setError
    } = q$4(ConfigContext);
    const translations = Shopify.theme.BundleTranslations;
    const GlobalSettings = Shopify.theme.BundleSettings;
    const messageConfig = config.message;
    const [messageCount, setMessageCount] = h$2(messageConfig.message.length);
    const updateMessageFields = (e2) => {
      let name = e2.target.name;
      let value = e2.target.value;
      let type = e2.target.type;
      if (name == "message" && GlobalSettings.message.character_limit > 0 && value.length > GlobalSettings.message.character_limit) {
        return;
      }
      if (name == "message") {
        setMessageCount(value.length);
      }
      setConfig(() => {
        let temp = {
          ...config
        };
        if (type == "checkbox")
          temp.message[name] = e2.target.checked;
        else
          temp.message[name] = value;
        return temp;
      });
    };
    return o("div", {
      class: "bundle__message-popup",
      children: [o("h2", {
        class: "title message-poup__title text-align-center is-h3",
        children: translations.popup.message.title
      }), o("div", {
        class: "message-poup__fields",
        children: [o("div", {
          class: "message-poup__field field",
          children: [o("input", {
            class: "checkbox",
            type: "checkbox",
            id: "skip-message",
            name: "skip",
            checked: messageConfig.skip,
            onChange: updateMessageFields
          }), o("label", {
            for: "skip-message",
            children: translations.popup.message.skip_message
          })]
        }), o("div", {
          class: "message-poup__field field message-field",
          children: [o("label", {
            children: [translations.popup.message.message_label, GlobalSettings.message.character_limit > 0 && o("span", {
              class: "message-poup__field__count",
              children: [messageCount, "/", GlobalSettings.message.character_limit]
            })]
          }), o("textarea", {
            class: "textarea",
            name: "message",
            placeholder: "Your Message",
            maxLength: GlobalSettings.message.character_limit > 0 ? GlobalSettings.message.character_limit : null,
            onChange: updateMessageFields,
            children: messageConfig.message
          })]
        }), o("div", {
          class: "message-poup__field field",
          children: [o("label", {
            children: translations.popup.message.from_label
          }), o("input", {
            class: "input",
            type: "text",
            name: "from",
            value: messageConfig.from,
            placeholder: "From",
            onChange: updateMessageFields
          })]
        }), o("button", {
          class: "button button--primary",
          onClick: toggleMessagePopup,
          children: translations.summary.next_button
        })]
      })]
    });
  };
  function i(e2, t2) {
    void 0 === t2 && (t2 = {});
    var n2 = t2.insertAt;
    if (e2 && "undefined" != typeof document) {
      var i2 = document.head || document.getElementsByTagName("head")[0], a2 = document.createElement("style");
      a2.type = "text/css", "top" === n2 && i2.firstChild ? i2.insertBefore(a2, i2.firstChild) : i2.appendChild(a2), a2.styleSheet ? a2.styleSheet.cssText = e2 : a2.appendChild(document.createTextNode(e2));
    }
  }
  i(".quantity-picker{display:inline-block;border:1px solid #dfdfdf;border-radius:3px;vertical-align:middle}.quantity-input:focus{background:red}.quantity-display,.quantity-modifier{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none}.quantity-modifier{height:100%;width:3rem;font-size:1.5rem;background:#f3f3f3;color:#888;border:0 solid #dbdbdb;text-align:center;cursor:pointer}.quantity-modifier:hover{background:#dadada;color:#555}.quantity-modifier:focus{outline:0}.left-modifier{border-radius:3px 0 0 3px}.mod-disable{color:#e0e0e0}.mod-disable:hover{background-color:#f3f3f3!important;color:#e0e0e0}.right-modifier{border-radius:0 3px 3px 0}.quantity-display{width:4rem;padding:.5rem;font-size:1.5rem;border:0;border-top:0 solid #dbdbdb;border-bottom:0 solid #dbdbdb;text-align:center}");
  i(`[data-quantity]{position:relative;width:100%;max-width:11rem;padding:0;margin:0;border:0}[data-quantity] legend{display:none}[data-quantity] input{font-size:16px;height:2.3rem;padding:0 3.1rem;margin-top:.6rem;border-radius:2rem;border:0;background:#fff;color:#222;box-shadow:0 5px 45px -10px rgba(0,0,0,.25);text-align:center;width:100%;box-sizing:border-box;font-weight:lighter}[data-quantity] input:focus{outline:none;box-shadow:0 5px 55px -10px rgba(0,0,0,.2),0 0 4px #3fff7f}[data-quantity] input[type=number]::-webkit-inner-spin-button,[data-quantity] input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}[data-quantity] input[type=number]{-moz-appearance:textfield}[data-quantity] button{position:absolute;width:2.5rem;height:2.5rem;top:.5rem;display:block;padding:0;margin:0;border:0;background:#e3e2e5 url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="50"><path d="M17 25h16M67 25h16M75 17v16" fill="none" stroke="rgb(59,69,66)" stroke-width="1.5px" stroke-linecap="round" stroke-linejoin="round" /></svg>') no-repeat 0 0;background-size:4.6rem 2.2rem;overflow:hidden;white-space:nowrap;text-indent:100%;border-radius:1.4rem;cursor:pointer;transition:opacity .15s;opacity:.7}[data-quantity] button:active{background-position-y:1px;box-shadow:inset 0 2px 12px -4px #c5d1d9}[data-quantity] button:focus{outline:none}[data-quantity] button:hover{opacity:1}[data-quantity] button.sub{left:-.1rem}[data-quantity] button.add{right:-.1rem;background-position-x:-2.2rem}`);
  const a = (i2) => {
    const [a2, o2] = h$2(i2.value ? i2.value : 0), r2 = (e2) => (t2) => {
      const n2 = Number(a2) + 1, r3 = Number(a2) - 1;
      switch (e2) {
        case "increment":
          (void 0 === i2.max || n2 <= Number(i2.max)) && (o2(n2), i2.onChange && i2.onChange(n2));
          break;
        case "decrement":
          (void 0 === i2.min || r3 >= Number(i2.min)) && (o2(r3), i2.onChange && i2.onChange(r3));
          break;
        case "input":
          (void 0 === i2.min && void 0 === i2.max || t2.target.value >= Number(i2.min) && t2.target.value <= Number(i2.max)) && (isNaN(t2.target.value) || (o2(t2.target.value), i2.onChange && i2.onChange(t2.target.value)));
      }
    };
    return p$2(() => {
      const e2 = new AbortController();
      return e2.signal, function() {
        e2.abort();
      };
    }, []), i2.smooth ? Cn.createElement("div", { style: { width: i2.width ? i2.width : "10rem" }, "data-quantity": "" }, Cn.createElement("button", { onClick: r2("decrement"), type: "button", title: "Down", className: "sub" }, "Down"), Cn.createElement("input", { style: { width: i2.width ? i2.width : "10rem" }, value: a2, type: "number", name: "quantity", pattern: "[0-9]+", onChange: r2("input") }), Cn.createElement("button", { type: "button", title: "Up", className: "add", onClick: r2("increment") }, "Up")) : Cn.createElement("span", { className: "quantity-picker" }, Cn.createElement("button", { className: (i2.disableDec ? "mod-disable " : "") + "quantity-modifier modifier-left", onClick: r2("decrement") }, "–"), Cn.createElement("input", { style: { width: i2.width ? i2.width : "4rem" }, className: "quantity-display", type: "text", value: a2, onChange: r2("input") }), Cn.createElement("button", { className: (i2.disableInc ? "mod-disable " : "") + "quantity-modifier modifier-right", onClick: r2("increment") }, "＋"));
  };
  var classnamesExports = {};
  var classnames$1 = {
    get exports() {
      return classnamesExports;
    },
    set exports(v2) {
      classnamesExports = v2;
    }
  };
  /*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  */
  (function(module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames() {
        var classes = [];
        for (var i2 = 0; i2 < arguments.length; i2++) {
          var arg = arguments[i2];
          if (!arg)
            continue;
          var argType = typeof arg;
          if (argType === "string" || argType === "number") {
            classes.push(arg);
          } else if (Array.isArray(arg)) {
            if (arg.length) {
              var inner = classNames.apply(null, arg);
              if (inner) {
                classes.push(inner);
              }
            }
          } else if (argType === "object") {
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
              classes.push(arg.toString());
              continue;
            }
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          }
        }
        return classes.join(" ");
      }
      if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
      } else {
        window.classNames = classNames;
      }
    })();
  })(classnames$1);
  const classnames = classnamesExports;
  var propTypesExports = {};
  var propTypes = {
    get exports() {
      return propTypesExports;
    },
    set exports(v2) {
      propTypesExports = v2;
    }
  };
  var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  var factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  {
    propTypes.exports = factoryWithThrowingShims();
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target2) {
      for (var i2 = 1; i2 < arguments.length; i2++) {
        var source = arguments[i2];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target2[key] = source[key];
          }
        }
      }
      return target2;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null)
      return {};
    var target2 = {};
    var sourceKeys = Object.keys(source);
    var key, i2;
    for (i2 = 0; i2 < sourceKeys.length; i2++) {
      key = sourceKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      target2[key] = source[key];
    }
    return target2;
  }
  var styles = { "label": "_4GdcU", "textareaView": "_G0k44", "shared": "_i5--j", "placeholder": "_TDklp", "inline": "_gmkRL", "readonly": "_-wzeg", "displayContainer": "_IYz6Z", "editButton": "_NGZSv" };
  var _excluded$1 = ["props", "inputRef", "handleBlur", "handleKeydown", "handleFocus", "inputClassName"];
  var Input = function Input2(_ref) {
    var _classnames;
    var _ref$props = _ref.props, id2 = _ref$props.id, inline = _ref$props.inline, style = _ref$props.style, type = _ref$props.type, name = _ref$props.name, inputRef = _ref.inputRef, handleBlur = _ref.handleBlur, handleKeydown = _ref.handleKeydown, handleFocus = _ref.handleFocus, inputClassName = _ref.inputClassName, rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
    return /* @__PURE__ */ o("input", _extends({
      id: id2,
      className: classnames(styles.shared, inputClassName, (_classnames = {}, _classnames[styles.inline] = inline, _classnames)),
      style,
      ref: inputRef,
      type,
      name,
      onBlur: handleBlur,
      onKeyDown: handleKeydown,
      autoFocus: true,
      onFocus: handleFocus
    }, rest));
  };
  var EditIcon = function EditIcon2() {
    return /* @__PURE__ */ o("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ o("path", {
        d: "M421.7 220.3L188.5 453.4L154.6 419.5L158.1 416H112C103.2 416 96 408.8 96 400V353.9L92.51 357.4C87.78 362.2 84.31 368 82.42 374.4L59.44 452.6L137.6 429.6C143.1 427.7 149.8 424.2 154.6 419.5L188.5 453.4C178.1 463.8 165.2 471.5 151.1 475.6L30.77 511C22.35 513.5 13.24 511.2 7.03 504.1C.8198 498.8-1.502 489.7 .976 481.2L36.37 360.9C40.53 346.8 48.16 333.9 58.57 323.5L291.7 90.34L421.7 220.3zM492.7 58.75C517.7 83.74 517.7 124.3 492.7 149.3L444.3 197.7L314.3 67.72L362.7 19.32C387.7-5.678 428.3-5.678 453.3 19.32L492.7 58.75z"
      })
    });
  };
  var sharedDefaultProps = {
    id: void 0,
    name: void 0,
    className: void 0,
    value: void 0,
    formatDisplayText: function formatDisplayText(x2) {
      return x2;
    },
    defaultValue: void 0,
    placeholder: "",
    onSave: function onSave() {
    },
    onChange: function onChange() {
    },
    onEditMode: function onEditMode() {
    },
    onBlur: function onBlur() {
    },
    style: {},
    readonly: false,
    inputClassName: void 0
  };
  var sharedPropTypes = {
    id: propTypesExports.string,
    name: propTypesExports.string,
    className: propTypesExports.string,
    value: propTypesExports.string,
    formatDisplayText: propTypesExports.func,
    defaultValue: propTypesExports.string,
    placeholder: propTypesExports.string,
    onSave: propTypesExports.func,
    onChange: propTypesExports.func,
    onEditMode: propTypesExports.func,
    onBlur: propTypesExports.func,
    style: propTypesExports.oneOfType([propTypesExports.object, propTypesExports.array]),
    readonly: propTypesExports.bool,
    inputClassName: propTypesExports.string
  };
  var EditTextPropTypes = _extends({}, sharedPropTypes, {
    type: propTypesExports.string,
    inline: propTypesExports.bool,
    showEditButton: propTypesExports.bool,
    editButtonContent: propTypesExports.any,
    editButtonProps: propTypesExports.object
  });
  var EditTextDefaultProps = _extends({}, sharedDefaultProps, {
    type: "text",
    inline: false,
    showEditButton: false,
    editButtonContent: /* @__PURE__ */ o(EditIcon, {}),
    editButtonProps: {}
  });
  _extends({}, sharedPropTypes, {
    rows: propTypesExports.oneOfType([propTypesExports.number, propTypesExports.oneOf(["auto"])])
  });
  _extends({}, sharedDefaultProps, {
    rows: 3
  });
  function EditText(_ref) {
    var id2 = _ref.id, name = _ref.name, className = _ref.className, placeholder = _ref.placeholder, inline = _ref.inline, style = _ref.style, readonly = _ref.readonly, type = _ref.type, value = _ref.value, defaultValue = _ref.defaultValue, formatDisplayText = _ref.formatDisplayText, onEditMode = _ref.onEditMode, _onChange = _ref.onChange, onSave = _ref.onSave, onBlur = _ref.onBlur, showEditButton = _ref.showEditButton, editButtonContent = _ref.editButtonContent, editButtonProps = _ref.editButtonProps, inputClassName = _ref.inputClassName;
    var inputRef = Cn.useRef(null);
    var _React$useState = Cn.useState({}), changeEvent = _React$useState[0], setChangeEvent = _React$useState[1];
    var _React$useState2 = Cn.useState(""), previousValue = _React$useState2[0], setPreviousValue = _React$useState2[1];
    var _React$useState3 = Cn.useState(""), savedText = _React$useState3[0], setSavedText = _React$useState3[1];
    var _React$useState4 = Cn.useState(false), editMode = _React$useState4[0], setEditMode = _React$useState4[1];
    Cn.useEffect(function() {
      if (defaultValue !== void 0) {
        setPreviousValue(defaultValue);
        setSavedText(defaultValue);
      }
    }, [defaultValue]);
    Cn.useEffect(function() {
      if (value !== void 0) {
        setSavedText(value);
        if (!editMode) {
          setPreviousValue(value);
        }
      }
    }, [value, editMode]);
    var handleClickDisplay = function handleClickDisplay2() {
      if (readonly || showEditButton)
        return;
      setEditMode(true);
      onEditMode();
    };
    var handleClickEditButton = function handleClickEditButton2() {
      setEditMode(true);
      onEditMode();
    };
    var handleBlur = function handleBlur2(save) {
      if (save === void 0) {
        save = true;
      }
      if (inputRef.current) {
        var _inputRef$current = inputRef.current, inputName = _inputRef$current.name, inputValue = _inputRef$current.value;
        if (save && previousValue !== inputValue) {
          onSave({
            name: inputName,
            value: inputValue,
            previousValue
          });
          setSavedText(inputValue);
          setPreviousValue(inputValue);
        } else if (!save) {
          _onChange(_extends({}, changeEvent, {
            target: changeEvent.target ? _extends({}, changeEvent.target, {
              value: previousValue
            }) : {
              value: previousValue
            }
          }));
        }
        setEditMode(false);
        onBlur();
      }
    };
    var handleKeydown = function handleKeydown2(e2) {
      if (e2.keyCode === 13 || e2.charCode === 13) {
        handleBlur();
      } else if (e2.keyCode === 27 || e2.charCode === 27) {
        handleBlur(false);
      }
    };
    var handleFocus = function handleFocus2(e2) {
      if (type === "text") {
        e2.currentTarget.setSelectionRange(e2.currentTarget.value.length, e2.currentTarget.value.length);
      }
    };
    var renderDisplayMode = function renderDisplayMode2() {
      var _classnames, _classnames2;
      return /* @__PURE__ */ o("div", {
        className: classnames(styles.displayContainer, (_classnames = {}, _classnames[styles.inline] = inline, _classnames)),
        children: [/* @__PURE__ */ o("div", {
          id: id2,
          className: classnames(styles.label, styles.shared, (_classnames2 = {}, _classnames2[styles.placeholder] = placeholder && !savedText, _classnames2[styles.inline] = inline, _classnames2[styles.readonly] = readonly || showEditButton, _classnames2), className),
          onClick: handleClickDisplay,
          style,
          "aria-label": "display component",
          children: formatDisplayText(savedText) || placeholder
        }), showEditButton && !readonly && /* @__PURE__ */ o("button", _extends({
          type: "button",
          className: styles.editButton
        }, editButtonProps, {
          onClick: handleClickEditButton,
          children: editButtonContent
        }))]
      });
    };
    var renderEditMode = function renderEditMode2(controlled) {
      var _sharedProps;
      var sharedProps = (_sharedProps = {
        inputRef,
        handleBlur,
        handleKeydown,
        handleFocus,
        props: {
          id: id2,
          inline,
          style,
          type,
          name
        }
      }, _sharedProps["aria-label"] = "input component", _sharedProps);
      return controlled ? /* @__PURE__ */ o(Input, _extends({}, sharedProps, {
        value,
        onChange: function onChange(e2) {
          setChangeEvent(e2);
          _onChange(e2);
        },
        inputClassName
      })) : /* @__PURE__ */ o(Input, _extends({}, sharedProps, {
        defaultValue: savedText,
        inputClassName
      }));
    };
    return !readonly && editMode ? renderEditMode(value !== void 0 && _onChange !== void 0) : renderDisplayMode();
  }
  EditText.defaultProps = EditTextDefaultProps;
  EditText.propTypes = EditTextPropTypes;
  function handleize(text) {
    return text.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
  }
  const fetchChecoutAttrs = (config) => {
    let attrs = {
      customAttributes: []
    };
    let message = config.message;
    if (message.skip)
      attrs.customAttributes.push({
        key: "Skip Message",
        value: "True"
      });
    else {
      attrs.customAttributes.push({
        key: "From",
        value: message.from
      });
      attrs.customAttributes.push({
        key: "Message",
        value: message.message
      });
    }
    return attrs;
  };
  function bind(fn2, thisArg) {
    return function wrap() {
      return fn2.apply(thisArg, arguments);
    };
  }
  const { toString } = Object.prototype;
  const { getPrototypeOf } = Object;
  const kindOf = ((cache) => (thing) => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  })(/* @__PURE__ */ Object.create(null));
  const kindOfTest = (type) => {
    type = type.toLowerCase();
    return (thing) => kindOf(thing) === type;
  };
  const typeOfTest = (type) => (thing) => typeof thing === type;
  const { isArray } = Array;
  const isUndefined = typeOfTest("undefined");
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
  }
  const isArrayBuffer = kindOfTest("ArrayBuffer");
  function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && isArrayBuffer(val.buffer);
    }
    return result;
  }
  const isString = typeOfTest("string");
  const isFunction = typeOfTest("function");
  const isNumber = typeOfTest("number");
  const isObject = (thing) => thing !== null && typeof thing === "object";
  const isBoolean = (thing) => thing === true || thing === false;
  const isPlainObject = (val) => {
    if (kindOf(val) !== "object") {
      return false;
    }
    const prototype2 = getPrototypeOf(val);
    return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
  };
  const isDate = kindOfTest("Date");
  const isFile = kindOfTest("File");
  const isBlob = kindOfTest("Blob");
  const isFileList = kindOfTest("FileList");
  const isStream = (val) => isObject(val) && isFunction(val.pipe);
  const isFormData = (thing) => {
    const pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
  };
  const isURLSearchParams = kindOfTest("URLSearchParams");
  const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  function forEach(obj, fn2, { allOwnKeys = false } = {}) {
    if (obj === null || typeof obj === "undefined") {
      return;
    }
    let i2;
    let l2;
    if (typeof obj !== "object") {
      obj = [obj];
    }
    if (isArray(obj)) {
      for (i2 = 0, l2 = obj.length; i2 < l2; i2++) {
        fn2.call(null, obj[i2], i2, obj);
      }
    } else {
      const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
      const len2 = keys.length;
      let key;
      for (i2 = 0; i2 < len2; i2++) {
        key = keys[i2];
        fn2.call(null, obj[key], key, obj);
      }
    }
  }
  function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i2 = keys.length;
    let _key;
    while (i2-- > 0) {
      _key = keys[i2];
      if (key === _key.toLowerCase()) {
        return _key;
      }
    }
    return null;
  }
  const _global = (() => {
    if (typeof globalThis !== "undefined")
      return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
  })();
  const isContextDefined = (context) => !isUndefined(context) && context !== _global;
  function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key) => {
      const targetKey = caseless && findKey(result, key) || key;
      if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
        result[targetKey] = merge(result[targetKey], val);
      } else if (isPlainObject(val)) {
        result[targetKey] = merge({}, val);
      } else if (isArray(val)) {
        result[targetKey] = val.slice();
      } else {
        result[targetKey] = val;
      }
    };
    for (let i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
      arguments[i2] && forEach(arguments[i2], assignValue);
    }
    return result;
  }
  const extend = (a2, b2, thisArg, { allOwnKeys } = {}) => {
    forEach(b2, (val, key) => {
      if (thisArg && isFunction(val)) {
        a2[key] = bind(val, thisArg);
      } else {
        a2[key] = val;
      }
    }, { allOwnKeys });
    return a2;
  };
  const stripBOM = (content) => {
    if (content.charCodeAt(0) === 65279) {
      content = content.slice(1);
    }
    return content;
  };
  const inherits = (constructor, superConstructor, props, descriptors2) => {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
      value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
  };
  const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
    let props;
    let i2;
    let prop2;
    const merged = {};
    destObj = destObj || {};
    if (sourceObj == null)
      return destObj;
    do {
      props = Object.getOwnPropertyNames(sourceObj);
      i2 = props.length;
      while (i2-- > 0) {
        prop2 = props[i2];
        if ((!propFilter || propFilter(prop2, sourceObj, destObj)) && !merged[prop2]) {
          destObj[prop2] = sourceObj[prop2];
          merged[prop2] = true;
        }
      }
      sourceObj = filter !== false && getPrototypeOf(sourceObj);
    } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
  };
  const endsWith = (str, searchString, position) => {
    str = String(str);
    if (position === void 0 || position > str.length) {
      position = str.length;
    }
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
  const toArray = (thing) => {
    if (!thing)
      return null;
    if (isArray(thing))
      return thing;
    let i2 = thing.length;
    if (!isNumber(i2))
      return null;
    const arr = new Array(i2);
    while (i2-- > 0) {
      arr[i2] = thing[i2];
    }
    return arr;
  };
  const isTypedArray = ((TypedArray) => {
    return (thing) => {
      return TypedArray && thing instanceof TypedArray;
    };
  })(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
  const forEachEntry = (obj, fn2) => {
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while ((result = iterator.next()) && !result.done) {
      const pair = result.value;
      fn2.call(obj, pair[0], pair[1]);
    }
  };
  const matchAll = (regExp, str) => {
    let matches;
    const arr = [];
    while ((matches = regExp.exec(str)) !== null) {
      arr.push(matches);
    }
    return arr;
  };
  const isHTMLForm = kindOfTest("HTMLFormElement");
  const toCamelCase = (str) => {
    return str.toLowerCase().replace(
      /[-_\s]([a-z\d])(\w*)/g,
      function replacer(m2, p1, p2) {
        return p1.toUpperCase() + p2;
      }
    );
  };
  const hasOwnProperty$1 = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop2) => hasOwnProperty2.call(obj, prop2))(Object.prototype);
  const isRegExp = kindOfTest("RegExp");
  const reduceDescriptors = (obj, reducer) => {
    const descriptors2 = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors2, (descriptor, name) => {
      if (reducer(descriptor, name, obj) !== false) {
        reducedDescriptors[name] = descriptor;
      }
    });
    Object.defineProperties(obj, reducedDescriptors);
  };
  const freezeMethods = (obj) => {
    reduceDescriptors(obj, (descriptor, name) => {
      if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1) {
        return false;
      }
      const value = obj[name];
      if (!isFunction(value))
        return;
      descriptor.enumerable = false;
      if ("writable" in descriptor) {
        descriptor.writable = false;
        return;
      }
      if (!descriptor.set) {
        descriptor.set = () => {
          throw Error("Can not rewrite read-only method '" + name + "'");
        };
      }
    });
  };
  const toObjectSet = (arrayOrString, delimiter) => {
    const obj = {};
    const define2 = (arr) => {
      arr.forEach((value) => {
        obj[value] = true;
      });
    };
    isArray(arrayOrString) ? define2(arrayOrString) : define2(String(arrayOrString).split(delimiter));
    return obj;
  };
  const noop = () => {
  };
  const toFiniteNumber = (value, defaultValue) => {
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
  };
  const ALPHA = "abcdefghijklmnopqrstuvwxyz";
  const DIGIT = "0123456789";
  const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
  };
  const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
    let str = "";
    const { length } = alphabet;
    while (size--) {
      str += alphabet[Math.random() * length | 0];
    }
    return str;
  };
  function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
  }
  const toJSONObject = (obj) => {
    const stack = new Array(10);
    const visit = (source, i2) => {
      if (isObject(source)) {
        if (stack.indexOf(source) >= 0) {
          return;
        }
        if (!("toJSON" in source)) {
          stack[i2] = source;
          const target2 = isArray(source) ? [] : {};
          forEach(source, (value, key) => {
            const reducedValue = visit(value, i2 + 1);
            !isUndefined(reducedValue) && (target2[key] = reducedValue);
          });
          stack[i2] = void 0;
          return target2;
        }
      }
      return source;
    };
    return visit(obj, 0);
  };
  const utils = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty: hasOwnProperty$1,
    hasOwnProp: hasOwnProperty$1,
    // an alias to avoid ESLint no-prototype-builtins detection
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject
  };
  function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error().stack;
    }
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
  }
  utils.inherits(AxiosError, Error, {
    toJSON: function toJSON() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: utils.toJSONObject(this.config),
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    }
  });
  const prototype$1 = AxiosError.prototype;
  const descriptors = {};
  [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
    // eslint-disable-next-line func-names
  ].forEach((code) => {
    descriptors[code] = { value: code };
  });
  Object.defineProperties(AxiosError, descriptors);
  Object.defineProperty(prototype$1, "isAxiosError", { value: true });
  AxiosError.from = (error, code, config, request, response, customProps) => {
    const axiosError = Object.create(prototype$1);
    utils.toFlatObject(error, axiosError, function filter(obj) {
      return obj !== Error.prototype;
    }, (prop2) => {
      return prop2 !== "isAxiosError";
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
  };
  const httpAdapter = null;
  function isVisitable(thing) {
    return utils.isPlainObject(thing) || utils.isArray(thing);
  }
  function removeBrackets(key) {
    return utils.endsWith(key, "[]") ? key.slice(0, -2) : key;
  }
  function renderKey(path, key, dots) {
    if (!path)
      return key;
    return path.concat(key).map(function each(token, i2) {
      token = removeBrackets(token);
      return !dots && i2 ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
  }
  function isFlatArray(arr) {
    return utils.isArray(arr) && !arr.some(isVisitable);
  }
  const predicates = utils.toFlatObject(utils, {}, null, function filter(prop2) {
    return /^is[A-Z]/.test(prop2);
  });
  function toFormData(obj, formData, options) {
    if (!utils.isObject(obj)) {
      throw new TypeError("target must be an object");
    }
    formData = formData || new FormData();
    options = utils.toFlatObject(options, {
      metaTokens: true,
      dots: false,
      indexes: false
    }, false, function defined(option, source) {
      return !utils.isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && utils.isSpecCompliantForm(formData);
    if (!utils.isFunction(visitor)) {
      throw new TypeError("visitor must be a function");
    }
    function convertValue(value) {
      if (value === null)
        return "";
      if (utils.isDate(value)) {
        return value.toISOString();
      }
      if (!useBlob && utils.isBlob(value)) {
        throw new AxiosError("Blob is not supported. Use a Buffer instead.");
      }
      if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
        return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
      }
      return value;
    }
    function defaultVisitor(value, key, path) {
      let arr = value;
      if (value && !path && typeof value === "object") {
        if (utils.endsWith(key, "{}")) {
          key = metaTokens ? key : key.slice(0, -2);
          value = JSON.stringify(value);
        } else if (utils.isArray(value) && isFlatArray(value) || (utils.isFileList(value) || utils.endsWith(key, "[]")) && (arr = utils.toArray(value))) {
          key = removeBrackets(key);
          arr.forEach(function each(el2, index2) {
            !(utils.isUndefined(el2) || el2 === null) && formData.append(
              // eslint-disable-next-line no-nested-ternary
              indexes === true ? renderKey([key], index2, dots) : indexes === null ? key : key + "[]",
              convertValue(el2)
            );
          });
          return false;
        }
      }
      if (isVisitable(value)) {
        return true;
      }
      formData.append(renderKey(path, key, dots), convertValue(value));
      return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
      defaultVisitor,
      convertValue,
      isVisitable
    });
    function build(value, path) {
      if (utils.isUndefined(value))
        return;
      if (stack.indexOf(value) !== -1) {
        throw Error("Circular reference detected in " + path.join("."));
      }
      stack.push(value);
      utils.forEach(value, function each(el2, key) {
        const result = !(utils.isUndefined(el2) || el2 === null) && visitor.call(
          formData,
          el2,
          utils.isString(key) ? key.trim() : key,
          path,
          exposedHelpers
        );
        if (result === true) {
          build(el2, path ? path.concat(key) : [key]);
        }
      });
      stack.pop();
    }
    if (!utils.isObject(obj)) {
      throw new TypeError("data must be an object");
    }
    build(obj);
    return formData;
  }
  function encode$1(str) {
    const charMap = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
      "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
      return charMap[match];
    });
  }
  function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && toFormData(params, this, options);
  }
  const prototype = AxiosURLSearchParams.prototype;
  prototype.append = function append(name, value) {
    this._pairs.push([name, value]);
  };
  prototype.toString = function toString2(encoder) {
    const _encode = encoder ? function(value) {
      return encoder.call(this, value, encode$1);
    } : encode$1;
    return this._pairs.map(function each(pair) {
      return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
  };
  function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  function buildURL(url, params, options) {
    if (!params) {
      return url;
    }
    const _encode = options && options.encode || encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) {
      serializedParams = serializeFn(params, options);
    } else {
      serializedParams = utils.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
    }
    if (serializedParams) {
      const hashmarkIndex = url.indexOf("#");
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }
      url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
  }
  class InterceptorManager {
    constructor() {
      this.handlers = [];
    }
    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     *
     * @return {Number} An ID used to remove interceptor later
     */
    use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
     */
    eject(id2) {
      if (this.handlers[id2]) {
        this.handlers[id2] = null;
      }
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
    clear() {
      if (this.handlers) {
        this.handlers = [];
      }
    }
    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     *
     * @returns {void}
     */
    forEach(fn2) {
      utils.forEach(this.handlers, function forEachHandler(h2) {
        if (h2 !== null) {
          fn2(h2);
        }
      });
    }
  }
  const InterceptorManager$1 = InterceptorManager;
  const transitionalDefaults = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  };
  const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
  const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
  const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
  const isStandardBrowserEnv = (() => {
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) {
      return false;
    }
    return typeof window !== "undefined" && typeof document !== "undefined";
  })();
  const isStandardBrowserWebWorkerEnv = (() => {
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
  })();
  const platform = {
    isBrowser: true,
    classes: {
      URLSearchParams: URLSearchParams$1,
      FormData: FormData$1,
      Blob: Blob$1
    },
    isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv,
    protocols: ["http", "https", "file", "blob", "url", "data"]
  };
  function toURLEncodedForm(data, options) {
    return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
      visitor: function(value, key, path, helpers2) {
        if (platform.isNode && utils.isBuffer(value)) {
          this.append(key, value.toString("base64"));
          return false;
        }
        return helpers2.defaultVisitor.apply(this, arguments);
      }
    }, options));
  }
  function parsePropPath(name) {
    return utils.matchAll(/\w+|\[(\w*)]/g, name).map((match) => {
      return match[0] === "[]" ? "" : match[1] || match[0];
    });
  }
  function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i2;
    const len2 = keys.length;
    let key;
    for (i2 = 0; i2 < len2; i2++) {
      key = keys[i2];
      obj[key] = arr[key];
    }
    return obj;
  }
  function formDataToJSON(formData) {
    function buildPath(path, value, target2, index2) {
      let name = path[index2++];
      const isNumericKey = Number.isFinite(+name);
      const isLast = index2 >= path.length;
      name = !name && utils.isArray(target2) ? target2.length : name;
      if (isLast) {
        if (utils.hasOwnProp(target2, name)) {
          target2[name] = [target2[name], value];
        } else {
          target2[name] = value;
        }
        return !isNumericKey;
      }
      if (!target2[name] || !utils.isObject(target2[name])) {
        target2[name] = [];
      }
      const result = buildPath(path, value, target2[name], index2);
      if (result && utils.isArray(target2[name])) {
        target2[name] = arrayToObject(target2[name]);
      }
      return !isNumericKey;
    }
    if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
      const obj = {};
      utils.forEachEntry(formData, (name, value) => {
        buildPath(parsePropPath(name), value, obj, 0);
      });
      return obj;
    }
    return null;
  }
  const DEFAULT_CONTENT_TYPE = {
    "Content-Type": void 0
  };
  function stringifySafely(rawValue, parser, encoder) {
    if (utils.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils.trim(rawValue);
      } catch (e2) {
        if (e2.name !== "SyntaxError") {
          throw e2;
        }
      }
    }
    return (encoder || JSON.stringify)(rawValue);
  }
  const defaults = {
    transitional: transitionalDefaults,
    adapter: ["xhr", "http"],
    transformRequest: [function transformRequest(data, headers) {
      const contentType = headers.getContentType() || "";
      const hasJSONContentType = contentType.indexOf("application/json") > -1;
      const isObjectPayload = utils.isObject(data);
      if (isObjectPayload && utils.isHTMLForm(data)) {
        data = new FormData(data);
      }
      const isFormData2 = utils.isFormData(data);
      if (isFormData2) {
        if (!hasJSONContentType) {
          return data;
        }
        return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
      }
      if (utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
        return data;
      }
      if (utils.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils.isURLSearchParams(data)) {
        headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
        return data.toString();
      }
      let isFileList2;
      if (isObjectPayload) {
        if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
          return toURLEncodedForm(data, this.formSerializer).toString();
        }
        if ((isFileList2 = utils.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
          const _FormData = this.env && this.env.FormData;
          return toFormData(
            isFileList2 ? { "files[]": data } : data,
            _FormData && new _FormData(),
            this.formSerializer
          );
        }
      }
      if (isObjectPayload || hasJSONContentType) {
        headers.setContentType("application/json", false);
        return stringifySafely(data);
      }
      return data;
    }],
    transformResponse: [function transformResponse(data) {
      const transitional = this.transitional || defaults.transitional;
      const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
      const JSONRequested = this.responseType === "json";
      if (data && utils.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
        const silentJSONParsing = transitional && transitional.silentJSONParsing;
        const strictJSONParsing = !silentJSONParsing && JSONRequested;
        try {
          return JSON.parse(data);
        } catch (e2) {
          if (strictJSONParsing) {
            if (e2.name === "SyntaxError") {
              throw AxiosError.from(e2, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
            }
            throw e2;
          }
        }
      }
      return data;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: platform.classes.FormData,
      Blob: platform.classes.Blob
    },
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    },
    headers: {
      common: {
        "Accept": "application/json, text/plain, */*"
      }
    }
  };
  utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
    defaults.headers[method] = {};
  });
  utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
  });
  const defaults$1 = defaults;
  const ignoreDuplicateOf = utils.toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ]);
  const parseHeaders = (rawHeaders) => {
    const parsed = {};
    let key;
    let val;
    let i2;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
      i2 = line.indexOf(":");
      key = line.substring(0, i2).trim().toLowerCase();
      val = line.substring(i2 + 1).trim();
      if (!key || parsed[key] && ignoreDuplicateOf[key]) {
        return;
      }
      if (key === "set-cookie") {
        if (parsed[key]) {
          parsed[key].push(val);
        } else {
          parsed[key] = [val];
        }
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    });
    return parsed;
  };
  const $internals = Symbol("internals");
  function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
  }
  function normalizeValue(value) {
    if (value === false || value == null) {
      return value;
    }
    return utils.isArray(value) ? value.map(normalizeValue) : String(value);
  }
  function parseTokens(str) {
    const tokens = /* @__PURE__ */ Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while (match = tokensRE.exec(str)) {
      tokens[match[1]] = match[2];
    }
    return tokens;
  }
  function isValidHeaderName(str) {
    return /^[-_a-zA-Z]+$/.test(str.trim());
  }
  function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if (utils.isFunction(filter)) {
      return filter.call(this, value, header);
    }
    if (isHeaderNameFilter) {
      value = header;
    }
    if (!utils.isString(value))
      return;
    if (utils.isString(filter)) {
      return value.indexOf(filter) !== -1;
    }
    if (utils.isRegExp(filter)) {
      return filter.test(value);
    }
  }
  function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w2, char, str) => {
      return char.toUpperCase() + str;
    });
  }
  function buildAccessors(obj, header) {
    const accessorName = utils.toCamelCase(" " + header);
    ["get", "set", "has"].forEach((methodName) => {
      Object.defineProperty(obj, methodName + accessorName, {
        value: function(arg1, arg2, arg3) {
          return this[methodName].call(this, header, arg1, arg2, arg3);
        },
        configurable: true
      });
    });
  }
  class AxiosHeaders {
    constructor(headers) {
      headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
      const self2 = this;
      function setHeader(_value, _header, _rewrite) {
        const lHeader = normalizeHeader(_header);
        if (!lHeader) {
          throw new Error("header name must be a non-empty string");
        }
        const key = utils.findKey(self2, lHeader);
        if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
          self2[key || _header] = normalizeValue(_value);
        }
      }
      const setHeaders = (headers, _rewrite) => utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
      if (utils.isPlainObject(header) || header instanceof this.constructor) {
        setHeaders(header, valueOrRewrite);
      } else if (utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
        setHeaders(parseHeaders(header), valueOrRewrite);
      } else {
        header != null && setHeader(valueOrRewrite, header, rewrite);
      }
      return this;
    }
    get(header, parser) {
      header = normalizeHeader(header);
      if (header) {
        const key = utils.findKey(this, header);
        if (key) {
          const value = this[key];
          if (!parser) {
            return value;
          }
          if (parser === true) {
            return parseTokens(value);
          }
          if (utils.isFunction(parser)) {
            return parser.call(this, value, key);
          }
          if (utils.isRegExp(parser)) {
            return parser.exec(value);
          }
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
    has(header, matcher) {
      header = normalizeHeader(header);
      if (header) {
        const key = utils.findKey(this, header);
        return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
      }
      return false;
    }
    delete(header, matcher) {
      const self2 = this;
      let deleted = false;
      function deleteHeader(_header) {
        _header = normalizeHeader(_header);
        if (_header) {
          const key = utils.findKey(self2, _header);
          if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
            delete self2[key];
            deleted = true;
          }
        }
      }
      if (utils.isArray(header)) {
        header.forEach(deleteHeader);
      } else {
        deleteHeader(header);
      }
      return deleted;
    }
    clear(matcher) {
      const keys = Object.keys(this);
      let i2 = keys.length;
      let deleted = false;
      while (i2--) {
        const key = keys[i2];
        if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
          delete this[key];
          deleted = true;
        }
      }
      return deleted;
    }
    normalize(format) {
      const self2 = this;
      const headers = {};
      utils.forEach(this, (value, header) => {
        const key = utils.findKey(headers, header);
        if (key) {
          self2[key] = normalizeValue(value);
          delete self2[header];
          return;
        }
        const normalized = format ? formatHeader(header) : String(header).trim();
        if (normalized !== header) {
          delete self2[header];
        }
        self2[normalized] = normalizeValue(value);
        headers[normalized] = true;
      });
      return this;
    }
    concat(...targets) {
      return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
      const obj = /* @__PURE__ */ Object.create(null);
      utils.forEach(this, (value, header) => {
        value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(", ") : value);
      });
      return obj;
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
      return "AxiosHeaders";
    }
    static from(thing) {
      return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
      const computed = new this(first);
      targets.forEach((target2) => computed.set(target2));
      return computed;
    }
    static accessor(header) {
      const internals = this[$internals] = this[$internals] = {
        accessors: {}
      };
      const accessors = internals.accessors;
      const prototype2 = this.prototype;
      function defineAccessor(_header) {
        const lHeader = normalizeHeader(_header);
        if (!accessors[lHeader]) {
          buildAccessors(prototype2, _header);
          accessors[lHeader] = true;
        }
      }
      utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
      return this;
    }
  }
  AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
  utils.freezeMethods(AxiosHeaders.prototype);
  utils.freezeMethods(AxiosHeaders);
  const AxiosHeaders$1 = AxiosHeaders;
  function transformData(fns, response) {
    const config = this || defaults$1;
    const context = response || config;
    const headers = AxiosHeaders$1.from(context.headers);
    let data = context.data;
    utils.forEach(fns, function transform(fn2) {
      data = fn2.call(config, data, headers.normalize(), response ? response.status : void 0);
    });
    headers.normalize();
    return data;
  }
  function isCancel(value) {
    return !!(value && value.__CANCEL__);
  }
  function CanceledError(message, config, request) {
    AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED, config, request);
    this.name = "CanceledError";
  }
  utils.inherits(CanceledError, AxiosError, {
    __CANCEL__: true
  });
  function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
      resolve(response);
    } else {
      reject(new AxiosError(
        "Request failed with status code " + response.status,
        [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
        response.config,
        response.request,
        response
      ));
    }
  }
  const cookies = platform.isStandardBrowserEnv ? (
    // Standard browser envs support document.cookie
    function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          const cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));
          if (utils.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }
          if (utils.isString(path)) {
            cookie.push("path=" + path);
          }
          if (utils.isString(domain)) {
            cookie.push("domain=" + domain);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          document.cookie = cookie.join("; ");
        },
        read: function read(name) {
          const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function nonStandardBrowserEnv() {
      return {
        write: function write() {
        },
        read: function read() {
          return null;
        },
        remove: function remove() {
        }
      };
    }()
  );
  function isAbsoluteURL(url) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
  }
  function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
  }
  function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL(requestedURL)) {
      return combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
  }
  const isURLSameOrigin = platform.isStandardBrowserEnv ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function standardBrowserEnv() {
      const msie = /(msie|trident)/i.test(navigator.userAgent);
      const urlParsingNode = document.createElement("a");
      let originURL;
      function resolveURL(url) {
        let href = url;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin2(requestURL) {
        const parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function nonStandardBrowserEnv() {
      return function isURLSameOrigin2() {
        return true;
      };
    }()
  );
  function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
  }
  function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== void 0 ? min : 1e3;
    return function push(chunkLength) {
      const now = Date.now();
      const startedAt = timestamps[tail];
      if (!firstSampleTS) {
        firstSampleTS = now;
      }
      bytes[head] = chunkLength;
      timestamps[head] = now;
      let i2 = tail;
      let bytesCount = 0;
      while (i2 !== head) {
        bytesCount += bytes[i2++];
        i2 = i2 % samplesCount;
      }
      head = (head + 1) % samplesCount;
      if (head === tail) {
        tail = (tail + 1) % samplesCount;
      }
      if (now - firstSampleTS < min) {
        return;
      }
      const passed = startedAt && now - startedAt;
      return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
    };
  }
  function progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = speedometer(50, 250);
    return (e2) => {
      const loaded = e2.loaded;
      const total = e2.lengthComputable ? e2.total : void 0;
      const progressBytes = loaded - bytesNotified;
      const rate = _speedometer(progressBytes);
      const inRange = loaded <= total;
      bytesNotified = loaded;
      const data = {
        loaded,
        total,
        progress: total ? loaded / total : void 0,
        bytes: progressBytes,
        rate: rate ? rate : void 0,
        estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
        event: e2
      };
      data[isDownloadStream ? "download" : "upload"] = true;
      listener(data);
    };
  }
  const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
  const xhrAdapter = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
      let requestData = config.data;
      const requestHeaders = AxiosHeaders$1.from(config.headers).normalize();
      const responseType = config.responseType;
      let onCanceled;
      function done() {
        if (config.cancelToken) {
          config.cancelToken.unsubscribe(onCanceled);
        }
        if (config.signal) {
          config.signal.removeEventListener("abort", onCanceled);
        }
      }
      if (utils.isFormData(requestData) && (platform.isStandardBrowserEnv || platform.isStandardBrowserWebWorkerEnv)) {
        requestHeaders.setContentType(false);
      }
      let request = new XMLHttpRequest();
      if (config.auth) {
        const username = config.auth.username || "";
        const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
        requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
      }
      const fullPath = buildFullPath(config.baseURL, config.url);
      request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
      request.timeout = config.timeout;
      function onloadend() {
        if (!request) {
          return;
        }
        const responseHeaders = AxiosHeaders$1.from(
          "getAllResponseHeaders" in request && request.getAllResponseHeaders()
        );
        const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
        const response = {
          data: responseData,
          status: request.status,
          statusText: request.statusText,
          headers: responseHeaders,
          config,
          request
        };
        settle(function _resolve(value) {
          resolve(value);
          done();
        }, function _reject(err) {
          reject(err);
          done();
        }, response);
        request = null;
      }
      if ("onloadend" in request) {
        request.onloadend = onloadend;
      } else {
        request.onreadystatechange = function handleLoad() {
          if (!request || request.readyState !== 4) {
            return;
          }
          if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
            return;
          }
          setTimeout(onloadend);
        };
      }
      request.onabort = function handleAbort() {
        if (!request) {
          return;
        }
        reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config, request));
        request = null;
      };
      request.onerror = function handleError() {
        reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request));
        request = null;
      };
      request.ontimeout = function handleTimeout() {
        let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
        const transitional = config.transitional || transitionalDefaults;
        if (config.timeoutErrorMessage) {
          timeoutErrorMessage = config.timeoutErrorMessage;
        }
        reject(new AxiosError(
          timeoutErrorMessage,
          transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
          config,
          request
        ));
        request = null;
      };
      if (platform.isStandardBrowserEnv) {
        const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
      requestData === void 0 && requestHeaders.setContentType(null);
      if ("setRequestHeader" in request) {
        utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
          request.setRequestHeader(key, val);
        });
      }
      if (!utils.isUndefined(config.withCredentials)) {
        request.withCredentials = !!config.withCredentials;
      }
      if (responseType && responseType !== "json") {
        request.responseType = config.responseType;
      }
      if (typeof config.onDownloadProgress === "function") {
        request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
      }
      if (typeof config.onUploadProgress === "function" && request.upload) {
        request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
      }
      if (config.cancelToken || config.signal) {
        onCanceled = (cancel) => {
          if (!request) {
            return;
          }
          reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
          request.abort();
          request = null;
        };
        config.cancelToken && config.cancelToken.subscribe(onCanceled);
        if (config.signal) {
          config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
      }
      const protocol = parseProtocol(fullPath);
      if (protocol && platform.protocols.indexOf(protocol) === -1) {
        reject(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config));
        return;
      }
      request.send(requestData || null);
    });
  };
  const knownAdapters = {
    http: httpAdapter,
    xhr: xhrAdapter
  };
  utils.forEach(knownAdapters, (fn2, value) => {
    if (fn2) {
      try {
        Object.defineProperty(fn2, "name", { value });
      } catch (e2) {
      }
      Object.defineProperty(fn2, "adapterName", { value });
    }
  });
  const adapters = {
    getAdapter: (adapters2) => {
      adapters2 = utils.isArray(adapters2) ? adapters2 : [adapters2];
      const { length } = adapters2;
      let nameOrAdapter;
      let adapter;
      for (let i2 = 0; i2 < length; i2++) {
        nameOrAdapter = adapters2[i2];
        if (adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) {
          break;
        }
      }
      if (!adapter) {
        if (adapter === false) {
          throw new AxiosError(
            `Adapter ${nameOrAdapter} is not supported by the environment`,
            "ERR_NOT_SUPPORT"
          );
        }
        throw new Error(
          utils.hasOwnProp(knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`
        );
      }
      if (!utils.isFunction(adapter)) {
        throw new TypeError("adapter is not a function");
      }
      return adapter;
    },
    adapters: knownAdapters
  };
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
    if (config.signal && config.signal.aborted) {
      throw new CanceledError(null, config);
    }
  }
  function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = AxiosHeaders$1.from(config.headers);
    config.data = transformData.call(
      config,
      config.transformRequest
    );
    if (["post", "put", "patch"].indexOf(config.method) !== -1) {
      config.headers.setContentType("application/x-www-form-urlencoded", false);
    }
    const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);
    return adapter(config).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config);
      response.data = transformData.call(
        config,
        config.transformResponse,
        response
      );
      response.headers = AxiosHeaders$1.from(response.headers);
      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config);
        if (reason && reason.response) {
          reason.response.data = transformData.call(
            config,
            config.transformResponse,
            reason.response
          );
          reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
        }
      }
      return Promise.reject(reason);
    });
  }
  const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? thing.toJSON() : thing;
  function mergeConfig(config1, config2) {
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target2, source, caseless) {
      if (utils.isPlainObject(target2) && utils.isPlainObject(source)) {
        return utils.merge.call({ caseless }, target2, source);
      } else if (utils.isPlainObject(source)) {
        return utils.merge({}, source);
      } else if (utils.isArray(source)) {
        return source.slice();
      }
      return source;
    }
    function mergeDeepProperties(a2, b2, caseless) {
      if (!utils.isUndefined(b2)) {
        return getMergedValue(a2, b2, caseless);
      } else if (!utils.isUndefined(a2)) {
        return getMergedValue(void 0, a2, caseless);
      }
    }
    function valueFromConfig2(a2, b2) {
      if (!utils.isUndefined(b2)) {
        return getMergedValue(void 0, b2);
      }
    }
    function defaultToConfig2(a2, b2) {
      if (!utils.isUndefined(b2)) {
        return getMergedValue(void 0, b2);
      } else if (!utils.isUndefined(a2)) {
        return getMergedValue(void 0, a2);
      }
    }
    function mergeDirectKeys(a2, b2, prop2) {
      if (prop2 in config2) {
        return getMergedValue(a2, b2);
      } else if (prop2 in config1) {
        return getMergedValue(void 0, a2);
      }
    }
    const mergeMap = {
      url: valueFromConfig2,
      method: valueFromConfig2,
      data: valueFromConfig2,
      baseURL: defaultToConfig2,
      transformRequest: defaultToConfig2,
      transformResponse: defaultToConfig2,
      paramsSerializer: defaultToConfig2,
      timeout: defaultToConfig2,
      timeoutMessage: defaultToConfig2,
      withCredentials: defaultToConfig2,
      adapter: defaultToConfig2,
      responseType: defaultToConfig2,
      xsrfCookieName: defaultToConfig2,
      xsrfHeaderName: defaultToConfig2,
      onUploadProgress: defaultToConfig2,
      onDownloadProgress: defaultToConfig2,
      decompress: defaultToConfig2,
      maxContentLength: defaultToConfig2,
      maxBodyLength: defaultToConfig2,
      beforeRedirect: defaultToConfig2,
      transport: defaultToConfig2,
      httpAgent: defaultToConfig2,
      httpsAgent: defaultToConfig2,
      cancelToken: defaultToConfig2,
      socketPath: defaultToConfig2,
      responseEncoding: defaultToConfig2,
      validateStatus: mergeDirectKeys,
      headers: (a2, b2) => mergeDeepProperties(headersToObject(a2), headersToObject(b2), true)
    };
    utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop2) {
      const merge2 = mergeMap[prop2] || mergeDeepProperties;
      const configValue = merge2(config1[prop2], config2[prop2], prop2);
      utils.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop2] = configValue);
    });
    return config;
  }
  const VERSION = "1.3.4";
  const validators$1 = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i2) => {
    validators$1[type] = function validator2(thing) {
      return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
    };
  });
  const deprecatedWarnings = {};
  validators$1.transitional = function transitional(validator2, version2, message) {
    function formatMessage(opt, desc) {
      return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    return (value, opt, opts) => {
      if (validator2 === false) {
        throw new AxiosError(
          formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
          AxiosError.ERR_DEPRECATED
        );
      }
      if (version2 && !deprecatedWarnings[opt]) {
        deprecatedWarnings[opt] = true;
        console.warn(
          formatMessage(
            opt,
            " has been deprecated since v" + version2 + " and will be removed in the near future"
          )
        );
      }
      return validator2 ? validator2(value, opt, opts) : true;
    };
  };
  function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") {
      throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
    }
    const keys = Object.keys(options);
    let i2 = keys.length;
    while (i2-- > 0) {
      const opt = keys[i2];
      const validator2 = schema[opt];
      if (validator2) {
        const value = options[opt];
        const result = value === void 0 || validator2(value, opt, options);
        if (result !== true) {
          throw new AxiosError("option " + opt + " must be " + result, AxiosError.ERR_BAD_OPTION_VALUE);
        }
        continue;
      }
      if (allowUnknown !== true) {
        throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
      }
    }
  }
  const validator = {
    assertOptions,
    validators: validators$1
  };
  const validators = validator.validators;
  class Axios {
    constructor(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager$1(),
        response: new InterceptorManager$1()
      };
    }
    /**
     * Dispatch a request
     *
     * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
     * @param {?Object} config
     *
     * @returns {Promise} The Promise to be fulfilled
     */
    request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig(this.defaults, config);
      const { transitional, paramsSerializer, headers } = config;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      if (paramsSerializer !== void 0) {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
      config.method = (config.method || this.defaults.method || "get").toLowerCase();
      let contextHeaders;
      contextHeaders = headers && utils.merge(
        headers.common,
        headers[config.method]
      );
      contextHeaders && utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        (method) => {
          delete headers[method];
        }
      );
      config.headers = AxiosHeaders$1.concat(contextHeaders, headers);
      const requestInterceptorChain = [];
      let synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      const responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      let promise;
      let i2 = 0;
      let len2;
      if (!synchronousRequestInterceptors) {
        const chain = [dispatchRequest.bind(this), void 0];
        chain.unshift.apply(chain, requestInterceptorChain);
        chain.push.apply(chain, responseInterceptorChain);
        len2 = chain.length;
        promise = Promise.resolve(config);
        while (i2 < len2) {
          promise = promise.then(chain[i2++], chain[i2++]);
        }
        return promise;
      }
      len2 = requestInterceptorChain.length;
      let newConfig = config;
      i2 = 0;
      while (i2 < len2) {
        const onFulfilled = requestInterceptorChain[i2++];
        const onRejected = requestInterceptorChain[i2++];
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected.call(this, error);
          break;
        }
      }
      try {
        promise = dispatchRequest.call(this, newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      i2 = 0;
      len2 = responseInterceptorChain.length;
      while (i2 < len2) {
        promise = promise.then(responseInterceptorChain[i2++], responseInterceptorChain[i2++]);
      }
      return promise;
    }
    getUri(config) {
      config = mergeConfig(this.defaults, config);
      const fullPath = buildFullPath(config.baseURL, config.url);
      return buildURL(fullPath, config.params, config.paramsSerializer);
    }
  }
  utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
    Axios.prototype[method] = function(url, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        url,
        data: (config || {}).data
      }));
    };
  });
  utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
      return function httpMethod(url, data, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          headers: isForm ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url,
          data
        }));
      };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
  });
  const Axios$1 = Axios;
  class CancelToken {
    constructor(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      let resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      const token = this;
      this.promise.then((cancel) => {
        if (!token._listeners)
          return;
        let i2 = token._listeners.length;
        while (i2-- > 0) {
          token._listeners[i2](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = (onfulfilled) => {
        let _resolve;
        const promise = new Promise((resolve) => {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message, config, request) {
        if (token.reason) {
          return;
        }
        token.reason = new CanceledError(message, config, request);
        resolvePromise(token.reason);
      });
    }
    /**
     * Throws a `CanceledError` if cancellation has been requested.
     */
    throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    }
    /**
     * Subscribe to the cancel signal
     */
    subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    }
    /**
     * Unsubscribe from the cancel signal
     */
    unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      const index2 = this._listeners.indexOf(listener);
      if (index2 !== -1) {
        this._listeners.splice(index2, 1);
      }
    }
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */
    static source() {
      let cancel;
      const token = new CancelToken(function executor(c2) {
        cancel = c2;
      });
      return {
        token,
        cancel
      };
    }
  }
  const CancelToken$1 = CancelToken;
  function spread(callback2) {
    return function wrap(arr) {
      return callback2.apply(null, arr);
    };
  }
  function isAxiosError(payload) {
    return utils.isObject(payload) && payload.isAxiosError === true;
  }
  const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
  };
  Object.entries(HttpStatusCode).forEach(([key, value]) => {
    HttpStatusCode[value] = key;
  });
  const HttpStatusCode$1 = HttpStatusCode;
  function createInstance(defaultConfig) {
    const context = new Axios$1(defaultConfig);
    const instance = bind(Axios$1.prototype.request, context);
    utils.extend(instance, Axios$1.prototype, context, { allOwnKeys: true });
    utils.extend(instance, context, null, { allOwnKeys: true });
    instance.create = function create(instanceConfig) {
      return createInstance(mergeConfig(defaultConfig, instanceConfig));
    };
    return instance;
  }
  const axios = createInstance(defaults$1);
  axios.Axios = Axios$1;
  axios.CanceledError = CanceledError;
  axios.CancelToken = CancelToken$1;
  axios.isCancel = isCancel;
  axios.VERSION = VERSION;
  axios.toFormData = toFormData;
  axios.AxiosError = AxiosError;
  axios.Cancel = axios.CanceledError;
  axios.all = function all(promises) {
    return Promise.all(promises);
  };
  axios.spread = spread;
  axios.isAxiosError = isAxiosError;
  axios.mergeConfig = mergeConfig;
  axios.AxiosHeaders = AxiosHeaders$1;
  axios.formToJSON = (thing) => formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
  axios.HttpStatusCode = HttpStatusCode$1;
  axios.default = axios;
  const axios$1 = axios;
  const fetchProducts = function(link) {
    return axios$1.get(link);
  };
  const fetchLineItems = (config) => {
    let items = [...config.selected.box, ...config.selected.products, ...config.selected.card];
    let lineIems = [];
    let boxQty = config.quantity;
    let addedBoxes = localStorage.getItem("added-boxes");
    if (addedBoxes) {
      addedBoxes = JSON.parse(addedBoxes);
    } else {
      addedBoxes = {};
    }
    let highestBoxNumber = 0;
    Object.keys(addedBoxes).forEach((box) => {
      let boxNumber = parseInt(box.split(" ")[1]);
      if (boxNumber > highestBoxNumber) {
        highestBoxNumber = boxNumber;
      }
    });
    let nextBoxNumber = `box ${highestBoxNumber + 1}`;
    addedBoxes[nextBoxNumber] = true;
    console.log(`nextBoxNumber => ${nextBoxNumber}`);
    for (let i2 = 0; i2 < boxQty; i2++) {
      items.forEach((item) => {
        lineIems.push({
          variantId: "gid://shopify/ProductVariant/" + item.variants[0].id,
          quantity: item.quantity,
          customAttributes: [{
            key: `Box`,
            "value": nextBoxNumber
          }]
        });
      });
    }
    return lineIems;
  };
  const RecommendationItem = ({
    product,
    selected,
    updateSelected
  }) => {
    let selectedIndex = selected.findIndex((temp) => temp.id == product.id);
    const toggleProduct = (e2) => {
      e2.preventDefault();
      e2.stopPropagation();
      let isChecked = e2.target.checked;
      if (isChecked)
        updateSelected(product, -1, -1);
      else
        updateSelected(product, selectedIndex, 0);
    };
    return o(_$4, {
      children: [o("input", {
        class: "visuallyhidden",
        id: "recommendation-" + product.id,
        type: "checkbox",
        name: "products",
        checked: selectedIndex > -1,
        onChange: toggleProduct
      }), o("label", {
        for: "recommendation-" + product.id,
        children: [o("div", {
          class: "image-wrapper is-relative",
          children: o(ProgressiveImage, {
            src: product.featured_image,
            children: (src) => o("img", {
              src,
              alt: product.title
            })
          })
        }), o("div", {
          class: "product-thumbnail",
          children: [o("h4", {
            class: "title is-text",
            children: product.title
          }), o("h5", {
            class: "price is-text",
            children: Shopify.formatMoney(product.price)
          })]
        })]
      })]
    });
  };
  const Recommendation = ({
    products
  }) => {
    const {
      config,
      setConfig
    } = q$4(ConfigContext);
    const selected = config.selected.products;
    const updateSelected = (p2, i2, q2) => {
      if (i2 == -1 && q2 == -1) {
        setConfig(() => {
          let temp = {
            ...config
          };
          let selectedTemp = [...temp.selected.products];
          p2.quantity = 1;
          selectedTemp.push(p2);
          temp.selected.products = selectedTemp;
          return temp;
        });
      } else {
        setConfig(() => {
          let temp = {
            ...config
          };
          let selectedTemp = [...temp.selected.products];
          if (q2) {
            selectedTemp[i2].quantity = q2;
          } else {
            selectedTemp = selectedTemp.slice(0, i2).concat(selectedTemp.slice(i2 + 1));
          }
          temp.selected.products = selectedTemp;
          return temp;
        });
      }
    };
    return o(_$4, {
      children: products.map((product, index2) => o("div", {
        class: "one-third column cart__recommendations__products__item",
        children: o(RecommendationItem, {
          product,
          selected,
          updateSelected
        }, index2)
      }))
    });
  };
  const Recommendations = () => {
    const {
      config
    } = q$4(ConfigContext);
    const [loading, setLoading] = h$2(true);
    const [products, setProducts] = h$2([]);
    const selectedIds = config.selected.products.map((p2) => p2.id);
    const step = config.steps[1];
    const fetchHtml = async () => {
      setLoading(true);
      let link = fetchLink();
      let {
        data
      } = await fetchProducts(link);
      let items = [];
      for (let i2 = 0; i2 < data.length; i2++) {
        if (items.length > 2) {
          break;
        }
        if (selectedIds.indexOf(data[i2].id) == -1) {
          items.push(data[i2]);
        }
      }
      setProducts(() => {
        let temp = [];
        temp.push(...items);
        return temp;
      });
      setLoading(false);
    };
    const fetchLink = () => {
      return "/collections/" + step.collection + "?view=" + step.template;
    };
    p$2(() => {
      fetchHtml();
    }, [config.selected.products.length]);
    if (!loading && !products.length)
      return o(_$4, {});
    return o(_$4, {
      children: o("div", {
        class: "cart__recommendations one-whole",
        children: [o("h4", {
          class: "title is-h5 cart__recommendations__title",
          children: "You May Also Like"
        }), o("div", {
          class: "cart__recommendations__products is-flex is-flex-wrap",
          children: loading ? o(ThreeDots, {
            height: 60,
            width: 60,
            color: "#FA7E7B",
            wrapperClass: "cart__recommendations__loader",
            visible: true,
            ariaLabel: "three-dots-loading"
          }) : o(Recommendation, {
            products,
            step
          })
        })]
      })
    });
  };
  const BoxItem$1 = ({
    product,
    index: index2,
    updateProductQuantity
  }) => {
    return o(_$4, {
      children: o("div", {
        class: "cart__item",
        children: [o(ProgressiveImage, {
          src: product.featured_image,
          children: (src) => o("img", {
            src,
            alt: product.title
          })
        }), o("div", {
          class: "cart__item__meta",
          children: [o("h5", {
            class: "is-text title",
            children: product.title
          }), o("h6", {
            class: "price is-text",
            children: Shopify.formatMoney(product.price)
          }), o("div", {
            class: "cart__item__meta__controls",
            children: [o(a, {
              min: 1,
              value: product.quantity,
              onChange: (val) => updateProductQuantity(val, index2)
            }, product.quantity), o("button", {
              class: "button__remove",
              onClick: () => updateProductQuantity(0, index2),
              children: ["Remove", o("span", {
                class: "icon  ",
                "data-icon": "remove",
                children: o("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  xlink: "http://www.w3.org/1999/xlink",
                  width: "16px",
                  height: "16px",
                  viewBox: "0 0 16 16",
                  version: "1.1",
                  children: [" ", o("title", {
                    xmlns: "http://www.w3.org/2000/svg",
                    children: "Remove"
                  }), " ", o("g", {
                    id: "noun-bin-2025360",
                    transform: "translate(3.272727, 2.181818)",
                    fill: "inherit",
                    "fill-rule": "nonzero",
                    children: [" ", o("path", {
                      d: "M8.80491651,1.67807245 L6.60368739,1.67807245 L6.60368739,0.502225284 C6.60368739,0.232750283 6.387216,0 6.11049435,0 L3.33189365,0 C3.06726501,0 2.83870062,0.2204358 2.83870062,0.502225284 L2.83870062,1.67815994 L0.649500062,1.67807451 C0.288621349,1.67807451 0,1.97206911 0,2.3394694 L0,2.7436819 C0,2.89064202 0.108237839,3.00095179 0.252643023,3.00095179 L9.20190243,3.00095179 C9.34621955,3.00095179 9.45454545,2.8907317 9.45454545,2.7436819 L9.45454545,2.3394694 C9.45437763,1.97206911 9.16575227,1.67807451 8.80487356,1.67807451 L8.80491651,1.67807245 Z M3.82508668,0.992157959 L5.62937285,0.992157959 L5.62937285,1.67807245 L3.82508668,1.67807245 L3.82508668,0.992157959 Z"
                    }), " ", o("path", {
                      d: "M8.45608785,3.66241024 L0.998371681,3.66241024 C0.902132346,3.66241024 0.829975935,3.74819385 0.829975935,3.8461082 L1.41939756,11.0116935 C1.44347834,11.3668668 1.73211902,11.6363636 2.08099064,11.6363636 L7.37356341,11.6363636 C7.72234911,11.6363636 8.01107785,11.3668886 8.03515648,11.0116935 L8.62457811,3.8461082 C8.6365764,3.74810636 8.55233578,3.66241024 8.45618237,3.66241024 L8.45608785,3.66241024 Z M3.57248662,10.0073216 L3.54840584,10.0073216 C3.33193446,10.0073216 3.15146288,9.83584192 3.13945579,9.61531425 L2.92298441,5.73242446 C2.91098612,5.49967418 3.07938165,5.30367049 3.30794175,5.29146537 C3.52441313,5.27924735 3.72898482,5.45072684 3.74097043,5.68347275 L3.95744181,9.56636254 C3.9694401,9.79911283 3.78904607,9.99511652 3.57248447,10.0073216 L3.57248662,10.0073216 Z M6.3150016,9.61540174 C6.30300331,9.83583754 6.12252508,10.0074091 5.90605155,10.0074091 L5.88197077,10.0074091 C5.65340637,9.9951911 5.48502781,9.79918938 5.49701343,9.56645003 L5.71348481,5.68356024 C5.7254831,5.45080996 5.91795983,5.27934774 6.14651349,5.29155286 C6.37506714,5.30375798 6.54345645,5.49977261 6.53147083,5.73251195 L6.3150016,9.61540174 Z"
                    }), " "]
                  })]
                })
              })]
            })]
          })]
        })]
      })
    });
  };
  const BoxList = () => {
    const {
      config,
      setConfig,
      setError
    } = q$4(ConfigContext);
    const products = config.selected.products;
    const updateProductQuantity = (q2, i2) => {
      setConfig((current) => {
        let selected = [...current.selected.products];
        if (q2) {
          selected[i2].quantity = q2;
        } else {
          selected = selected.slice(0, i2).concat(selected.slice(i2 + 1));
        }
        return {
          ...current,
          selected: {
            ...current.selected,
            products: selected
          }
        };
      });
    };
    return o(_$4, {
      children: o("div", {
        class: "cart__items",
        children: [o("h3", {
          class: "caption is-h5",
          children: "Box Contents"
        }), products.length ? o(_$4, {
          children: products.map((product, index2) => {
            return o(BoxItem$1, {
              product,
              index: index2,
              updateProductQuantity
            }, index2);
          })
        }) : o("h4", {
          class: "is-text cart__items__empty",
          children: "No Products Selected"
        })]
      })
    });
  };
  const Cart = ({
    toggleCartDrawer
  }) => {
    const headerEl = _$3(null);
    const {
      config,
      setConfig,
      checkout
    } = q$4(ConfigContext);
    const {
      breakpoint
    } = useBreakpoint$1(Shopify.theme.BREAKPOINTS);
    const message = config.message;
    const hasCard = config.selected.card.length > 0;
    const hasBox = config.selected.box.length > 0;
    const hasProducts = config.selected.products.length > 0;
    const productsPrice = config.quantity * config.selected.products.reduce((productsPrice2, item) => productsPrice2 += item.price * item.quantity, 0);
    const boxPrice = config.quantity * config.selected.box.reduce((boxPrice2, item) => boxPrice2 += item.price * item.quantity, 0);
    const cardPrice = config.quantity * config.selected.card.reduce((cardPrice2, item) => cardPrice2 += item.price * item.quantity, 0);
    const translations = Shopify.theme.BundleTranslations;
    const freeShippingThreshold = parseInt(Shopify.theme.BundleConfig.freeShippingThreshold);
    let showFreeShippingBar = false;
    let totalBundlePrice = (productsPrice + boxPrice + cardPrice) / 100;
    let remainingShippingTarget = 0;
    let remainingPriceForFreeShipping = 0;
    if (freeShippingThreshold > 0) {
      showFreeShippingBar = true;
      remainingShippingTarget = totalBundlePrice * 100 / freeShippingThreshold;
      remainingPriceForFreeShipping = freeShippingThreshold - totalBundlePrice;
    }
    const handleNameChange = (obj) => {
      setConfig(() => {
        let temp = {
          ...config
        };
        temp.name = obj.value;
        return temp;
      });
    };
    const updateQuantity = (val) => {
      setConfig(() => {
        let temp = {
          ...config
        };
        temp.quantity = val;
        return temp;
      });
    };
    p$2(() => {
      document.documentElement.style.setProperty("--cart-header-height", headerEl.current.offsetHeight + "px");
    });
    return o("div", {
      class: "cart",
      children: [o("div", {
        class: "cart__header is-relative",
        ref: headerEl,
        children: [o(EditText, {
          className: "is-h4",
          inputClassName: "field__edit is-h4",
          name: "cart-name",
          defaultValue: config.name,
          showEditButton: true,
          onSave: handleNameChange
        }), breakpoint != "small" ? o("p", {
          class: "is-text",
          children: translations.cart.name_cart
        }) : null, o("button", {
          class: "button_close",
          onClick: toggleCartDrawer,
          children: "X"
        })]
      }), o("div", {
        class: "cart__content is-flex is-flex-wrap",
        children: [o("div", {
          class: "cart__content__left one-half column medium-down--one-whole",
          children: [o(BoxList, {}), o("div", {
            class: "cart__quantity",
            children: [o("h3", {
              class: "caption is-h5",
              children: translations.cart.quantity_label
            }), o(a, {
              min: 1,
              value: config.quantity,
              onChange: (val) => {
                updateQuantity(val);
              }
            })]
          }), o(Recommendations, {})]
        }), o("div", {
          class: "cart__content__right  one-half column medium-down--one-whole",
          children: o("div", {
            class: "cart__summary",
            children: [showFreeShippingBar && o("div", {
              class: "freeShippingBarContainer",
              children: [o("h3", {
                class: "shippingMessage",
                children: remainingShippingTarget < 100 ? o(_$4, {
                  children: ["Please add more ", o("span", {
                    children: Shopify.formatMoney(remainingPriceForFreeShipping * 100)
                  }), " to get free shipping."]
                }) : o(_$4, {
                  children: "Congratulations! 🎉 You’ve earned free shipping!"
                })
              }), o("div", {
                class: "freeShippingBarOuter",
                children: o("div", {
                  class: "freeShippingInnerBar",
                  style: {
                    width: `${remainingShippingTarget}%`
                  }
                })
              })]
            }), o("h3", {
              class: "caption is-h5",
              children: translations.cart.summary_label
            }), o("div", {
              class: "cart__summary-row",
              children: [o("h6", {
                class: "is-text",
                children: config.name
              }), o("h6", {
                class: "is-text",
                children: hasProducts ? Shopify.formatMoney(productsPrice) : "Not Selected"
              })]
            }), o("div", {
              class: "cart__summary-row",
              children: [o("h6", {
                class: "is-text",
                children: translations.cart.design_label
              }), o("h6", {
                class: "is-text",
                children: hasBox ? Shopify.formatMoney(boxPrice) : "Not Selected"
              })]
            }), o("div", {
              class: "cart__summary-row",
              children: [o("h6", {
                class: "is-text",
                children: translations.cart.card_label
              }), o("h6", {
                class: "is-text",
                children: hasCard ? Shopify.formatMoney(cardPrice) : "Not Selected"
              })]
            }), message && !message.skip && message.from && message.message ? o(_$4, {
              children: [
              // Message section first
              o("div", {
                class: "cart__summary-row",
                children: [
                  o("h6", {
                    class: "is-text",
                    children: translations.popup.message.message_label
                  }),
                  o("h6", {
                    class: "is-text",
                    children: message.message
                  })
                ]
              }),
              // From section below
              o("div", {
                class: "cart__summary-row",
                children: [
                  o("h6", {
                    class: "is-text",
                    children: translations.popup.message.from_label
                  }),
                  o("h6", {
                    class: "is-text",
                    children: message.from
                  })
                ]
              })
            ]
            }) : null, o("div", {
              class: "cart__totals",
              children: [o("div", {
                class: "cart__totals-row",
                children: [o("h6", {
                  class: "is-h6",
                  children: translations.cart.total_label
                }), o("h6", {
                  class: true,
                  children: Shopify.formatMoney(productsPrice + boxPrice + cardPrice)
                })]
              }), o("div", {
                class: "cart__totals-row",
                children: [o("h6", {
                  class: "is-h6",
                  children: translations.cart.taxes_label
                }), o("h6", {
                  class: "is-text",
                  children: translations.cart.taxes
                })]
              }), o("div", {
                class: "cart__checkout",
                children: [o("button", {
                  class: "button button--primary",
                  onClick: checkout,
                  "data-path": "cart",
                  children: "Complete Box"
                }), o("button", {
                  class: "button button--secondary checkoutBtnElem is-hidden",
                  onClick: checkout,
                  "data-path": "checkout",
                  children: "Proceed to Checkout"
                })]
              })]
            })]
          })
        })]
      })]
    });
  };
  const Product = ({
    products,
    step
  }) => {
    const {
      config,
      setConfig,
      setError
    } = q$4(ConfigContext);
    const selected = config.selected.products;
    const updateSelected = (p2, i2, q2) => {
      if (i2 == -1 && q2 == -1) {
        setConfig(() => {
          let temp = {
            ...config
          };
          let selectedTemp = [...temp.selected.products];
          p2.quantity = 1;
          selectedTemp.push(p2);
          temp.selected.products = selectedTemp;
          return temp;
        });
      } else {
        setConfig(() => {
          let temp = {
            ...config
          };
          let selectedTemp = [...temp.selected.products];
          if (q2) {
            selectedTemp[i2].quantity = q2;
          } else {
            selectedTemp = selectedTemp.slice(0, i2).concat(selectedTemp.slice(i2 + 1));
          }
          temp.selected.products = selectedTemp;
          return temp;
        });
      }
    };
    return o(_$4, {
      children: products.length ? o(_$4, {
        children: products.map((product, index2) => o("div", {
          class: "one-third medium-down--one-half column steps__step__products__item steps__step__products__item-" + step.type,
          children: o(ProductItem, {
            product,
            selected,
            updateSelected
          })
        }))
      }) : o("span", {
        class: "steps__step__products-empty",
        children: "No Products Found..."
      })
    });
  };
  function ProductItem({
    product,
    selected,
    updateSelected
  }) {
    let selectedIndex = selected.findIndex((temp) => temp.id == product.id);
    const toggleProduct = () => {
      if (selectedIndex == -1)
        updateSelected(product, -1, -1);
      else if (selectedIndex > -1)
        updateSelected(product, selectedIndex, 0);
    };
    return o(_$4, {
      children: [o("div", {
        class: `product__image-${selectedIndex > -1 ? "selected" : null} is-relative`,
        children: [o("div", {
          class: "image-wrapper is-relative",
          onClick: toggleProduct,
          children: o(ProgressiveImage, {
            src: product.featured_image,
            children: (src) => o("img", {
              src,
              alt: product.title
            })
          })
        }), selectedIndex > -1 ? o(a, {
          min: 0,
          value: selected[selectedIndex].quantity,
          onChange: (val) => {
            updateSelected(product, selectedIndex, val);
            return false;
          }
        }, selected[selectedIndex].quantity) : null]
      }), o("div", {
        class: `prodIs-${selectedIndex > -1 ? "selected" : null} product-thumbnail`,
        children: [o(Popup, {
          className: "bundle__popup",
          modal: true,
          position: "center center",
          trigger: o("button", {
            class: "button button--link-style",
            children: "More Info"
          }),
          children: (close) => o(_$4, {
            children: [o("button", {
              class: "button__close",
              onClick: close,
              children: "×"
            }), o("div", {
              class: "bundle__popup is-flex is-flex-wrap",
              children: [o(ProgressiveImage, {
                class: "one-half column medium-down--one-whole",
                src: product.featured_image,
                children: (src) => o("img", {
                  src,
                  alt: product.title
                })
              }), o("div", {
                class: "product-thumbnail",
                children: [o("h4", {
                  class: "product-thumbnail__title is-h5",
                  children: product.title
                }), o("div", {
                  class: "product-thumbnail__content is-text",
                  children: HtmlParser(product.description)
                })]
              })]
            })]
          })
        }), o("h4", {
          class: "title is-text",
          children: product.title
        }), o("h5", {
          class: "price is-text",
          children: Shopify.formatMoney(product.price)
        })]
      })]
    });
  }
  const Box = ({
    products,
    step,
    index: index2
  }) => {
    const {
      config,
      setConfig,
      setError
    } = q$4(ConfigContext);
    const selected = config.selected.box;
    const prevSelectedRef = _$3([]);
    const updateSelected = (p2) => {
      setConfig((current) => {
        let temp = [];
        p2.quantity = 1;
        temp.push(p2);
        return {
          ...current,
          selected: {
            ...current.selected,
            box: temp
          }
        };
      });
    };
    const changeStep = (index22) => {
      setConfig(() => {
        let temp = {
          ...config
        };
        temp.steps = temp.steps.map((step2, i2) => ({
          ...step2,
          active: i2 === index22
        }));
        return temp;
      });
      const stepsAndNavContainer = document.querySelector(".navigationAndSetps");
      const body = document.querySelector("body");
      const html = document.documentElement;
      if (stepsAndNavContainer) {
        stepsAndNavContainer.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        body.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        html.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    p$2(() => {
      if (prevSelectedRef.current !== selected && selected.length > 0) {
        changeStep(1);
      }
      prevSelectedRef.current = selected;
    }, [selected]);
    return o(_$4, {
      children: products.length ? o(_$4, {
        children: products.map((product, index22) => o("div", {
          class: "one-third medium-down--one-half column steps__step__products__item",
          children: o(BoxItem, {
            product,
            selected,
            updateSelected
          })
        }))
      }) : o("span", {
        class: "steps__step__products-empty",
        children: "No Boxes Found..."
      })
    });
  };
  function BoxItem({
    product,
    selected,
    updateSelected
  }) {
    let isSelected = selected.findIndex((p2) => p2.id == product.id);
    return o(_$4, {
      children: [o("input", {
        class: "visuallyhidden",
        id: "box-" + product.id,
        type: "radio",
        name: "box",
        checked: isSelected > -1,
        onChange: () => updateSelected(product)
      }), o("label", {
        for: "box-" + product.id,
        children: [o("div", {
          class: "image-wrapper is-relative",
          children: o(ProgressiveImage, {
            src: product.featured_image,
            children: (src) => o("img", {
              src,
              alt: product.title
            })
          })
        }), o("div", {
          class: "product-thumbnail",
          children: [o(Popup, {
            className: "bundle__popup",
            modal: true,
            position: "center center",
            trigger: o("button", {
              class: "button button--link-style",
              children: " More Info"
            }),
            children: (close) => o(_$4, {
              children: [o("button", {
                class: "button__close",
                onClick: close,
                children: "×"
              }), o("div", {
                class: "bundle__popup is-flex is-flex-wrap",
                children: [o(ProgressiveImage, {
                  class: "one-half column medium-down--one-whole",
                  src: product.featured_image,
                  children: (src) => o("img", {
                    src,
                    alt: product.title
                  })
                }), o("div", {
                  class: "product-thumbnail",
                  children: [o("h4", {
                    class: "product-thumbnail__title is-h5",
                    children: product.title
                  }), o("div", {
                    class: "product-thumbnail__content is-text",
                    children: HtmlParser(product.description)
                  })]
                })]
              })]
            })
          }), o("h4", {
            class: "product-thumbnail__title is-text",
            children: product.title
          }), o("h5", {
            class: "product-thumbnail__price is-text",
            children: Shopify.formatMoney(product.price)
          })]
        })]
      })]
    });
  }
  const Card = ({
    products,
    step,
    index: index2
  }) => {
    const {
      config,
      setConfig,
      setError
    } = q$4(ConfigContext);
    const selected = config.selected.card;
    const updateSelected = (p2) => {
      setConfig((current) => {
        let temp = [];
        p2.quantity = 1;
        temp.push(p2);
        return {
          ...current,
          selected: {
            ...current.selected,
            card: temp
          }
        };
      });
    };
    return o(_$4, {
      children: products.length ? o(_$4, {
        children: products.map((product, index22) => o("div", {
          class: "one-third medium-down--one-half column steps__step__products__item",
          children: o(CardItem, {
            product,
            selected,
            updateSelected
          })
        }))
      }) : o("span", {
        class: "steps__step__products-empty",
        children: "No Cards Found..."
      })
    });
  };
  function CardItem({
    product,
    selected,
    updateSelected
  }) {
    let isSelected = selected.findIndex((p2) => p2.id == product.id);
    return o(_$4, {
      children: [o("input", {
        class: "visuallyhidden",
        id: "card-" + product.id,
        type: "radio",
        name: "card",
        checked: isSelected > -1,
        onChange: () => updateSelected(product)
      }), o("label", {
        for: "card-" + product.id,
        children: [o("div", {
          class: "image-wrapper is-relative",
          children: o(ProgressiveImage, {
            src: product.featured_image,
            children: (src) => o("img", {
              src,
              alt: product.title
            })
          })
        }), o("div", {
          class: "product-thumbnail",
          children: [o(Popup, {
            className: "bundle__popup",
            modal: true,
            position: "center center",
            trigger: o("button", {
              class: "button button--link-style",
              children: " More Info"
            }),
            children: (close) => o(_$4, {
              children: [o("button", {
                class: "button__close",
                onClick: close,
                children: "×"
              }), o("div", {
                class: "bundle__popup is-flex is-flex-wrap",
                children: [o(ProgressiveImage, {
                  class: "one-half column medium-down--one-whole",
                  src: product.featured_image,
                  children: (src) => o("img", {
                    src,
                    alt: product.title
                  })
                }), o("div", {
                  class: "product-thumbnail",
                  children: [o("h4", {
                    class: "product-thumbnail__title is-h5",
                    children: product.title
                  }), o("div", {
                    class: "product-thumbnail__content is-text",
                    children: HtmlParser(product.description)
                  })]
                })]
              })]
            })
          }), o("h4", {
            class: "product-thumbnail__title is-text",
            children: product.title
          }), o("h5", {
            class: "product-thumbnail__price is-text",
            children: Shopify.formatMoney(product.price)
          })]
        })]
      })]
    });
  }
  const MessageStep = ({
    toggleMessagePopup,
    step,
    index: index2
  }) => {
    const {
      config,
      setConfig,
      setError
    } = q$4(ConfigContext);
    const translations = Shopify.theme.BundleTranslations;
    const GlobalSettings = Shopify.theme.BundleSettings;
    const messageConfig = config.message;
    const [messageCount, setMessageCount] = h$2(messageConfig.message.length);
    const updateMessageFields = (e2) => {
      var _a2;
      let name = e2.target.name;
      let value = e2.target.value;
      let type = e2.target.type;
      if (name == "message" && GlobalSettings.message.character_limit > 0 && value.length > GlobalSettings.message.character_limit) {
        return;
      }
      if (name == "message") {
        setMessageCount(value.length);
      }
      setConfig(() => {
        let temp = {
          ...config
        };
        if (type == "checkbox")
          temp.message[name] = e2.target.checked;
        else
          temp.message[name] = value;
        return temp;
      });
      if (type === "text") {
        (_a2 = document.querySelector("#fromField")) == null ? void 0 : _a2.setAttribute("value", value ?? "");
      }
      if (type === "textarea") {
        const textarea = document.querySelector("#msgField");
        if (textarea) {
          textarea.value = value ?? "";
        }
      }
    };
    return o("div", {
      class: "bundle__message-popup",
      children: o("div", {
        class: "message-poup__fields",
        children: [o("div", {
          class: "message-poup__field field",
          children: [o("input", {
            class: "checkbox",
            type: "checkbox",
            id: "skip-message",
            name: "skip",
            checked: messageConfig.skip,
            onChange: updateMessageFields
          }), o("label", {
            for: "skip-message",
            children: translations.popup.message.skip_message
          })]
        }), o("div", {
          class: "message-poup__field field message-field",
          children: [o("label", {
            children: [translations.popup.message.message_label, GlobalSettings.message.character_limit > 0 && o("span", {
              class: "message-poup__field__count",
              children: [messageCount, "/", GlobalSettings.message.character_limit]
            })]
          }), o("textarea", {
            class: "textarea",
            name: "message",
            placeholder: "Your Message",
            maxLength: GlobalSettings.message.character_limit > 0 ? GlobalSettings.message.character_limit : null,
            onChange: updateMessageFields,
            children: messageConfig.message
          })]
        }), o("div", {
          class: "message-poup__field field",
          children: [o("label", {
            children: translations.popup.message.from_label
          }), o("input", {
            class: "input",
            type: "text",
            name: "from",
            value: messageConfig.from,
            placeholder: "From",
            onChange: updateMessageFields
          })]
        })]
      })
    });
  };
  const Step = ({
    step,
    index: index2
  }) => {
    const [page, setPage] = h$2(1);
    const [loading, setLoading] = h$2(true);
    const [tags, setTags] = h$2([]);
    const [products, setProducts] = h$2([]);
    const fetchHtml = async () => {
      setLoading(true);
      let link = fetchLink();
      let {
        data
      } = await fetchProducts(link);
      setProducts(() => {
        let temp = [...products];
        temp.push(...data);
        return temp;
      });
      setPage(() => {
        let temp = page;
        temp++;
        return temp;
      });
      setLoading(false);
    };
    const fetchLink = () => {
      if (tags.length) {
        let joined = tags.join("+");
        return "/collections/" + step.collection + "/" + joined + "?view=" + step.template + "&page=" + page;
      }
      return "/collections/" + step.collection + "?view=" + step.template + "&page=" + page;
    };
    const updateTag = (e2) => {
      let val = e2.target.value;
      setProducts([]);
      setPage(1);
      setTags(() => {
        let temp = [...tags];
        let i2 = tags.indexOf(val);
        if (i2 > -1) {
          temp = temp.slice(0, i2).concat(temp.slice(i2 + 1));
        } else {
          temp.push(val);
        }
        return temp;
      });
    };
    p$2(() => {
      fetchHtml();
    }, []);
    p$2(() => {
      fetchHtml();
    }, [tags]);
    let HTML2 = o(Box, {
      products,
      step,
      index: index2
    });
    if (step.type == "products")
      HTML2 = o(Product, {
        products,
        step,
        index: index2
      });
    else if (step.type == "card")
      HTML2 = o(Card, {
        products,
        step,
        index: index2
      });
    else if (step.type == "messageStep")
      HTML2 = o(MessageStep, {
        step,
        index: index2
      });
    let Products = o("div", {
      class: "steps__step__products is-flex is-flex-wrap",
      children: HTML2
    });
    if (loading && page == 1)
      Products = o(_$4, {});
    let tagsHTML = o(_$4, {});
    if (step.tags && step.tags.length && step.type != "messageStep") {
      tagsHTML = o("div", {
        class: "steps__step__tags is-flex is-flex-wrap is-justify-center",
        children: step.tags.map((tag, i2) => {
          return o(_$4, {
            children: [o("input", {
              type: "checkbox",
              class: "visuallyhidden",
              checked: tags.indexOf(handleize(tag)) > -1 ? true : false,
              onChange: updateTag,
              id: step.type + "-tag-" + i2,
              value: handleize(tag)
            }), o("label", {
              class: "steps__step__tags-item",
              for: step.type + "-tag-" + i2,
              children: tag
            })]
          });
        })
      });
    }
    return o(_$4, {
      children: o("div", {
        class: "steps__step one-whole",
        children: [o("h4", {
          class: "title steps__step__pretitle",
          children: ["Step ", index2 + 1]
        }), o("h2", {
          class: "title steps__step__title",
          children: step.title
        }), tagsHTML, Products, loading ? o(ThreeDots, {
          height: 60,
          width: 60,
          color: "#FA7E7B",
          wrapperStyle: {},
          wrapperClass: "steps__step__loader",
          visible: true,
          ariaLabel: "three-dots-loading"
        }) : o(_$4, {
          children: page <= step.total ? o("button", {
            class: "button button--primary steps__step__load-more",
            onClick: fetchHtml,
            children: "Load More"
          }) : null
        })]
      })
    });
  };
  const Steps = ({
    toggleCartDrawer
  }) => {
    const {
      config,
      setConfig,
      setError
    } = q$4(ConfigContext);
    const {
      breakpoint
    } = useBreakpoint$1(Shopify.theme.BREAKPOINTS);
    return o("div", {
      class: "steps is-flex one-half medium-down--one-whole is-flex-wrap",
      children: [breakpoint == "small" ? o(PrevNextBtns, {
        context: "steps",
        toggleCartDrawer
      }) : null, config.steps.map((step, index2) => step.active ? o(Step, {
        index: index2,
        step
      }, index2) : null)]
    });
  };
  function Page() {
    const [isCartOpen, setIsCartOpen] = h$2(false);
    const [isMessagePopupOpen, setIsMessagePopupOpen] = h$2(false);
    const {
      breakpoint
    } = useBreakpoint$1(Shopify.theme.BREAKPOINTS);
    const toggleCartDrawer = () => {
      const event = new CustomEvent(`GB:SUMMARY:${isCartOpen ? "CLOSE" : "OPEN"}`);
      setIsCartOpen((prevState) => !prevState);
      document.dispatchEvent(event);
    };
    const toggleMessagePopup = () => {
      const event = new CustomEvent(`GB:MESSAGE_POPUP:${isCartOpen ? "CLOSE" : "OPEN"}`);
      setIsMessagePopupOpen((prevState) => !prevState);
      document.dispatchEvent(event);
    };
    p$2(() => {
    }, []);
    return o(_$4, {
      children: o("div", {
        class: "mainContainer",
        children: [o("div", {
          class: "rowArea container",
          children: [o("div", {
            class: "navigationAndSetps",
            children: [o("div", {
              class: "mobileStepsArea",
              children: o(Nav, {
                toggleCartDrawer,
                toggleMessagePopup,
                isMessagePopupOpen
              })
            }), o(Nav, {
              toggleCartDrawer,
              toggleMessagePopup,
              isMessagePopupOpen
            }), o(Steps, {
              toggleCartDrawer
            })]
          }), o("div", {
            class: "sideSummaryArea",
            children: breakpoint != "small" ? o(Summary, {
              toggleCartDrawer
            }) : null
          })]
        }), o(EZDrawer, {
          open: isCartOpen,
          onClose: toggleCartDrawer,
          direction: "right",
          className: "bundle__cart-drawer",
          children: o(Cart, {
            toggleCartDrawer
          })
        }), o(Popup, {
          className: "message-popup",
          open: isMessagePopupOpen,
          closeOnDocumentClick: false,
          closeOnEscape: false,
          children: o(MessagePopup, {
            toggleMessagePopup
          })
        })]
      })
    });
  }
  const ReactToastify = "";
  const index$2 = "";
  const index$1 = "";
  const index = "";
  const id = Shopify.theme.BundleConfig.id;
  let cacheConfig = JSON.parse(localStorage.getItem(`bundle-config-${id}`) || false);
  cacheConfig = Shopify.theme.BundleConfig;
  function Builder() {
    const [config, setConfig] = h$2(cacheConfig);
    const [error, setError] = h$2(false);
    const translations = Shopify.theme.BundleTranslations;
    const checkout = (e2) => {
      const err = validate();
      if (err.length) {
        return setError(err);
      }
      let btn = e2.target;
      btn.classList.add("is-loading");
      var btnContainer = btn.closest(".cart__checkout");
      var siblingBtns = btnContainer.querySelectorAll("button");
      siblingBtns.forEach(function(button) {
        if (button !== btn) {
          button.classList.add("fadeIn");
        }
      });
      const lineItems = fetchLineItems(config);
      const attributes = fetchChecoutAttrs(config);
      localStorage.removeItem(`bundle-config-${config.id}`);
      localStorage.removeItem("cartAttributes");
      addToShopifyCartAndCheckout(lineItems, attributes, btn);
    };
    const addToShopifyCartAndCheckout = (lineItems, attributes, btn) => {
      console.log("inside Add to cart function");
      console.log(`Line ITEMS = > ${JSON.stringify(lineItems)}`);
      const message = config.message;
      localStorage.setItem("cartAttributes", JSON.stringify(attributes));
      var redirectingPath = btn.getAttribute("data-path");
      var finalProdForCart = [];
      let index = 0;
      lineItems.forEach((item) => {
        let properties = {};
        if (item.customAttributes) {
          item.customAttributes.forEach((attr) => {
            if (attr.key === "Box") {
              addBoxNumberInStorage(attr.value);
              if (index === 0 && message) {
                try {
                  let parsedMessage = message;
                  if (typeof message === "string") {
                    const fixed = message.replace(/'/g, '"').replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');
                    parsedMessage = JSON.parse(fixed);
                  }
                  if (parsedMessage.skip !== true && parsedMessage.skip !== "true") {
                    if (parsedMessage.message) {
                      properties["Message"] = parsedMessage.message;
                    }
                    if (parsedMessage.from) {
                      properties["From"] = parsedMessage.from;
                    }
                  }
                } catch (err) {
                  console.error("Invalid message format:", message, err);
                }
              }
            }
            properties[attr.key] = attr.value;
          });
        }
        const variantId = item.variantId.replace("gid://shopify/ProductVariant/", "");
        finalProdForCart.push({
          id: variantId,
          quantity: item.quantity,
          properties
        });
        index++;
      });
      if (finalProdForCart.length > 0) {
        axios$1.post("/cart/add.js", {
          items: finalProdForCart
        }).then((response) => {
          console.log("PRODUCT ADDED");
          localStorage.removeItem(`bundle-config-bundle`);
          setTimeout(() => {
            btn.classList.remove("is-loading");
            const cartSubmitButton = document.getElementById("cartSubmit");
            if (cartSubmitButton && redirectingPath === "checkout") {
              cartSubmitButton.click();
            } else {
              window.location.href = "/cart";
            }
          }, 200);
        }).catch((error2) => {
          btn.classList.remove("is-loading");
          alert("Please Try Again..");
          console.log("ERROR", error2);
        });
      }
    };
    const addBoxNumberInStorage = (boxId) => {
      let addedBoxes = localStorage.getItem("added-boxes");
      if (addedBoxes) {
        addedBoxes = JSON.parse(addedBoxes);
      } else {
        addedBoxes = {};
      }
      let highestBoxNumber = 0;
      Object.keys(addedBoxes).forEach((box) => {
        let boxNumber = parseInt(box.split(" ")[1]);
        if (boxNumber > highestBoxNumber) {
          highestBoxNumber = boxNumber;
        }
      });
      let nextBoxNumber = `box ${highestBoxNumber + 1}`;
      addedBoxes[nextBoxNumber] = true;
      if (boxId == nextBoxNumber) {
        localStorage.setItem("added-boxes", JSON.stringify(addedBoxes));
      }
    };
    const validate = () => {
      const selectedProducts = config.selected.products;
      const selectedBox = config.selected.box;
      const selectedCard = config.selected.card;
      const message = config.message;
      let err = [];
      if (!selectedBox.length) {
        err.push(translations.errors.box);
      }
      if (!selectedProducts.length) {
        err.push(translations.errors.product);
      }
      if (selectedCard.length) {
        if (!message.skip) {
          if (!message.from.trim().length || !message.message.trim().length)
            err.push(translations.errors.message);
        }
      }
      return err;
    };
    p$2(() => {
      if (error) {
        if (typeof error != "string") {
          error.map((e2) => {
            const notify = () => Q$1.error(e2);
            notify();
          });
        } else {
          const notify = () => Q$1.error(error);
          notify();
        }
        setError(false);
      }
    }, [error]);
    p$2(() => {
      localStorage.setItem(`bundle-config-${config.id}`, JSON.stringify(config));
    }, [config]);
    return o(ConfigContext.Provider, {
      value: {
        config,
        setConfig,
        setError,
        checkout
      },
      children: [o(k$2, {
        position: "top-left",
        autoClose: 5e3,
        hideProgressBar: false,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true
      }), o(App, {})]
    });
  }
  function App() {
    const {
      config,
      setConfig,
      setError
    } = q$4(ConfigContext);
    const [client, checkout] = useClient();
    const [loading, setLoading] = h$2(true);
    p$2(() => {
      if (client) {
        setConfig(() => {
          let temp = {
            ...config
          };
          temp.client = client;
          temp.checkout = checkout;
          return temp;
        });
        setTimeout(function() {
          setLoading(false);
        }, 0);
      }
    }, [client]);
    return o(_$4, {
      children: loading ? o(ThreeDots, {
        height: 60,
        width: 60,
        color: "#FA7E7B",
        wrapperStyle: {},
        wrapperClass: "bundle__loader",
        visible: true,
        ariaLabel: "three-dots-loading"
      }) : (
        // <>{config.isOld ? <ReusePopup /> : <Page />}</>
        o(Page, {})
      )
    });
  }
  Shopify.theme.BREAKPOINTS = {
    small: 0,
    tablet: 798
  };
  B$4(o(Builder, {}), document.getElementById("bundle-wrapper"));
});
